import { startScatterNetwork } from "./scatterNetwork.js";
import { getDates, makeCalendar, makeCalendarTooltip } from './calendar.js';
import { debug_dataexplorer_dates } from './debug.js';
import { createDashboardPage } from './dashboard_page.js';
var __rendezvouz_setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;

let allow_daterange_persist_reload = false;
let allow_daterange_debug = false;
const dataExplorerSavedRangeStorageKey = 'dataexplorer_saved_date_v1';

function clearDataExplorerSavedRangeCacheOnReload() {
	if (allow_daterange_persist_reload === true) {
		return;
	}

	try {
		let navEntry = window.performance && typeof window.performance.getEntriesByType === 'function'
			? window.performance.getEntriesByType('navigation')[0]
			: null;
		let isReload = navEntry
			? navEntry.type === 'reload'
			: !!(window.performance && window.performance.navigation && window.performance.navigation.type === 1);

		if (isReload) {
			window.localStorage.removeItem(dataExplorerSavedRangeStorageKey);
		}
	} catch (e) {
		console.log('Could not clear Data Explorer saved range cache on reload:', e);
	}
}

clearDataExplorerSavedRangeCacheOnReload();



if (!window.dash_clientside) {
	window.dash_clientside = {};
	var __rendezvouz_setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
}





window.swanbot_dataexplorer_blocked = true;
let loaded_events = false;
let de_loading_events = false;
let active_event_track = 0;


window.get_date_range = 3;
window.calStartDay = 5;
window.calEndDay = 1;
window.window.calType = "day";
let gridOptions;
let digestGridOptions;
let actionid = 111;
let customerid = "";
let attachedimg;
var title_edit_button;
let gridObj;
let comment_editor;
let comment_mentions = [];
let channel_mentions = [];

let dashboard_query;
let has_slack_service = false;
let details_tag_editor_control;
let details_category_editor_control;
let details_status_editor_control;
let args_handle;
let advanced_filters = [];
let digest_copy = "";
//let cache_events_url;
//let cache_results;
//let get_explore_start_date;

let explore_timeline;
let timeline_items;
let explore_set_filters;
let explore_filters_picker;
let explore_debounce = 2000;
let explore_is_debounce = false;
let explore_is_debounce_results = false;
let explore_selected_filters = '';
let change_filter_handler;

let digest_events = null;


let explorercalendarObj;


let chatbot_writer;
let swanbot_session;
let swanbot_key;
let swanbot_dataexplorer_session;
let swanbot_dataexplorer_init = false;
window.swanbot_graphs = [];


let swanbot_dataexplorer_links = [];
let swanbot_dataexplorer_links_data = {};
let swanbot_dataexplorer_links_dates = [];
let swanbot_dataexplorer_currently_showing = "";
let swanbot_dataexplorer_agents = [];

let swanbot_dataexplorer_graph_id = "";
let swanbot_dataexplorer_date_graph_id = "";
window.swanbot_graphdata = { "graphs": [], "titles": [] };
let swanbot_dataexplorer_graphs = [];
window.swanbot_dataexplorer_filter_groupstacked = true;
let swanbot_dataexplorer_filter_groupselected = ["Total Transactions"];
let swanbot_dataexplorer_filter_tracename_index = [];
let swanbot_dataexplorer_filter_period = "hour";
let swanbot_dataexplorer_investigate_selected = false;
let swanbot_dataexplorer_last_query = "";
let swanbot_dataexplorer_is_stopping = false;
let swanbot_dataexplorer_totalstable_isopen = false;
let dataExplorerInitialLoaderShown = false;

let swanbot_dataexplorer_processing_compare = false;
let swanbot_dataexplorer_compare_types = null;
let swanbot_dataexplorer_compare_option_loaded = false;
let swanbot_dataexplorer_compare_modality_analysis = "";
let swanbot_dataexplorer_lock_period_selection = false;
window.swanbot_dataexplorer_period_mode_preference = window.swanbot_dataexplorer_period_mode_preference || "";

window.swanbot_dataexplorer_processing_compare = false;
window.swanbot_dataexplorer_compare_options_requested = false;
window.swanbot_dataexplorer_compare_options_stale = false;
window.swanbot_dataexplorer_compare_options_refresh_inflight = false;
window.reset_compare_dataexplorer_options_state = function () {
	swanbot_dataexplorer_compare_option_loaded = false;
	let compareOptionList = document.getElementById("comparison_drowpdown_container");
	if (compareOptionList) {
		compareOptionList.innerHTML = "";
	}
};

let swanbot_grouping_index = 0;

let swanbot_maingraph_toomuchdata = false;

let stopPlasmaEffect;

function setDataExplorerGraphId(graphId) {
	swanbot_dataexplorer_graph_id = graphId;

	if (window.WingmanState && typeof window.WingmanState === 'object') {
		window.WingmanState.swanbot_dataexplorer_graph_id = graphId;
	}
}


let already_loaded = [];

var timer;
var customer_status_options = [{ "title": "Active", "value": "active" }, { "title": "Archived - Event Resolved", "value": "archived_resolved" }, { "title": "Archived - Not an Issue", "value": "archived_notanissue" }, { "title": "Archived - Unknown", "value": "archived_unknown" }];

// const graphHexColors = [
//   '#FF0000', // Red
//   '#0000FF', // Blue
//   '#008000', // Green
//   '#FFA500', // Orange
//   '#800080', // Purple
//   '#00FFFF', // Cyan
//   '#FFFF00', // Yellow
//   '#FF00FF', // Magenta
//   '#808000', // Olive
//   '#008080', // Teal
//   '#00FF00', // Lime
//   '#FFC0CB', // Pink
//   '#A52A2A', // Brown
//   '#000080', // Navy
//   '#800000', // Maroon
//   '#4682B4', // Steel Blue
//   '#DAA520', // Goldenrod
//   '#228B22', // Forest Green
//   '#4B0082', // Indigo
//   '#FF6347', // Tomato
//   '#ADD8E6', // Light Blue
//   '#F0E68C', // Khaki
//   '#9ACD32', // YellowGreen
//   '#FA8072', // Salmon
//   '#9370DB', // Medium Purple
//   '#40E0D0', // Turquoise
//   '#FF8C00', // Dark Orange
//   '#BA55D3', // Medium Orchid
//   '#6B8E23', // Olive Drab
//   '#CD5C5C', // Indian Red
//   '#6495ED', // Cornflower Blue
//   '#FFE4C4', // Bisque
//   '#8B4513', // Saddle Brown
//   '#D2691E', // Chocolate
//   '#BC8F8F', // Rosy Brown
//   '#B0C4DE', // Light Steel Blue
//   '#7FFF00', // Chartreuse
//   '#FFD700', // Gold
//   '#87CEEB', // Sky Blue
//   '#F4A460', // Sandy Brown
//   '#D8BFD8', // Thistle
//   '#AFEEEE', // Pale Turquoise
//   '#EE82EE', // Violet
//   '#F08080', // Light Coral
//   '#708090', // Slate Gray
//   '#98FB98', // Pale Green
//   '#DDA0DD', // Plum
//   '#8FBC8F', // Dark Sea Green
//   '#FFDEAD', // Navajo White
//   '#B22222', // Firebrick
//   '#A9A9A9', // Dark Gray
//   '#FF1493', // Deep Pink
//   '#4169E1', // Royal Blue
//   '#FF69B4', // Hot Pink
//   '#00CED1'  // Dark Turquoise
// ];


// const graphHexColors = [
//   '#FF2626', // Red (brighter)
//   '#2626FF', // Blue (brighter)
//   '#269926', // Green (brighter)
//   '#FFB426', // Orange (brighter)
//   '#992699', // Purple (brighter)
//   '#26FFFF', // Cyan (brighter)
//   '#FFFF26', // Yellow (brighter)
//   '#FF26FF', // Magenta (brighter)
//   '#999926', // Olive (brighter)
//   '#269999', // Teal (brighter)
//   '#26FF26', // Lime (brighter)
//   '#FFD2D8', // Pink (brighter)
//   '#BA3434', // Brown (brighter)
//   '#262699', // Navy (brighter)
//   '#992626', // Maroon (brighter)
//   '#5799CF', // Steel Blue (brighter)
//   '#E6BB26', // Goldenrod (brighter)
//   '#2C992C', // Forest Green (brighter)
//   '#592699', // Indigo (brighter)
//   '#FF765C', // Tomato (brighter)
//   '#B8E0EE', // Light Blue (brighter)
//   '#F2EBD1', // Khaki (brighter)
//   '#A7D739', // YellowGreen (brighter)
//   '#FB9083', // Salmon (brighter)
//   '#A182E4', // Medium Purple (brighter)
//   '#4DE5D6', // Turquoise (brighter)
//   '#FF9D26', // Dark Orange (brighter)
//   '#C66AD8', // Medium Orchid (brighter)
//   '#789F2A', // Olive Drab (brighter)
//   '#DC6D6D', // Indian Red (brighter)
//   '#74A6F1', // Cornflower Blue (brighter)
//   '#FFE9D3', // Bisque (brighter)
//   '#995116', // Saddle Brown (brighter)
//   '#DE7535', // Chocolate (brighter)
//   '#C79BA2', // Rosy Brown (brighter)
//   '#C0D2E8', // Light Steel Blue (brighter)
//   '#8EFF26', // Chartreuse (brighter)
//   '#FFDD26', // Gold (brighter)
//   '#94D5F0', // Sky Blue (brighter)
//   '#F6B375', // Sandy Brown (brighter)
//   '#E0C7E0', // Thistle (brighter)
//   '#BBF2F2', // Pale Turquoise (brighter)
//   '#F090F0', // Violet (brighter)
//   '#F29090', // Light Coral (brighter)
//   '#8090A4', // Slate Gray (brighter)
//   '#A5FFAC', // Pale Green (brighter)
//   '#E5B2E5', // Plum (brighter)
//   '#9AC79C', // Dark Sea Green (brighter)
//   '#FFE9BD', // Navajo White (brighter)
//   '#BF2E2E', // Firebrick (brighter)
//   '#B6B6B6', // Dark Gray (brighter)
//   '#FF29A6', // Deep Pink (brighter)
//   '#5179EC', // Royal Blue (brighter)
//   '#FF7DF4', // Hot Pink (brighter)
//   '#26DDDF'  // Dark Turquoise (brighter)
// ];


// const graphHexColors = [
//   '#B30000', // Red (darker)
//   '#0000B3', // Blue (darker)
//   '#005900', // Green (darker)
//   '#B37300', // Orange (darker)
//   '#590059', // Purple (darker)
//   '#00B3B3', // Cyan (darker)
//   '#B3B300', // Yellow (darker)
//   '#B300B3', // Magenta (darker)
//   '#595900', // Olive (darker)
//   '#005959', // Teal (darker)
//   '#00B300', // Lime (darker)
//   '#B3868B', // Pink (darker)
//   '#731D1D', // Brown (darker)
//   '#000059', // Navy (darker)
//   '#590000', // Maroon (darker)
//   '#315C80', // Steel Blue (darker)
//   '#997317', // Goldenrod (darker)
//   '#186318', // Forest Green (darker)
//   '#35005C', // Indigo (darker)
//   '#B34732', // Tomato (darker)
//   '#7895A3', // Light Blue (darker)
//   '#A8A063', // Khaki (darker)
//   '#6B9023', // YellowGreen (darker)
//   '#B05C51', // Salmon (darker)
//   '#674F99', // Medium Purple (darker)
//   '#2C9E96', // Turquoise (darker)
//   '#B36300', // Dark Orange (darker)
//   '#803C99', // Medium Orchid (darker)
//   '#4B651B', // Olive Drab (darker)
//   '#914040', // Indian Red (darker)
//   '#4769A8', // Cornflower Blue (darker)
//   '#B39F8A', // Bisque (darker)
//   '#63300E', // Saddle Brown (darker)
//   '#94471B', // Chocolate (darker)
//   '#836868', // Rosy Brown (darker)
//   '#7C899F', // Light Steel Blue (darker)
//   '#59B300', // Chartreuse (darker)
//   '#B39700', // Gold (darker)
//   '#5F91A6', // Sky Blue (darker)
//   '#AC7544', // Sandy Brown (darker)
//   '#978497', // Thistle (darker)
//   '#7BA5A5', // Pale Turquoise (darker)
//   '#A65D9E', // Violet (darker)
//   '#A85A5A', // Light Coral (darker)
//   '#4E5966', // Slate Gray (darker)
//   '#6DAE6D', // Pale Green (darker)
//   '#977097', // Plum (darker)
//   '#658465', // Dark Sea Green (darker)
//   '#B39D79', // Navajo White (darker)
//   '#7D1919', // Firebrick (darker)
//   '#767676', // Dark Gray (darker)
//   '#B30D6D', // Deep Pink (darker)
//   '#2E479E', // Royal Blue (darker)
//   '#B34E80', // Hot Pink (darker)
//   '#009092'  // Dark Turquoise (darker)
// ];



const graphHexColors = [


	// Paired (12 colors) - good for showing pairs or related categories
	'#A6CEE3', // Light Blue
	'#1F78B4', // Dark Blue
	'#B2DF8A', // Light Green
	'#33A02C', // Dark Green
	'#FB9A99', // Light Red
	'#E31A1C', // Dark Red
	'#FDBF6F', // Light Orange
	'#FF7F00', // Dark Orange
	'#CAB2D6', // Light Purple
	'#6A3D9A', // Dark Purple
	'#FFFF99', // Very Light Yellow
	'#B15928', // Brown

	// Dark2 (8 colors) - generally good contrast
	'#1B9E77', // Dark Teal
	'#D95F02', // Dark Orange-Brown
	'#7570B3', // Muted Purple
	'#E7298A', // Bright Pink
	'#66A61E', // Olive Green
	'#E6AB02', // Goldenrod
	'#A6761D', // Darker Brown
	'#666666', // Dark Gray

	// Accent (8 colors)
	'#7FC97F', // Medium Green
	'#BEBADA', // Light Purple (already used, but common in small palettes)
	'#FDC086', // Light Orange
	'#FFFF99', // Very Light Yellow (already used)
	'#386CB0', // Dark Blue-Purple
	'#F0027F', // Strong Pink
	'#BF5B17', // Rusty Orange
	'#666666', // Dark Gray (already used)

	// Use a few more from Set1 (9 colors) to reach enough distinct colors without too much repetition
	'#E41A1C', // Strong Red
	'#377EB8', // Medium Blue
	'#4DAF4A', // Medium Green
	'#984EA3', // Medium Purple
	'#FF7F00', // Dark Orange (already used, but common)
	'#FFFF33', // Bright Yellow (a bit brighter than FFFFB3)
	'#A65628', // Dark Brown
	'#F781BF', // Pink
	'#999999',  // Medium Gray

	// From ColorBrewer2.org - Qualitative palettes
	// Set3 (12 colors)
	'#8DD3C7', // Light Blue-Green
	'#FFFFB3', // Pale Yellow
	'#BEBADA', // Light Purple
	'#FB8072', // Salmon Red
	'#80B1D3', // Sky Blue
	'#FDB462', // Orange-Yellow
	'#B3DE69', // Light Green
	'#FCCDE5', // Light Pink
	'#D9D9D9', // Light Gray
	'#BC80BD', // Plum
	'#CCEBC5', // Pale Green
	'#FFED6F', // Bright Yellow

];

const graphGrayColors = [
	'rgba(235, 235, 235, 0.35)',
	'rgba(225, 225, 225, 0.35)',
	'rgba(215, 215, 215, 0.35)',
	'rgba(205, 205, 205, 0.35)',
	'rgba(195, 195, 195, 0.35)',
	'rgba(185, 185, 185, 0.35)',
	'rgba(175, 175, 175, 0.35)',
	'rgba(165, 165, 165, 0.35)',
	'rgba(155, 155, 155, 0.35)',
	'rgba(145, 145, 145, 0.35)',
	'rgba(135, 135, 135, 0.35)',
	'rgba(125, 125, 125, 0.35)'
];

function getGraphGrayColor(index) {
	if (!graphGrayColors.length) {
		return 'rgba(205, 205, 205, 0.35)';
	}

	let safeIndex = Number(index);
	if (Number.isNaN(safeIndex) || safeIndex < 0) {
		safeIndex = 0;
	}

	return graphGrayColors[safeIndex % graphGrayColors.length];
}


/*
	def : 1 , 3
	mon : 1  1
	tue : 2  2
	wed : 3  3
	thu : 4  4
	fri : 5  5
	sat : 6  6
	sun : 7  0
*/

//let popoverCard = '<div id="event_details"><div class="h-100"><div class=""><h4 class="card-title"></h4><p id="card-range" class="card-range"> </p><p id="card-range-duration" class="card-range"> </p><p id="card-id" class="card-range"> </p><div><p id="card-event-cause-toggle" class="card-cause">Event Cause: <a href="#" class="btn-showhide-cause">▼</a></p><div id="card-root-cause" class="card-root-cause"></div></div><p id="card-event-chart-toggle" class="card-charts">Event Timeline: <a href="#" class="btn-showhide-card">▶</a></p><div id="card-event-chart" class="img-small-version"><img id="card-priceline" class="card-image" src=""><img id="card-heatmap" class="card-image" src=""></div><div id="card-tags" class="card-pills"></div><p id="class-text" class="card-text"></p><div class="row"><div class="col-lg-8 col-md-6"><div class="btn-group" role="group"><a id="card-link" class="btn btn-primary btn-details" href="#"><span id="card-link-title" class="sidebar-text">Details</span></a><a id="card-like-up" class="btn btn-link" href="#"></a><a id="card-like-down" class="btn btn-link" href="#"></a><div id="dashboard-resolve-button" class="dropdown"><button type="button" id="react-aria5261270616-1" aria-expanded="false" class="dropdown-toggle btn btn-light">Resolve</button><div x-placement="bottom-start" class="dropdown-menu" aria-labelledby="react-aria5261270616-1" data-popper-reference-hidden="true" data-popper-escaped="true" data-popper-placement="bottom-start" style="position: absolute; inset: 0px auto auto 0px; transform: translate3d(0px, 2px, 0px);"><button id="resolve-nonotes" n_clicks_timestamp="-1" data-rr-ui-dropdown-item="" class="dropdown-item">Close</button><button id="resolve-withnotes" n_clicks_timestamp="-1" data-rr-ui-dropdown-item="" class="dropdown-item">Close with notes</button></div></div></div></div><div class="col-lg-4 col-md-6 text-end"><a id="dashboard-close-event" class="btn btn-dark close-all-card" href=""><span class="sidebar-text">Close</span></a></div></div></div></div></div>';

//let exp_hover_card = '<div id="custom-event-tooltip-popup" class="md-tooltip"><h3 class="card-header" id="card-header"></h3><div class="popover-body"><div id="event_details"><div class="h-100"><div class=""><h3 class="card-title" id="card-title"></h3><p id="card-range" class="card-range"> </p><p id="card-range-duration" class="card-range"> </p><p id="card-id" class="card-range"> </p><div><p id="card-event-cause-toggle" class="card-cause">Event Cause: <a href="#" class="btn-showhide-cause">▼</a></p><div id="card-root-cause" class="card-root-cause"></div></div><p id="card-event-chart-toggle" class="card-charts">Event Timeline: <a href="#" class="btn-showhide-card">▶</a></p><div id="card-event-chart" class="img-small-version"><img id="card-priceline" class="card-image" src=""><img id="card-heatmap" class="card-image" src=""></div><div id="card-tags" class="card-pills"></div><p id="class-text" class="card-text"></p><div class="row"><div class="col-lg-8 col-md-6"><div class="btn-group" role="group"><a id="card-link" class="btn btn-primary btn-details" href="#"><span id="card-link-title" class="sidebar-text">Details</span></a><a id="card-like-up" class="btn btn-link" href="#"></a><a id="card-like-down" class="btn btn-link" href="#"></a></div></div><div class="col-lg-4 col-md-6 text-end"><a id="dashboard-close-event" class="btn btn-dark close-all-card" href=""><span class="sidebar-text">Close</span></a></div></div></div></div></div></div></div>';



Quill.prototype.getHtml = function () {
	return this.container.querySelector('.ql-editor').innerHTML;
};



function waitForElm(selector) {
	return new Promise(resolve => {
		if (document.querySelector(selector)) {
			return resolve(document.querySelector(selector));
		}

		const observer = new MutationObserver(mutations => {
			if (document.querySelector(selector)) {
				resolve(document.querySelector(selector));
				observer.disconnect();
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
}


function waitForElmDel(selector) {
	return new Promise(resolve => {
		if (!document.querySelector(selector)) {
			return resolve(selector);
		}

		const observer = new MutationObserver(mutations => {
			for (const mutation of mutations) {
				for (const removedNode of mutation.removedNodes) {
					if (removedNode.classList) {
						//if (removedNode.id === selector) {
						if (removedNode.classList.contains("modal")) {
							resolve(selector);
							observer.disconnect();
						}
					}
				}
			}
		});

		observer.observe(document.body, {
			childList: true,
			subtree: true
		});
	});
}

function recreateNode(el, withChildren) {
	if (withChildren) {
		el.parentNode.replaceChild(el.cloneNode(true), el);
	}
	else {
		var newEl = el.cloneNode(false);
		while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
		el.parentNode.replaceChild(newEl, el);
	}
}

function returnTag(tag_type, tag_value, tag_event_type) {
	//console.log("tag", tag_type, tag_value, tag_event_type);

	if (window.WingmanState.customer_events) {
		// page context window.WingmanState.customer_events
		//console.log("no need to get window.WingmanState.customer_events_categories, already exists in returnTag")
	} else {
		window.updateCustomerEventCats();
	}

	if (tag_type == "resource") {
		ttag = ""
		var event_data = window.WingmanState.customer_events[tag_event_type];
		//console.log("event_data", event_data.name)
		ttag = "tag_resource_" + event_data.name;
		tname = event_data.name;
		tcolor = event_data.color;

		return makeTag(ttag, tname, tcolor);

	} else if (tag_type == "user") {
		if (tag_value == "new") {
			return makeTag("tag_new", tag_value, "");
		} else if (tag_value == "resolved") {
			return makeTag("tag_resolved", "RESOLVED", "");
		} else {
			return makeTag("tag_user", tag_value, "");
		}
	}
}

function returnFilter(filter_type, filter_key, filter_values) {

	if (filter_type == "filter") {
		return makeFilter("light", filter_key, filter_values);
	} else {
		return makeFilter("dark", filter_key, filter_values);
	}

}


function makeTag(badge_class, tag_value, tag_color) {
	return "<span class='badge badge_" + badge_class + "' style='background-color:" + tag_color + "'>" + tag_value + "</span>"
}

function prependChild(parentEle, newFirstChildEle) {
	parentEle.insertBefore(newFirstChildEle, parentEle.firstChild)
}

function makeFilter(filter_class, filter_key, filter_values) {
	strfilter = "<span class='badge badge-" + filter_class + "'>";
	strfilter = strfilter + filter_key;
	filterval = filter_values.toString();
	strfilter = strfilter + " " + filterval.slice(0, 340);
	if (filterval.length > 340) {
		strfilter = strfilter + "..."
	}
	strfilter = strfilter + "</span>"
	return strfilter

}

function startTimer() {
	var startTimestamp = moment(document.getElementById('detail_date_end').value);
	setInterval(function () {
		startTimestamp.add(1, 'second');
		if (document.getElementById('timer')) {
			document.getElementById('timer').innerHTML = startTimestamp.format('HH:mm:ss');
		}
	}, 1000);
}


/* extracted getDates */


function getSubgroupCache() {
	customerid = document.querySelector("#customer_id").value;

	let cachekey = customerid + "_dataexplorer_subgroup_sources";
	let datagroup_cache = get_cache(cachekey);
	if (datagroup_cache) {
		swanbot_dataexplorer_filter_groupselected = datagroup_cache;
	}
	//console.log("loading getSubgroupCache ", swanbot_dataexplorer_filter_groupselected);

}



/* extracted makeCalendarTooltip */



/* extracted makeCalendar */


function updateTotals(incoming_events, search_string = null) {
	// set totals
	var trend_days = document.getElementById("trend_days");
	var trend_days_new = document.getElementById("trend_days_new");
	var trend_days_resolved = document.getElementById("trend_days_resolved");
	trend_days.innerHTML = incoming_events.events_total;
	//trend_days_new.innerHTML = incoming_events.events_new;
	trend_days_resolved.innerHTML = incoming_events.events_closed;



	//console.log("dispatch event for dashboard total events summary :", incoming_events.events_by_cat)
	var dashboard_update_totals = document.getElementById("dashboard_update_totals");
	__rendezvouz_setter.call(dashboard_update_totals, JSON.stringify(incoming_events.events_by_cat));
	var client_event = new Event('input', { bubbles: true });
	dashboard_update_totals.dispatchEvent(client_event);


}


/* extracted clean_explorer_timeline */



/* extracted make_explore_timeline */


function filterfilterEvents(calObj, incoming_events, search_string = null) {

	var search_events = incoming_events.events;

	if (typeof window.make_explore_timeline === 'function') {
		window.make_explore_timeline(search_events);
	} else {
		console.error('window.make_explore_timeline is not available in filterfilterEvents');
	}


}



function filterEvents(calObj, incoming_events, search_string = null) {
	var events = [];

	//console.log("filter_events")


	if (window.WingmanState.customer_events) {
		//console.log("no need to get window.WingmanState.customer_events_categories, already exists in filterEvents", window.WingmanState.customer_events)
	} else {
		window.updateCustomerEventCats();
	}

	selected = document.getElementById("dashboard_selected_cats").value
	search_events = incoming_events.events;

	for (var i = 0; i < search_events.length; ++i) {
		var include_event = true;
		var item = search_events[i];
		if (selected.indexOf(item.type) > -1) {
			if (search_string) {
				search_string = search_string.toLowerCase();
				search_fields = item.name + " " + JSON.stringify(item.display_filters) + " " + item.tags.toString();
				search_fields = search_fields.toLowerCase();
				if (search_fields.indexOf(search_string) == -1) {
					include_event = false;
				}
			}
			if (include_event) {
				events.push(item);
			}
		}
	}

	// clean the events
	for (ae in events) {
		events[ae].start = events[ae].ts_start;
		events[ae].end = events[ae].ts_end;

		// resource 99 should be unranked
		events[ae].resource = 1
		events[ae].title = "Event - "

		var event_data = window.WingmanState.customer_events[events[ae].type];
		if (event_data) {
			events[ae].resource = event_data.rank;
			events[ae].title = event_data.display_name + " - "
		}


		events[ae].title = events[ae].title + events[ae].start + " - " + events[ae].end


		if (events[ae].hasOwnProperty('name')) {
			if (events[ae].name !== "") {
				events[ae].title = events[ae].name
			}
		}

		if (events[ae].hasOwnProperty('disposition')) {
			if (events[ae].disposition == "resolved") {
				events[ae].cssClass = "md-stripes-bg"
			}
			if (events[ae].disposition == "hot") {
				events[ae].cssClass = "md-hot-bg"
			}
			if (events[ae].disposition == "new") {
				events[ae].cssClass = "md-new-bg"
			}
		}

		if (events[ae].hasOwnProperty('status')) {
			let sstatus = events[ae].status;

			switch (sstatus) {
				case 'active':
					break;
				case 'draft_suggested_active':
					break;
				case 'archived_unknown':
				case 'archived_resolved':
				case 'archived_notanissue':
					events[ae].cssClass = "md-stripes-bg"
					break;
				default:
					events[ae].cssClass = "md-nonactive-bg"
			}
		}

		if (events[ae].hasOwnProperty('tags')) {
			let stags = events[ae].tags;
			if (stags.includes("Small Numbers")) {
				events[ae].cssClass = "md-stripes-bg"
			}
			if (stags.includes("Large Numbers")) {
				events[ae].cssClass = "md-largevents-bg"
			}

		}



	}
	//log_events(events);
	calObj.setEvents(events);
	calObj.navigate(window.get_start_date);


	window.calendar_loader_hide();



	//window.WingmanState.eventcalendarObj.setEvents(events);

}















function log_events(eventstolog) {
	let all_events = []
	for (event in eventstolog) {
		all_events.push(eventstolog[event].id)
	}
	console.log("events_to_index", all_events);

}


/* extracted calendar_loader_show */



/* extracted calendar_loader_hide */


const dashboardPage = createDashboardPage({
	initializeCalendar: () => {
		customerid = document.getElementById('customer_id').value;
		getDates();
		load_event_cal();
		makeCalendar(text => load_events(text, advanced_filters));
		return window.WingmanState.eventcalendarObj;
	},
	renderEvents: (calendar, events, text) => {
		filterEvents(calendar, events, text);
		updateTotals(events, text);
	},
	getCache: get_cache,
	setCache: set_cache,
});

function load_events(text, event_filters = null, bust_cache = false) {
	dashboardPage.refresh({ text, filters: event_filters, bustCache: bust_cache });
}


function get_filter_event_json_data(eventURL, text) {
	let filter_loader = document.getElementById("event_timeline_loading");
	filter_loader.classList.remove("btn-hide");
	//console.log("get_event_json_data - start")
	//console.log("get filter events ", eventURL)
	mobiscroll.getJson(eventURL, function (results_events) {
		//console.log("get_filter_event_json_data - complete")
		//console.log("retrieved Event data using mobicompon get_filter_event_json_data ", results_events)
		var events = results_events;
		filterfilterEvents(explorercalendarObj, events, text);
	}, 'json');
}

function load_event_cal() {

	mobiscroll.setOptions({
		theme: 'material',
		themeVariant: 'light'
	});


	//makeCalendar();


}


function set_cache(key, value) {
	let cache_status = false;
	Lockr.set(key, value);
	cache_status = true;
	return cache_status;
}

function get_cache(key) {
	let cache_value = null;
	return cache_value = Lockr.get(key);

}



/* extracted change_event_timezone */






function snartElem() {
	let markDataExplorerExited = function () {
		if (window.swanbot_dataexplorer_initial_visit_done === true || window.swanbot_dataexplorer_blocked === true) {
			window.swanbot_dataexplorer_reopen_on_return = true;
			window.swanbot_dataexplorer_initial_visit_done = false;
			window.swanbot_dataexplorer_blocked = false;
		}
	};

	waitForElm('#area-date-events').then((elm) => {
		markDataExplorerExited();

		//console.log("on events overview")

		page_type = "dashboard";

		var dashboard_event_loaded = document.getElementById("dashboard_event_loaded");
		__rendezvouz_setter.call(dashboard_event_loaded, JSON.stringify(page_type));
		var client_event = new Event('input', { bubbles: true });
		dashboard_event_loaded.dispatchEvent(client_event);


		ready_dashboard();
		//console.log(window.get_start_date, window.get_end_date, window.calStartDay, window.calEndDay)
		//get_active_date = new Date(date_start.value);
		setTimeout(function () {
			if (document.getElementById('area-date-events') !== elm) return;
			//console.log("page load snartElem event complete at 1000ms ");
			//getDates();
			//load_event_cal();
			makeCalendarTooltip();
		}, 1000)


	});


	waitForElmDel("#area-date-events").then((elm) => {
		//console.log("no longer on events overview")
	});



	waitForElm('#area-event-details').then((elm) => {
		markDataExplorerExited();

		console.log("on events detail")
		page_type = "details";


		var details_event_loaded = document.getElementById("details_event_loaded");
		__rendezvouz_setter.call(details_event_loaded, JSON.stringify(page_type));
		var client_event = new Event('input', { bubbles: true });
		details_event_loaded.dispatchEvent(client_event);


		ready_social();
		ready_details();
		ready_swanbot();
		//startTimer();

	});

	waitForElmDel("#area-event-details").then((elm) => {
		//console.log("no longer on events details")
	});


	waitForElm('#area-digest').then((elm) => {
		markDataExplorerExited();

		//console.log("on events digest")
		page_type = "digest";


		ready_digest();

	});

	waitForElmDel("#area-digest").then((elm) => {
		//console.log("no longer on digest")
	});


	waitForElm('#area-cache').then((elm) => {
		markDataExplorerExited();

		//console.log("on cache management")
		page_type = "cache";

	});


	waitForElmDel("#area-cache").then((elm) => {
		//console.log("no longer on cache")
	});




	waitForElm('#area-event-limbo').then((elm) => {
		markDataExplorerExited();
		//console.log("on limbo")
		result = "ok";

		//make_limbo();

	});

	waitForElmDel("#area-event-limbo").then((elm) => {
		//console.log("no longer on limbo")
	});


	waitForElm('#area-explore').then((elm) => {
		markDataExplorerExited();

		console.log("on explore")
		page_type = "explore";

		var explore_loaded = document.getElementById("explore_loaded");
		__rendezvouz_setter.call(explore_loaded, JSON.stringify(page_type));
		var client_event = new Event('input', { bubbles: true });
		explore_loaded.dispatchEvent(client_event);


		setTimeout(make_selected_filters, 1300);

		setTimeout(function () {
			makeCalendarTooltip();
		}, 1000)

		ready_explore();

	});

	waitForElmDel("#area-explore").then((elm) => {
		//console.log("no longer on explore")
	});



	waitForElm('#area-dataexplorer-events').then((elm) => {

		console.log("on dataexplorer overview")

		page_type = "dataexplorer";

		var dataexplorer_event_loaded = document.getElementById("dataexplorer_event_loaded");

		let updateDataExplorerTimezoneLinkLabel = function (tz) {
			let timezoneLinkEl = document.getElementById('dataexplorer_timezone-picker-link');
			if (!timezoneLinkEl) return;

			let resolvedTimezone = (tz || '').trim();
			let resolvedTimezoneShort = '';
			if (!resolvedTimezone) {
				let hiddenTimezoneInput = document.getElementById('timezone_dataexplorer_selected');
				if (hiddenTimezoneInput && hiddenTimezoneInput.value) {
					resolvedTimezone = String(hiddenTimezoneInput.value).trim();
				}
			}

			let hiddenTimezoneShortInput = document.getElementById('timezone_short_dataexplorer_selected');
			if (hiddenTimezoneShortInput && hiddenTimezoneShortInput.value) {
				resolvedTimezoneShort = String(hiddenTimezoneShortInput.value).trim();
			}

			if (!resolvedTimezone) {
				try {
					let storeRaw = window.localStorage.getItem('timezone_dataexplorer_store');
					if (storeRaw) {
						let parsedStore = JSON.parse(storeRaw);
						if (parsedStore && typeof parsedStore === 'object') {
							resolvedTimezone = String(parsedStore.timezone || (parsedStore.data && parsedStore.data.timezone) || '').trim();
						}
					}
				} catch (e) {
					console.log('DataExplorer timezone link label: unable to parse timezone store', e);
				}
			}

			if ((!resolvedTimezoneShort || resolvedTimezoneShort.toUpperCase() === 'UTC') && resolvedTimezone && window.moment && window.moment.tz && window.moment.tz.zone(resolvedTimezone)) {
				resolvedTimezoneShort = window.moment.tz(resolvedTimezone).format('z') || resolvedTimezoneShort;
			}

			resolvedTimezone = resolvedTimezone || 'UTC';
			if (resolvedTimezoneShort && resolvedTimezoneShort !== resolvedTimezone) {
				timezoneLinkEl.textContent = resolvedTimezone + ' (' + resolvedTimezoneShort + ')';
			} else {
				timezoneLinkEl.textContent = resolvedTimezone;
			}
		};

		updateDataExplorerTimezoneLinkLabel();

		let resolveDataExplorerSelectedTimezone = function (tzOverride) {
			let resolvedTimezone = (tzOverride || '').trim();
			if (!resolvedTimezone) {
				let hiddenTimezoneInput = document.getElementById('timezone_dataexplorer_selected');
				if (hiddenTimezoneInput && hiddenTimezoneInput.value) {
					resolvedTimezone = String(hiddenTimezoneInput.value).trim();
				}
			}

			if (!resolvedTimezone) {
				try {
					let storeRaw = window.localStorage.getItem('timezone_dataexplorer_store');
					if (storeRaw) {
						let parsedStore = JSON.parse(storeRaw);
						if (parsedStore && typeof parsedStore === 'object') {
							resolvedTimezone = String(parsedStore.timezone || (parsedStore.data && parsedStore.data.timezone) || '').trim();
						}
					}
				} catch (e) {
					console.log('DataExplorer latest-available label: unable to parse timezone store', e);
				}
			}

			return resolvedTimezone || 'UTC';
		};

		let resolveDataExplorerLatestAvailableUtc = function (fallbackValue) {
			let latestAvailableSourceEl = document.getElementById('dataexplorer_latest_available_utc');
			if (latestAvailableSourceEl) {
				let latestAvailableValue = String(latestAvailableSourceEl.textContent || '').trim();
				if (latestAvailableValue) {
					return latestAvailableValue;
				}
			}

			let dateEndEl = document.getElementById('date_end');
			if (dateEndEl && dateEndEl.value) {
				return String(dateEndEl.value).trim();
			}

			return fallbackValue || '';
		};

		window.getDataExplorerLatestAvailableLabel = function (maxDateUtcStr, tz) {
			if (!maxDateUtcStr) return '';

			let baseUtcLabel = 'Latest data up to ' + maxDateUtcStr + ' UTC';
			let resolvedTimezone = resolveDataExplorerSelectedTimezone(tz);

			if (!resolvedTimezone || resolvedTimezone.toUpperCase() === 'UTC') {
				return baseUtcLabel;
			}

			if (window.moment && window.moment.tz && window.moment.tz.zone(resolvedTimezone)) {
				let cleaned = String(maxDateUtcStr).trim().replace('T', ' ');
				let m = window.moment.utc(cleaned, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
				if (!m.isValid()) {
					m = window.moment.utc(cleaned);
				}
				if (m.isValid()) {
					let localMoment = m.tz(resolvedTimezone);
					let localLabel = localMoment.format('YYYY-MM-DD HH:mm:ss');
					let localShort = localMoment.format('z') || resolvedTimezone;
					return baseUtcLabel + ' / ' + localLabel + ' ' + localShort;
				}
			}

			return baseUtcLabel;
		};

		window.renderDataExplorerLatestAvailableLabels = function (maxDateUtcStr, tz) {
			let latestAvailableUtc = resolveDataExplorerLatestAvailableUtc(maxDateUtcStr);
			let latestAvailableLabel = window.getDataExplorerLatestAvailableLabel(latestAvailableUtc, tz);

			let idpUpToUtcEl = document.getElementById('idp-up-to-utc');
			if (idpUpToUtcEl) {
				idpUpToUtcEl.textContent = latestAvailableLabel;
			}

			let inlineLatestAvailableEl = document.getElementById('dataexplorer_latest_available_jsfe');
			if (inlineLatestAvailableEl) {
				inlineLatestAvailableEl.textContent = latestAvailableLabel;
			}
		};

		window.renderDataExplorerLatestAvailableLabels();
		let timezoneSelectedElForLink = document.getElementById('timezone_dataexplorer_selected');
		if (timezoneSelectedElForLink && !timezoneSelectedElForLink.dataset.linkSyncBound) {
			timezoneSelectedElForLink.dataset.linkSyncBound = 'true';
			timezoneSelectedElForLink.addEventListener('input', function () {
				updateDataExplorerTimezoneLinkLabel(this.value || '');
				window.renderDataExplorerLatestAvailableLabels(resolveDataExplorerLatestAvailableUtc(), this.value || '');
			});
		}

		let latestAvailableSourceEl = document.getElementById('dataexplorer_latest_available_utc');
		if (latestAvailableSourceEl && !latestAvailableSourceEl.dataset.latestAvailableSyncBound) {
			latestAvailableSourceEl.dataset.latestAvailableSyncBound = 'true';
			let latestAvailableObserver = new MutationObserver(function () {
				let latestAvailableUtc = resolveDataExplorerLatestAvailableUtc();
				window.renderDataExplorerLatestAvailableLabels(latestAvailableUtc);
				if (typeof window.updateDataExplorerModalLatestAvailable === 'function') {
					window.updateDataExplorerModalLatestAvailable(latestAvailableUtc);
				}
			});
			latestAvailableObserver.observe(latestAvailableSourceEl, {
				childList: true,
				characterData: true,
				subtree: true
			});
		}





		// Initial Visit Gate
		window.invoke_dataexplorer_calendar_modal = function(isInitial = false) {
			window.swanbot_dataexplorer_blocked = true;

			let isValidTimezone = function(tz) {
				if (!tz || typeof tz !== 'string') return false;
				if (window.moment && window.moment.tz) {
					return !!window.moment.tz.zone(tz);
				}
				return tz === 'UTC';
			};

			let timezoneSelectedEl = document.getElementById('timezone_dataexplorer_selected');
			let timezoneShortSelectedEl = document.getElementById('timezone_short_dataexplorer_selected');
			let dataExplorerIsAdminEl = document.getElementById('dataexplorer_is_admin');
			let allowAnyDateEl = document.getElementById('dataexplorer_allow_any_date');
			let selectedTimezone = timezoneSelectedEl && timezoneSelectedEl.value ? timezoneSelectedEl.value : 'UTC';
			let selectedTimezoneShort = timezoneShortSelectedEl && timezoneShortSelectedEl.value ? timezoneShortSelectedEl.value : '';
			const dataExplorerIsAdmin = !!(dataExplorerIsAdminEl && String(dataExplorerIsAdminEl.value).toLowerCase() === 'true');
			const allowAnyDate = !!(allowAnyDateEl && String(allowAnyDateEl.value).toLowerCase() === 'true');
			const hasCalledDataExplorerSwanbot = !!(window.WingmanState && window.WingmanState.swanbot_url_called);
			if ((!selectedTimezone || selectedTimezone === '') && timezoneShortSelectedEl && timezoneShortSelectedEl.value) {
				selectedTimezone = timezoneShortSelectedEl.value;
			}

			// If hidden input is stale/default UTC, try persisted store and dropdown-rendered values.
			if (!isValidTimezone(selectedTimezone) || selectedTimezone.toUpperCase() === 'UTC') {
				let timezoneStoreValue = '';
				try {
					let userPreference = window.localStorage.getItem('timezone_dataexplorer_user_preference');
					if (userPreference && isValidTimezone(userPreference)) {
					    timezoneStoreValue = userPreference;
					} else {
						let storeRaw = window.localStorage.getItem('timezone_dataexplorer_store');
						if (storeRaw) {
							let storeParsed = JSON.parse(storeRaw);
							if (storeParsed && typeof storeParsed === 'object') {
								timezoneStoreValue = (storeParsed.timezone || (storeParsed.data && storeParsed.data.timezone) || '').trim();
							}
						}
					}
				} catch (e) {
					console.log('Mobiscroll DataExplorer - failed to parse timezone_dataexplorer_store:', e);
				}

				let timezoneDropdownLabelEl = document.querySelector('#timezone_options_select .Select-value-label')
					|| document.querySelector('#timezone_options_select [class*="singleValue"]');
				let timezoneDropdownHiddenEl = document.querySelector('#timezone_options_select input[type="hidden"]');
				let timezoneDropdownValue = timezoneDropdownHiddenEl && timezoneDropdownHiddenEl.value
					? timezoneDropdownHiddenEl.value.trim()
					: (timezoneDropdownLabelEl ? (timezoneDropdownLabelEl.textContent || '').trim() : '');

				if (isValidTimezone(timezoneStoreValue)) {
					selectedTimezone = timezoneStoreValue;
				} else if (isValidTimezone(timezoneDropdownValue)) {
					selectedTimezone = timezoneDropdownValue;
				}
			}

			if (!isValidTimezone(selectedTimezone)) {
				selectedTimezone = 'UTC';
			}
			let lastHourlyTimezoneSelection = selectedTimezone;
			let savedPeriodModePreference = '';
			try {
				savedPeriodModePreference = window.sessionStorage.getItem('dataexplorer_period_mode_v1') || window.swanbot_dataexplorer_period_mode_preference || '';
			} catch (e) {
				console.log('Could not read DataExplorer period mode preference:', e);
				savedPeriodModePreference = window.swanbot_dataexplorer_period_mode_preference || '';
			}
			if (savedPeriodModePreference !== 'day' && savedPeriodModePreference !== 'hour') {
				savedPeriodModePreference = '';
			}

			const forcedDailyOnlyLock = window.swanbot_dataexplorer_lock_period_selection === true || (document.getElementById("dataexplorer_daily_only") && String(document.getElementById("dataexplorer_daily_only").value).toLowerCase() === "true");
			const isDailyOnlyLocked = window.swanbot_dataexplorer_filter_period === "day" || forcedDailyOnlyLock;
			const shouldStartInDailyMode = isDailyOnlyLocked || savedPeriodModePreference === 'day';
			if (shouldStartInDailyMode) {
				selectedTimezone = 'UTC';
				selectedTimezoneShort = 'UTC';
			}
			updateDataExplorerTimezoneLinkLabel(selectedTimezone);
			if ((!selectedTimezoneShort || selectedTimezoneShort.toUpperCase() === 'UTC') && window.moment && window.moment.tz && window.moment.tz.zone(selectedTimezone)) {
				selectedTimezoneShort = window.moment.tz(selectedTimezone).format('z') || selectedTimezoneShort;
			}
			let selectedTimezoneLabel = selectedTimezoneShort && selectedTimezoneShort.trim() !== '' ? selectedTimezoneShort : selectedTimezone;

			let parseBackendDateToTimezoneDate = function(dateStr, tz) {
				if (!dateStr) return null;
				let cleaned = String(dateStr).trim().replace('T', ' ');
				if (window.moment && window.moment.tz) {
					let m = window.moment.utc(cleaned, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
					if (!m.isValid()) {
						m = window.moment.utc(cleaned);
					}
					if (m.isValid()) {
						return m.tz(tz).toDate();
					}
				}
				return new Date(cleaned.replace(' ', 'T'));
			};

			// Build a local Date whose visible wall-clock values match the selected timezone.
			// This keeps Mobiscroll's calendar/timegrid aligned with the selected timezone,
			// even when the browser local timezone is different.
			let parseBackendDateToPickerWallDate = function(dateStr, tz) {
				if (!dateStr) return null;
				let cleaned = String(dateStr).trim().replace('T', ' ');
				if (window.moment && window.moment.tz) {
					let m = window.moment.utc(cleaned, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
					if (!m.isValid()) {
						m = window.moment.utc(cleaned);
					}
					if (m.isValid()) {
						let tzMoment = m.tz(tz);
						return new Date(
							tzMoment.year(),
							tzMoment.month(),
							tzMoment.date(),
							tzMoment.hour(),
							tzMoment.minute(),
							tzMoment.second(),
							0
						);
					}
				}

				let fallback = parseBackendDateToTimezoneDate(cleaned, tz);
				if (!fallback || Number.isNaN(fallback.getTime())) return null;
				return new Date(
					fallback.getFullYear(),
					fallback.getMonth(),
					fallback.getDate(),
					fallback.getHours(),
					fallback.getMinutes(),
					fallback.getSeconds(),
					0
				);
			};

			let parseSavedWallDateToPickerWallDate = function(dateStr, tz) {
				if (!dateStr) return null;
				let cleaned = String(dateStr).trim().replace('T', ' ');

				if (window.moment && window.moment.tz) {
					let m = window.moment.tz(cleaned, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true, tz);
					if (!m.isValid()) {
						m = window.moment.tz(cleaned, tz);
					}
					if (m.isValid()) {
						return new Date(
							m.year(),
							m.month(),
							m.date(),
							m.hour(),
							m.minute(),
							m.second(),
							0
						);
					}
				}

				let fallback = new Date(cleaned.replace(' ', 'T'));
				if (!fallback || Number.isNaN(fallback.getTime())) return null;
				return new Date(
					fallback.getFullYear(),
					fallback.getMonth(),
					fallback.getDate(),
					fallback.getHours(),
					fallback.getMinutes(),
					fallback.getSeconds(),
					0
				);
			};

			let normalizePickerDayEnd = function(dateObj) {
				if (!dateObj || Number.isNaN(dateObj.getTime())) return null;
				let normalized = new Date(dateObj.getTime());
				normalized.setHours(23, 0, 0, 0);
				return normalized;
			};

			let isSameCalendarDay = function(d1, d2) {
				if (!d1 || !d2) return false;
				return d1.getFullYear() === d2.getFullYear() &&
					d1.getMonth() === d2.getMonth() &&
					d1.getDate() === d2.getDate();
			};

			let getSelectableEndForDay = function(dayDate, latestAvailableDate) {
				if (!dayDate || Number.isNaN(dayDate.getTime())) return null;
				if (latestAvailableDate && !Number.isNaN(latestAvailableDate.getTime()) && isSameCalendarDay(dayDate, latestAvailableDate)) {
					return new Date(latestAvailableDate.getTime());
				}
				return normalizePickerDayEnd(dayDate);
			};

			let formatDateForTimezone = function(dateObj, tz, withTime) {
				if (window.moment && window.moment.tz) {
					let m = window.moment.tz({
						year: dateObj.getFullYear(),
						month: dateObj.getMonth(),
						day: dateObj.getDate(),
						hour: dateObj.getHours(),
						minute: dateObj.getMinutes(),
						second: dateObj.getSeconds()
					}, tz);
					return withTime ? m.format('YYYY-MM-DD HH:mm:ss') : m.format('YYYY-MM-DD');
				}
				let y = dateObj.getFullYear();
				let mm = String(dateObj.getMonth() + 1).padStart(2, '0');
				let dd = String(dateObj.getDate()).padStart(2, '0');
				if (!withTime) return y + '-' + mm + '-' + dd;
				let hh = String(dateObj.getHours()).padStart(2, '0');
				let mi = String(dateObj.getMinutes()).padStart(2, '0');
				let ss = String(dateObj.getSeconds()).padStart(2, '0');
				return y + '-' + mm + '-' + dd + ' ' + hh + ':' + mi + ':' + ss;
			};

			let formatPickerWallDateToUtcString = function(dateObj, tz) {
				if (!dateObj) return '';
				if (window.moment && window.moment.tz) {
					let m = window.moment.tz({
						year: dateObj.getFullYear(),
						month: dateObj.getMonth(),
						day: dateObj.getDate(),
						hour: dateObj.getHours(),
						minute: dateObj.getMinutes(),
						second: dateObj.getSeconds()
					}, tz);
					if (m.isValid()) {
						return m.utc().format('YYYY-MM-DD HH:mm:ss');
					}
				}

				let yyyy = dateObj.getFullYear();
				let mm = String(dateObj.getMonth() + 1).padStart(2, '0');
				let dd = String(dateObj.getDate()).padStart(2, '0');
				let hh = String(dateObj.getHours()).padStart(2, '0');
				let mi = String(dateObj.getMinutes()).padStart(2, '0');
				let ss = String(dateObj.getSeconds()).padStart(2, '0');
				return yyyy + '-' + mm + '-' + dd + ' ' + hh + ':' + mi + ':' + ss;
			};

			let getTimezoneShortLabel = function(tz) {
				if (window.moment && window.moment.tz && window.moment.tz.zone(tz)) {
					return window.moment.tz(tz).format('z') || '';
				}
				return '';
			};

			let updateLatestAvailableLabels = function(maxDateUtcStr, tz) {
				window.renderDataExplorerLatestAvailableLabels(maxDateUtcStr, tz);
			};

			let activeCustomerId = 'global';
			try {
				let customerInput = document.getElementById('customer_id');
				if (customerInput && customerInput.value) {
					activeCustomerId = String(customerInput.value).trim();
				}
			} catch (e) {
				console.log('Could not resolve active customer_id for DataExplorer keys:', e);
			}

			const dataExplorerMaxAvailableKey = 'dataexplorer_max_available_utc_v1:' + activeCustomerId;
			let toComparableUtcTs = function(dateStr) {
				if (!dateStr) return null;
				let cleaned = String(dateStr).trim().replace('T', ' ');
				if (window.moment && window.moment.utc) {
					let m = window.moment.utc(cleaned, ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', 'YYYY-MM-DD'], true);
					if (!m.isValid()) m = window.moment.utc(cleaned);
					if (m.isValid()) return m.valueOf();
				}
				let dt = new Date(cleaned.replace(' ', 'T') + 'Z');
				let ts = dt.getTime();
				return Number.isNaN(ts) ? null : ts;
			};

			// Get max available date. Keep a per-customer ceiling so user selections do not shrink future max.
			let dateEndEl = document.getElementById('date_end');
			let backendMaxDateStr = resolveDataExplorerLatestAvailableUtc(dateEndEl ? dateEndEl.value : null);
			let storedMaxDateStr = null;
			try {
				storedMaxDateStr = window.sessionStorage.getItem(dataExplorerMaxAvailableKey);
			} catch (e) {
				console.log('Could not read DataExplorer max-available cache:', e);
			}

			let maxDateStr = backendMaxDateStr;
			let backendTs = toComparableUtcTs(backendMaxDateStr);
			let storedTs = toComparableUtcTs(storedMaxDateStr);
			if (storedTs !== null && (backendTs === null || storedTs > backendTs)) {
				maxDateStr = storedMaxDateStr;
			}

			if (maxDateStr) {
				try {
					window.sessionStorage.setItem(dataExplorerMaxAvailableKey, maxDateStr);
				} catch (e) {
					console.log('Could not persist DataExplorer max-available cache:', e);
				}
			}
			let latestAvailableDateObj = maxDateStr ? parseBackendDateToPickerWallDate(maxDateStr, selectedTimezone) : new Date();
			let maxDateObj = getSelectableEndForDay(latestAvailableDateObj, latestAvailableDateObj) || normalizePickerDayEnd(new Date()) || new Date();

			let dateMinEl = document.getElementById('date_min');
			let minDateStr = dateMinEl ? dateMinEl.value : null;
			let minDateObj = minDateStr ? parseBackendDateToPickerWallDate(minDateStr, selectedTimezone) : null;

			// Generate an ID for the container
			let popupId = "initial-dataexplorer-calendar-popup";
			let existing = document.getElementById(popupId);
			if (existing) existing.remove();

			const modalTimezoneOptions = [
				"UTC",
				"America/New_York",
				"America/Chicago",
				"America/Denver",
				"America/Los_Angeles",
				"Pacific/Honolulu",
				"America/Anchorage"
			];
			const modalTimezoneOptionsHtml = modalTimezoneOptions
				.map(function (tzName) {
					const selectedAttr = tzName === selectedTimezone ? ' selected' : '';
					return '<option value="' + tzName + '"' + selectedAttr + '>' + tzName + '</option>';
				})
				.join('');

			let popupDiv = document.createElement("div");
			popupDiv.id = popupId;
			popupDiv.innerHTML = `
				<style>
					.wide-mobiscroll-popup .mbsc-popup {
						max-width: 95vw !important;
						width: 1050px !important;
						height: auto !important;
						max-height: none !important;
						overflow: visible !important;
					}
					.wide-mobiscroll-popup .mbsc-popup-content {
						overflow: visible !important;
						max-height: none !important;
					}
					.wide-mobiscroll-popup .mbsc-popup-wrapper {
						overflow-y: auto !important;
					}
					.wide-mobiscroll-popup .mbsc-datepicker-tab-wrapper {
						justify-content: flex-start !important;
						width: 100% !important;
						max-width: 100% !important;
					}
					.wide-mobiscroll-popup .mbsc-datepicker-tab-calendar {
						display: block !important;
						width: 66% !important; min-width: 620px !important;
						box-sizing: border-box !important;
					}
					.wide-mobiscroll-popup .mbsc-datepicker-tab-timegrid {
						position: absolute !important;
						top: 0 !important;
						right: 0 !important;
						bottom: 0 !important;
						display: flex !important;
						flex-direction: column;
						width: 34% !important;
						box-sizing: border-box !important;
						overflow-y: auto !important;
						overflow-x: hidden !important;
						height: 100% !important;
						touch-action: auto !important;
					}
					.custom-timegrid-header {
						position: sticky;
						top: 0;
						background-color: var(--mbsc-bg, #fff);
						z-index: 20;
						text-align: center;
						padding: 10px 0;
						font-weight: 600;
						font-size: 14px;
						color: var(--mbsc-text, #333);
						border-bottom: 1px solid var(--mbsc-divider, #ccc);
						flex-shrink: 0;
						width: 100%;
						box-sizing: border-box;
					}
					.wide-mobiscroll-popup .mbsc-timegrid-row {
						display: block !important;
					}
					.wide-mobiscroll-popup .mbsc-timegrid-cell {
						width: 100% !important;
						max-width: 100% !important;
						flex: 0 0 100% !important;
						display: block !important;
						text-align: center;
					}
					.wide-mobiscroll-popup .mbsc-timegrid-container {
						flex: 1 1 auto;
						overflow-y: auto !important;
						height: 100% !important;
						touch-action: auto !important;
					}
					.wide-mobiscroll-popup .mbsc-scrollview-scroll:has(> .mbsc-datepicker-tab-calendar) {
						display: block !important;
						position: relative !important;
						transform: none !important;
						width: 100% !important;
					}
					.wide-mobiscroll-popup .mbsc-datepicker-tabs {
						display: none !important;
					}
                                        .wide-mobiscroll-popup .mbsc-calendar-controls {
                                                display: flex !important;
                                        }

                                        .wide-mobiscroll-popup .mbsc-calendar-slide {
                                                width: 50% !important;
                                                max-width: 50% !important;
                                        }

										.wide-mobiscroll-popup .mbsc-range-day-start .mbsc-calendar-day-text,
										.wide-mobiscroll-popup .mbsc-range-day-start .mbsc-calendar-cell-text {
											background-color: #28a745 !important;
											border-color: #28a745 !important;
											color: #fff !important;
										}

				.mbsc-material.mbsc-range-control-wrapper .mbsc-material.mbsc-segmented-button.mbsc-selected { background-color: #eef6ff !important; }
</style>
				<div class="mbsc-form-group" style="min-width: 880px; max-width: 95vw; margin-top: 0; padding-top: 0; position: relative;">
					<div style="position: sticky; top: 0; z-index: 100; background: #fff; padding-top: 10px;">
						<div style="display: flex; justify-content: space-between; align-items: center; padding-right: 15px;">
							<div class="mbsc-form-group-title" style="margin-top: 0; padding-top: 0; display: block; margin-bottom: 0; font-size:20px">Select Data Explorer Date Range</div>
							<button id="idp-close-btn" style="background: none; border: none; font-size: 24px; font-weight: bold; cursor: pointer; color: #666; line-height: 1; padding: 0;">&times;</button>
						</div>
						<div id="idp-quick-ranges-and-settings" class="mbsc-padding" style="display: flex; justify-content: space-between; align-items: center; gap: 10px; flex-wrap: wrap; padding-left: 0 !important; padding-bottom: 10px !important; padding-top: 0px !important; margin-top: 0px !important;">
							<div id="idp-quick-ranges" style="display: flex; gap: 10px; flex-wrap: wrap;"></div>
							
							<div id="idp-period-toggle" style="display: flex; align-items: center;">
								<style>
									.custom-pill-toggle { position: relative; display: inline-flex; background-color: #1a73e8; border-radius: 50px; padding: 4px; cursor: pointer; width: 160px; box-shadow: inset 0 2px 4px rgba(0,0,0,0.1); margin: 0; }
									.custom-pill-toggle.custom-pill-toggle-disabled { background-color: #94a3b8; cursor: not-allowed; box-shadow: inset 0 1px 2px rgba(0,0,0,0.08); }
									.custom-pill-toggle input { display: none; }
									.custom-pill-toggle .pill-slider { position: absolute; top: 4px; left: 4px; width: 76px; bottom: 4px; background-color: #fff; border-radius: 50px; transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1); box-shadow: 0 1px 3px rgba(0,0,0,0.15); z-index: 1; }
									.custom-pill-toggle input:checked ~ .pill-slider { transform: translateX(76px); }
									.custom-pill-toggle .pill-option { flex: 1; position: relative; z-index: 2; text-align: center; font-size: 13px; font-weight: 600; color: #fff; padding: 4px 0; user-select: none; transition: color 0.3s; }
									.custom-pill-toggle input:not(:checked) ~ .opt-hourly { color: #1a73e8; }
									.custom-pill-toggle input:checked ~ .opt-daily { color: #1a73e8; }
									.custom-pill-toggle.custom-pill-toggle-disabled .pill-option { color: rgba(255,255,255,0.85); }
									.custom-pill-toggle.custom-pill-toggle-disabled input:checked ~ .opt-daily { color: #64748b; }
									.custom-pill-toggle.custom-pill-toggle-disabled input:not(:checked) ~ .opt-hourly { color: #64748b; }
								</style>
								<label class="custom-pill-toggle ${forcedDailyOnlyLock ? 'custom-pill-toggle-disabled' : ''}" ${forcedDailyOnlyLock ? 'title="Daily mode is locked for this customer."' : ''}>
									<input type="checkbox" id="idp-period-switch" ${forcedDailyOnlyLock ? 'disabled' : ''}>
									<div class="pill-slider"></div>
									<div class="pill-option opt-hourly">Hourly</div>
									<div class="pill-option opt-daily">Daily</div>
								</label>
							</div>
							<div id="idp-timezone-container" style="display: flex; align-items: center; gap: 8px;">
								<label for="idp-timezone-select" style="font-size: 12px; color: #666; margin: 0;">Timezone</label>
								<select id="idp-timezone-select" style="min-width: 210px;" class="form-select form-select-sm">${modalTimezoneOptionsHtml}</select>
							</div>
						</div>
					</div>
					<div id="initial-modal-datepicker"></div>
					<div class="mbsc-padding" style="display: flex; gap: 15px; align-items: center; font-size: 12px; color: #666; margin-top: 5px;">
						<span style="display: flex; align-items: center; gap: 5px;">
							<span style="width: 8px; height: 8px; border-radius: 50%; background-color: #28a745; display: inline-block;"></span>
							Complete Data
						</span>
						<span style="display: flex; align-items: center; gap: 5px;">
							<span style="width: 8px; height: 8px; border-radius: 50%; background-color: #ffc107; display: inline-block;"></span>
							Partial Data
						</span>
						<span id="idp-dst-legend" style="display: none; align-items: center; gap: 12px;"></span>
					</div>
					<div id="idp-processing-warning" class="mbsc-padding" style="display: none; margin-top: 8px; font-size: 12px; font-weight: 600; padding-top: 10px !important; padding-bottom: 8px !important; background-color: #fff7bf; border-left: 10px solid #ffd700; text-align: left;">
						Large date ranges take a little extra time to load.
					</div>
					${allow_daterange_debug ? '<div id="idp-range-debug" class="mbsc-padding" style="margin-top: 8px; font-size: 12px; padding-top: 10px !important; padding-bottom: 10px !important; background-color: #f5f7fb; border-left: 10px solid #9fb3d9; text-align: left; color: #334155;"></div>' : ''}
					<div class="mbsc-padding" style="display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #ccc; padding-top: 15px; margin-top: 10px;">
						<div>
							<div style="font-size: 12px; color: #777; margin-bottom: 4px;">Selected Range:</div>
							<div id="idp-summary" style="font-weight: 600; font-size: 14px; color: #555;">No range selected</div>
							<div id="idp-up-to-utc" style="font-size: 12px; color: #777; margin-top: 4px;"></div>
						</div>
					    <button id="idp-apply" class="btn btn-primary" style="min-width:120px;" disabled>Load Data Explorer</button>
					</div>
				</div>
			`;
			document.body.appendChild(popupDiv);

			updateLatestAvailableLabels(maxDateStr, selectedTimezone);

			const dataExplorerLoadedSessionKey = 'dataexplorer_loaded_this_session_v1:' + activeCustomerId;
			const dataExplorerSavedRangeKey = 'dataexplorer_saved_date_v1';
			let modalOpenCountThisRefresh = Number(window.swanbot_dataexplorer_modal_open_count_this_refresh || 0);
			let hasLoadedDataExplorerInSession = function () {
				try {
					let loadedFlag = window.sessionStorage.getItem(dataExplorerLoadedSessionKey) === 'true';
					let hasSavedRange = !!window.localStorage.getItem(dataExplorerSavedRangeKey);
					return loadedFlag && hasSavedRange;
				} catch (e) {
					console.log('DataExplorer session check failed:', e);
					return false;
				}
			};

			let formatDebugDateTime = function (dateObj) {
				if (!dateObj || Number.isNaN(dateObj.getTime())) {
					return 'n/a';
				}

				return formatDateForTimezone(dateObj, selectedTimezone, true) + ' ' + (selectedTimezoneLabel || selectedTimezone || 'UTC');
			};
			let setRangeDecisionDebug = function () {};
			let pushRangeDecisionDebug = function () {};
			let renderRangeDecisionDebug = function () {};

			if (allow_daterange_debug === true) {
				({
					formatDebugDateTime,
					setRangeDecisionDebug,
					pushRangeDecisionDebug,
					renderRangeDecisionDebug
				} = debug_dataexplorer_dates({
					selectedTimezone: selectedTimezone,
					selectedTimezoneLabel: selectedTimezoneLabel,
					formatDateForTimezone: formatDateForTimezone,
					hasCalledDataExplorerSwanbot: hasCalledDataExplorerSwanbot,
					dataExplorerLoadedSessionKey: dataExplorerLoadedSessionKey,
					dataExplorerSavedRangeKey: dataExplorerSavedRangeKey,
					dataExplorerMaxAvailableKey: dataExplorerMaxAvailableKey,
					savedPeriodModePreference: savedPeriodModePreference,
					modalOpenCountThisRefresh: modalOpenCountThisRefresh,
					isDailyOnlyLocked: isDailyOnlyLocked,
					shouldStartInDailyMode: shouldStartInDailyMode,
					maxDateStr: maxDateStr,
					hasLoadedDataExplorerInSession: hasLoadedDataExplorerInSession
				}));
			}

			// Fix for mousewheel scrolling on the time grid 
			// Mobiscroll intercepts wheel events which breaks the native auto overflow.
			popupDiv.addEventListener('wheel', function(e) {
				if (e.target.closest('.mbsc-timegrid-container')) {
					e.stopPropagation();
				}
			}, { capture: true, passive: false });

			window.dataexplorer_zen = window.dataexplorer_zen || function() {
				console.log("zen");
                                let graphlocation = document.getElementById("graph-dataexplorer-details");
                                if (!graphlocation) return;

                                const numPoints = 120;
                                let windPointsHtml = '';
                                for (let i = 0; i < numPoints; i++) {
                                        windPointsHtml += `<div class="dataexplorer_zen_pixel"></div>`;
                                }

                                const containerHtml = `
                                    <div class="dataexplorer_zen_container" style="position:relative; width:100%; height:400px; background:linear-gradient(to bottom, #f8fafc, #f1f5f9); overflow:hidden; border-radius: 8px; display: flex; align-items: center; justify-content: center; border: 1px solid #e2e8f0;">
                                        <div style="z-index: 10; text-align: center; color: #cbd5e1; font-family: monospace; letter-spacing: 3px; user-select: none;">
                                            <div style="font-size: 24px; font-weight: 300;">ZEN MODE</div>
                                            <div style="font-size: 11px; margin-top: 8px; color: #94a3b8;">AWAITING DATA RANGE</div>
                                        </div>
                                        <div class="dataexplorer_zen_pixels" style="position: absolute; top:0; left:0; width:100%; height:100%; pointer-events:none;">
                                            ${windPointsHtml}
                                        </div>
                                    </div>
                                `;

                                graphlocation.innerHTML = containerHtml;

                                const zenPointsContainer = document.querySelector('.dataexplorer_zen_pixels');
                                const zenPoints = zenPointsContainer.querySelectorAll('.dataexplorer_zen_pixel');
                                
                                const colors = ['#e2e8f0', '#cbd5e1', '#94a3b8', '#38bdf8', '#7dd3fc'];

                                zenPoints.forEach((point) => {
                                        const size = Math.random() * 4 + 2; 
                                        point.style.position = 'absolute';
                                        point.style.width = size + 'px';
                                        point.style.height = size + 'px'; // square wind blown pixels
                                        point.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
                                        if (Math.random() > 0.8) {
                                                point.style.boxShadow = '0 0 4px ' + point.style.backgroundColor;
                                                point.style.borderRadius = '50%'; // mix some orbs in
                                        } else {
                                                point.style.borderRadius = '1px';
                                        }
                                        
                                        point.style.left = '-20px'; // start off screen
                                        
                                        // initial vertical position
                                        const startY = Math.random() * 100;
                                        point.style.top = startY + '%';
                                        
                                        // random duration for crossing the screen
                                        const duration = Math.random() * 3000 + 2000; 
                                        // compute target container width or fallback to 1000
                                        const endX = (zenPointsContainer.clientWidth > 0 ? zenPointsContainer.clientWidth : 1000) + 100;
                                        
                                        // slight vertical wave
                                        const waveY = (Math.random() * 80 - 40); 

                                        // apply web animation
                                        point.animate([
                                                { transform: `translate(0px, 0px)`, opacity: 0 },
                                                { opacity: Math.random() * 0.5 + 0.2, offset: 0.1 },
                                                { opacity: Math.random() * 0.5 + 0.2, offset: 0.9 },
                                                { transform: `translate(${endX}px, ${waveY}px)`, opacity: 0 }
                                        ], {
                                                duration: duration,
                                                delay: Math.random() * 5000, 
                                                iterations: Infinity,
                                                easing: 'ease-in-out'
                                        });
                                });
                        };
			const closeButton = document.getElementById('idp-close-btn');
			if (closeButton) {
				closeButton.addEventListener('click', function() {
					if (!hasCalledDataExplorerSwanbot) {
						window.location.href = '/';
						return;
					}

					initialPopup.close();
					return;
				});
			}

			// Init Mobiscroll Popup
			var initialPopup = mobiscroll.popup('#' + popupId, {
				display: 'center',
				cssClass: 'mbsc-no-padding wide-mobiscroll-popup',
				theme: 'material',
				themeVariant: 'light',
				buttons: [],
				touchUi: false,
				closeOnOverlayClick: false,
				onClose: function () {
					window.updateDataExplorerModalLatestAvailable = null;
					popupDiv.remove();
				}
			});

			let formatSummary = (d1, d2) => {
				if (!d1 || !d2) return "No range selected";
				let opts = { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };

				let diffMs = Math.max(0, d2.getTime() - d1.getTime());
				let totalHours = Math.floor(diffMs / (1000 * 60 * 60));
				let days = Math.floor(totalHours / 24);
				let hours = totalHours % 24;

				let durationParts = [];
				if (days > 0) {
					durationParts.push(days + ' day' + (days === 1 ? '' : 's'));
				}
				if (hours > 0 || durationParts.length === 0) {
					durationParts.push(hours + ' hour' + (hours === 1 ? '' : 's'));
				}

				return d1.toLocaleString(undefined, opts) + " " + selectedTimezoneLabel + " - " + d2.toLocaleString(undefined, opts) + " " + selectedTimezoneLabel + " (" + durationParts.join(' and ') + ")";
			};

			let updateRangeDisplayTimezoneLabels = () => {
				let selectors = [
					'#initial-modal-datepicker .mbsc-range-btn-start .mbsc-range-btn-value',
					'#initial-modal-datepicker .mbsc-range-btn-end .mbsc-range-btn-value',
					'#initial-modal-datepicker .mbsc-range-btn-start .mbsc-range-btn-text',
					'#initial-modal-datepicker .mbsc-range-btn-end .mbsc-range-btn-text',
					'#initial-modal-datepicker .mbsc-range-start .mbsc-range-btn-value',
					'#initial-modal-datepicker .mbsc-range-end .mbsc-range-btn-value',
					'#initial-modal-datepicker .mbsc-range-start .mbsc-range-btn-text',
					'#initial-modal-datepicker .mbsc-range-end .mbsc-range-btn-text',
					'#initial-modal-datepicker .mbsc-range-start .mbsc-button-text',
					'#initial-modal-datepicker .mbsc-range-end .mbsc-button-text',
					'#initial-modal-datepicker .mbsc-datepicker-tab-item-start .mbsc-button-text',
					'#initial-modal-datepicker .mbsc-datepicker-tab-item-end .mbsc-button-text'
				];

				selectors.forEach((selector) => {
					document.querySelectorAll(selector).forEach((el) => {
						let text = (el.textContent || '').trim();
						if (!text) return;
						if (!el.dataset.tzOriginalText) {
							el.dataset.tzOriginalText = text;
						}
						el.textContent = el.dataset.tzOriginalText + ' ' + selectedTimezoneLabel;
					});
				});
			};

			let updateDstLabelHoverText = () => {
				document.querySelectorAll('#initial-modal-datepicker .mbsc-calendar-label-text').forEach((el) => {
					let labelText = (el.textContent || '').trim().toLowerCase();
					if (labelText === 'spring forward') {
						el.setAttribute('title', 'Spring forward: this day loses one hour due to DST start.');
					}
					if (labelText === 'fall back') {
						el.setAttribute('title', 'Fall back: this day gains one hour due to DST end.');
					}
				});
			};

			let isSameDay = (d1, d2) => {
				return isSameCalendarDay(d1, d2);
			};

			let getDefaultEndDateForDay = (endDate) => {
				return getSelectableEndForDay(endDate, latestAvailableDateObj);
			};

			let clampEndDateToAvailability = (endDate) => {
				let clamped = new Date(endDate.getTime());
				if (allowAnyDate) {
					return clamped;
				}
				let maxSelectableEnd = getDefaultEndDateForDay(maxDateObj);
				if (clamped.getTime() > maxSelectableEnd.getTime()) {
					clamped = new Date(maxSelectableEnd.getTime());
				}
				return clamped;
			};

			let lastPickerRange = null;

			// Shift the initial view so the right-side calendar shows the max available month (e.g. March)
			// and the left-side calendar shows the previous month (e.g. February).
			let leftAlignDate = new Date(maxDateObj);
			leftAlignDate.setDate(1); // Set to the 1st to ensure safe month subtraction
			leftAlignDate.setMonth(leftAlignDate.getMonth() - 1);
			leftAlignDate.setHours(0, 0, 0, 0);

			let getDstTransitionDays = function(minDate, maxDate, tz) {
				let transitions = {};
				if (!(window.moment && window.moment.tz && window.moment.tz.zone(tz))) {
					return transitions;
				}

				let dayCursor = window.moment.tz({
					year: minDate.getFullYear(),
					month: minDate.getMonth(),
					day: minDate.getDate(),
					hour: 0,
					minute: 0,
					second: 0
				}, tz);

				let maxCursor = window.moment.tz({
					year: maxDate.getFullYear(),
					month: maxDate.getMonth(),
					day: maxDate.getDate(),
					hour: 0,
					minute: 0,
					second: 0
				}, tz);

				while (dayCursor.isSameOrBefore(maxCursor, 'day')) {
					let nextDay = dayCursor.clone().add(1, 'day');
					let currOffset = dayCursor.utcOffset();
					let nextOffset = nextDay.utcOffset();

					if (nextOffset !== currOffset) {
						let key = dayCursor.format('YYYY-MM-DD');
						transitions[key] = nextOffset > currOffset ? 'spring-forward' : 'fall-back';
					}

					dayCursor.add(1, 'day');
				}

				return transitions;
			};

			let dstTransitionsByDay = {};
			let dstCalendarLabels = [];
			let markedDates = [];

			let rebuildCalendarMarkers = function() {
				dstTransitionsByDay = (minDateObj && maxDateObj)
					? getDstTransitionDays(minDateObj, maxDateObj, selectedTimezone)
					: {};
				dstCalendarLabels = [];
				markedDates = [];

				if (!(minDateObj && maxDateObj)) {
					return;
				}

				let currDate = new Date(minDateObj);
				currDate.setHours(0, 0, 0, 0);
				let endDate = new Date(maxDateObj);
				endDate.setHours(23, 59, 59, 999);

				while (currDate <= endDate) {
					let isMinDay = (currDate.getFullYear() === minDateObj.getFullYear() && currDate.getMonth() === minDateObj.getMonth() && currDate.getDate() === minDateObj.getDate());
					let isMaxDay = (currDate.getFullYear() === maxDateObj.getFullYear() && currDate.getMonth() === maxDateObj.getMonth() && currDate.getDate() === maxDateObj.getDate());

					let isPartialMin = isMinDay && (minDateObj.getHours() > 0 || minDateObj.getMinutes() > 0);
					let isPartialMax = isMaxDay && latestAvailableDateObj && (latestAvailableDateObj.getHours() < 23 || (latestAvailableDateObj.getHours() === 23 && latestAvailableDateObj.getMinutes() < 59));
					let currKey = currDate.getFullYear() + '-' + String(currDate.getMonth() + 1).padStart(2, '0') + '-' + String(currDate.getDate()).padStart(2, '0');
					let dstType = dstTransitionsByDay[currKey] || null;

					let dotColor = '#28a745'; // green
					if (isPartialMin || isPartialMax) {
						dotColor = '#ffc107'; // yellow
					}
					markedDates.push({ date: new Date(currDate), color: dotColor });

					if (dstType === 'spring-forward') {
						dstCalendarLabels.push({
							date: new Date(currDate),
							text: 'Spring forward',
							color: '#0d6efd'
						});
						markedDates.push({ date: new Date(currDate), color: '#0d6efd' });
					}
					if (dstType === 'fall-back') {
						dstCalendarLabels.push({
							date: new Date(currDate),
							text: 'Fall back',
							color: '#fd7e14'
						});
						markedDates.push({ date: new Date(currDate), color: '#fd7e14' });
					}

					currDate.setDate(currDate.getDate() + 1);
				}
			};

			rebuildCalendarMarkers();

			let idpDstLegendEl = document.getElementById('idp-dst-legend');
			if (idpDstLegendEl) {
				let hasSpring = dstCalendarLabels.some(l => l.text === 'Spring forward');
				let hasFall = dstCalendarLabels.some(l => l.text === 'Fall back');
				let legendHtml = '';
				if (hasSpring) {
					legendHtml += `<span style="display: flex; align-items: center; gap: 5px;"><span style="width: 8px; height: 8px; border-radius: 50%; background-color: #0d6efd; display: inline-block;"></span>Spring forward</span>`;
				}
				if (hasFall) {
					legendHtml += `<span style="display: flex; align-items: center; gap: 5px;"><span style="width: 8px; height: 8px; border-radius: 50%; background-color: #fd7e14; display: inline-block;"></span>Fall back</span>`;
				}
				
				if (legendHtml) {
					idpDstLegendEl.innerHTML = legendHtml;
					idpDstLegendEl.style.display = 'flex';
				} else {
					idpDstLegendEl.innerHTML = '';
					idpDstLegendEl.style.display = 'none';
				}
			}

			console.log("Mobiscroll DataExplorer - initializing datepicker with:", {
				minDateObj: minDateObj,
				latestAvailableDateObj: latestAvailableDateObj,
				maxDateObj: maxDateObj,
				leftAlignDate: leftAlignDate,
				selectedTimezone: selectedTimezone
			});
			
			window.WINGMAN_MAX_HOURLY_DAYS = 15;
			window.WINGMAN_MAX_HOURLY_DAYS_NORMAL = 31;

						const maxRangeDays = shouldStartInDailyMode ? window.WINGMAN_MAX_HOURLY_DAYS_NORMAL : window.WINGMAN_MAX_HOURLY_DAYS;
			let datepickerConfig = {
				controls: shouldStartInDailyMode ? ['calendar'] : ['calendar', 'timegrid'],
				select: 'range',
				display: 'inline',
				pages: 2,
				touchUi: false,
				marked: markedDates, labels: undefined,
				// Keep End-tab focus anchored to the latest selectable date/month.
				refDate: leftAlignDate,
				displayDate: leftAlignDate,
				min: allowAnyDate ? undefined : minDateObj,
				max: allowAnyDate ? undefined : maxDateObj,
				maxRange: allowAnyDate ? undefined : (shouldStartInDailyMode ? maxRangeDays : maxRangeDays * 24 * 60 * 60 * 1000),
				showRangeLabels: true,
				theme: 'material',
				themeVariant: 'light',
				timeFormat: 'HH:mm',
				stepMinute: 60,
				onInit: function (event, inst) {
					console.log("Mobiscroll DataExplorer - onInit triggered, current refDate/val:", {
						refDate: leftAlignDate,
						currentVal: inst.getVal()
					});
				},
				onPageLoading: function (event, inst) {
					console.log("Mobiscroll DataExplorer - onPageLoading:", {
						firstDay: event.firstDay,
						lastDay: event.lastDay,
						month: event.month,
						year: event.year
					});
				},
				onPageLoaded: function (event, inst) {
					console.log("Mobiscroll DataExplorer - onPageLoaded:", {
						firstDay: event.firstDay,
						lastDay: event.lastDay
					});
					setTimeout(() => updateRangeDisplayTimezoneLabels(), 0);
					setTimeout(() => updateDstLabelHoverText(), 0);

					// Inject sticky header for timegrid
					setTimeout(() => {
						let timeGrid = document.querySelector('#initial-modal-datepicker .mbsc-timegrid-container');
						if (timeGrid && !timeGrid.querySelector('.custom-timegrid-header')) {
							let headerDiv = document.createElement('div');
							headerDiv.className = 'custom-timegrid-header';
							headerDiv.innerText = 'Selected Time (' + selectedTimezoneLabel + ')';
							timeGrid.prepend(headerDiv);
						}
					}, 50);
				},
				onChange: function (event, inst) {
					setTimeout(() => updateRangeDisplayTimezoneLabels(), 0);
					let val = inst.getVal();
					if (val && val.length === 2 && val[0] && val[1]) {
						let endDayChanged = !lastPickerRange || !lastPickerRange[1] || !isSameDay(val[1], lastPickerRange[1]);
						console.log('Mobiscroll DataExplorer - end selection mode:', {
							mode: endDayChanged ? 'end-day-change' : 'time-adjustment',
							previousEnd: lastPickerRange && lastPickerRange[1] ? lastPickerRange[1] : null,
							incomingEnd: val[1]
						});
						let targetEnd = endDayChanged ? getDefaultEndDateForDay(val[1]) : val[1];
						targetEnd = clampEndDateToAvailability(targetEnd);

						if (val[1].getTime() !== targetEnd.getTime()) {
							lastPickerRange = [new Date(val[0].getTime()), new Date(targetEnd.getTime())];
							updateSelectedRangeSummary(val[0], targetEnd);
							inst.setVal([val[0], targetEnd]);
							return;
						}

						lastPickerRange = [new Date(val[0].getTime()), new Date(targetEnd.getTime())];
						updateSelectedRangeSummary(val[0], targetEnd);
					} else {
						let stableVal = inst.getVal();
						if (stableVal && stableVal.length === 2 && stableVal[0] && stableVal[1]) {
							let stableEnd = clampEndDateToAvailability(stableVal[1]);
							lastPickerRange = [new Date(stableVal[0].getTime()), new Date(stableEnd.getTime())];
							updateSelectedRangeSummary(stableVal[0], stableEnd);
							return;
						}

						lastPickerRange = null;
						clearSelectedRangeSummary();
					}
				}
			};

			console.log("DEBUG MARKERS:", { minDateObj: minDateObj, latestAvailableDateObj: latestAvailableDateObj, maxDateObj: maxDateObj, count: markedDates.length }); console.log("Mobiscroll DataExplorer - using manual timezone conversion (plugin disabled for stability)", {
				selectedTimezone: selectedTimezone,
				hasMobiscrollMomentTimezone: !!(mobiscroll && mobiscroll.momentTimezone),
				hasWindowMomentTz: !!(window.moment && window.moment.tz)
			});

			let dpInst = mobiscroll.datepicker('#initial-modal-datepicker', datepickerConfig);
				console.log("[DEBUG] Datepicker Initialized with maxRange =", datepickerConfig.maxRange, "ms"); window.debugMobiscrollInst = dpInst;

			function getQuickRangeOptions() {
				let isDailyOnlyLocked = window.swanbot_dataexplorer_filter_period === "day" || window.swanbot_dataexplorer_lock_period_selection === true;
				let periodSwitchEl = document.getElementById('idp-period-switch');
				let isDaily = periodSwitchEl ? periodSwitchEl.checked : isDailyOnlyLocked;
				if (isDaily) {
					return [
						{ id: 'idp-last-7', type: 'days', days: 7, label: 'Last 7 Days' },
						{ id: 'idp-last-14', type: 'days', days: 14, label: 'Last 14 Days' },
						{ id: 'idp-last-30', type: 'months_to_date', monthsBackStart: 0, label: 'This month' }
					];
				} else {
					return [
						{ id: 'idp-last-24', type: 'days', days: 1, label: 'Last 1 Day' },
						{ id: 'idp-last-3', type: 'days', days: 3, label: 'Last 3 Days' },
						{ id: 'idp-last-7', type: 'days', days: 7, label: 'Last 7 Days' },
						{ id: 'idp-last-14', type: 'days', days: 14, label: 'Last 14 Days' }
					];
				}
			}

			function resolveQuickRangeSelection(optionMeta) {
				if (!optionMeta) {
					return null;
				}

				let dEnd = getDefaultEndDateForDay(new Date(maxDateObj.getTime()));
				let dStart = new Date(dEnd.getTime());
				let source = 'default quick range';
				let sourceReason = '';

				if (optionMeta.type === 'months_to_date') {
					let monthsBackStart = Number(optionMeta.monthsBackStart || 0);
					dStart.setDate(1);
					dStart.setHours(0, 0, 0, 0);
					dStart.setMonth(dStart.getMonth() - monthsBackStart);
					source = 'calendar month quick range';
					sourceReason = 'Used the current month-to-date quick range, starting at the beginning of this month at 00:00 and ending at the latest available timestamp today.';
				} else {
					let daysBack = Number(optionMeta.days || 0);
					dStart.setDate(dStart.getDate() - daysBack);
					dStart.setHours(0, 0, 0, 0);
					sourceReason = 'Used the quick-range default for ' + daysBack + ' day(s), anchored to the latest available day and normalized the start to 00:00 for calendar-style selection.';
				}

				if (!allowAnyDate && minDateObj && dStart.getTime() < minDateObj.getTime()) {
					dStart = new Date(minDateObj.getTime());
					dStart.setHours(0, 0, 0, 0);
				}

				return {
					start: dStart,
					end: dEnd,
					source: source,
					sourceReason: sourceReason
				};
			}

			function applyQuickRangeOption(optionMeta) {
				let selection = resolveQuickRangeSelection(optionMeta);
				if (!selection) {
					return;
				}

				let dStart = selection.start;
				let dEnd = selection.end;
				lastPickerRange = [new Date(dStart.getTime()), new Date(dEnd.getTime())];
				setRangeDecisionDebug({
					source: selection.source,
					sourceReason: selection.sourceReason,
					selectedRange: formatDebugDateTime(dStart) + ' to ' + formatDebugDateTime(dEnd)
				});

				dpInst.setVal([dStart, dEnd]);
				setTimeout(() => dpInst.navigate(leftAlignDate), 10);
				updateSelectedRangeSummary(dStart, dEnd);
				renderRangeDecisionDebug();
			}

			function renderQuickRanges() {
				let container = document.getElementById('idp-quick-ranges');
				if (!container) return;
				let options = getQuickRangeOptions();
				container.innerHTML = '';
				options.forEach(opt => {
					let btn = document.createElement('button');
					btn.id = opt.id;
					btn.className = 'btn btn-outline-primary btn-sm m-1';
					btn.innerText = opt.label;
					btn.addEventListener('click', () => applyQuickRangeOption(opt));
					container.appendChild(btn);
				});
				let currentVal = dpInst ? dpInst.getVal() : null;
				if (currentVal && currentVal[0] && currentVal[1]) {
					updateQuickHighlights(currentVal[0], currentVal[1]);
				} else if (typeof lastPickerRange !== 'undefined' && lastPickerRange && lastPickerRange[0] && lastPickerRange[1]) {
					updateQuickHighlights(lastPickerRange[0], lastPickerRange[1]);
				}
			}

			function updateQuickHighlights(dStart, dEnd) {
				let btns = getQuickRangeOptions();
				let quickRangeEnd = getDefaultEndDateForDay(new Date(maxDateObj.getTime()));
				btns.forEach(b => {
					let btnEl = document.getElementById(b.id);
					if (!btnEl) return;
					let isMatch = false;
					if (dStart && dEnd) {
						let resolvedQuickRange = resolveQuickRangeSelection(b);
						let expectedStart = resolvedQuickRange ? resolvedQuickRange.start : null;
						let expectedEnd = resolvedQuickRange ? resolvedQuickRange.end : quickRangeEnd;
						if (expectedStart && Math.abs(dEnd.getTime() - expectedEnd.getTime()) < 1000 && Math.abs(dStart.getTime() - expectedStart.getTime()) < 1000) {
							isMatch = true;
						}
					}
					if (isMatch) {
						btnEl.classList.remove('btn-outline-primary');
						btnEl.classList.add('btn-primary');
					} else {
						btnEl.classList.add('btn-outline-primary');
						btnEl.classList.remove('btn-primary');
					}
				});
			}

			function updateSelectedRangeSummary(dStart, dEnd) {
				document.getElementById('idp-summary').innerText = formatSummary(dStart, dEnd);
				updateQuickHighlights(dStart, dEnd);
				updateProcessingWarning(dStart, dEnd);
				document.getElementById('idp-apply').removeAttribute('disabled');
			}

			function updateProcessingWarning(dStart, dEnd) {
				let warningEl = document.getElementById('idp-processing-warning');
				if (!warningEl) {
					return;
				}

				if (!(dStart && dEnd)) {
					warningEl.style.display = 'none';
					return;
				}

				let periodSwitchEl = document.getElementById('idp-period-switch');
				let isDailyMode = periodSwitchEl
					? periodSwitchEl.checked
					: (window.swanbot_dataexplorer_filter_period === 'day' || window.swanbot_dataexplorer_lock_period_selection === true || (document.getElementById('dataexplorer_daily_only') && String(document.getElementById('dataexplorer_daily_only').value).toLowerCase() === 'true'));
				if (!isDailyMode) {
					warningEl.style.display = 'none';
					return;
				}

				let warningThresholdDays = 32;
				let selectedRangeDays = Math.ceil(Math.abs(dEnd.getTime() - dStart.getTime()) / (1000 * 60 * 60 * 24));

				warningEl.style.display = selectedRangeDays > warningThresholdDays ? 'block' : 'none';
			}

			function clearSelectedRangeSummary() {
				document.getElementById('idp-summary').innerText = 'No range selected';
				document.getElementById('idp-apply').setAttribute('disabled', 'disabled');
				updateQuickHighlights(null, null);
				updateProcessingWarning(null, null);
			}

			function getActiveQuickRangeOption() {
				let quickButtons = getQuickRangeOptions();

				for (let i = 0; i < quickButtons.length; i++) {
					let buttonMeta = quickButtons[i];
					let buttonEl = document.getElementById(buttonMeta.id);
					if (buttonEl && buttonEl.classList.contains('btn-primary')) {
						return buttonMeta;
					}
				}

				return null;
			}

			// Helper to apply quick dates and visually select them
			function setRangeDays(daysBack) {
				applyQuickRangeOption({ type: 'days', days: daysBack });
			}

			window.updateDataExplorerModalLatestAvailable = function (updatedMaxDateUtcStr) {
				let nextMaxDateStr = resolveDataExplorerLatestAvailableUtc(updatedMaxDateUtcStr);
				if (!nextMaxDateStr) {
					return;
				}

				let currentMaxTs = toComparableUtcTs(maxDateStr);
				let nextMaxTs = toComparableUtcTs(nextMaxDateStr);
				maxDateStr = nextMaxDateStr;

				try {
					window.sessionStorage.setItem(dataExplorerMaxAvailableKey, maxDateStr);
				} catch (e) {
					console.log('Could not persist DataExplorer max-available cache:', e);
				}

				updateLatestAvailableLabels(maxDateStr, selectedTimezone);

				if (nextMaxTs === null || (currentMaxTs !== null && nextMaxTs <= currentMaxTs)) {
					return;
				}

				let nextLatestAvailableDateObj = parseBackendDateToPickerWallDate(maxDateStr, selectedTimezone);
				if (!nextLatestAvailableDateObj || Number.isNaN(nextLatestAvailableDateObj.getTime())) {
					return;
				}

				latestAvailableDateObj = nextLatestAvailableDateObj;
				maxDateObj = getSelectableEndForDay(latestAvailableDateObj, latestAvailableDateObj);
				leftAlignDate = new Date(maxDateObj);
				leftAlignDate.setDate(1);
				leftAlignDate.setMonth(leftAlignDate.getMonth() - 1);
				leftAlignDate.setHours(0, 0, 0, 0);
				rebuildCalendarMarkers();

				let currentVal = dpInst.getVal();
				let safeRange = null;
				if (currentVal && currentVal.length === 2 && currentVal[0] && currentVal[1]) {
					let safeStart = new Date(currentVal[0].getTime());
					let safeEnd = clampEndDateToAvailability(currentVal[1]);
					if (safeEnd.getTime() < safeStart.getTime()) {
						safeEnd = getDefaultEndDateForDay(new Date(safeStart.getTime()));
						safeEnd = clampEndDateToAvailability(safeEnd);
					}
					safeRange = [safeStart, safeEnd];
				}

				try {
					let latestAvailableOptions = {
						marked: markedDates, labels: undefined,
						refDate: leftAlignDate,
						displayDate: leftAlignDate
					};
					if (!allowAnyDate) {
						latestAvailableOptions.max = maxDateObj;
					}
					dpInst.setOptions(latestAvailableOptions);

					if (safeRange) {
						lastPickerRange = [new Date(safeRange[0].getTime()), new Date(safeRange[1].getTime())];
						dpInst.setVal(safeRange);
						updateSelectedRangeSummary(safeRange[0], safeRange[1]);
					} else {
						updateQuickHighlights(null, null);
					}

					setTimeout(() => {
						updateRangeDisplayTimezoneLabels();
						updateDstLabelHoverText();
					}, 0);
				} catch (e) {
					console.log('Mobiscroll DataExplorer - latest-available update failed:', e);
				}
			};

			// Attempt to restore currently selected range from Data Explorer inputs.
			let restoredRange = false;
			try {
				if (!hasLoadedDataExplorerInSession()) {
					pushRangeDecisionDebug('First modal load uses the 3-day calendar default, starting at 00:00 and ending at the latest available time.');
					setRangeDays(3);
					restoredRange = true;
				}

				if (restoredRange) {
					// pass
				} else {
				let restoreFromSavedRange = function () {
					try {
						if (!hasLoadedDataExplorerInSession()) {
							return null;
						}

						let savedRangeRaw = window.localStorage.getItem(dataExplorerSavedRangeKey);
						if (!savedRangeRaw) {
							return null;
						}

						let savedRange = JSON.parse(savedRangeRaw);
						if (!(savedRange && savedRange.start && savedRange.end)) {
							return null;
						}

						let restoredStart = parseSavedWallDateToPickerWallDate(savedRange.start, selectedTimezone);
						let restoredEnd = parseSavedWallDateToPickerWallDate(savedRange.end, selectedTimezone);
						if (!restoredStart || !restoredEnd || Number.isNaN(restoredStart.getTime()) || Number.isNaN(restoredEnd.getTime())) {
							return null;
						}

						return [restoredStart, restoredEnd];
					} catch (e) {
						console.log('Mobiscroll DataExplorer - failed to parse saved local range:', e);
						return null;
					}
				};

				let savedRange = restoreFromSavedRange();
				if (savedRange) {
					let restoredStart = savedRange[0];
					let restoredEnd = savedRange[1];
					restoredEnd = clampEndDateToAvailability(restoredEnd);
					if (restoredEnd.getTime() < restoredStart.getTime()) {
						restoredEnd = getDefaultEndDateForDay(new Date(restoredStart.getTime()));
						restoredEnd = clampEndDateToAvailability(restoredEnd);
					}

					lastPickerRange = [new Date(restoredStart.getTime()), new Date(restoredEnd.getTime())];
					setRangeDecisionDebug({
						source: 'local saved range cache',
						sourceReason: 'Restored the picker from dataexplorer_saved_date_v1 because Data Explorer had already loaded in this session.',
						selectedRange: formatDebugDateTime(restoredStart) + ' to ' + formatDebugDateTime(restoredEnd)
					});
					dpInst.setVal([restoredStart, restoredEnd]);
					updateSelectedRangeSummary(restoredStart, restoredEnd);
					restoredRange = true;
					renderRangeDecisionDebug();
				}

				if (restoredRange) {
					// pass
				} else {
				let selectedStartInput = document.getElementById('date_start');
				let selectedEndInput = document.getElementById('date_end');
				let selectedStartStr = selectedStartInput && selectedStartInput.value ? String(selectedStartInput.value).trim() : '';
				let selectedEndStr = selectedEndInput && selectedEndInput.value ? String(selectedEndInput.value).trim() : '';

				if (selectedStartStr && selectedEndStr) {
					let restoredStart = parseBackendDateToPickerWallDate(selectedStartStr, selectedTimezone);
					let restoredEnd = parseBackendDateToPickerWallDate(selectedEndStr, selectedTimezone);
					if (restoredStart && restoredEnd && !Number.isNaN(restoredStart.getTime()) && !Number.isNaN(restoredEnd.getTime())) {
						restoredEnd = clampEndDateToAvailability(restoredEnd);
						if (restoredEnd.getTime() < restoredStart.getTime()) {
							restoredEnd = getDefaultEndDateForDay(new Date(restoredStart.getTime()));
							restoredEnd = clampEndDateToAvailability(restoredEnd);
						}

						lastPickerRange = [new Date(restoredStart.getTime()), new Date(restoredEnd.getTime())];
						setRangeDecisionDebug({
							source: 'hidden input restore',
							sourceReason: 'Restored from the current hidden date_start/date_end values because no saved local range was available.',
							selectedRange: formatDebugDateTime(restoredStart) + ' to ' + formatDebugDateTime(restoredEnd)
						});
						dpInst.setVal([restoredStart, restoredEnd]);
						updateSelectedRangeSummary(restoredStart, restoredEnd);
						restoredRange = true;
						renderRangeDecisionDebug();
					}
				}
				}
				}
			} catch (e) {
				console.log('Mobiscroll DataExplorer - failed to restore selected range, falling back to quick range:', e);
				pushRangeDecisionDebug('Restore path threw an error: ' + e);
			}

			if (!restoredRange) {
				// Default selection to 7 days
				setRangeDecisionDebug({
					source: 'fallback quick range',
					sourceReason: 'No restore path succeeded, so the picker fell back to the existing 7-day quick-range default.',
					selectedRange: 'pending'
				});
				pushRangeDecisionDebug('Fallback was used because neither session default, saved cache, nor hidden input restore produced a valid range.');
				setRangeDays(7);
			}

			renderRangeDecisionDebug();

			function getRangeTabInteraction(targetEl) {
				if (!targetEl) return false;
				let tabEl = targetEl.closest('.mbsc-segmented-button, [role="tab"], .mbsc-segmented-item, .mbsc-btn');
				if (!tabEl) return null;
				let rawLabel = (tabEl.getAttribute('aria-label') || tabEl.textContent || '').trim().toLowerCase();
				if (rawLabel === 'end' || rawLabel.indexOf('end date') !== -1) return 'end';
				if (rawLabel === 'start' || rawLabel.indexOf('start date') !== -1) return 'start';

				// Mobiscroll often renders Start/End as two segmented buttons without stable aria labels.
				// Use their visual order as a fallback: first is Start, second is End.
				if (tabEl.classList && tabEl.classList.contains('mbsc-segmented-button')) {
					let segmentedGroup = tabEl.parentElement;
					if (segmentedGroup) {
						let segmentedButtons = Array.from(segmentedGroup.querySelectorAll('.mbsc-segmented-button'));
						let segmentedIndex = segmentedButtons.indexOf(tabEl);
						if (segmentedIndex === 0) return 'start';
						if (segmentedIndex === 1) return 'end';
					}
				}
				return null;
			}

			function applyTabLayout(tabName, reason) {
				if (!tabName) return;
				let targetPages = tabName === 'end' ? 1 : 2;
				let targetDate = tabName === 'end' ? maxDateObj : leftAlignDate;
				console.log('Mobiscroll DataExplorer - applying tab layout:', {
					tabName: tabName,
					reason: reason,
					targetPages: targetPages,
					targetDate: targetDate
				});
				try {
					dpInst.setOptions({
						pages: targetPages,
						refDate: targetDate,
						displayDate: targetDate
					});
					dpInst.navigate(targetDate);
				} catch (err) {
					console.log('Mobiscroll DataExplorer - applyTabLayout failed:', err);
				}
			}

			function handleTabInteraction(e, source) {
				let tabName = getRangeTabInteraction(e.target);
				if (!tabName) return;
				if (tabName === 'end') {
					console.log('Mobiscroll DataExplorer - End date button clicked:', {
						source: source,
						targetText: (e.target.textContent || '').trim(),
						targetClass: e.target.className,
						timestamp: new Date().toISOString()
					});
				}
				console.log('Mobiscroll DataExplorer - Range tab interaction detected:', {
					tabName: tabName,
					source: source,
					targetText: (e.target.textContent || '').trim(),
					targetClass: e.target.className
				});
				setTimeout(() => applyTabLayout(tabName, 'tab-interaction'), 0);
			}

			// Keep initial state as a 2-page Feb+Mar layout.
			setTimeout(() => applyTabLayout('start', 'initial-layout'), 0);

			popupDiv.addEventListener('pointerdown', function (e) {
				handleTabInteraction(e, 'pointerdown');
			}, true);

			popupDiv.addEventListener('click', function (e) {
				handleTabInteraction(e, 'click');
			}, true);

			let idpTimezoneSelect = document.getElementById('idp-timezone-select');
			let idpTimezoneContainer = document.getElementById('idp-timezone-container');
			let setTimezoneControlTooltip = function (message) {
				let tooltipMessage = message || '';
				if (idpTimezoneSelect) {
					idpTimezoneSelect.title = tooltipMessage;
					idpTimezoneSelect.style.cursor = tooltipMessage ? 'not-allowed' : '';
				}
				if (idpTimezoneContainer) {
					idpTimezoneContainer.title = tooltipMessage;
					idpTimezoneContainer.style.opacity = tooltipMessage ? '0.7' : '1';
					idpTimezoneContainer.style.cursor = tooltipMessage ? 'not-allowed' : '';
				}
			};

			let syncModalTimezone = function (newTimezone, options) {
				let syncOptions = options || {};
				let persistUserPreference = syncOptions.persistUserPreference !== false;
				let forceSync = syncOptions.forceSync === true;

				newTimezone = (newTimezone || '').trim();
				if (!isValidTimezone(newTimezone)) {
					return;
				}

				let timezoneChanged = newTimezone !== selectedTimezone;
				if (!timezoneChanged && !forceSync) {
					return;
				}

				if (persistUserPreference) {
					lastHourlyTimezoneSelection = newTimezone;
				}

				let timezoneStorePayload = JSON.stringify({ timezone: newTimezone });
				try {
					window.localStorage.setItem('timezone_dataexplorer_store', timezoneStorePayload);
				} catch (e) {
					console.log('Could not persist timezone_dataexplorer_store from modal select:', e);
				}

				if (persistUserPreference) {
					try {
						window.localStorage.setItem('timezone_dataexplorer_user_preference', newTimezone);
					} catch (e) {
						console.log('Could not persist user preference for timezone:', e);
					}
				}

				let timezoneSelectedInput = document.getElementById('timezone_dataexplorer_selected');
				if (timezoneSelectedInput) {
					if (typeof __rendezvouz_setter === 'function') {
						__rendezvouz_setter.call(timezoneSelectedInput, newTimezone);
					} else {
						timezoneSelectedInput.value = newTimezone;
					}
					timezoneSelectedInput.dispatchEvent(new Event('input', { bubbles: true }));
				}

				let timezoneShortInput = document.getElementById('timezone_short_dataexplorer_selected');
				if (timezoneShortInput) {
					let shortTimezone = getTimezoneShortLabel(newTimezone);
					if (typeof __rendezvouz_setter === 'function') {
						__rendezvouz_setter.call(timezoneShortInput, shortTimezone);
					} else {
						timezoneShortInput.value = shortTimezone;
					}
					timezoneShortInput.dispatchEvent(new Event('input', { bubbles: true }));
				}

				let timezoneDropdownHiddenInput = document.querySelector('#timezone_options_select input[type="hidden"]');
				if (timezoneDropdownHiddenInput) {
					if (typeof __rendezvouz_setter === 'function') {
						__rendezvouz_setter.call(timezoneDropdownHiddenInput, newTimezone);
					} else {
						timezoneDropdownHiddenInput.value = newTimezone;
					}
					timezoneDropdownHiddenInput.dispatchEvent(new Event('input', { bubbles: true }));
					timezoneDropdownHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
				}

				if (idpTimezoneSelect && idpTimezoneSelect.value !== newTimezone) {
					idpTimezoneSelect.value = newTimezone;
				}

				if (!timezoneChanged) {
					selectedTimezone = newTimezone;
					selectedTimezoneShort = getTimezoneShortLabel(newTimezone);
					selectedTimezoneLabel = selectedTimezoneShort && selectedTimezoneShort.trim() !== '' ? selectedTimezoneShort : selectedTimezone;
					updateDataExplorerTimezoneLinkLabel(selectedTimezone);
					updateLatestAvailableLabels(maxDateStr, selectedTimezone);
					return;
				}

				let previousTimezone = selectedTimezone;
				let currentVal = dpInst.getVal();
				let currentUtcRange = null;
				let preserveMidnightStart = false;
				let previousStartDateParts = null;
				let activeQuickRangeOption = getActiveQuickRangeOption();
				if (currentVal && currentVal.length === 2 && currentVal[0] && currentVal[1]) {
					preserveMidnightStart = currentVal[0].getHours() === 0 && currentVal[0].getMinutes() === 0;
					if (preserveMidnightStart) {
						previousStartDateParts = {
							year: currentVal[0].getFullYear(),
							month: currentVal[0].getMonth(),
							date: currentVal[0].getDate()
						};
					}
					currentUtcRange = [
						formatPickerWallDateToUtcString(currentVal[0], previousTimezone),
						formatPickerWallDateToUtcString(currentVal[1], previousTimezone)
					];
				}

				selectedTimezone = newTimezone;
				selectedTimezoneShort = getTimezoneShortLabel(newTimezone);
				selectedTimezoneLabel = selectedTimezoneShort && selectedTimezoneShort.trim() !== '' ? selectedTimezoneShort : selectedTimezone;
				updateDataExplorerTimezoneLinkLabel(selectedTimezone);

				latestAvailableDateObj = maxDateStr ? parseBackendDateToPickerWallDate(maxDateStr, selectedTimezone) : new Date();
				maxDateObj = getSelectableEndForDay(latestAvailableDateObj, latestAvailableDateObj) || normalizePickerDayEnd(new Date()) || new Date();
				minDateObj = minDateStr ? parseBackendDateToPickerWallDate(minDateStr, selectedTimezone) : null;
				leftAlignDate = new Date(maxDateObj);
				leftAlignDate.setDate(1);
				leftAlignDate.setMonth(leftAlignDate.getMonth() - 1);
				leftAlignDate.setHours(0, 0, 0, 0);
				rebuildCalendarMarkers();

				let convertedRange = null;
				if (currentUtcRange && currentUtcRange[0] && currentUtcRange[1]) {
					let convertedStart = parseBackendDateToPickerWallDate(currentUtcRange[0], selectedTimezone);
					let convertedEnd = parseBackendDateToPickerWallDate(currentUtcRange[1], selectedTimezone);
					if (convertedStart && convertedEnd) {
						if (preserveMidnightStart && previousStartDateParts) {
							convertedStart = new Date(
								previousStartDateParts.year,
								previousStartDateParts.month,
								previousStartDateParts.date,
								0,
								0,
								0,
								0
							);
							if (!allowAnyDate && minDateObj && convertedStart.getTime() < minDateObj.getTime()) {
								convertedStart = new Date(minDateObj.getTime());
								convertedStart.setHours(0, 0, 0, 0);
							}
						}
						convertedEnd = clampEndDateToAvailability(convertedEnd);
						if (convertedEnd.getTime() < convertedStart.getTime()) {
							convertedEnd = getDefaultEndDateForDay(new Date(convertedStart.getTime()));
							convertedEnd = clampEndDateToAvailability(convertedEnd);
						}
						convertedRange = [convertedStart, convertedEnd];
					}
				}

				try {
					let timezoneOptions = {
						marked: markedDates, labels: undefined,
						refDate: leftAlignDate,
						displayDate: leftAlignDate
					};
					if (!allowAnyDate) {
						timezoneOptions.min = minDateObj;
						timezoneOptions.max = maxDateObj;
					}
					dpInst.setOptions(timezoneOptions);

					if (activeQuickRangeOption) {
						applyQuickRangeOption(activeQuickRangeOption);
					} else if (convertedRange) {
						lastPickerRange = [new Date(convertedRange[0].getTime()), new Date(convertedRange[1].getTime())];
						dpInst.setVal(convertedRange);
						updateSelectedRangeSummary(convertedRange[0], convertedRange[1]);
					} else {
						lastPickerRange = null;
						clearSelectedRangeSummary();
					}

					dpInst.navigate(leftAlignDate);
					updateLatestAvailableLabels(maxDateStr, selectedTimezone);

					setTimeout(() => {
						updateRangeDisplayTimezoneLabels();
						updateDstLabelHoverText();
						let timegridHeader = document.querySelector('#initial-modal-datepicker .custom-timegrid-header');
						if (timegridHeader) {
							timegridHeader.innerText = 'Selected Time (' + selectedTimezoneLabel + ')';
						}
					}, 0);
				} catch (e) {
					console.log('Mobiscroll DataExplorer - in-place timezone update failed, falling back to modal rebuild:', e);
					let existingModal = document.getElementById('initial-dataexplorer-calendar-popup');
					if (existingModal) {
						existingModal.remove();
					}
					if (window.invoke_dataexplorer_calendar_modal) {
						window.invoke_dataexplorer_calendar_modal(false);
					}
				}
			};

			let updateTimezoneControlState = function (isDailyMode) {
				if (!idpTimezoneSelect) {
					return;
				}

				if (isDailyMode) {
					if (selectedTimezone !== 'UTC' || !isValidTimezone(lastHourlyTimezoneSelection)) {
						lastHourlyTimezoneSelection = selectedTimezone;
					}
					syncModalTimezone('UTC', { persistUserPreference: false, forceSync: true });
					idpTimezoneSelect.disabled = true;
					setTimezoneControlTooltip('UTC required for daily mode');
					return;
				}

				idpTimezoneSelect.disabled = false;
				setTimezoneControlTooltip('');

				let restoreTimezone = (lastHourlyTimezoneSelection || '').trim();
				if (!isValidTimezone(restoreTimezone)) {
					restoreTimezone = 'UTC';
				}

				syncModalTimezone(restoreTimezone, { persistUserPreference: true, forceSync: true });
			};

			let periodSwitchEl = document.getElementById('idp-period-switch');
			if (periodSwitchEl) {
				// Init switch state based on settings
				periodSwitchEl.checked = shouldStartInDailyMode;
				periodSwitchEl.addEventListener('change', function () {
					let isDailyContent = periodSwitchEl.checked;
					window.swanbot_dataexplorer_filter_period = isDailyContent ? "day" : "hour";
					updateTimezoneControlState(isDailyContent);
					if (dpInst) {
						let newMaxRange = isDailyContent ? window.WINGMAN_MAX_HOURLY_DAYS_NORMAL : window.WINGMAN_MAX_HOURLY_DAYS;
						let maxMillis = newMaxRange * 24 * 60 * 60 * 1000;
						console.log("[DEBUG] Dynamic Switch! isDaily=" + isDailyContent + ", setting maxRange to " + newMaxRange + " days (" + maxMillis + " ms)");
						dpInst.setOptions({ controls: isDailyContent ? ['calendar'] : ['calendar', 'timegrid'], marked: markedDates, labels: undefined, maxRange: allowAnyDate ? undefined : (isDailyContent ? newMaxRange : maxMillis) });

						// Enforce maximum range constraint when switching back to Hourly
						if (!allowAnyDate && !isDailyContent) {
							let currentVal = dpInst.getVal();
							if (currentVal && currentVal[0] && currentVal[1]) {
								let diffMillis = currentVal[1].getTime() - currentVal[0].getTime();
								if (diffMillis > maxMillis) {
									console.log("[DEBUG] Range too long for hourly, automatically selecting 7 days.");
									setRangeDays(7);
								}
							}
						}
					}
					renderQuickRanges(); // Redraw quick ranges when mode changes
					let currentVal = dpInst ? dpInst.getVal() : null;
					if (currentVal && currentVal[0] && currentVal[1]) {
						updateProcessingWarning(currentVal[0], currentVal[1]);
					} else if (typeof lastPickerRange !== 'undefined' && lastPickerRange && lastPickerRange[0] && lastPickerRange[1]) {
						updateProcessingWarning(lastPickerRange[0], lastPickerRange[1]);
					} else {
						updateProcessingWarning(null, null);
					}
				});
			}

			if (idpTimezoneSelect) {
				idpTimezoneSelect.addEventListener('change', function () {
					let newTimezone = (this.value || '').trim();
					if (!isValidTimezone(newTimezone)) {
						return;
					}

					syncModalTimezone(newTimezone);
				});
			}

			window.swanbot_dataexplorer_filter_period = shouldStartInDailyMode ? 'day' : 'hour';
			updateTimezoneControlState(shouldStartInDailyMode);
			renderQuickRanges(); // Initialize quick ranges after the modal period state is applied

			document.getElementById('idp-apply').addEventListener('click', () => {
				console.log("Load Dash popup apply button clicked! (idp-apply)");
				let sel = dpInst.getVal();
				console.log("Selected dates raw from dpInst:", sel);
				
				if (sel && sel.length === 2 && sel[0] && sel[1]) {
						let d0 = sel[0];
						let d1 = clampEndDateToAvailability(sel[1]);

					// Make sure it doesn't exceed the configured range cap
						let diffDays = Math.ceil(Math.abs(sel[1] - sel[0]) / (1000 * 60 * 60 * 24));
						console.log(`Difference in days: ${diffDays}`);
										let currentIsDaily = window.swanbot_dataexplorer_filter_period === 'day' || window.swanbot_dataexplorer_lock_period_selection === true;
                                        let effectiveMaxRangeDays = currentIsDaily ? window.WINGMAN_MAX_HOURLY_DAYS_NORMAL : window.WINGMAN_MAX_HOURLY_DAYS;
										if (!allowAnyDate && diffDays > effectiveMaxRangeDays) {
                                                alert(`Selected range exceeds ${effectiveMaxRangeDays} days. Please select a shorter range.`);
                                                return;
                                        }

					// Custom range update: target Dash DatePickerRange native inputs
						let dateInputs = document.querySelectorAll('#dataexplorer-date-picker-range input');
					console.log("Found DatePickerRange inputs:", dateInputs.length);
					if (dateInputs.length >= 2) {
						let startReactInput = dateInputs[0];
						let endReactInput = dateInputs[1];

						dpInst.setVal([d0, d1]);
						
						let startStr = formatDateForTimezone(d0, selectedTimezone, false);
						let endStr = formatDateForTimezone(d1, selectedTimezone, false);
						console.log(`Formatted short strings: Start=${startStr}, End=${endStr}`);
						
						// Create full datetime string for custom backend bounds parsing
						let startFullStr = formatDateForTimezone(d0, selectedTimezone, true);
						let endFullStr = formatDateForTimezone(d1, selectedTimezone, true);
						console.log(`Formatted long strings: Start=${startFullStr}, End=${endFullStr}`);

						let overridePayload = JSON.stringify({
							start: startFullStr,
							end: endFullStr,
							timezone: selectedTimezone,
							timezoneLabel: selectedTimezoneLabel,
							source: 'mobiscroll'
						});

						let hiddenInputSetterDescriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value");
						let hiddenInputNativeSetter = hiddenInputSetterDescriptor && hiddenInputSetterDescriptor.set ? hiddenInputSetterDescriptor.set : null;
						let primeHiddenInputValue = function (inputEl, nextValue) {
							if (!inputEl) {
								return;
							}

							if (hiddenInputNativeSetter) {
								hiddenInputNativeSetter.call(inputEl, nextValue);
							} else if (typeof __rendezvouz_setter === 'function') {
								__rendezvouz_setter.call(inputEl, nextValue);
							} else {
								inputEl.value = nextValue;
							}
						};

						let hiddenDateStartInput = document.getElementById('date_start');
						let hiddenDateEndInput = document.getElementById('date_end');
						primeHiddenInputValue(hiddenDateStartInput, startFullStr);
						primeHiddenInputValue(hiddenDateEndInput, endFullStr);

						let datetimeOverrideInput = document.getElementById('dataexplorer_datetime_override');
						if (datetimeOverrideInput) {
							primeHiddenInputValue(datetimeOverrideInput, overridePayload);
							datetimeOverrideInput.dispatchEvent(new Event('input', { bubbles: true }));
							datetimeOverrideInput.dispatchEvent(new Event('change', { bubbles: true }));
							console.log("Dispatched dataexplorer_datetime_override payload:", overridePayload);
						}

						// Update the visible range label immediately from the applied Mobiscroll selection.
						let rangeLabelEl = document.getElementById('dataexplorer_date-selected');
						if (rangeLabelEl) {
							let timezoneLabelForRange = selectedTimezoneLabel || selectedTimezone || 'UTC';
							let startLabel = startFullStr.slice(0, 16);
							let endLabel = endFullStr.slice(0, 16);
							rangeLabelEl.textContent = `${startLabel} ${timezoneLabelForRange} to ${endLabel} ${timezoneLabelForRange}`;
						}

						let rangeLabelElJsfe = document.getElementById('dataexplorer_date-selected-jsfe');
						if (rangeLabelElJsfe) {
							let timezoneLabelForRange = selectedTimezoneLabel || selectedTimezone || 'UTC';
							let startLabel = startFullStr.slice(0, 16);
							let endLabel = endFullStr.slice(0, 16);
							rangeLabelElJsfe.textContent = `${startLabel} ${timezoneLabelForRange} to ${endLabel} ${timezoneLabelForRange}`;
						}
						
						window.localStorage.setItem('dataexplorer_saved_date_v1', JSON.stringify({
							"start": startFullStr,
							"end": endFullStr
						}));
						window.swanbot_dataexplorer_period_mode_preference = currentIsDaily ? 'day' : 'hour';
						try {
							window.sessionStorage.setItem('dataexplorer_period_mode_v1', window.swanbot_dataexplorer_period_mode_preference);
						} catch (e) {
							console.log('Could not persist DataExplorer modal period preference:', e);
						}

						try {
							window.sessionStorage.setItem(dataExplorerLoadedSessionKey, 'true');
						} catch (e) {
							console.log('Could not persist dataexplorer session loaded flag:', e);
						}
						console.log("Updated Data Explorer saved range.");
						
						let reactInputSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
						
						if (reactInputSetter) {
							console.log("reactInputSetter found, updating Dash inputs directly.");
							reactInputSetter.call(startReactInput, startStr);
							startReactInput.dispatchEvent(new Event('change', { bubbles: true }));
							reactInputSetter.call(endReactInput, endStr);
							endReactInput.dispatchEvent(new Event('change', { bubbles: true }));
						} else {
                            console.log("reactInputSetter NOT found!");
                        }
						
					}
					
					// Also store exact time to any hidden fields if they exist? Let's check if there are time hidden fields
                    let startTimeInput = document.getElementById('dataexplorer_date_time_store');
                    // if Dash handles start/end time exactly from inputs, we shouldn't worry about modifying python store without react.
                    // Instead, let's inject into JS event as a special override if needed, but for now we dispatch to dataexplorer_event_loaded.

					// Silent fallback: if Dash doesn't fire update_dataexplorer_daterange soon,
					// trigger the client load directly using the applied values.
					window._dataexplorer_failsafe_triggered = false;
					window._dataexplorer_failsafe_timer = setTimeout(() => {
						if (!window._dataexplorer_failsafe_triggered && !de_loading_events && !(window.WingmanState && window.WingmanState.swanbot_url_called)) {
							window._dataexplorer_failsafe_triggered = true;
							if (typeof window.make_dataexplorer === 'function') {
								window.make_dataexplorer();
							}
						}
					}, 1200);

					console.log("Closing Mobiscroll popup...");
					initialPopup.close();
					window.swanbot_dataexplorer_blocked = false; // globally unblock dash clientside_callbacks

					if (document.getElementById("initial-dataexplorer-calendar-popup")) {
						// Remove the ID so the blocking logic lets the subsequent requests through,
						// but leave the DOM element intact so Mobiscroll can cleanly animate the close.
						console.log("Removing popup ID to unblock dash clientside_callbacks...");
						document.getElementById("initial-dataexplorer-calendar-popup").removeAttribute("id");
					} else {
                        console.log("initial-dataexplorer-calendar-popup not found during close!");
                    }
					
					// Let Dash's set_max_data handle setting the completion status
					/*
					let payload = "update_complete";
					console.log("Dispatching input event to dataexplorer_event_loaded with payload:", payload);
					__rendezvouz_setter.call(dataexplorer_event_loaded, payload);
					var client_event = new Event('input', { bubbles: true });
					dataexplorer_event_loaded.dispatchEvent(client_event);
					*/
				} else {
                    console.log("Date selection validation failed. Selection=", sel);
                }
			});

			initialPopup.open();
		};

		// Intercept clicks on the new date range link
		if (!window.swanbot_dataexplorer_click_listener_added) {
			window.swanbot_dataexplorer_click_listener_added = true;
			document.addEventListener('click', function(e) {
				let el = e.target.closest('#dataexplorer_date-selected, #dataexplorer_date-selected-jsfe, #dataexplorer_timezone-picker-link');
				if (el) {
					e.preventDefault();
					if (window.invoke_dataexplorer_calendar_modal) {
						window.invoke_dataexplorer_calendar_modal(false);
					}
				}
			});
		}

		let shouldShowInitialDataExplorerModal = (!window.swanbot_dataexplorer_initial_visit_done) || (window.swanbot_dataexplorer_reopen_on_return === true);
		if (shouldShowInitialDataExplorerModal) {
			window.swanbot_dataexplorer_initial_visit_done = true;
			window.swanbot_dataexplorer_reopen_on_return = false;
			window.invoke_dataexplorer_calendar_modal(true);
			return; // Exit early, do not fire initial dash update until user clicks Apply.
		}

		__rendezvouz_setter.call(dataexplorer_event_loaded, JSON.stringify(page_type));
		var client_event = new Event('input', { bubbles: true });
		dataexplorer_event_loaded.dispatchEvent(client_event);





		/*
		setTimeout(function () {
			makeCalendarTooltip();
		}, 1000)

		var card_header = document.getElementById('card-header');
		var card_title = document.getElementById('card-title');

		var resource = get_resources.find(function (robj) {
			return robj.id === event_item.event.resource;
		});

		window.populate_card(event_item, 'custom-event-tooltip-popup')

		card_header.style.backgroundColor = event_item.resource_color;
		card_title.innerHTML = event_item.event.name;


		*/


	});
	waitForElmDel("#area-dataexplorer-events").then((elm) => {
		// Mark that user left Data Explorer so modal can respawn on return.
		window.swanbot_dataexplorer_reopen_on_return = true;
		window.swanbot_dataexplorer_initial_visit_done = false;
		window.swanbot_dataexplorer_blocked = false;
		//console.log("no longer on dataexplorer")
	});


}

function open_event_details() {
	//console.log('open details view');
	window.location.href = "/events/details?event=" + active_event_track;
}


/* extracted ready_swanbot */



function ready_social() {
	//console.log("bind click to button")
	$('.details-new-interaction').on("click", function () {
		//console.log($(this));
		//let cid = (this).id.split("_");
		//actionid = cid[1];
		$(this).click(getScreen());
		//$(this).click(do_drag());
	});

}

function ready_digest() {

	/*
		copy_html = document.getElementById("copy_html");
		
		copy_html.addEventListener("click", function(e) {
			console.log("copy daily_digest_selection");
			display_toast("Digest Copied to Clipboard");
			copyElementToClipboard("daily_digest_selection");
			e.preventDefault();
			return false;
		})
	*/

	send_email_btn = document.getElementById("send_email");
	send_email_btn.addEventListener("click", function (e) {
		console.log("send daily_digest_selection");
		display_toast("Sending Daily Digest...");
		send_email_message();
		e.preventDefault();
		return false;
	})

}


function get_filter_event_data() {

	//console.log("get_filter_event_data")

	let default_filter_js = document.querySelector("#default_filter_js").value;
	let date_start = document.querySelector("#date_start").value;
	let date_end = document.querySelector("#date_end").value;
	let first_event_date = document.querySelector("#first_event_date").value;

	//get_explore_start_date = first_event_date; // global

	//console.log("get_filter_event_data", default_filter_js, date_start, date_end, first_event_date)
	var event_status = '/active,draft_suggested_active/';
	var text = ""

	default_filter_js = default_filter_js.toString();
	//console.log("default_filter_js toString()", default_filter_js)

	default_filter_js = JSON.parse(default_filter_js)
	//console.log("type default", typeof(default_filter_js))

	default_filter_js = default_filter_js.toString();
	//console.log("default_filter_js toString()", default_filter_js)

	if (explore_set_filters) {
		default_filter_js = explore_set_filters.join(",");
	}

	if (default_filter_js) {
		var eventURL = '/xapi/filterevents' + event_status + '?start=' + date_start + '&end=' + date_end + '&filters=' + encodeURIComponent(default_filter_js);
		get_filter_event_json_data(eventURL, text);
	}

}



/* extracted make_timeline_control */



/* extracted ready_timeline_expand */




function ready_explore() {

	/*
	var button_clear = document.getElementById("btn_clear_filters");
	button_clear.addEventListener("click", function(e) {
		console.log("clear filters");
		display_toast("Filters Cleared");
		let efp = explore_filters_picker[0].selectize;
		efp.clear();
		default_filter_js = "";
		changeFilters(null);
		e.preventDefault();
		return false;
	})
	*/



}

function changeFilters(allFilters) {
	explore_selected_filters = allFilters;

	if (explore_is_debounce && !explore_is_debounce_results) {
		// waiting for timeout to kick in
		console.log("cancel change wait for next event")
		clearTimeout(change_filter_handler);
		explore_is_debounce = true;
		explore_is_debounce_results = false;
		change_filter_handler = setTimeout(function () {
			changeFiltersAction();
		}, explore_debounce);

	} else if (!explore_is_debounce) {
		explore_is_debounce = true;
		explore_is_debounce_results = false;
		change_filter_handler = setTimeout(function () {
			changeFiltersAction();
		}, explore_debounce);
	} else {
		console.log('debounce is already running');
	}
}

function changeFiltersAction() {
	explore_is_debounce = false;
	explore_is_debounce_results = true;
	//console.log("all filters changed", explore_selected_filters);
	explore_set_filters = explore_selected_filters;
	window.dash_clientside.clientside.update_explore();
}

function make_selected_filters() {

	let filter_options_js = document.querySelector("#filter_options_js").value;
	let default_filter_js = document.querySelector("#default_filter_js").value;
	let all_filters_js = document.querySelector("#all_filters").value;

	var customer_filter_options = [];
	all_filters_js = JSON.parse(all_filters_js)

	//console.log("all_filters_js", all_filters_js)
	//filter_options_js
	for (filter in all_filters_js) {
		var newfilter = { title: all_filters_js[filter].filter_name, value: all_filters_js[filter].filter_name, name: all_filters_js[filter].name }
		customer_filter_options.push(newfilter)
	}

	filter_type_area = document.getElementById("filter_dropdown_area");

	var select_area = document.createElement("select");
	select_area.setAttribute('class', 'filter_select_area');
	select_area.setAttribute("id", "filter_select_area");
	select_area.setAttribute("multiple", "multiple");

	//console.log("filter_type_area", filter_type_area)
	//console.log("select_area", select_area)
	//console.log("default_filter_js", default_filter_js)
	//console.log("load options", customer_filter_options)


	let all_defaults = []

	if (default_filter_js) {
		default_filter_js = default_filter_js.toString();
		default_filter_js = JSON.parse(default_filter_js)
		all_defaults = default_filter_js;
	}



	//console.log("filter_type_area", filter_type_area)
	//console.log("make_selected_filters", all_defaults)

	for (dfs in all_defaults) {
		var new_option = document.createElement("option");
		new_option.text = all_defaults[dfs];
		new_option.value = all_defaults[dfs];
		new_option.selected = "selected";
		//console.log("adding ", new_option)
		select_area.add(new_option);

	}


	filter_type_area.replaceWith(select_area);


	explore_filters_picker = $(select_area).selectize({
		plugins: ["restore_on_backspace", "remove_button"],
		persist: true,
		searchField: "value",
		maxItems: 12,
		options: customer_filter_options,
		respect_word_boundaries: false,
		onChange: function (value) {
			changeFilters(value);
		},
		onItemAdd: function (value, $item) {
			this.close();
		},
		onDropdownClose: function (dropdown) {
			$(dropdown).prev().find('input').focus();
		},
		render: {
			item: function (item, escape) {
				//console.log("render: ", item, "escape: ", escape);
				return (
					"<div><span>" + item.title + "</span></div>"
				);
			},
			option: function (item, escape) {
				//var label = item.title || item.value;
				//console.log("item to render", item)
				return (
					"<div><span>" + item.title + "</span></div>"
				);
			},
		}
	});

}


function send_email_message() {
	let selection_list = digestGridOptions.api.getRenderedNodes();
	let sdata = []

	for (asel in selection_list) {
		sdata.push(selection_list[asel].data)
	}

	if (document.querySelector("#digest_send_to .Select-value .Select-value-label")) {
		let dsto = []
		const selected_email = Array.from(document.querySelectorAll("#digest_send_to .Select-value .Select-value-label"));
		for (var i = 0; i < selected_email.length; i++) {
			//console.log("email:", selected_email[i]);
			let email_address = selected_email[i].innerText
			dsto.push(email_address.trim())
		}

		const selected_template = document.querySelectorAll("#digest_template .Select-value .Select-value-label")[0].innerText;

		//let dsto = document.querySelectorAll("#digest_send_to .Select-value").innerText;
		let dsorg = document.getElementById("digest_org").value;
		let dsrange = document.getElementById("digest_range").value;
		let dssubject = "Event Digest " + dsorg + " " + dsrange
		let payload_data = {}
		payload_data["events"] = sdata;
		payload_data["daterange"] = dsrange;
		payload_data["customer"] = dsorg
		let jsondata = {
			"message_body": "",
			"message_payload": payload_data,
			"message_type": "digest_template",
			"message_template": selected_template,
			"message_subject": dssubject,
			"message_to": dsto
		}

		//console.log("jsondata", jsondata)
		res = axios.post('/xapi/message/send',
			jsondata, {
			headers: {
				'Content-Type': 'application/json'
			}
		}
		).then(response => {
			let response_msg;
			if ("msg" in response.data) {
				response_msg = response.data["msg"]
			}
			display_toast("Sent Daily Digest to (" + dsto + ") - " + response_msg);
		})
			.catch(error => {
				console.log(error);
				display_toast("Could not send Daily Digest " + error, mdtoast.ERROR);
			});


	} else {
		display_toast("No Recipients Selected", mdtoast.ERROR);
	}
}


function send_email_message_old() {
	let dsm = document.getElementById('daily_digest_selection');
	let dsm_email = '';
	if (dsm.outerHTML)
		dsm_email = dsm.outerHTML;
	else if (XMLSerializer)
		dsm_email = new XMLSerializer().serializeToString(dsm);

	if (document.querySelector("#digest_send_to .Select-value .Select-value-label")) {
		let dsto = []
		const selected_email = Array.from(document.querySelectorAll("#digest_send_to .Select-value .Select-value-label"));
		for (var i = 0; i < selected_email.length; i++) {
			let email_address = selected_email[i].innerText
			dsto.push(email_address.trim())
		}

		//let dsto = document.querySelectorAll("#digest_send_to .Select-value").innerText;
		let dsorg = document.getElementById("digest_org").value;
		let dsrange = document.getElementById("digest_range").value;
		let dssubject = "Event Digest - " + dsorg + " - " + dsrange
		let jsondata = {
			"message_body": dsm_email,
			"message_type": "digest",
			"message_subject": dssubject,
			"message_to": dsto
		}


		res = axios.post('/xapi/message/send',
			jsondata, {
			headers: {
				'Content-Type': 'application/json'
			}
		}
		).then(response => {
			console.log(response);
			display_toast("Sent Daily Digest to " + dsto);
		})
			.catch(error => {
				console.log(error);
				display_toast("Could not send Daily Digest " + error, mdtoast.ERROR);
			});

	} else {
		display_toast("No Recipient Selected", mdtoast.ERROR);
	}


}



function display_toast(msg, toast_type = mdtoast.SUCCESS) {
	var wingToast = mdtoast(msg, { duration: 5000, init: true, position: 'top right', type: toast_type });
	wingToast.show();
}

// Exporting for cross-module usage
window.display_toast = display_toast;


function ready_dashboard() {
	console.log("ready_dashboard");
	customerid = document.querySelector("#customer_id").value;
}


function ready_details() {

	//console.log("ready_details");
	actionid = document.querySelector("#detail_id").value;
	customerid = document.querySelector("#customer_id").value;

	//console.log("bind to edit title action");
	title_edit_button = document.getElementById("details-edit-button")

	//console.log("bind to save title action");
	title_save_button = document.getElementById("details-save-title-button");

	//console.log("bind to cancel title action");
	title_cancel_button = document.getElementById("details-cancel-title-button");

	//console.log("bind to edit tag action");
	tag_edit_button = document.getElementById("details-add-tag-button")

	//console.log("bind to save tag action");
	tag_save_button = document.getElementById("details-save-tag-button");

	//console.log("bind to cancel tag action");
	tag_cancel_button = document.getElementById("details-cancel-tag-button");


	//console.log("bind to watch event tag action");
	watch_event_button = document.getElementById("watch_event")




	category_edit_button = document.getElementById("details-edit-category-button")
	category_save_button = document.getElementById("details-save-category-button");
	category_cancel_button = document.getElementById("details-cancel-category-button");

	status_edit_button = document.getElementById("details-edit-status-button")
	status_save_button = document.getElementById("details-save-status-button");
	status_cancel_button = document.getElementById("details-cancel-status-button");

	like_capture_area = document.getElementById("like_capture_area");


	if (document.getElementById("event-resolve-normal")) {
		resolve_button_normal = document.getElementById("event-resolve-normal")
		resolve_button_normal.addEventListener("click", function (e) {
			close_event("normal");
			e.preventDefault();
			return false;
		});
	}



	//console.log("bind to edit category action")


	title_edit_button.addEventListener("click", function (e) {
		make_title_editable();
		e.preventDefault();
		return false;
	});

	title_edit_button.addEventListener("focusout", function (e) {
		//console.log("save and blur from focusout");
		e.preventDefault();
		return false;
	});

	title_edit_button.addEventListener("keydown", function (e) {
		if (e.key === "Enter") {
			//console.log("save and blur from enter key");
		}
		e.preventDefault();
		return false;
	});

	title_save_button.addEventListener("click", function (e) {
		save_title();
		e.preventDefault();
		return false;
	});

	title_cancel_button.addEventListener("click", function (e) {
		location.reload();
		e.preventDefault();
		return false;
	});

	tag_edit_button.addEventListener("click", function (e) {
		console.log("edit tags");
		make_select_tags();
		e.preventDefault();
		return false;
	});

	tag_cancel_button.addEventListener("click", function (e) {
		location.reload();
		e.preventDefault();
		return false;
	});

	tag_save_button.addEventListener("click", function (e) {
		save_tags();
		e.preventDefault();
		return false;
	});


	/*
	watch_event_button.addEventListener("click", function(e) {
		watch_event();
		e.preventDefault();
		return false;
	})
	*/


	category_edit_button.addEventListener("click", function (e) {
		//console.log("edit category");
		make_select_category();
		e.preventDefault();
		return false;
	});

	category_cancel_button.addEventListener("click", function (e) {
		location.reload();
		e.preventDefault();
		return false;
	});

	category_save_button.addEventListener("click", function (e) {
		save_category();
		e.preventDefault();
		return false;
	});


	status_edit_button.addEventListener("click", function (e) {
		make_select_status();
		e.preventDefault();
		return false;
	});

	status_save_button.addEventListener("click", function (e) {
		save_status();
		e.preventDefault();
		return false;
	});

	status_cancel_button.addEventListener("click", function (e) {
		location.reload();
		e.preventDefault();
		return false;
	});



	if (like_capture_area) {
		make_like_capture();
	}

	//console.log("share link setup")
	new ClipboardJS('#share_event', {
		text: function (trigger) {
			const currentUrl = window.location.href;
			display_toast("Copied direct link to your clipboard", mdtoast.INFO);
			trigger.style.backgroundColor = "#a8f1a8";
			return currentUrl;
		}
	});


	url = new URL(window.location.href);

	if (url.searchParams.has('action')) {
		display_toast("Thank you for the feedback!");
	}

}



function expand_chart() {

	console.log(this);
}

function formatCategories(category) {
	console.log("category", category)
	return category;
};




function make_select_category() {
	var selected_category = document.getElementById("event_cat_selected").value;
	var categories_available = document.getElementById("event_cats").value
	categories_available = JSON.parse(categories_available)
	let get_resources = window.get_resources_by_event_types(categories_available)
	//console.log("get_resources", get_resources);
	var selectize_category_area = document.getElementById("category_editor_area")

	var category_edit_button = document.getElementById("details-edit-category-button")
	var category_save_button = document.getElementById("details-save-category-button")
	var category_cancel_button = document.getElementById("details-cancel-category-button")

	var customer_category_options = [];
	for (category in get_resources) {
		var newcategory = { title: get_resources[category].name, value: get_resources[category].category, name: get_resources[category].name, color: get_resources[category].color, img: get_resources[category].img }
		customer_category_options.push(newcategory)
	}


	var select_area = document.createElement("select");
	select_area.setAttribute('class', 'category_select_area');
	select_area.setAttribute("id", "category_select_area");

	category_edit_button.classList.add("btn-hide");
	category_save_button.classList.remove("btn-hide");
	category_cancel_button.classList.remove("btn-hide");

	var new_option = document.createElement("option");
	new_option.text = selected_category;
	new_option.value = selected_category;
	new_option.selected = "selected";
	select_area.add(new_option);

	selectize_category_area.replaceWith(select_area);



	details_category_editor_control = $(select_area).selectize({
		plugins: ["restore_on_backspace", "remove_button"],
		persist: true,
		maxItems: 1,
		options: customer_category_options,
		render: {
			item: function (item, escape) {
				console.log("render: ", item, "escape: ", escape);
				return (
					"<div><img src='" + item.img + "' style='width: 24px;' /><span>" + item.name + "</span></div>"
				);
			},
			option: function (item, escape) {
				//var label = item.title || item.value;
				console.log("item to render", item)
				return (
					"<div><img src='" + item.img + "' style='width: 24px;' /><span>" + item.name + "</span></div>"
				);
			},
		}
	});

}



function make_select_tags() {
	var selected_tags = document.getElementById("detail_tags").value;
	selected_tags = JSON.parse(selected_tags)
	var tags_available = document.getElementById("detail_tags_available").value
	tags_available = JSON.parse(tags_available)

	var selectize_tag_area = document.getElementById("tag_editor_area")

	var tag_edit_button = document.getElementById("details-add-tag-button")
	var tag_save_button = document.getElementById("details-save-tag-button")
	var tag_cancel_button = document.getElementById("details-cancel-tag-button")



	var select_area = document.createElement("select");
	select_area.setAttribute('class', 'tag_select_area');
	select_area.setAttribute("id", "tag_select_area");
	select_area.setAttribute("multiple", "multiple");

	tag_edit_button.classList.add("btn-hide");
	tag_save_button.classList.remove("btn-hide");
	tag_cancel_button.classList.remove("btn-hide");

	if (selected_tags.length > 0) {
		for (tag in selected_tags) {
			var new_option = document.createElement("option");
			new_option.text = selected_tags[tag];
			new_option.value = selected_tags[tag];
			new_option.selected = "selected";
			select_area.add(new_option);
		}
	}

	selectize_tag_area.replaceWith(select_area);

	var customer_tag_options = [];
	for (atag in tags_available) {
		var newtag = { title: tags_available[atag], value: tags_available[atag] }
		customer_tag_options.push(newtag)
	}


	details_tag_editor_control = $(select_area).selectize({
		plugins: ["restore_on_backspace", "remove_button"],
		persist: true,
		maxItems: null,
		valueField: "value",
		labelField: "title",
		searchField: ["title", "value"],
		options: customer_tag_options,
		render: {
			item: function (item, escape) {
				return (
					"<span class='badge badge_tag_user'>" +
					item.title +
					"</span>"
				);
			},
			option: function (item, escape) {
				var label = item.title || item.value;
				return (
					'<span class="badge badge_tag_user_incoming">' +
					escape(label) +
					"</span>"
				);
			},
		}
	});

}




function make_select_status() {
	var selected_status = document.getElementById("event_status_selected").value;
	var selectize_status_area = document.getElementById("status_editor_area")

	var status_edit_button = document.getElementById("details-edit-status-button")
	var status_save_button = document.getElementById("details-save-status-button")
	var status_cancel_button = document.getElementById("details-cancel-status-button")


	var select_area = document.createElement("select");
	select_area.setAttribute('class', 'status_select_area');
	select_area.setAttribute("id", "status_select_area");

	status_edit_button.classList.add("btn-hide");
	status_save_button.classList.remove("btn-hide");
	status_cancel_button.classList.remove("btn-hide");

	var new_option = document.createElement("option");
	new_option.text = selected_status;
	new_option.value = selected_status;
	new_option.selected = "selected";
	select_area.add(new_option);

	selectize_status_area.replaceWith(select_area);



	details_status_editor_control = $(select_area).selectize({
		persist: true,
		maxItems: 1,
		valueField: "value",
		labelField: "title",
		searchField: ["title", "value"],
		options: customer_status_options,
		render: {
			item: function (item, escape) {
				return (
					"<div class=''>" +
					item.title +
					"</div>"
				);
			},
			option: function (item, escape) {
				var label = item.title || item.value;
				return (
					'<div class="">' +
					escape(label) +
					"</div>"
				);
			},
		}
	});

}


function save_status() {

	var selected_status = document.getElementById("event_status_selected");
	var selectize_status_area = document.getElementById("status_editor_area")

	var status_edit_button = document.getElementById("details-edit-status-button")
	var status_save_button = document.getElementById("details-save-status-button")
	var status_cancel_button = document.getElementById("details-cancel-status-button")


	var selectedstatus = $('#status_select_area').val()

	var update_json = {};
	update_json["status"] = selectedstatus;

	var jsondata = JSON.stringify(update_json);

	console.log("put", jsondata)

	res = axios.put('/xapi/event/' + actionid,
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		selected_status.value = selectedstatus;
		status_edit_button.classList.remove("btn-hide");
		status_save_button.classList.add("btn-hide");
		status_cancel_button.classList.add("btn-hide");

		var status_control = details_status_editor_control[0].selectize;
		status_control.destroy()

		var event_div = document.createElement("div");
		event_div.setAttribute("id", "status_editor_area");

		let status_details = customer_status_options.find(o => o.value === selectedstatus);

		//cat_details = customer_status_options[selectedcategory]
		console.log("cat_details", status_details);

		var status_span = document.createElement("span");
		status_span.innerHTML = status_details.title;
		event_div.appendChild(status_span)


		var status_editor = document.getElementById("status_select_area")

		status_editor.replaceWith(event_div);

	})
		.catch(error => {
			console.log(error);
		});




}




function make_title_editable() {
	var title_field = document.getElementById("details-title");
	var title_edit_button = document.getElementById("details-edit-button");
	var title_save_button = document.getElementById("details-save-title-button");
	var title_cancel_button = document.getElementById("details-cancel-title-button");

	title_edit_button.classList.add("btn-hide");

	title_save_button.classList.remove("btn-hide");
	title_cancel_button.classList.remove("btn-hide");


	var text_area = document.createElement("input");
	text_area.setAttribute('type', 'text');
	text_area.setAttribute('class', 'title_edit_area');
	text_area.setAttribute("id", "title_edit_area");
	text_area.setAttribute("value", title_field.innerText);



	title_field.replaceWith(text_area);



}


function make_category_editable() {

	/*
	<select class="select">
	  <option value="1" data-mdb-icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-1.jpg"
		>One</option
	  >
	  <option value="2" data-mdb-icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-2.jpg"
		>Two</option
	  >
	  <option value="3" data-mdb-icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-3.jpg"
		>Three</option
	  >
	  <option value="4" data-mdb-icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-4.jpg"
		>Four</option
	  >
	  <option value="5" data-mdb-icon="https://mdbootstrap.com/img/Photos/Avatars/avatar-5.jpg"
		>Five</option
	  >
	</select>
	*/

}


function save_title() {
	var title_edit_area = document.getElementById("title_edit_area");
	var title_edit_button = document.getElementById("details-edit-button");
	var title_save_button = document.getElementById("details-save-title-button");
	var title_cancel_button = document.getElementById("details-cancel-title-button");

	var title_value = title_edit_area.value

	var update_json = {};
	update_json["name"] = title_value;

	var jsondata = JSON.stringify(update_json);

	console.log("put", jsondata)

	res = axios.put('/xapi/event/' + actionid,
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		title_edit_button.classList.remove("btn-hide");
		title_save_button.classList.add("btn-hide");
		title_cancel_button.classList.add("btn-hide");

		var title_text = document.createElement("h5");
		title_text.setAttribute('class', 'details-title');
		title_text.setAttribute("id", "details-title");
		title_text.innerHTML = title_value;

		title_edit_area.replaceWith(title_text);

	})
		.catch(error => {
			console.log(error);
		});




}



function save_category() {
	var selected_category = document.getElementById("event_cat_selected");
	var category_edit_button = document.getElementById("details-edit-category-button")
	var category_save_button = document.getElementById("details-save-category-button")
	var category_cancel_button = document.getElementById("details-cancel-category-button")
	var categories_available = document.getElementById("event_cats").value
	categories_available = JSON.parse(categories_available)

	var selectedcategory = $('#category_select_area').val()

	var update_json = {};
	update_json["type"] = selectedcategory;

	var jsondata = JSON.stringify(update_json);

	console.log("put", jsondata)

	res = axios.put('/xapi/event/' + actionid,
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		selected_category.value = selectedcategory;
		category_edit_button.classList.remove("btn-hide");
		category_save_button.classList.add("btn-hide");
		category_cancel_button.classList.add("btn-hide");

		var category_control = details_category_editor_control[0].selectize;
		category_control.destroy()

		var event_div = document.createElement("div");
		event_div.setAttribute("id", "category_editor_area");

		cat_details = categories_available[selectedcategory]
		console.log("cat_details", cat_details);

		var event_img = document.createElement("img");
		event_img.setAttribute("src", cat_details.icon);
		event_img.style.width = "24px";
		event_div.appendChild(event_img)

		var event_span = document.createElement("span");
		//event_span.style.color = cat_details.color;
		event_span.innerHTML = cat_details.display_name;
		event_div.appendChild(event_span)

		var category_editor = document.getElementById("category_select_area")

		category_editor.replaceWith(event_div);

	})
		.catch(error => {
			console.log(error);
		});




}





function close_event(close_type) {

	var update_json = {};
	update_json["status"] = "archived";

	var jsondata = JSON.stringify(update_json);

	console.log("put", jsondata)

	res = axios.put('/xapi/event/' + actionid,
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		location.reload();

	})
		.catch(error => {
			console.log(error);
		});




}





function save_tags() {

	var selected_tags = document.getElementById("detail_tags");

	var tag_edit_button = document.getElementById("details-add-tag-button")
	var tag_save_button = document.getElementById("details-save-tag-button")
	var tag_cancel_button = document.getElementById("details-cancel-tag-button")


	var selectedtags = $('#tag_select_area').val()

	var update_json = {};
	update_json["tags"] = selectedtags;

	var jsondata = JSON.stringify(update_json);

	console.log("put", jsondata)

	res = axios.put('/xapi/event/' + actionid,
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		tag_edit_button.classList.remove("btn-hide");
		tag_save_button.classList.add("btn-hide");
		tag_cancel_button.classList.add("btn-hide");

		var tag_control = details_tag_editor_control[0].selectize;
		tag_control.destroy()

		var event_div = document.createElement("div");
		event_div.setAttribute("id", "tag_editor_area");

		let detail_tags_value = selectedtags;
		selected_tags.value = JSON.stringify(detail_tags_value);
		for (ntag in detail_tags_value) {
			var event_span = document.createElement("span");
			event_span.setAttribute("class", "badge badge_tag_user");
			event_span.innerHTML = detail_tags_value[ntag]
			event_div.appendChild(event_span)
		}



		var tags_editor = document.getElementById("tag_select_area")

		tags_editor.replaceWith(event_div);

	})
		.catch(error => {
			console.log(error);
		});




}



function watch_event() {

	let watch_event_button = document.getElementById("watch_event")

	let actionid = document.querySelector("#detail_id").value;
	let loggedinid = document.querySelector("#loggedin_js").value;
	let customerid = document.querySelector("#customer_id").value;
	console.log("watch event", customerid, actionid, loggedinid)
	jsondata = { "customerid": customerid, "actionid": actionid, "userid": loggedinid }
	res = axios.post('/xapi/settings/watch',
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		//display_toast("Sent Daily Digest to " + dsto);
		display_toast("You are now subscribed to event changes");
		watch_event_button.style.backgroundColor = "#77e789";
	})
		.catch(error => {
			console.log(error);
			//display_toast("Could not send Daily Digest " + error, mdtoast.ERROR);
			display_toast("You could not be subscribed to event changes", mdtoast.ERROR);
			//watch_event_button.style.backgroundColor = "#77e789";
		});


}


function make_like_capture() {

	var like_capture_area = document.getElementById("like_capture_area");
	var like_status = $('#event_like_status').val()

	console.log("make_like_capture", like_status)

	like_capture_area.innerHTML = '<a id="card-like-up" class="btn btn-link" href="#"></a><a id="card-like-down" class="btn btn-link" href="#"></a>';

	var cardlike = like_capture_area.querySelector("#card-like-up");
	var carddislike = like_capture_area.querySelector("#card-like-down");

	//console.log("cardlike", cardlike)
	//console.log("carddislike", carddislike)

	if (like_status) {
		draw_likes(like_capture_area, like_status);
	} else {
		cardlike.classList.add("btn-like")
		carddislike.classList.add("btn-unlike")
	}

	active_event_track = actionid;

	cardlike.addEventListener("click", function (e) {
		update_likes(like_capture_area, "like", active_event_track);
		e.preventDefault();
		return false;
	})

	carddislike.addEventListener("click", function (e) {
		update_likes(like_capture_area, "dislike", active_event_track);
		e.preventDefault();
		return false;
	})

}

function slack_capture() {
	console.log("getScreen")
	getScreen()
}


function typeWriterEffectHTML(element, htmlText, speed) {
	return new Promise((resolve) => {
		let i = 0;
		let tempHTML = "";

		function type() {
			if (i < htmlText.length) {
				tempHTML += htmlText.charAt(i);
				element.innerHTML = tempHTML;
				i++;
				setTimeout(type, speed);
			} else {
				resolve(); // Resolve the Promise when typing is complete
			}
		}

		type();
	});
}


function addChatNoEffectHTML(element, htmlText) {
	return new Promise((resolve) => {
		element.innerHTML = htmlText;
		resolve(); // Resolve the Promise when typing is complete
	});
}


window.slightdelay = function(ms) {
	return new Promise(resolve => setTimeout(resolve, ms));
}



var customNodeCreator = function (character) {
	return document.createTextNode(character);
}

function fivedigit() {
	return Math.floor(Math.random() * 90000) + 10000;
}


/* extracted closeswanbot */



/* extracted showswanbot */



/* extracted swanbot_input_init */




/* extracted dataexplorer_swanbot_input_init */


function clean_e_chat(text) {
	text = findgraphs(text);
	return DOMPurify.sanitize(marked.parse(text));
	//return text.replace(/\r\n|\r|\n/g, "<br>");
}



/* extracted clean_swanbot_chat */






/* extracted clean_dataexplorer_swanbot_chat */





function handle_dataexplorer_events(text) {
	findlinks(text);
}




function handlegraph(text, graphtoprocess) {
	//console.log("graphtoprocess", graphtoprocess)
	//console.log("text", text)
	const findid = /([0-9]+)/g;
	const graphid = graphtoprocess.match(findid);
	//console.log("get graphid", graphid[0]);

	window.swanbot_graphs.push(graphid[0])
	var cleantext = text.replace(graphtoprocess, '');
	return cleantext
}

window.findgraphs = function(text) {
	window.swanbot_graphs = [];

	//console.log("raw text", text)
	const findgraphregex = /<graph id=([0-9]+) \/>/g;
	//console.log('<graph>([\s\S]*?)<\/graph>/g;')
	const allgraphs = text.matchAll(findgraphregex);

	for (const match of allgraphs) {
		text = handlegraph(text, match[0]);
		//console.log(`Found ${match[0]} at index ${match.index}.`);
	}
	//console.log("allgraphs", allgraphs); 
	return text;
}


// Function to disable all buttons with a specific class
function disableButtonsByClass(className) {
	const buttons = document.querySelectorAll(`.${className}`);
	buttons.forEach(button => {
		button.disabled = true;
	});
}

// Function to enable all buttons with a specific class
function enableButtonsByClass(className) {
	const buttons = document.querySelectorAll(`.${className}`);
	buttons.forEach(button => {
		button.disabled = false;
	});
}




function findlinks(text) {

	//console.log("findlinks", text)
	const findlinksregex = /https:\/\/wingman\.grayswan\.io\/events\/details\?event=([a-zA-Z0-9]+)/g;

	const alllinks = text.matchAll(findlinksregex);

	for (const match of alllinks) {
		if (!swanbot_dataexplorer_links.includes(match[1])) {
			swanbot_dataexplorer_links.push(match[1]);
		}
		//console.log(`Found ${match[0]} and ${match[1]} at index ${match.index}.`);
	}
}


async function display_dataexplorer_totals() {

	let queryeventoutput = document.getElementById("graph-dataexplorer-totals");
	let queryeventoutput_table_exists = document.getElementById("graph-dataexplorer-totals-table");
	let queryevent_button_id = document.querySelector("#toggle_dataexplorer_graph_totals span");
	let focusdata = window.WingmanState.swanbot_dataexplorer_graphdata["focus"] || {};

	let totals_data = "";


	if (queryeventoutput_table_exists) {

		queryeventoutput.innerHTML = totals_data;
		queryevent_button_id.innerText = "Source Totals"



	} else {

		queryevent_button_id.innerText = "Hide Source Totals"
		totals_data += "<h4>Source Totals  <button class='btn btn-sm btn-link copy_source_table_btn' id='copy_source_table_btn'><span class=''><i class='heroicons-outline--clipboard-copy'></i></span></button> <button class='btn btn-sm btn-link download_source_table_btn' id='download_source_table_btn'><span class=''><i class='icon-park--download'></i></span></button></h4>"
		totals_data += '<div id="graph-dataexplorer-totals-table"></div>'

		queryeventoutput.innerHTML = totals_data;



		createSummaryTable(window.WingmanState.swanbot_dataexplorer_graphdata, "graph-dataexplorer-totals-table")




		document.getElementById("copy_source_table_btn").addEventListener("click", function (e) {
			copyTableToClipboard("sourceSummaryTable")
			e.preventDefault();
			return false;
		});

		document.getElementById("download_source_table_btn").addEventListener("click", function (e) {
			downloadCSV(window.WingmanState.swanbot_dataexplorer_graphdata)
			e.preventDefault();
			return false;
		})


		swanbot_dataexplorer_totalstable_isopen = true;





	}

}





const getSum = (arr) => {
	if (!arr || !Array.isArray(arr)) {
		return 0;
	}
	return arr.reduce((sum, current) => sum + (current || 0), 0);
};










/**
 * Dynamic formatter to handle unbound column types.
 * @param {string} key - The metric key (e.g., "revenue", "impressions")
 * @param {number} value - The numeric value to format
 * @param {boolean} isCsv - Whether to return a CSV-friendly string (no commas)
 */
function formatMetricValue(key, value, isCsv = false) {
	if (value === null || value === undefined) return "N/A";

	const upperKey = key.toUpperCase();

	// Handle specific exclusion: REVENUE IMPRESSIONS is a count, not currency
	//if (upperKey.includes("REVENUE IMPRESSIONS")) {

	if (window.WingmanState.swanbot_dataexplorer_graphdata["axis_types"]["transactions"].some(item => upperKey === item.toUpperCase())) {

		const formattedNum = Math.floor(value).toLocaleString();
		return isCsv ? formattedNum.replaceAll(',', '') : formattedNum;
	}

	// Handle currency-like fields (Revenue, Cost, Profit, Rev, CPM)
	//if (upperKey.includes("REV") || upperKey.includes("COST") || upperKey.includes("PROFIT") || upperKey.includes("CPM")) {

	if ([...window.WingmanState.swanbot_dataexplorer_graphdata["axis_types"]["cpm"], ...window.WingmanState.swanbot_dataexplorer_graphdata["axis_types"]["revenue"]].some(item => upperKey === item.toUpperCase())) {
		const formatted = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: 'USD',
			minimumFractionDigits: 2
		}).format(value);
		return isCsv ? formatted.replaceAll(',', '') : formatted;
	}

	// Handle other decimal/rate fields (Rate, Percentage)
	if (upperKey.includes("RATE") || upperKey.includes("PERCENT")) {
		return value.toFixed(2);
	}

	// Handle standard numbers (Impressions, Transactions, etc)
	const formattedNum = value.toLocaleString();
	return isCsv ? formattedNum.replaceAll(',', '') : formattedNum;
}








/**
 * Creates a summary table with Metrics as Columns and Data Sources (Main + Subgraphs) as Rows.
 * Includes Comparison data rows if available.
 */
function createSummaryTable(dataObject, containerId) {
	const tableContainer = document.getElementById(containerId);
	if (!tableContainer) {
		console.error("Table container not found:", containerId);
		return;
	}

	// Guard against null data to prevent infinite loops or crashes
	if (!dataObject) return;

	const allRows = prepareAllDataRows(dataObject);

	// Identify Unique Columns (Metric Names)
	const metricKeysSet = new Set();
	allRows.forEach(row => {
		if (row.totals && typeof row.totals === 'object') {
			Object.keys(row.totals).forEach(key => metricKeysSet.add(key));
		}
	});
	const metricKeys = Array.from(metricKeysSet);

	// Build Table
	tableContainer.innerHTML = '';

	// Bootstrap: table-responsive wrapper
	const wrapper = document.createElement('div');
	wrapper.className = "table-responsive border rounded";

	const table = document.createElement('table');
	table.className = "table table-striped table-hover table-sm mb-0";
	table.id = "sourceSummaryTable";
	table.style.fontSize = "0.875rem";

	const thead = document.createElement('thead');
	thead.className = "table-light";
	const headerRow = document.createElement('tr');

	// --- Header: Source Column ---
	const sourceTh = document.createElement('th');
	sourceTh.textContent = "Source";
	sourceTh.style.maxWidth = "180px";
	sourceTh.style.minWidth = "120px";
	sourceTh.style.overflow = "hidden";
	sourceTh.style.textOverflow = "ellipsis";
	sourceTh.style.whiteSpace = "nowrap";
	sourceTh.className = "px-3 align-middle";
	headerRow.appendChild(sourceTh);

	metricKeys.forEach(key => {
		const th = document.createElement('th');
		th.className = "px-3 align-middle text-capitalize";
		th.style.whiteSpace = "nowrap";
		// Convert to string explicitly to prevent RangeError on non-string types
		const label = String(key).split('_').join(' ');
		th.textContent = label;
		headerRow.appendChild(th);
	});
	thead.appendChild(headerRow);
	table.appendChild(thead);

	const tbody = document.createElement('tbody');
	allRows.forEach(row => {
		const tr = document.createElement('tr');
		if (row.isComparison) {
			tr.className = "table-light text-muted fst-italic";
		}

		// --- Body: Source Cell ---
		const nameCell = document.createElement('td');
		nameCell.textContent = row.name;
		nameCell.title = row.name;
		nameCell.className = `px-3 align-middle ${row.isComparison ? '' : 'fw-bold'}`;

		nameCell.style.maxWidth = "180px";
		nameCell.style.overflow = "hidden";
		nameCell.style.textOverflow = "ellipsis";
		nameCell.style.whiteSpace = "nowrap";

		tr.appendChild(nameCell);

		metricKeys.forEach(key => {
			const valCell = document.createElement('td');
			valCell.className = "px-3 align-middle font-monospace";
			valCell.style.whiteSpace = "nowrap";
			const rawValue = row.totals ? row.totals[key] : undefined;
			valCell.textContent = (rawValue !== undefined) ? formatMetricValue(key, rawValue) : "-";
			tr.appendChild(valCell);
		});
		tbody.appendChild(tr);
	});

	table.appendChild(tbody);
	wrapper.appendChild(table);
	tableContainer.appendChild(wrapper);

	// Ensure this global flag exists and is only set once
	if (typeof swanbot_dataexplorer_totalstable_isopen !== 'undefined') {
		swanbot_dataexplorer_totalstable_isopen = true;
	}
}




/**
 * Internal helper to unify data row extraction for Table and CSV.
 */
function prepareAllDataRows(dataObject) {
	const parseGraphPayload = function (value) {
		if (typeof value === 'string') {
			try {
				return JSON.parse(value);
			} catch (e) {
				return null;
			}
		}

		return value && typeof value === 'object' ? value : null;
	};

	const rows = [];
	const mainGraphData = parseGraphPayload(dataObject.graphs);
	const compareGraphData = parseGraphPayload(dataObject.graphs_compare);

	// Main Graph
	const mainTotals = mainGraphData?.totals || {};
	rows.push({ name: "[Source Totals]", totals: mainTotals, isComparison: false });

	if (compareGraphData?.totals) {
		rows.push({ name: "[Source Totals] Comparison", totals: compareGraphData.totals, isComparison: true });
	}

	// Subgraphs
	if (Array.isArray(dataObject.subgraphGroupData)) {
		dataObject.subgraphGroupData.forEach((group, index) => {
			const groupObj = parseGraphPayload(group);
			const title = dataObject.subgraphGroupTitles?.[index] || `[No Name Source ${index + 1}]`;

			rows.push({ name: title, totals: groupObj?.totals || {}, isComparison: false });

			if (dataObject.subgraphs_compare && dataObject.subgraphs_compare[index]) {
				const comp = dataObject.subgraphs_compare[index];
				const compObj = parseGraphPayload(comp);
				rows.push({ name: `${title} Comparison`, totals: compObj?.totals || {}, isComparison: true });
			}
		});
	}
	return rows;
}






/**
 * Generates and downloads a CSV file from the provided data.
 * Updated to properly escape fields containing commas or quotes.
 */

/* extracted downloadCSV */







/**
 * Creates a summary table from the provided data.
 * @param {object} dataObject - The full data object.
 * @param {string} containerId - The ID of the HTML element to render the table into.
 */

/* extracted createSummaryTable_classic */






/**
 * Generates and downloads a CSV file from the provided data.
 * @param {object} dataObject - The full data object.
 * @param {string} fileName - The desired name for the downloaded file.
 */

/* extracted downloadCSV_classic */




function copyTableToClipboard(tableId) {
	const table = document.getElementById(tableId);
	if (!table) {
		console.error("Table not found:", tableId);
		return;
	}

	let tsvText = "";

	// Get table headers
	const headerCells = table.querySelectorAll('thead th');
	const headerText = Array.from(headerCells).map(cell => cell.textContent.trim()).join('\t');
	tsvText += headerText + '\n';

	// Get table body rows
	const bodyRows = table.querySelectorAll('tbody tr');
	bodyRows.forEach(row => {
		const rowCells = row.querySelectorAll('td');
		const rowText = Array.from(rowCells).map(cell => cell.textContent.trim()).join('\t');
		tsvText += rowText + '\n';
	});

	// Create a temporary textarea to hold the text
	const tempTextArea = document.createElement('textarea');
	tempTextArea.value = tsvText;
	document.body.appendChild(tempTextArea);
	tempTextArea.select();

	// Copy the text to the clipboard
	try {
		const successful = document.execCommand('copy');
		if (successful) {
			display_toast("Copied source data to your clipboard", mdtoast.INFO);
		} else {
			display_toast("Copy failed - Please try again", mdtoast.ERROR);
		}
	} catch (err) {
		console.error('Copy failed:', err);
		display_toast("Copy failed - Please try again", mdtoast.ERROR);
	}

	// Clean up the temporary textarea
	document.body.removeChild(tempTextArea);
}


async function display_links() {

	let max_events = swanbot_dataexplorer_links.length;
	let queryeventoutput = document.getElementById("graph-dataexplorer-events");
	let i = 0;
	let event_data = "";
	let eventsSectionTitle = formatDataExplorerEventsSectionTitle(max_events);
	ensureDataExplorerSectionToggleStyles();
	event_data += '<div class="accordion" id="eventAccordian">'

	while (i < max_events) {
		let event_id = swanbot_dataexplorer_links[i];
		//console.log("links", swanbot_dataexplorer_links, event_id)
		const response = await get_event_data(event_id);
		const cardresponse = await generate_data_card(event_id); //swanbot_dataexplorer_links_data[swanbot_dataexplorer_links[i]]
		event_data += swanbot_dataexplorer_links_data[event_id]["card_data"]; //swanbot_dataexplorer_links_data[swanbot_dataexplorer_links[i]]["card_data"]
		i++;
	}

	event_data += '</div>'

	queryeventoutput.innerHTML = renderDataExplorerCollapsibleSection('events', eventsSectionTitle, event_data);
	bindDataExplorerSectionToggleHandlers(queryeventoutput);

	const accordion = document.getElementById('eventAccordian');
	const collapseElements = accordion.querySelectorAll('.collapse');

	collapseElements.forEach(element => {
		bootstrap.Collapse.getOrCreateInstance(element);
		element.addEventListener('hidden.bs.collapse', function (e) {
			e.stopPropagation();
			let tid = e.target.id;
			let event_id = tid.replace("collapse_", "");
			//console.log("Hide event: ", event_id)
		});
		element.addEventListener('shown.bs.collapse', function (e) {
			e.stopPropagation();
			let tid = e.target.id;
			let event_id = tid.replace("collapse_", "");
			//console.log("Show event: ", event_id);
			update_dataexplorer_graph(event_id);
		});
	});


	//console.log("clear the swanbot_dataexplorer_links and underying data")



}

function summarizeDataExplorerAgentText(text, limit = 96) {
	let normalized = String(text || "").replace(/\s+/g, ' ').trim();
	if (!normalized) {
		return "Untitled agent";
	}

	if (normalized.length <= limit) {
		return normalized;
	}

	let truncated = normalized.slice(0, limit - 3).trim();
	let lastSpace = truncated.lastIndexOf(' ');
	if (lastSpace > 0) {
		truncated = truncated.slice(0, lastSpace);
	}

	return truncated.trim() + '...';
}

function escapeDataExplorerHtml(value) {
	return String(value || "")
		.replace(/&/g, '&amp;')
		.replace(/</g, '&lt;')
		.replace(/>/g, '&gt;')
		.replace(/"/g, '&quot;')
		.replace(/'/g, '&#39;');
}

function formatDataExplorerAgentDate(value) {
	if (!value) {
		return 'Never';
	}

	let normalizedInput = String(value).trim();
	if (!normalizedInput || /^never$/i.test(normalizedInput)) {
		return 'Never';
	}

	let parsedTimestamp = parseDataExplorerAgentTimestamp(normalizedInput);
	if (parsedTimestamp !== null) {
		if (window.moment) {
			let dateValue = window.moment.utc(parsedTimestamp);
			if (dateValue.isValid()) {
				return dateValue.format('MMMM D, YYYY H:mm:ss [UTC]');
			}
		}

		let fallbackDate = new Date(parsedTimestamp);
		if (!Number.isNaN(fallbackDate.getTime())) {
			return fallbackDate.toLocaleString('en-US', {
				month: 'long',
				day: 'numeric',
				year: 'numeric',
				hour: 'numeric',
				minute: '2-digit',
				second: '2-digit',
				hour12: false,
				timeZone: 'UTC',
			}) + ' UTC';
		}
	}

	return normalizedInput;
}

function parseDataExplorerAgentTimestamp(value) {
	if (!value) {
		return null;
	}

	let normalizedInput = String(value).trim();
	if (!normalizedInput || /^never$/i.test(normalizedInput)) {
		return null;
	}

	if (window.moment) {
		let parsedWithFormat = window.moment.utc(normalizedInput, ['YYYY-MM-DD_HH-mm-ss', 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm', window.moment.ISO_8601], true);
		if (parsedWithFormat.isValid()) {
			return parsedWithFormat.valueOf();
		}
	}

	let normalizedValue = normalizedInput
		.replace(/^(\d{4}-\d{2}-\d{2})_(\d{2})-(\d{2})-(\d{2})$/, '$1T$2:$3:$4Z')
		.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2}):(\d{2})$/, '$1T$2:$3:$4Z')
		.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}):(\d{2})$/, '$1T$2:$3:00Z');
	let parsed = new Date(normalizedValue);
	if (!Number.isNaN(parsed.getTime())) {
		return parsed.getTime();
	}

	return null;
}

function formatDataExplorerAgentRelativeDate(value) {
	if (!value) {
		return 'Never';
	}

	let timestamp = parseDataExplorerAgentTimestamp(value);

	if (timestamp === null) {
		return String(value);
	}

	let diffSeconds = Math.floor((Date.now() - timestamp) / 1000);
	let isFuture = diffSeconds < 0;
		diffSeconds = Math.abs(diffSeconds);

	if (diffSeconds < 60) {
		return isFuture ? 'In under a minute' : 'Just now';
	}

	let units = [
		{ label: 'day', seconds: 86400 },
		{ label: 'hour', seconds: 3600 },
		{ label: 'minute', seconds: 60 },
	];
	let parts = [];

	units.forEach(unit => {
		if (parts.length >= 3) {
			return;
		}

		let count = Math.floor(diffSeconds / unit.seconds);
		if (count <= 0) {
			return;
		}

		diffSeconds -= count * unit.seconds;
		parts.push(count + ' ' + unit.label + (count === 1 ? '' : 's'));
	});

	if (parts.length === 0) {
		parts.push('1 minute');
	}

	if (parts.length === 1) {
		return isFuture ? ('In ' + parts[0]) : (parts[0] + ' ago');
	}

	let lastPart = parts.pop();
	let combined = parts.join(', ') + ' and ' + lastPart;
	return isFuture ? ('In ' + combined) : (combined + ' ago');
}

function renderDataExplorerAgentRunDateCell(value) {
	let relativeDate = formatDataExplorerAgentRelativeDate(value);
	let utcDate = formatDataExplorerAgentDate(value);

	if (relativeDate === 'Never' && utcDate === 'Never') {
		return "<span class='text-muted'>Never</span>";
	}

	return "<div style='line-height: 1.25; min-width: 190px;'><div style='font-weight: 600;'>" + escapeDataExplorerHtml(relativeDate) + "</div><div class='text-muted mt-1' style='font-size: 11px;'>" + escapeDataExplorerHtml(utcDate) + "</div></div>";
}

function deriveAgentNotificationIcons(agent) {
	let icons = [];
	let seenKinds = new Set();
	let channels = Array.isArray(agent.notification_channels) ? agent.notification_channels : [];
	let iconByKind = {
		email: "<span class='me-2' title='Email delivery'><i class='fas fa-envelope'></i></span>",
		slack: "<span class='me-2' title='Slack delivery'><i class='fab fa-slack'></i></span>",
		inapp: "<span class='me-2' title='In-app alert'><i class='fas fa-bell'></i></span>",
		webhook: "<span class='me-2' title='Webhook delivery'><i class='fas fa-link'></i></span>",
	};

	function normalizeNotificationKind(channelType) {
		if (channelType === 'email') {
			return 'email';
		}
		if (channelType === 'slack') {
			return 'slack';
		}
		if (channelType === 'inapp' || channelType === 'in-app' || channelType === 'in_app' || channelType === 'app' || channelType === 'alert' || channelType === 'notification') {
			return 'inapp';
		}
		if (channelType === 'webhook' || channelType === 'http') {
			return 'webhook';
		}

		return '';
	}

	channels.forEach(channel => {
		if (!channel || channel.enabled === false) {
			return;
		}

		let channelType = String(channel.type || '').trim().toLowerCase();
		let notificationKind = normalizeNotificationKind(channelType);
		if (!notificationKind || seenKinds.has(notificationKind)) {
			return;
		}
		seenKinds.add(notificationKind);
	});

	['email', 'slack', 'inapp', 'webhook'].forEach(notificationKind => {
		if (seenKinds.has(notificationKind)) {
			icons.push(iconByKind[notificationKind]);
		}
	});

	if (icons.length === 0) {
		let haystack = [
			agent.delivery_text,
			agent.delivery,
			agent.notification_style,
			agent.notificationStyle,
			agent.notifications,
			agent.notification,
		].map(item => {
			if (item && typeof item === 'object') {
				try {
					return JSON.stringify(item);
				} catch (_error) {
					return '';
				}
			}
			return String(item || '');
		}).join(' ').toLowerCase();

		if (haystack.includes('email') || haystack.includes('mail')) {
			icons.push(iconByKind.email);
		}
		if (haystack.includes('slack') || haystack.includes('channel') || haystack.includes('dm')) {
			icons.push(iconByKind.slack);
		}
		if (haystack.includes('app') || haystack.includes('alert') || haystack.includes('notify') || haystack.includes('notification')) {
			icons.push(iconByKind.inapp);
		}
		if (haystack.includes('webhook') || haystack.includes('http')) {
			icons.push(iconByKind.webhook);
		}
	}

	return icons.join('');
}

function normalizeDataExplorerAgents(results) {
	let rawAgents = [];
	if (Array.isArray(results)) {
		rawAgents = results;
	} else if (Array.isArray(results && results.agents)) {
		rawAgents = results.agents;
	} else if (Array.isArray(results && results.data)) {
		rawAgents = results.data;
	} else if (Array.isArray(results && results.data && results.data.agents)) {
		rawAgents = results.data.agents;
	}

	return rawAgents.map(agent => {
		let interestText = agent.interest_summary || agent.interest_text || agent.interest || agent.prompt || agent.question || agent.name || agent.description || '';
		let lastRunDate = agent.last_run || agent.lastRun || agent.last_run_at || agent.lastRunAt || agent.last_run_date || agent.lastRunDate || agent.updated_at || agent.updatedAt || 'Never';

		return {
			agentId: agent.agent_id || agent.id || '',
			name: String(agent.name || agent.title || ''),
			interestSummary: summarizeDataExplorerAgentText(interestText),
			interestText: String(agent.interest_text || interestText || ''),
			lastActivityRelative: formatDataExplorerAgentRelativeDate(lastRunDate),
			lastRunDate: formatDataExplorerAgentDate(lastRunDate),
			status: String(agent.status || ''),
			health: String(agent.health || ''),
			notificationChannels: Array.isArray(agent.notification_channels) ? agent.notification_channels : [],
			notificationIcons: deriveAgentNotificationIcons(agent),
		};
	});
}

function renderDataExplorerEventsWaitingState() {
	let queryeventoutput = document.getElementById("graph-dataexplorer-events");
	if (!queryeventoutput) {
		return;
	}

	ensureDataExplorerSectionToggleStyles();
	queryeventoutput.innerHTML = renderDataExplorerCollapsibleSection(
		'events',
		formatDataExplorerEventsSectionTitle(0),
		""
	);
	bindDataExplorerSectionToggleHandlers(queryeventoutput);
}

function getDataExplorerAgentStatusBadge(status) {
	let normalized = String(status || '').trim().toLowerCase();
	if (!normalized) {
		return '';
	}

	let className = 'badge badge-secondary';
	if (normalized === 'success' || normalized === 'active') {
		className = 'badge badge-success';
	} else if (normalized === 'warning') {
		className = 'badge badge-warning';
	} else if (normalized === 'fail' || normalized === 'error' || normalized === 'inactive') {
		className = 'badge badge-danger';
	} else if (normalized === 'disabled') {
		className = 'badge badge-dark';
	}

	return "<span class='" + className + "'>" + escapeDataExplorerHtml(status) + "</span>";
}

function renderDataExplorerAgentBoolean(value, trueLabel, falseLabel) {
	return value ? trueLabel : falseLabel;
}

function maskDataExplorerEmailTarget(target) {
	let value = String(target || '').trim();
	let atIndex = value.indexOf('@');
	if (atIndex <= 0) {
		return value;
	}

	return value.slice(0, atIndex + 1) + '*************';
}

function renderDataExplorerAgentChannels(channels) {
	if (!Array.isArray(channels) || channels.length === 0) {
		return "<div class='text-muted'>No notification channels configured.</div>";
	}

	let items = channels.map(channel => {
		let type = String(channel.type || '').trim();
		let target = String(channel.target || '').trim();
		let normalizedType = type.toLowerCase();
		let displayTarget = normalizedType === 'email' ? maskDataExplorerEmailTarget(target) : target;
		let enabled = channel.enabled !== false;
		let iconHtml = deriveAgentNotificationIcons({ notification_channels: [channel] }) || "<span class='me-2'><i class='fas fa-link'></i></span>";
		let enabledBadge = enabled ? "<span class='badge badge-success'>enabled</span>" : "<span class='badge badge-secondary'>disabled</span>";
		return "<div class='d-flex align-items-center justify-content-between border rounded px-3 py-2 mb-2'>"
			+ "<div class='me-3'>" + iconHtml + "<strong>" + escapeDataExplorerHtml(type || 'channel') + "</strong>"
			+ (displayTarget ? "<div class='text-muted small mt-1'>" + escapeDataExplorerHtml(displayTarget) + "</div>" : '')
			+ "</div>"
			+ enabledBadge
			+ "</div>";
	});

	return items.join('');
}

function renderDataExplorerAgentConfiguration(configuration) {
	if (!configuration || typeof configuration !== 'object') {
		return "<div class='text-muted'>No configuration available.</div>";
	}

	let monoFontStack = "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace";
	let objective = configuration.objective ? "<div class='mb-0 dataexplorer-agent-config-text' style='font-family: " + monoFontStack + "; font-size: 12px; line-height: 1.6; white-space: pre-wrap;'>" + escapeDataExplorerHtml(configuration.objective) + "</div>" : '';

	if (!objective) {
		objective = "<div class='text-muted' style='font-size: 12px; font-family: " + monoFontStack + ";'>No configuration text available.</div>";
	}

	return "<div class='border rounded bg-white p-4' style='font-family: " + monoFontStack + ";'>" + objective + "</div>";
}

function ensureDataExplorerAgentDetailStyles() {
	if (document.getElementById('dataexplorer-agent-detail-styles')) {
		return;
	}

	let styleElement = document.createElement('style');
	styleElement.id = 'dataexplorer-agent-detail-styles';
	styleElement.textContent = ""
		+ ".dataexplorer-agent-detail-tabs {"
		+ "display: inline-flex;"
		+ "gap: 10px;"
		+ "padding: 4px;"
		+ "border-radius: 999px;"
		+ "background: #f8fafc;"
		+ "border: 1px solid #e2e8f0;"
		+ "margin-bottom: 20px;"
		+ "}"
		+ ".dataexplorer-agent-detail-tab {"
		+ "border: 0;"
		+ "background: transparent;"
		+ "color: #475569;"
		+ "padding: 8px 14px;"
		+ "border-radius: 999px;"
		+ "font-size: 13px;"
		+ "font-weight: 700;"
		+ "letter-spacing: 0.01em;"
		+ "transition: background 140ms ease, color 140ms ease, box-shadow 140ms ease;"
		+ "}"
		+ ".dataexplorer-agent-detail-tab:hover {"
		+ "color: #0f172a;"
		+ "background: rgba(255, 255, 255, 0.85);"
		+ "}"
		+ ".dataexplorer-agent-detail-tab.is-active {"
		+ "background: #ffffff;"
		+ "color: #0f172a;"
		+ "box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);"
		+ "}"
		+ ".dataexplorer-agent-detail-tab-panel.d-none {"
		+ "display: none !important;"
		+ "}"
		+ ".dataexplorer-agent-config-text {"
		+ "overflow-wrap: anywhere;"
		+ "}"
		+ ".dataexplorer-agent-result-row {"
		+ "position: relative;"
		+ "}"
		+ ".dataexplorer-agent-result-row::before {"
		+ "content: '';"
		+ "position: absolute;"
		+ "left: 0;"
		+ "top: 0;"
		+ "bottom: 0;"
		+ "width: 0;"
		+ "background: transparent;"
		+ "transition: width 140ms ease;"
		+ "}"
		+ ".dataexplorer-agent-result-row.table-active::before {"
		+ "width: 4px;"
		+ "background: #3b82f6;"
		+ "}"
		+ ".dataexplorer-agent-result-markdown {"
		+ "font-size: 13px;"
		+ "}"
		+ ".dataexplorer-agent-result-markdown h1,"
		+ ".dataexplorer-agent-result-markdown h2,"
		+ ".dataexplorer-agent-result-markdown h3,"
		+ ".dataexplorer-agent-result-markdown h4,"
		+ ".dataexplorer-agent-result-markdown h5,"
		+ ".dataexplorer-agent-result-markdown h6 {"
		+ "font-size: 14px;"
		+ "margin-bottom: 8px;"
		+ "}"
		+ ".dataexplorer-agent-result-markdown p {"
		+ "margin-bottom: 8px;"
		+ "}"
		+ ".dataexplorer-agent-result-markdown ul,"
		+ ".dataexplorer-agent-result-markdown ol {"
		+ "margin-bottom: 8px;"
		+ "}"
		+ ".dataexplorer-agent-result-header-row {"
		+ "position: relative;"
		+ "}"
		+ ".dataexplorer-agent-result-header-row::before {"
		+ "content: '';"
		+ "position: absolute;"
		+ "left: 0;"
		+ "top: 0;"
		+ "bottom: 0;"
		+ "width: 4px;"
		+ "background: transparent;"
		+ "}"
		+ ".dataexplorer-agent-result-row td:first-child {"
		+ "padding-left: 6px;"
		+ "}"
		+ ".dataexplorer-agent-result-header-row th:first-child {"
		+ "padding-left: 6px;"
		+ "}";
	document.head.appendChild(styleElement);
}

function renderDataExplorerAgentEventResult(event) {
	function formatAgentResultLabel(value) {
		return String(value || '')
			.replace(/[_-]/g, ' ')
			.replace(/\b\w/g, function (letter) {
				return letter.toUpperCase();
			});
	}

	function renderAgentResultBadge(value) {
		let normalized = String(value || '').trim().toLowerCase();
		if (!normalized) {
			return "<span class='text-muted'>Unknown</span>";
		}

		let badgeStyles = {
			lift: "background: #e6f6ec; color: #166534; border: 1px solid #b7e4c7;",
			steady: "background: #eef2f7; color: #475569; border: 1px solid #d7dee8;",
			slip: "background: #fff4e5; color: #b45309; border: 1px solid #f3d19c;",
			shift: "background: #edf4ff; color: #1d4ed8; border: 1px solid #bfd4ff;",
			review: "background: #fff8db; color: #a16207; border: 1px solid #f6df91;",
			drop: "background: #fdecec; color: #b91c1c; border: 1px solid #f3b6b6;",
			recover: "background: #e8fbf5; color: #0f766e; border: 1px solid #a8ead7;",
			blocked: "background: #2a2f3a; color: #f8fafc; border: 1px solid #111827;",
		};

		let style = badgeStyles[normalized] || "background: #f4f4f5; color: #3f3f46; border: 1px solid #d4d4d8;";
		return "<span style='display: inline-flex; align-items: center; padding: 4px 10px; border-radius: 999px; font-size: 12px; font-weight: 700; letter-spacing: 0.01em; white-space: nowrap; " + style + "'>" + escapeDataExplorerHtml(formatAgentResultLabel(normalized)) + "</span>";
	}

	let resultValue = event.result ?? event.results;
	if (resultValue && typeof resultValue === 'object' && !Array.isArray(resultValue)) {
		if (resultValue.result !== undefined && resultValue.result !== null && resultValue.result !== '') {
			if (typeof resultValue.result === 'string') {
				return renderAgentResultBadge(resultValue.result);
			}
			return escapeDataExplorerHtml(String(resultValue.result));
		}

		let firstSimpleValue = Object.values(resultValue).find(value => {
			return value === null || ['string', 'number', 'boolean'].includes(typeof value) || Array.isArray(value);
		});
		if (firstSimpleValue === undefined) {
			return "<span class='text-muted'>No result data</span>";
		}

		if (Array.isArray(firstSimpleValue)) {
			return escapeDataExplorerHtml(firstSimpleValue.join(', '));
		}

		if (typeof firstSimpleValue === 'string') {
			return renderAgentResultBadge(firstSimpleValue);
		}

		return escapeDataExplorerHtml(String(firstSimpleValue));
	}

	if (resultValue !== undefined && resultValue !== null && resultValue !== '') {
		if (typeof resultValue === 'string') {
			return renderAgentResultBadge(resultValue);
		}
		return escapeDataExplorerHtml(String(resultValue));
	}

	return escapeDataExplorerHtml(String(event.results_found ?? '0'));
}

function resolveDataExplorerAgentResultMarkdown(event) {
	if (!event || typeof event !== 'object') {
		return '';
	}

	let resultValue = event.result && typeof event.result === 'object' ? event.result : {};
	let resultsValue = event.results && typeof event.results === 'object' ? event.results : {};
	let candidates = [
		event.summary_markdown,
		event.summaryMarkdown,
		event.result_markdown,
		event.resultMarkdown,
		resultValue.summary_markdown,
		resultValue.summaryMarkdown,
		resultValue.summary,
		resultsValue.summary_markdown,
		resultsValue.summaryMarkdown,
		resultsValue.summary,
		event.summary,
	];

	let match = candidates.find(value => typeof value === 'string' && value.trim());
	return match ? match.trim() : '';
}

function formatDataExplorerAgentNotificationStatus(event) {
	if (!event || typeof event !== 'object') {
		return 'Unknown';
	}
	if (!event.notified) {
		return 'Not sent';
	}
	if (event.notification_success) {
		return 'Delivered';
	}
	return 'Failed';
}

function renderDataExplorerAgentSelectedResultPanel(event) {
	let markdown = resolveDataExplorerAgentResultMarkdown(event);
	if (!markdown) {
		return "<div class='border rounded bg-white p-4 text-muted'>No result details available for this run.</div>";
	}

	return "<div class='border rounded bg-white p-4'><div class='dataexplorer-agent-result-markdown' style='line-height: 1.6;'>" + clean_e_chat(markdown) + "</div></div>";
}

function renderDataExplorerAgentResultHeader(event, isMostRecent) {
	if (!event) {
		return '';
	}

	let rawDate = escapeDataExplorerHtml(formatDataExplorerAgentDate(event.ran_at));
	let badge = isMostRecent ? " <span class='badge badge-primary ms-2' style='font-size: 11px; vertical-align: middle;'>Most Recent</span>" : '';
	return "<div style='margin-bottom: 10px;'><div style='font-size: 14px; font-weight: 600; display: inline-block;'>" + rawDate + "</div>" + badge + "</div>";
}

function renderDataExplorerAgentResultsTable(events) {
	let rows = Array.isArray(events) ? events.slice(0, 10) : [];
	if (rows.length === 0) {
		return "<div class='text-muted'>No recent results available.</div>";
	}

	let tableRows = rows.map((event, index) => {
		let notificationStatus = formatDataExplorerAgentNotificationStatus(event);
		let notificationCell = escapeDataExplorerHtml(notificationStatus);
		if (notificationStatus === 'Delivered') {
			notificationCell = "<span class='text-success fw-bold'><i class='fas fa-check-circle me-1'></i>" + notificationCell + "</span>";
		} else if (notificationStatus === 'Failed') {
			notificationCell = "<span class='text-danger fw-bold'>" + notificationCell + "</span>";
		}

		return "<tr class='dataexplorer-agent-result-row" + (index === 0 ? " table-active" : '') + "' data-agent-result-index='" + index + "' style='cursor: pointer;'>"
			+ "<td>" + renderDataExplorerAgentRunDateCell(event.ran_at) + "</td>"
			+ "<td>" + getDataExplorerAgentStatusBadge(event.status) + "</td>"
			+ "<td>" + notificationCell + "</td>"
			+ "</tr>";
	}).join('');

	return "<div class='table-responsive border rounded bg-white'>"
		+ "<table class='table table-sm table-hover mb-0'>"
		+ "<thead class='table-light'><tr class='dataexplorer-agent-result-header-row'><th>Date Run</th><th>Status</th><th>Notification</th></tr></thead>"
		+ "<tbody>" + tableRows + "</tbody></table></div>";
}

function renderDataExplorerAgentSummaryBadge(label, value, style) {
	return "<div class='border rounded px-3 py-2' style='min-width: 180px; background: #fff; " + style + "'>"
		+ "<div class='text-muted' style='font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em; margin-bottom: 4px;'>" + escapeDataExplorerHtml(label) + "</div>"
		+ "<div style='font-size: 14px; font-weight: 700; line-height: 1.35;'>" + escapeDataExplorerHtml(value) + "</div>"
		+ "</div>";
}

function summarizeDataExplorerAgentNotificationPreference(detail) {
	if (detail.notification_trend) {
		let trendValue = String(detail.notification_trend).trim();
		let channels = Array.isArray(detail.notification_channels) ? detail.notification_channels : [];
		let hasSlackChannel = channels.some(channel => {
			return channel && channel.enabled !== false && String(channel.type || '').trim().toLowerCase() === 'slack';
		});
		if (hasSlackChannel && trendValue && !/slack/i.test(trendValue)) {
			return trendValue + ' to our slack channel';
		}
		return trendValue;
	}

	let channels = Array.isArray(detail.notification_channels) ? detail.notification_channels : [];
	if (channels.length === 0) {
		return '';
	}

	return channels
		.filter(channel => channel && channel.enabled !== false)
		.map(channel => {
			let type = String(channel.type || '').trim();
			let target = String(channel.target || '').trim();
			return target ? (type + ': ' + target) : type;
		})
		.filter(Boolean)
		.join(', ');
}

function formatDataExplorerAgentAge(detail) {
	if (detail.agent_age) {
		return String(detail.agent_age);
	}

	let createdAt = detail.created_at || detail.createdAt || detail.inserted_at || detail.insertedAt || detail.started_at || detail.startedAt;
	if (!createdAt) {
		return 'Age unavailable';
	}

	if (window.moment) {
		let createdMoment = window.moment.utc(createdAt);
		if (createdMoment.isValid()) {
			let nowMoment = window.moment.utc();
			let months = nowMoment.diff(createdMoment, 'months');
			createdMoment.add(months, 'months');
			let days = nowMoment.diff(createdMoment, 'days');
			let parts = [];
			if (months > 0) {
				parts.push(months + ' month' + (months === 1 ? '' : 's'));
			}
			parts.push(days + ' day' + (days === 1 ? '' : 's'));
			return parts.join(', ');
		}
	}

	let createdDate = new Date(createdAt);
	if (Number.isNaN(createdDate.getTime())) {
		return 'Age unavailable';
	}

	let ageDays = Math.max(0, Math.floor((Date.now() - createdDate.getTime()) / 86400000));
	let months = Math.floor(ageDays / 30);
	let days = ageDays % 30;
	let parts = [];
	if (months > 0) {
		parts.push(months + ' month' + (months === 1 ? '' : 's'));
	}
	parts.push(days + ' day' + (days === 1 ? '' : 's'));
	return parts.join(', ');
}

function resolveDataExplorerAgentCronExpression(detail) {
	if (!detail || typeof detail !== 'object') {
		return '';
	}

	let configuration = detail.configuration && typeof detail.configuration === 'object' ? detail.configuration : {};
	let schedule = detail.schedule && typeof detail.schedule === 'object' ? detail.schedule : {};
	let configurationSchedule = configuration.schedule && typeof configuration.schedule === 'object' ? configuration.schedule : {};
	let candidates = [
		detail.cron_expression,
		detail.cronExpression,
		detail.cron,
		detail.schedule_cron,
		detail.scheduleCron,
		detail.run_schedule,
		detail.runSchedule,
		typeof detail.schedule === 'string' ? detail.schedule : '',
		schedule.cron_expression,
		schedule.cronExpression,
		schedule.cron,
		schedule.expression,
		configuration.cron_expression,
		configuration.cronExpression,
		configuration.cron,
		typeof configuration.schedule === 'string' ? configuration.schedule : '',
		configurationSchedule.cron_expression,
		configurationSchedule.cronExpression,
		configurationSchedule.cron,
		configurationSchedule.expression,
	];

	let match = candidates.find(value => typeof value === 'string' && value.trim());
	return match ? match.trim() : '';
}

function formatDataExplorerScheduleTime(hourValue, minuteValue) {
	if (!/^\d+$/.test(String(hourValue)) || !/^\d+$/.test(String(minuteValue))) {
		return '';
	}

	let hour = Number(hourValue);
	let minute = Number(minuteValue);
	if (Number.isNaN(hour) || Number.isNaN(minute)) {
		return '';
	}

	let suffix = hour >= 12 ? 'PM' : 'AM';
	let displayHour = hour % 12 || 12;
	return displayHour + ':' + String(minute).padStart(2, '0') + ' ' + suffix;
}

function formatDataExplorerScheduleDayLabel(dayValue) {
	let normalized = String(dayValue || '').trim().toUpperCase();
	let names = {
		'0': 'Sunday',
		'1': 'Monday',
		'2': 'Tuesday',
		'3': 'Wednesday',
		'4': 'Thursday',
		'5': 'Friday',
		'6': 'Saturday',
		'7': 'Sunday',
		SUN: 'Sunday',
		MON: 'Monday',
		TUE: 'Tuesday',
		WED: 'Wednesday',
		THU: 'Thursday',
		FRI: 'Friday',
		SAT: 'Saturday',
	};

	return names[normalized] || normalized;
}

function describeDataExplorerAgentActivityTrend(detail) {
	let cronExpression = resolveDataExplorerAgentCronExpression(detail);
	if (!cronExpression) {
		return '';
	}

	let fields = cronExpression.replace(/\?/g, '*').trim().split(/\s+/).filter(Boolean);
	if (fields.length === 6) {
		fields = fields.slice(1);
	} else if (fields.length >= 7) {
		fields = fields.slice(1, 6);
	}

	if (fields.length !== 5) {
		return 'Custom schedule';
	}

	let minute = fields[0];
	let hour = fields[1];
	let dayOfMonth = fields[2];
	let month = fields[3];
	let dayOfWeek = fields[4];
	let isDaily = dayOfMonth === '*' && month === '*' && dayOfWeek === '*';
	let formattedTime = formatDataExplorerScheduleTime(hour, minute);

	if (minute === '0' && hour === '*' && isDaily) {
		return 'Every hour';
	}

	let minuteStepMatch = minute.match(/^\*\/(\d+)$/);
	if (minuteStepMatch && hour === '*' && isDaily) {
		let stepMinutes = Number(minuteStepMatch[1]);
		if (stepMinutes === 60) {
			return 'Every hour';
		}
		return 'Every ' + stepMinutes + ' minutes';
	}

	let hourStepMatch = hour.match(/^\*\/(\d+)$/);
	if (hourStepMatch && /^\d+$/.test(minute) && isDaily) {
		let stepHours = Number(hourStepMatch[1]);
		if (stepHours <= 1) {
			return 'Every hour';
		}
		if (stepHours <= 4) {
			return 'Every few hours';
		}
		return 'Every ' + stepHours + ' hours';
	}

	let dayStepMatch = dayOfMonth.match(/^\*\/(\d+)$/);
	if (dayStepMatch && /^\d+$/.test(hour) && /^\d+$/.test(minute) && month === '*' && dayOfWeek === '*') {
		let stepDays = Number(dayStepMatch[1]);
		let dayPeriod = Number(hour) >= 5 && Number(hour) < 12 && Number(minute) === 0 ? ' in the morning' : '';
		if (stepDays <= 2) {
			return 'Every 2 days' + dayPeriod;
		}
		if (stepDays <= 4) {
			return 'Every few days' + dayPeriod;
		}
		return 'Every ' + stepDays + ' days' + dayPeriod;
	}

	if (/^\d+$/.test(hour) && /^\d+$/.test(minute) && isDaily) {
		let hourNumber = Number(hour);
		let minuteNumber = Number(minute);
		if (minuteNumber === 0 && hourNumber >= 5 && hourNumber < 12) {
			return 'Every morning';
		}
		if (minuteNumber === 0 && hourNumber >= 12 && hourNumber < 17) {
			return 'Every afternoon';
		}
		if (minuteNumber === 0 && hourNumber >= 17 && hourNumber < 22) {
			return 'Every evening';
		}
		if (minuteNumber === 0 && hourNumber === 0) {
			return 'Every day at midnight';
		}
		return formattedTime ? 'Every day at ' + formattedTime : 'Every day';
	}

	if (/^(1-5|MON-FRI)$/i.test(dayOfWeek) && /^\d+$/.test(hour) && /^\d+$/.test(minute) && dayOfMonth === '*' && month === '*') {
		let timeLabel = formattedTime ? ' at ' + formattedTime : '';
		return 'Every weekday' + timeLabel;
	}

	if (/^(0,6|6,0|SAT,SUN|SUN,SAT)$/i.test(dayOfWeek) && /^\d+$/.test(hour) && /^\d+$/.test(minute) && dayOfMonth === '*' && month === '*') {
		let timeLabel = formattedTime ? ' at ' + formattedTime : '';
		return 'Every weekend' + timeLabel;
	}

	if (/^[0-7A-Z,]+$/i.test(dayOfWeek) && !dayOfWeek.includes('*') && dayOfMonth === '*' && month === '*') {
		let dayNames = dayOfWeek.split(',').map(formatDataExplorerScheduleDayLabel).filter(Boolean);
		let prefix = dayNames.length > 1 ? 'Every ' + dayNames.slice(0, -1).join(', ') + ' and ' + dayNames[dayNames.length - 1] : 'Every ' + dayNames[0];
		return formattedTime ? prefix + ' at ' + formattedTime : prefix;
	}

	return 'Custom schedule';
}

function formatDataExplorerNotificationTrend(events) {
	let detail = arguments.length > 1 ? arguments[1] : null;
	let scheduledTrend = describeDataExplorerAgentActivityTrend(detail);
	if (scheduledTrend) {
		return scheduledTrend;
	}

	if (detail && detail.notification_trend) {
		return String(detail.notification_trend);
	}

	let recentEvents = Array.isArray(events) ? events.filter(event => event && event.ran_at) : [];
	let notifiedEvents = recentEvents.filter(event => !!event.notified);
	if (notifiedEvents.length === 0) {
		return 'Rarely notifies';
	}
	if (notifiedEvents.length === 1) {
		return 'Notified once recently';
	}

	let sortedEvents = notifiedEvents.slice().sort((left, right) => {
		return new Date(right.ran_at).getTime() - new Date(left.ran_at).getTime();
	});
	let totalGapMs = 0;
	let gapCount = 0;
	for (let index = 0; index < sortedEvents.length - 1; index++) {
		let current = new Date(sortedEvents[index].ran_at).getTime();
		let next = new Date(sortedEvents[index + 1].ran_at).getTime();
		if (!Number.isNaN(current) && !Number.isNaN(next) && current > next) {
			totalGapMs += (current - next);
			gapCount += 1;
		}
	}

	if (gapCount === 0) {
		return 'Notifies frequently';
	}

	let averageGapHours = totalGapMs / gapCount / 3600000;
	if (averageGapHours <= 12) {
		return 'Tends to notify every few hours';
	}
	if (averageGapHours <= 36) {
		return 'Tends to notify daily';
	}
	if (averageGapHours <= 24 * 10) {
		return 'Tends to notify weekly';
	}
	return 'Tends to notify occasionally';
}

function isDataExplorerAgentExplicitlyDisabled(detail) {
	if (!detail || typeof detail !== 'object') {
		return false;
	}

	if (detail.enabled === false || detail.paused === true) {
		return true;
	}

	let normalizedEnabled = String(detail.enabled ?? '').trim().toLowerCase();
	if (normalizedEnabled === 'false' || normalizedEnabled === '0' || normalizedEnabled === 'disabled') {
		return true;
	}

	return false;
}

function formatDataExplorerAgentHealth(detail, events) {
	if (isDataExplorerAgentExplicitlyDisabled(detail) || String(detail.status || '').trim().toLowerCase() === 'paused' || String(detail.status_field || '').trim().toLowerCase() === 'disabled' || String(detail.health || '').trim().toLowerCase() === 'paused') {
		return {
			label: 'Paused',
			style: 'background: #f5f3ff; border-color: #ddd6fe; color: #6d28d9;'
		};
	}

	let explicitHealth = String(detail.health || '').trim().toLowerCase();
	if (explicitHealth) {
		if (explicitHealth === 'healthy' || explicitHealth === 'success' || explicitHealth === 'active') {
			return {
				label: 'Healthy',
				style: 'background: #ecfdf3; border-color: #bbf7d0; color: #166534;'
			};
		}
		if (explicitHealth === 'warning' || explicitHealth === 'monitoring') {
			return {
				label: 'Monitoring',
				style: 'background: #fffbeb; border-color: #fde68a; color: #92400e;'
			};
		}
		if (explicitHealth === 'error' || explicitHealth === 'fail' || explicitHealth === 'blocked' || explicitHealth === 'needs_attention' || explicitHealth === 'needs attention') {
			return {
				label: 'Needs Attention',
				style: 'background: #fff1f2; border-color: #fecdd3; color: #9f1239;'
			};
		}

		return {
			label: explicitHealth.replace(/[_-]/g, ' ').replace(/\b\w/g, function (letter) {
				return letter.toUpperCase();
			}),
			style: 'background: #f8fafc; border-color: #e2e8f0; color: #334155;'
		};
	}

	let recentEvents = Array.isArray(events) ? events.slice(0, 10) : [];
	let hasRecentError = recentEvents.some(event => {
		let status = String(event && event.status || '').trim().toLowerCase();
		return status === 'error' || status === 'fail' || (event && event.notified && !event.notification_success);
	});
	if (hasRecentError) {
		return {
			label: 'Needs Attention',
			style: 'background: #fff1f2; border-color: #fecdd3; color: #9f1239;'
		};
	}

	let latestStatus = String(detail.status || (recentEvents[0] && recentEvents[0].status) || '').trim().toLowerCase();
	if (latestStatus === 'warning') {
		return {
			label: 'Monitoring',
			style: 'background: #fffbeb; border-color: #fde68a; color: #92400e;'
		};
	}

	return {
		label: 'Healthy',
		style: 'background: #ecfdf3; border-color: #bbf7d0; color: #166534;'
	};
}

function formatDataExplorerAgentStatus(detail) {
	let explicitStatus = String(detail.status || '').trim().toLowerCase();
	if (!explicitStatus) {
		return {
			label: 'Unknown',
			style: 'background: #f8fafc; border-color: #e2e8f0; color: #475569;'
		};
	}

	if (explicitStatus === 'idle') {
		return {
			label: 'Idle',
			style: 'background: #f8fafc; border-color: #cbd5e1; color: #475569;'
		};
	}
	if (explicitStatus === 'active' || explicitStatus === 'running' || explicitStatus === 'success') {
		return {
			label: explicitStatus.replace(/[_-]/g, ' ').replace(/\b\w/g, function (letter) {
				return letter.toUpperCase();
			}),
			style: 'background: #ecfdf3; border-color: #bbf7d0; color: #166534;'
		};
	}
	if (explicitStatus === 'paused') {
		return {
			label: 'Paused',
			style: 'background: #f5f3ff; border-color: #ddd6fe; color: #6d28d9;'
		};
	}
	if (explicitStatus === 'warning' || explicitStatus === 'monitoring') {
		return {
			label: explicitStatus.replace(/[_-]/g, ' ').replace(/\b\w/g, function (letter) {
				return letter.toUpperCase();
			}),
			style: 'background: #fffbeb; border-color: #fde68a; color: #92400e;'
		};
	}
	if (explicitStatus === 'error' || explicitStatus === 'fail' || explicitStatus === 'blocked' || explicitStatus === 'failed') {
		return {
			label: explicitStatus.replace(/[_-]/g, ' ').replace(/\b\w/g, function (letter) {
				return letter.toUpperCase();
			}),
			style: 'background: #fff1f2; border-color: #fecdd3; color: #9f1239;'
		};
	}

	return {
		label: explicitStatus.replace(/[_-]/g, ' ').replace(/\b\w/g, function (letter) {
			return letter.toUpperCase();
		}),
		style: 'background: #f8fafc; border-color: #e2e8f0; color: #334155;'
	};
}

function isDataExplorerAgentPaused(detail) {
	if (!detail || typeof detail !== 'object') {
		return false;
	}

	return isDataExplorerAgentExplicitlyDisabled(detail)
		|| String(detail.status || '').trim().toLowerCase() === 'paused'
		|| String(detail.status_field || '').trim().toLowerCase() === 'disabled'
		|| String(detail.health || '').trim().toLowerCase() === 'paused';
}

function renderDataExplorerAgentControlStrip(detail, events) {
	let health = formatDataExplorerAgentHealth(detail, events);
	let status = formatDataExplorerAgentStatus(detail);
	let notificationTrend = formatDataExplorerNotificationTrend(events, detail);

	let badges = [
		renderDataExplorerAgentSummaryBadge('Health', health.label, health.style),
		renderDataExplorerAgentSummaryBadge('Status', status.label, status.style),
		renderDataExplorerAgentSummaryBadge('Agent Activity Trend', notificationTrend, 'background: #eff6ff; border-color: #bfdbfe; color: #1d4ed8;'),
	].join('');

	return "<div class='border rounded p-3 mb-4' style='background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%); border-color: #e2e8f0;'>"
		+ "<div class='d-flex flex-wrap justify-content-between align-items-center gap-3'>"
		+ "<div class='d-flex flex-wrap gap-2'>" + badges + "</div>"
		+ "</div></div>";
}

function closeDataExplorerAgentFormModal() {
	let modal = document.getElementById('dataexplorer-agent-form-modal');
	if (modal) {
		modal.remove();
	}
	let feedback = document.getElementById('dataexplorer-agent-detail-feedback');
	if (feedback) {
		feedback.textContent = '';
		feedback.className = 'd-none';
	}
}


function renderDataExplorerAgentFormExamples(exampleType, examples) {
	if (!Array.isArray(examples) || examples.length === 0) {
		return '';
	}

	let buttons = examples.map(example => {
		let label = example && example.label ? String(example.label) : '';
		let value = example && example.value ? String(example.value) : '';
		return "<button type='button' class='btn btn-sm btn-light border' data-agent-form-example='" + escapeDataExplorerHtml(exampleType) + "' data-agent-form-value='" + escapeDataExplorerHtml(value) + "'>" + escapeDataExplorerHtml(label) + "</button>";
	}).join('');

	return "<div class='mt-2'><div class='text-muted small mb-2'>Try an example:</div><div class='d-flex flex-wrap gap-2'>" + buttons + "</div></div>";
}

function buildDataExplorerAgentFormConfig(mode, detail) {
	let isClone = mode === 'clone';
	let prompt = isClone && detail && detail.configuration ? String(detail.configuration.objective || '') : '';
	let description = isClone ? String(detail && (detail.name || detail.id) || '').trim() : '';

	return {
		mode: isClone ? 'clone' : 'create',
		title: isClone ? 'Clone Agent' : 'Add New Agent',
		submitLabel: isClone ? 'Submit' : 'Create Agent',
		successMessage: isClone ? 'Agent clone submitted.' : 'Agent created.',
		prompt: prompt,
		description: description,
		promptPlaceholder: isClone ? 'Adjust the cloned prompt for this version of the agent.' : 'Example: Watch for interesting events and summarize them.',
		descriptionPlaceholder: isClone ? 'Short description for the cloned agent.' : 'Example: My test agent',
		promptExamples: [
			{
				label: 'Campaign lifecycle watch',
				value: 'Watch for campaign start and campaign end signals across active Scripps inventory, especially events like Capital One - Discover 2026, WNBA 2026, and NBA Promo 2026. Summarize which campaigns changed state, when the change started, and whether the volume pattern looks expected or risky.'
			},
			{
				label: 'Partner anomaly monitor',
				value: 'Track demand partners and supply-side integrations for unusual impression behavior, focusing on patterns like Undertone spikes and bursts, Amagi new patterns, and Publica more-than-usual volume. Highlight the partner, the dominant anomaly tag, the time window, and whether the issue looks like a one-time spike or a sustained trend.'
			},
			{
				label: 'Line item and channel changes',
				value: 'Monitor line items and channels for sudden new patterns or bursts in delivery, such as Team Usa new pattern activity, LinkedIn line item bursts, or Chime and OpenX Tablo campaign changes. Tell me which channel or line item moved, what filter identified it, and whether it should be investigated immediately.'
			}
		]
	};
}

function renderDataExplorerAgentFormModal(config) {
	return "<div class='modal fade show' id='dataexplorer-agent-form-modal' tabindex='-1' role='dialog' aria-modal='true' style='display:block; background: rgba(15, 23, 42, 0.35); z-index: 1080;'>"
		+ "<div class='modal-dialog modal-lg modal-dialog-scrollable' role='document' style='margin: 4rem auto;'>"
		+ "<div class='modal-content'>"
		+ "<div class='modal-header'><h5 class='modal-title'>" + escapeDataExplorerHtml(config.title) + "</h5><button type='button' class='btn-close' aria-label='Close' data-agent-form-close='true'></button></div>"
		+ "<div class='modal-body'>"
		+ "<div id='dataexplorer-agent-form-feedback' class='d-none'></div>"
		+ "<div class='mb-3'><label class='form-label fw-bold'>Prompt</label><textarea id='dataexplorer-agent-form-prompt' class='form-control' style='min-height: 140px;' placeholder='" + escapeDataExplorerHtml(config.promptPlaceholder) + "'>" + escapeDataExplorerHtml(config.prompt) + "</textarea><div class='text-muted small mt-2'>This is sent as the agent prompt.</div>" + renderDataExplorerAgentFormExamples('prompt', config.promptExamples) + "</div>"
		+ "<div class='mb-0'><label class='form-label fw-bold'>Description</label><input id='dataexplorer-agent-form-description' class='form-control' type='text' placeholder='" + escapeDataExplorerHtml(config.descriptionPlaceholder) + "' value='" + escapeDataExplorerHtml(config.description) + "' /><div class='text-muted small mt-2'>This is sent as the agent description.</div></div>"
		+ "</div>"
		+ "<div class='modal-footer'><button type='button' class='btn btn-secondary' data-agent-form-close='true'>Cancel</button><button type='button' class='btn btn-primary' id='dataexplorer-agent-form-submit'>" + escapeDataExplorerHtml(config.submitLabel) + "</button></div>"
		+ "</div></div></div>";
}

function bindDataExplorerAgentFormModal(config) {
	let formModal = document.getElementById('dataexplorer-agent-form-modal');
	if (!formModal) {
		return;
	}

	formModal.querySelectorAll('[data-agent-form-close="true"]').forEach(button => {
		button.addEventListener('click', function () {
			closeDataExplorerAgentFormModal();
		});
	});

	formModal.addEventListener('click', function (event) {
		if (event.target === formModal) {
			closeDataExplorerAgentFormModal();
		}
	});

	formModal.querySelectorAll('[data-agent-form-example]').forEach(button => {
		button.addEventListener('click', function () {
			let exampleValue = button.getAttribute('data-agent-form-value') || '';
			let field = document.getElementById('dataexplorer-agent-form-prompt');
			if (field) {
				field.value = exampleValue;
				field.focus();
			}
		});
	});

	let submitButton = document.getElementById('dataexplorer-agent-form-submit');
	if (submitButton) {
		submitButton.addEventListener('click', async function () {
			let promptField = document.getElementById('dataexplorer-agent-form-prompt');
			let descriptionField = document.getElementById('dataexplorer-agent-form-description');
			let feedback = document.getElementById('dataexplorer-agent-form-feedback');
			let prompt = promptField ? promptField.value.trim() : '';
			let description = descriptionField ? descriptionField.value.trim() : '';

			if (!prompt || !description) {
				if (feedback) {
					feedback.className = 'alert alert-danger mb-3';
					feedback.textContent = 'Prompt and description are required.';
				}
				return;
			}

			let payload = {
				prompt: prompt,
				description: description,
			};

			submitButton.disabled = true;
			submitButton.textContent = 'Submitting...';

			let result = config.mode === 'clone'
				? await window.clone_dataexplorer_agent(payload)
				: await window.create_dataexplorer_agent(payload);

			submitButton.disabled = false;
			submitButton.textContent = config.submitLabel;

			if (!result || result.status !== 'success') {
				if (feedback) {
					feedback.className = 'alert alert-danger mb-3';
					feedback.textContent = result && result.msg ? result.msg : 'Unable to submit agent.';
				}
				return;
			}

			closeDataExplorerAgentFormModal();
			if (typeof window.make_dataexplorer_agents === 'function') {
				await window.make_dataexplorer_agents();
			}
			let detailFeedback = document.getElementById('dataexplorer-agent-detail-feedback');
			let createdAgentId = result && result.agent && result.agent.agent_id ? String(result.agent.agent_id) : '';
			let successMessage = config.mode === 'clone'
				? (createdAgentId ? 'Agent clone created: ' + createdAgentId + '.' : 'Agent clone created.')
				: (createdAgentId ? 'Agent created: ' + createdAgentId + '.' : 'Agent created.');
			if (detailFeedback) {
				detailFeedback.className = 'alert alert-success mb-3';
				detailFeedback.textContent = successMessage;
			} else if (typeof display_toast === 'function') {
				display_toast(successMessage);
			}
		});
	}
}

function openDataExplorerAgentCloneModal(detail) {
	closeDataExplorerAgentFormModal();
	let config = buildDataExplorerAgentFormConfig('clone', detail);
	let container = document.createElement('div');
	container.innerHTML = renderDataExplorerAgentFormModal(config);
	document.body.appendChild(container.firstChild);
	bindDataExplorerAgentFormModal(config);
}

function openDataExplorerAgentCreateModal() {
	closeDataExplorerAgentFormModal();
	let config = buildDataExplorerAgentFormConfig('create');
	let container = document.createElement('div');
	container.innerHTML = renderDataExplorerAgentFormModal(config);
	document.body.appendChild(container.firstChild);
	bindDataExplorerAgentFormModal(config);
}

function setDataExplorerAgentDeleteConfirmationVisible(visible) {
	let modal = document.getElementById('dataexplorer-agent-detail-modal');
	if (!modal) {
		return;
	}

	let confirmContainer = modal.querySelector('[data-agent-delete-confirm="true"]');
	let deleteButton = modal.querySelector('[data-agent-action="delete"]');
	if (!confirmContainer || !deleteButton) {
		return;
	}

	confirmContainer.classList.toggle('d-none', !visible);
	confirmContainer.classList.toggle('d-flex', !!visible);
	deleteButton.classList.toggle('d-none', !!visible);
	deleteButton.disabled = !!visible;

	if (visible) {
		let confirmDeleteButton = modal.querySelector('[data-agent-action="confirm-delete"]');
		if (confirmDeleteButton) {
			confirmDeleteButton.focus();
		}
	}
}

function bindDataExplorerAgentDetailActionHandlers(detail) {
	let modal = document.getElementById('dataexplorer-agent-detail-modal');
	if (!modal) {
		return;
	}

	modal.querySelectorAll('[data-agent-action]').forEach(button => {
		button.addEventListener('click', async function () {
			let action = button.getAttribute('data-agent-action');
			if (action === 'run') {
				setDataExplorerAgentDeleteConfirmationVisible(false);
				let feedback = document.getElementById('dataexplorer-agent-detail-feedback');
				button.disabled = true;
				button.className = 'btn btn-dark btn-sm';
				button.innerHTML = "<i class='fas fa-spinner fa-spin' style='margin-right: 6px;'></i>Running...";

				let result = await window.run_dataexplorer_agent(detail.id);

				button.disabled = false;
				button.className = 'btn btn-dark btn-sm';
				button.innerHTML = "<i class='fas fa-play-circle' style='margin-right: 6px;'></i>Run Job";

				if (result && result.status === 'already-running') {
					if (feedback) {
						feedback.className = 'alert alert-warning mb-3';
						feedback.textContent = result.retryAfter
							? 'Agent is already running. Retry after ' + result.retryAfter + '.'
							: 'Agent is already running.';
					}
					return;
				}

				if (!result || result.status !== 'success') {
					if (feedback) {
						feedback.className = 'alert alert-danger mb-3';
						feedback.textContent = result && result.msg ? result.msg : 'Unable to run agent.';
					}
					return;
				}

				if (typeof window.make_dataexplorer_agents === 'function') {
					await window.make_dataexplorer_agents();
				}
				await showDataExplorerAgentDetailModal(detail.id);
				feedback = document.getElementById('dataexplorer-agent-detail-feedback');
				if (feedback) {
					feedback.className = 'alert alert-success mb-3';
					feedback.textContent = 'Agent run started.';
				}
				return;
			}
			if (action === 'toggle-pause') {
				setDataExplorerAgentDeleteConfirmationVisible(false);
				let feedback = document.getElementById('dataexplorer-agent-detail-feedback');
				let shouldResume = isDataExplorerAgentPaused(detail);
				let actionLabel = shouldResume
					? "<i class='fas fa-play' style='margin-right: 6px;'></i>Resume"
					: "<i class='fas fa-pause' style='margin-right: 6px;'></i>Pause";

				button.disabled = true;
				button.className = shouldResume ? 'btn btn-dark btn-sm' : 'btn btn-outline-dark btn-sm';
				button.innerHTML = shouldResume ? "<i class='fas fa-spinner fa-spin' style='margin-right: 6px;'></i>Resuming..." : "<i class='fas fa-spinner fa-spin' style='margin-right: 6px;'></i>Pausing...";

				let result = await window.update_dataexplorer_agent_run_state(detail.id, shouldResume);

				button.disabled = false;
				button.className = shouldResume ? 'btn btn-dark btn-sm' : 'btn btn-outline-dark btn-sm';
				button.innerHTML = actionLabel;

				if (!result || result.status !== 'success') {
					if (feedback) {
						feedback.className = 'alert alert-danger mb-3';
						feedback.textContent = result && result.msg ? result.msg : 'Unable to update agent run state.';
					}
					return;
				}

				if (typeof window.make_dataexplorer_agents === 'function') {
					await window.make_dataexplorer_agents();
				}
				await showDataExplorerAgentDetailModal(detail.id);
				feedback = document.getElementById('dataexplorer-agent-detail-feedback');
				if (feedback) {
					feedback.className = 'alert alert-success mb-3';
					feedback.textContent = shouldResume ? 'Agent resumed.' : 'Agent paused.';
				}
				return;
			}
			if (action === 'clone') {
				setDataExplorerAgentDeleteConfirmationVisible(false);
				openDataExplorerAgentCloneModal(detail);
				return;
			}
			if (action === 'delete') {
				let feedback = document.getElementById('dataexplorer-agent-detail-feedback');
				if (feedback) {
					feedback.textContent = '';
					feedback.className = 'd-none';
				}
				setDataExplorerAgentDeleteConfirmationVisible(true);
				return;
			}
			if (action === 'cancel-delete') {
				setDataExplorerAgentDeleteConfirmationVisible(false);
				return;
			}
			if (action === 'confirm-delete') {
				let feedback = document.getElementById('dataexplorer-agent-detail-feedback');
				button.disabled = true;
				button.textContent = 'Deleting...';

				let result = await window.delete_dataexplorer_agent(detail.id);

				button.disabled = false;
				button.textContent = 'Delete';

				if (!result || result.status !== 'success') {
					if (feedback) {
						feedback.className = 'alert alert-danger mb-3';
						feedback.textContent = result && result.msg ? result.msg : 'Unable to delete agent.';
					}
					return;
				}

				setDataExplorerAgentDeleteConfirmationVisible(false);
				closeDataExplorerAgentDetailModal();
				if (typeof window.make_dataexplorer_agents === 'function') {
					await window.make_dataexplorer_agents();
				}
				if (typeof display_toast === 'function') {
					display_toast('Agent deleted.');
				}
			}
		});
	});
}

function bindDataExplorerAgentResultSelectionHandlers(events) {
	let modal = document.getElementById('dataexplorer-agent-detail-modal');
	if (!modal) {
		return;
	}

	let rows = modal.querySelectorAll('[data-agent-result-index]');
	let resultPanel = modal.querySelector('#dataexplorer-agent-results-panel');
	if (!rows.length || !resultPanel) {
		return;
	}

	rows.forEach(row => {
		row.addEventListener('click', function () {
			let indexValue = Number(row.getAttribute('data-agent-result-index'));
			if (Number.isNaN(indexValue) || !Array.isArray(events) || !events[indexValue]) {
				return;
			}

			rows.forEach(otherRow => {
				otherRow.classList.remove('table-active');
			});
			row.classList.add('table-active');
			let resultHeader = modal.querySelector('#dataexplorer-agent-result-header');
			if (resultHeader) {
				resultHeader.innerHTML = renderDataExplorerAgentResultHeader(events[indexValue], indexValue === 0);
			}
			resultPanel.innerHTML = renderDataExplorerAgentSelectedResultPanel(events[indexValue]);
		});
	});
}

function bindDataExplorerAgentDetailTabHandlers() {
	let modal = document.getElementById('dataexplorer-agent-detail-modal');
	if (!modal) {
		return;
	}

	let tabs = modal.querySelectorAll('[data-agent-detail-tab]');
	let panels = modal.querySelectorAll('[data-agent-detail-panel]');
	if (!tabs.length || !panels.length) {
		return;
	}

	tabs.forEach(tab => {
		tab.addEventListener('click', function () {
			let activeTab = tab.getAttribute('data-agent-detail-tab');
			if (!activeTab) {
				return;
			}

			tabs.forEach(otherTab => {
				let isActive = otherTab === tab;
				otherTab.classList.toggle('is-active', isActive);
				otherTab.setAttribute('aria-selected', isActive ? 'true' : 'false');
			});

			panels.forEach(panel => {
				let matches = panel.getAttribute('data-agent-detail-panel') === activeTab;
				panel.classList.toggle('d-none', !matches);
			});
		});
	});
}

function closeDataExplorerAgentDetailModal() {
	let modal = document.getElementById('dataexplorer-agent-detail-modal');
	if (modal) {
		modal.remove();
	}
	document.body.style.overflow = '';
	if (document.body.classList) {
		document.body.classList.remove('modal-open');
	}
}

function renderDataExplorerAgentDetailModalShell(title, bodyHtml) {
	return "<div class='modal fade show' id='dataexplorer-agent-detail-modal' tabindex='-1' role='dialog' aria-modal='true' style='display:block; background: rgba(0, 0, 0, 0.45);'>"
		+ "<div class='modal-dialog modal-dialog-scrollable' role='document' style='max-width: 94vw; width: 94vw; margin: 1rem auto;'>"
		+ "<div class='modal-content' style='min-height: 82vh;'>"
		+ "<div class='modal-header'>"
		+ "<h4 class='modal-title'>" + escapeDataExplorerHtml(title) + "</h4>"
		+ "<button type='button' class='btn-close' aria-label='Close' data-agent-modal-close='true'></button>"
		+ "</div>"
		+ "<div class='modal-body'>" + bodyHtml + "</div>"
		+ "<div class='modal-footer'><button type='button' class='btn btn-secondary' data-agent-modal-close='true'>Close</button></div>"
		+ "</div></div></div>";
}

function bindDataExplorerAgentModalCloseHandlers(modalElement) {
	if (!modalElement) {
		return;
	}

	modalElement.querySelectorAll('[data-agent-modal-close="true"]').forEach(button => {
		button.addEventListener('click', function () {
			closeDataExplorerAgentDetailModal();
		});
	});

	modalElement.addEventListener('click', function (event) {
		if (event.target === modalElement) {
			closeDataExplorerAgentDetailModal();
		}
	});
}

function buildDataExplorerAgentDetailMarkup(results) {
	let detail = results && results.agent ? results.agent : {};
	let configuration = detail.configuration || {};
	let channels = Array.isArray(detail.notification_channels) ? detail.notification_channels : [];
	let events = Array.isArray(detail.events) ? detail.events : [];
	let initialResult = events.length > 0 ? events[0] : null;
	let agentTitle = detail.name || 'Unnamed Agent';
	if (detail.id) {
		agentTitle += " (" + detail.id + ")";
	}

	let tabNavigation = "<div class='dataexplorer-agent-detail-tabs' role='tablist' aria-label='Agent detail views'>"
		+ "<button type='button' class='dataexplorer-agent-detail-tab is-active' data-agent-detail-tab='activity' aria-selected='true'>Agent Activity</button>"
		+ "<button type='button' class='dataexplorer-agent-detail-tab' data-agent-detail-tab='configuration' aria-selected='false'>Configuration</button>"
		+ "</div>";

	let activityPanel = "<div class='dataexplorer-agent-detail-tab-panel' data-agent-detail-panel='activity'>"
		+ "<div class='row g-4 align-items-start'>"
		+ "<div class='col-lg-7 col-xl-8'>"
		+ "<div class='mb-4'><div class='fw-bold mb-3' style='font-size: 20px;'>Agent Results</div>"
		+ "<div id='dataexplorer-agent-result-header'>" + renderDataExplorerAgentResultHeader(initialResult, !!initialResult) + "</div>"
		+ "<div id='dataexplorer-agent-results-panel'>" + renderDataExplorerAgentSelectedResultPanel(initialResult) + "</div></div>"
		+ "</div>"
		+ "<div class='col-lg-5 col-xl-4'>"
		+ "<div class='mb-4'><div class='smallheader mb-2'>Recent Agent Activity</div>" + renderDataExplorerAgentResultsTable(events) + "</div>"
		+ "</div>"
		+ "</div>"
		+ "</div>";

	let configurationPanel = "<div class='dataexplorer-agent-detail-tab-panel d-none' data-agent-detail-panel='configuration'>"
		+ "<div class='row g-4 align-items-start'>"
		+ "<div class='col-lg-7 col-xl-8'>"
		+ "<div class='mb-4'><div class='fw-bold mb-3' style='font-size: 20px;'>Configuration</div>" + renderDataExplorerAgentConfiguration(configuration) + "</div>"
		+ "</div>"
		+ "<div class='col-lg-5 col-xl-4'>"
		+ "<div class='mb-4'><div class='smallheader mb-2'>Notification Configuration</div>" + renderDataExplorerAgentChannels(channels) + "</div>"
		+ "</div>"
		+ "</div>"
		+ "</div>";

	let agentsUrl = '/agents?' + new URLSearchParams({
		agent: detail.id || '',
		customer: document.getElementById('customer_id')?.value || '',
	}).toString();
	let bodyHtml = "<div class='container-fluid px-0'>"
		+ "<div class='row g-4'>"
		+ "<div class='col-12'>"
		+ "<a class='btn btn-outline-primary mb-3' href='" + escapeDataExplorerHtml(agentsUrl) + "'>Open in Agents</a>"
		+ "<div id='dataexplorer-agent-detail-feedback' class='d-none'></div>"
		+ renderDataExplorerAgentControlStrip(detail, events)
		+ tabNavigation
		+ activityPanel
		+ configurationPanel
		+ "</div>"
		+ "</div></div>";

	return renderDataExplorerAgentDetailModalShell(agentTitle || detail.id || 'Agent Details', bodyHtml);
}

export {
	renderDataExplorerAgentConfiguration as renderAgentConfiguration,
	renderDataExplorerAgentChannels as renderAgentChannels,
	renderDataExplorerAgentSelectedResultPanel as renderAgentResult,
	getDataExplorerAgentStatusBadge as renderAgentStatus,
	escapeDataExplorerHtml as escapeAgentHtml,
};

let dataExplorerSectionVisibility = {
	agents: true,
	events: true,
};

const DATAEXPLORER_MAX_AGENTS = 5;

function ensureDataExplorerSectionToggleStyles() {
	if (document.getElementById('dataexplorer-section-toggle-styles')) {
		return;
	}

	let styleElement = document.createElement('style');
	styleElement.id = 'dataexplorer-section-toggle-styles';
	styleElement.textContent = ""
		+ ".dataexplorer-section-toggle {"
		+ "display: inline-flex;"
		+ "align-items: center;"
		+ "gap: 10px;"
		+ "padding: 0;"
		+ "border: 0;"
		+ "background: transparent;"
		+ "color: inherit;"
		+ "box-shadow: none;"
		+ "text-align: left;"
		+ "}"
		+ ".dataexplorer-section-toggle:focus-visible {"
		+ "outline: 2px solid rgba(37, 99, 235, 0.35);"
		+ "outline-offset: 4px;"
		+ "border-radius: 6px;"
		+ "}"
		+ ".dataexplorer-section-twisty {"
		+ "display: inline-flex;"
		+ "align-items: center;"
		+ "justify-content: center;"
		+ "width: 16px;"
		+ "color: #64748b;"
		+ "transition: transform 140ms ease, color 140ms ease;"
		+ "font-size: 12px;"
		+ "flex: 0 0 auto;"
		+ "}"
		+ ".dataexplorer-section.is-collapsed .dataexplorer-section-twisty {"
		+ "transform: rotate(-90deg);"
		+ "}"
		+ ".dataexplorer-section-toggle:hover .dataexplorer-section-twisty {"
		+ "color: #334155;"
		+ "}"
		+ ".dataexplorer-section-content.d-none {"
		+ "display: none !important;"
		+ "}"
		+ ".dataexplorer-section-content {"
		+ "padding-top: 8px;"
		+ "}"
		+ ".dataexplorer-agent-item {"
		+ "font-family: Oswald, sans-serif;"
		+ "}";
	document.head.appendChild(styleElement);
}

function renderDataExplorerCollapsibleSection(sectionKey, title, bodyHtml, options = {}) {
	let isOpen = dataExplorerSectionVisibility[sectionKey] !== false;
	let headerActions = options.headerActions || '';
	let sectionClass = isOpen ? 'dataexplorer-section' : 'dataexplorer-section is-collapsed';
	let contentClass = isOpen ? 'dataexplorer-section-content' : 'dataexplorer-section-content d-none';
	let sectionStyle = options.sectionStyle || '';

	return "<div class='" + sectionClass + "' data-dataexplorer-section='" + escapeDataExplorerHtml(sectionKey) + "'" + (sectionStyle ? " style='" + escapeDataExplorerHtml(sectionStyle) + "'" : '') + ">"
		+ "<div class='d-flex justify-content-between align-items-center gap-3 flex-wrap'>"
		+ "<button type='button' class='dataexplorer-section-toggle' data-dataexplorer-section-toggle='" + escapeDataExplorerHtml(sectionKey) + "' aria-expanded='" + (isOpen ? 'true' : 'false') + "'>"
		+ "<span class='dataexplorer-section-twisty' aria-hidden='true'><i class='fas fa-chevron-down'></i></span>"
		+ "<h4 class='mb-0'>" + escapeDataExplorerHtml(title) + "</h4>"
		+ "</button>"
		+ headerActions
		+ "</div>"
		+ "<div class='" + contentClass + "' data-dataexplorer-section-content='" + escapeDataExplorerHtml(sectionKey) + "'>" + bodyHtml + "</div>"
		+ "</div>";
}

function formatDataExplorerAgentsSectionTitle(agentCount) {
	let normalizedCount = Number.isFinite(agentCount) ? agentCount : 0;
	return "My Agents (" + normalizedCount + ")";
}

function formatDataExplorerEventsSectionTitle(eventCount) {
	let normalizedCount = Number.isFinite(eventCount) ? eventCount : 0;
	return "Events Discovered in your Chat (" + normalizedCount + ")";
}

function bindDataExplorerSectionToggleHandlers(container) {
	if (!container) {
		return;
	}

	container.querySelectorAll('[data-dataexplorer-section-toggle]').forEach(toggle => {
		if (toggle.dataset.toggleBound === 'true') {
			return;
		}
		toggle.dataset.toggleBound = 'true';
		toggle.addEventListener('click', function () {
			let section = toggle.closest('[data-dataexplorer-section]');
			if (!section) {
				return;
			}

			let sectionKey = section.getAttribute('data-dataexplorer-section') || '';
			let content = section.querySelector('[data-dataexplorer-section-content]');
			let nextExpanded = toggle.getAttribute('aria-expanded') !== 'true';

			toggle.setAttribute('aria-expanded', nextExpanded ? 'true' : 'false');
			section.classList.toggle('is-collapsed', !nextExpanded);
			if (content) {
				content.classList.toggle('d-none', !nextExpanded);
			}

			if (sectionKey) {
				dataExplorerSectionVisibility[sectionKey] = nextExpanded;
			}
		});
	});
}

async function showDataExplorerAgentDetailModal(agentId) {
	if (!agentId) {
		return;
	}

	ensureDataExplorerAgentDetailStyles();
	closeDataExplorerAgentDetailModal();
	document.body.style.overflow = 'hidden';
	if (document.body.classList) {
		document.body.classList.add('modal-open');
	}

	let container = document.createElement('div');
	container.innerHTML = renderDataExplorerAgentDetailModalShell('Agent Details', "<div class='text-muted'>Loading agent details...</div>");
	document.body.appendChild(container.firstChild);

	let modalElement = document.getElementById('dataexplorer-agent-detail-modal');
	bindDataExplorerAgentModalCloseHandlers(modalElement);

	let results = await window.load_explorer_swanbot_agent_detail(agentId);
	if (!results || results.status !== 'success' || !results.agent) {
		modalElement.outerHTML = renderDataExplorerAgentDetailModalShell('Agent Details', "<div class='text-muted'>Unable to load agent details right now.</div>");
		bindDataExplorerAgentModalCloseHandlers(document.getElementById('dataexplorer-agent-detail-modal'));
		return;
	}

	modalElement.outerHTML = buildDataExplorerAgentDetailMarkup(results);
	bindDataExplorerAgentModalCloseHandlers(document.getElementById('dataexplorer-agent-detail-modal'));
	bindDataExplorerAgentDetailActionHandlers(results.agent || {});
	bindDataExplorerAgentDetailTabHandlers();
	bindDataExplorerAgentResultSelectionHandlers(Array.isArray(results.agent && results.agent.events) ? results.agent.events : []);
}

async function make_dataexplorer_agents() {
	let queryagentoutput = document.getElementById("graph-dataexplorer-agents");
	if (!queryagentoutput) {
		return [];
	}

	queryagentoutput.style.display = dataExplorerInitialLoaderShown ? '' : 'none';

	ensureDataExplorerSectionToggleStyles();

	queryagentoutput.innerHTML = renderDataExplorerCollapsibleSection('agents', 'My Agents', "<div class='text-muted'>Loading agents...</div>", {
		sectionStyle: 'padding-left: 36px; padding-top: 10px; margin-top: 14px;'
	});
	bindDataExplorerSectionToggleHandlers(queryagentoutput);

	try {
		let results = await window.load_explorer_swanbot_agents();
		swanbot_dataexplorer_agents = normalizeDataExplorerAgents(results);
		let agentsSectionTitle = formatDataExplorerAgentsSectionTitle(swanbot_dataexplorer_agents.length);

		let addAgentButton = "";

		let agentsMarkup = "";
		if (swanbot_dataexplorer_agents.length === 0) {
			agentsMarkup += "<div class='text-muted'>No agents are currently configured for this organization.</div>";
			queryagentoutput.innerHTML = renderDataExplorerCollapsibleSection('agents', agentsSectionTitle, agentsMarkup, {
				headerActions: addAgentButton,
				sectionStyle: 'padding-left: 36px; padding-top: 10px; margin-top: 14px;'
			});
			bindDataExplorerSectionToggleHandlers(queryagentoutput);
			let emptyAddAgentTrigger = queryagentoutput.querySelector('[data-agent-create-trigger="true"]');
			if (emptyAddAgentTrigger) {
				emptyAddAgentTrigger.addEventListener('click', function () {
					openDataExplorerAgentCreateModal();
				});
			}
			return [];
		}

		agentsMarkup += "<div class='list-group'>";
		swanbot_dataexplorer_agents.forEach(agent => {
			let statusBadge = agent.status ? getDataExplorerAgentStatusBadge(agent.status) : "";
			let healthBadge = String(agent.health || '').trim().toLowerCase() === 'paused' ? "<span class='badge badge-dark'>paused</span>" : "";

			agentsMarkup += "<div class='list-group-item py-2 px-3 dataexplorer-agent-item' data-agent-id='" + escapeDataExplorerHtml(agent.agentId) + "' style='cursor: pointer;'>";
			agentsMarkup += "<div class='d-flex justify-content-between align-items-start gap-3'>";
			agentsMarkup += "<div style='min-width: 0;'>";
			agentsMarkup += "<div>" + escapeDataExplorerHtml(agent.name || agent.interestSummary) + "</div>";
			agentsMarkup += "<div class='text-muted mt-1'><span style='font-size: 10px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #000 !important;'>Last Activity</span><span style='font-size: 10px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: #000 !important;'>: " + escapeDataExplorerHtml(agent.lastActivityRelative) + "</span></div>";
			agentsMarkup += "</div>";
			agentsMarkup += "<div class='d-flex flex-column align-items-end gap-2'>";
			if (statusBadge || healthBadge) {
				agentsMarkup += "<div class='d-flex flex-wrap justify-content-end gap-2'>" + statusBadge + healthBadge + "</div>";
			}
			agentsMarkup += "<div class='text-nowrap text-secondary' style='font-size: 16px; padding-top: 2px;'>" + agent.notificationIcons + "</div>";
			agentsMarkup += "</div>";
			agentsMarkup += "</div>";
			agentsMarkup += "</div>";
		});
		agentsMarkup += "</div>";

		queryagentoutput.innerHTML = renderDataExplorerCollapsibleSection('agents', agentsSectionTitle, agentsMarkup, {
			headerActions: addAgentButton,
			sectionStyle: 'padding-left: 36px; padding-top: 10px; margin-top: 14px;'
		});
		bindDataExplorerSectionToggleHandlers(queryagentoutput);
		let addAgentTrigger = queryagentoutput.querySelector('[data-agent-create-trigger="true"]');
		if (addAgentTrigger) {
			addAgentTrigger.addEventListener('click', function () {
				openDataExplorerAgentCreateModal();
			});
		}
		queryagentoutput.querySelectorAll('[data-agent-id]').forEach(agentRow => {
			agentRow.addEventListener('click', function () {
				let agentId = agentRow.getAttribute('data-agent-id');
				showDataExplorerAgentDetailModal(agentId);
			});
		});
		return swanbot_dataexplorer_agents;
	} catch (error) {
		console.error("Unable to render data explorer agents", error);
		queryagentoutput.innerHTML = renderDataExplorerCollapsibleSection('agents', 'My Agents', "<div class='text-muted'>Unable to load agents right now.</div>", {
			sectionStyle: 'padding-left: 36px; padding-top: 10px; margin-top: 14px;'
		});
		bindDataExplorerSectionToggleHandlers(queryagentoutput);
		return [];
	}
}



function update_dataexplorer_graph(event_id) {
	//console.log("event to update with", event_id)

	let timezone_selected_input = document.getElementById("timezone_dataexplorer_selected");
	let timezone_select_data = document.querySelector("#timezone_options_select .Select-value .Select-value-label");
	let timezone_selected = "UTC";

	if (timezone_selected_input && timezone_selected_input.value) {
		let hiddenTimezoneValue = String(timezone_selected_input.value).trim();
		if (hiddenTimezoneValue) {
			timezone_selected = hiddenTimezoneValue;
		}
	}

	if (timezone_selected === "UTC" && timezone_select_data) {
		let timezone_value_from_select = timezone_select_data.innerText;
		timezone_selected = timezone_value_from_select
		//timezone_selected = getShortTimezone(timezone_value_from_select);
	}

	//console.log("convert all date times in moment to this timezone:", timezone_selected)
	//console.log("window.get_end_date: ", window.get_end_date)
	//console.log("window.get_start_date: ", window.get_start_date)

	let evaluate_end_date = window.get_end_date;
	let evaluate_start_date = window.get_start_date;

	if (timezone_selected !== "UTC") {
		evaluate_end_date = window.get_end_date.clone().tz(timezone_selected);
		evaluate_start_date = window.get_start_date.clone().tz(timezone_selected);
	}

	//console.log("evaluate_end_date formatted", evaluate_end_date.format('YYYY-MM-DD HH:mm:ss.SSSZZ'))
	//console.log("evaluate_start_date formatted", evaluate_start_date.format('YYYY-MM-DD HH:mm:ss.SSSZZ'))


	if (swanbot_dataexplorer_currently_showing !== event_id) {
		swanbot_dataexplorer_currently_showing = event_id;
		let event_data = swanbot_dataexplorer_links_data[event_id]
		//console.log("use clusters", event_data.clusters)

		let pricelinelayout = {}
		let layout = {}
		let shapes = []
		let annotations = [];
		var arrow_size = '22'
		var up_arrow = '&#9652'
		var up_arrow_start_text = "<span style='font-size:" + arrow_size + "px;color:green;'>" + up_arrow + ";</span>"
		var up_arrow_end_text = "<span style='font-size:" + arrow_size + "px;color:red;'>" + up_arrow + ";</span>"


		let clusterdata = event_data.clusters;

		if (clusterdata) {

			var total_clusters = clusterdata.length;

			for (let x = 0; x < total_clusters; x++) {

				let endcolor = "red";
				let endwidth = 2;
				let endtype = "dash"
				var start_cluster = clusterdata[x]["ts_start"];
				var end_cluster = clusterdata[x]["ts_end"];

				//console.log("start_cluster from cluster:", start_cluster)
				start_cluster = moment.utc(start_cluster);
				end_cluster = moment.utc(end_cluster);

				if (timezone_selected !== "UTC") {
					start_cluster = start_cluster.tz(timezone_selected);
					end_cluster = end_cluster.tz(timezone_selected);
				}

				//console.log("start_cluster moment", start_cluster)

				//start_cluster = moment(start_cluster);
				//start_cluster = start_cluster.subtract(1, 'hour');
				if (start_cluster >= evaluate_end_date) {
					start_cluster = evaluate_end_date;
					//console.log("this start cluster is beyond the end., moved it to the end ", start_cluster)

				}

				//end_cluster = moment(end_cluster);
				//end_cluster = end_cluster.add(1, 'hour');
				if (end_cluster >= evaluate_end_date) {
					//console.log("this end cluster is beyond the end., moved it to the end ", end_cluster)
					end_cluster = evaluate_end_date;
				}

				if (start_cluster.isSame(end_cluster)) {
					//console.log("SAME DATE")
					//start_cluster = start_cluster.subtract(1, 'hour');
					//end_cluster = end_cluster.add(1, 'hour');
					endcolor = "#FF8C00";
					endtype = "solid";
				}


				start_cluster_str = start_cluster.format('YYYY-MM-DD HH:mm:ss');
				end_cluster_str = end_cluster.format('YYYY-MM-DD HH:mm:ss');
				//console.log("start_cluster_str, end_cluster_str", start_cluster_str, end_cluster_str)



				start_annotation = {
					type: 'line',
					x0: start_cluster_str,
					y0: 0,
					x1: start_cluster_str,
					y1: 1,
					xref: 'x',
					yref: 'paper',
					line: {
						color: 'green',
						width: 2,
						dash: 'dash'
					}
				}

				end_annotation = {
					type: 'line',
					x0: end_cluster_str,
					y0: 0,
					x1: end_cluster_str,
					y1: 1,
					xref: 'x',
					yref: 'paper',
					line: {
						color: endcolor,
						width: endwidth,
						dash: endtype
					}
				}

				start_annotation_arrow = {
					x: start_cluster_str,
					y: 20,
					xref: "x",
					yref: "y",
					text: up_arrow_start_text,
					showarrow: false
				}

				end_annotation_arrow = {
					x: end_cluster_str,
					y: 20,
					xref: "x",
					yref: "y",
					text: up_arrow_end_text,
					showarrow: false
				}

				annotations.push(start_annotation_arrow)
				annotations.push(end_annotation_arrow)

				shapes.push(start_annotation)
				shapes.push(end_annotation)
			}


		}

		if (shapes) {
			pricelinelayout["shapes"] = shapes;
		}

		if (annotations) {
			//pricelinelayout["annotations"] = annotations
		}

		Plotly.relayout(swanbot_dataexplorer_graph_id, pricelinelayout);
		//Plotly.relayout(swanbot_dataexplorer_date_graph_id, layout);



		//console.log("event data", event_data)
	} else {
		console.log("already showing this event");
	}
}



function update_graph_aoe(event_data_start, event_data_end) {
	let pricelinelayout = {}
	let layout = {}
	let shapes = []
	let annotations = [];
	var arrow_size = '33'
	var up_arrow = '&#9652'
	var up_arrow_start_text = "<span style='font-size:" + arrow_size + "px;color:green;'>" + up_arrow + ";</span>"
	var up_arrow_end_text = "<span style='font-size:" + arrow_size + "px;color:red;'>" + up_arrow + ";</span>"

	let endcolor = "red";
	let endwidth = 2;
	let endtype = "dash"
	let startcolor = "green";
	let startwidth = 2;
	let starttype = "dash"
	var start_cluster = event_data_start;
	var end_cluster = event_data_end;
	let evaluate_end_date = null;
	let sbplot = document.getElementById(swanbot_dataexplorer_graph_id);

	//console.log("start_cluster from cluster:", start_cluster)
	start_cluster = moment(start_cluster);
	end_cluster = moment(end_cluster);

	if (sbplot && Array.isArray(sbplot.data)) {
		sbplot.data.forEach(trace => {
			if (!trace || !Array.isArray(trace.x) || trace.x.length === 0) {
				return;
			}

			let trace_end_date = moment(trace.x[trace.x.length - 1]);
			if (!trace_end_date.isValid()) {
				return;
			}

			if (!evaluate_end_date || trace_end_date.isAfter(evaluate_end_date)) {
				evaluate_end_date = trace_end_date;
			}
		});
	}

	if (!evaluate_end_date && window.get_end_date) {
		evaluate_end_date = moment(window.get_end_date);
	}


	//console.log("start_cluster moment", start_cluster)

	//end_cluster = moment(end_cluster);
	//end_cluster = end_cluster.add(1, 'hour');
	if (evaluate_end_date && end_cluster.isAfter(evaluate_end_date)) {
		//console.log("this end cluster is beyond the end., moved it to the end ", end_cluster)
		end_cluster = evaluate_end_date.clone();
	}



	if (start_cluster.isSame(end_cluster)) {
		//console.log("SAME DATE")
		//start_cluster = start_cluster.subtract(1, 'hour');
		//end_cluster = end_cluster.add(1, 'hour');
		endcolor = "#FF8C00";
		endtype = "solid";
	}


	start_cluster_str = start_cluster.format('YYYY-MM-DD HH:mm:ss');
	end_cluster_str = end_cluster.format('YYYY-MM-DD HH:mm:ss');
	//console.log("start_cluster_str, end_cluster_str", start_cluster_str, end_cluster_str)



	start_annotation = {
		type: 'line',
		x0: start_cluster_str,
		y0: 0,
		x1: start_cluster_str,
		y1: 1,
		xref: 'x',
		yref: 'paper',
		line: {
			color: startcolor,
			width: startwidth,
			dash: starttype
		}
	}

	end_annotation = {
		type: 'line',
		x0: end_cluster_str,
		y0: 0,
		x1: end_cluster_str,
		y1: 1,
		xref: 'x',
		yref: 'paper',
		line: {
			color: endcolor,
			width: endwidth,
			dash: endtype
		}
	}

	start_annotation_arrow = {
		x: start_cluster_str,
		y: 20,
		xref: "x",
		yref: "y",
		text: up_arrow_start_text,
		showarrow: false
	}

	end_annotation_arrow = {
		x: end_cluster_str,
		y: 20,
		xref: "x",
		yref: "y",
		text: up_arrow_end_text,
		showarrow: false
	}

	annotations.push(start_annotation_arrow)
	annotations.push(end_annotation_arrow)

	shapes.push(start_annotation)
	shapes.push(end_annotation)




	if (shapes) {
		pricelinelayout["shapes"] = shapes;
	}

	if (annotations) {
		//pricelinelayout["annotations"] = annotations
	}

	Plotly.relayout(swanbot_dataexplorer_graph_id, pricelinelayout);
	//Plotly.relayout(swanbot_dataexplorer_date_graph_id, layout);
}

async function get_event_data(event_id) {
	//console.log("---- get_event_data ----", event_id);

	res = axios.get('/xapi/event/' + event_id,
	).then(response => {
		if (response.data.status == "success") {
			let event_data = response.data.event.event_data;
			//console.log("event_data", event_data)
			let event_start_data = {
				"id": event_data["id"],
				"start": event_data["ts_start"]
			}
			swanbot_dataexplorer_links_dates.push(event_start_data)

			swanbot_dataexplorer_links_data[event_data["id"]] = {
				"id": event_data["id"],
				"name": event_data["name"],
				"range": event_data["ts_start"] + " UTC to " + event_data["ts_end"] + " UTC",
				"cause": "<span class='badge badge-light'></span>",
				"priceline": event_data["cardpath_priceline"],
				"rowdata": event_data["cardpath"],
				"tags": "<span class='badge badge_tag_resource_partner' style='background-color:#2b7bba'>partner</span> <span class='badge badge_tag_user' style='background-color:'>Degradation</span><span class='badge badge_tag_user' style='background-color:'>Large Numbers</span>",
				"clusters": event_data["clusters"],
				"card_data": "",
			}
		}
		/*
				console.log(response);	 
		*/
	})
		.catch(error => {
			console.log(error);
		});

	return res;


}



async function generate_data_card(event_id) {
	//console.log("---- generate_data_card ----", event_id);

	if (event_id && swanbot_dataexplorer_links_data[event_id]) {


		let event_name = swanbot_dataexplorer_links_data[event_id]["name"];
		let event_range = swanbot_dataexplorer_links_data[event_id]["range"];
		let event_causes = swanbot_dataexplorer_links_data[event_id]["cause"];
		let event_priceline = swanbot_dataexplorer_links_data[event_id]["priceline"];
		let event_rowdata = swanbot_dataexplorer_links_data[event_id]["rowdata"];
		let event_tags = swanbot_dataexplorer_links_data[event_id]["tags"];

		return new Promise((resolve) => {
			let card_template = `
			<div class="accordion-item">
				<h2 class="accordion-header" id="heading_${event_id}">
				<button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_${event_id}" aria-expanded="true" aria-controls="collapse_${event_id}">
					${event_name}
				</button>
				</h2>
				<div id="collapse_${event_id}" class="accordion-collapse collapse show" aria-labelledby="heading_${event_id}" data-bs-parent="#eventAccordian">
					<div class="accordion-body">
						<a href="/events/details?event=${event_id}" target="_blank">
							<div class="dataexplorer_embeded_card">
								<p id="card-range" class="card-range">${event_range}</p>
								<p id="card-id" class="card-range" data-event-i-d="qndkjhcrh">Event ID: ${event_id}</p>
								<p id="card-event-chart-toggle" class="card-charts">Event Timeline:</p>
								<div id="card-event-chart" class="">
									<img id="card-priceline" class="card-image" src="${event_priceline}">
									<img id="card-heatmap" class="card-image" src="${event_rowdata}">
								</div>
							</div>
						</a>
				</div>
				</div>
			</div>
			`;


			/*
								<div class="dataexplorer_embeded_card">
							<p id="card-range" class="card-range">${event_range}</p>
							<p id="card-id" class="card-range" data-event-i-d="qndkjhcrh">Event ID: ${event_id}</p>
							<div>
								<p id="card-event-cause-toggle" class="card-cause">Event Cause:</p>
								<div id="card-root-cause" class="card-root-cause">
								${event_causes}
								</div>
							</div>
							<p id="card-event-chart-toggle" class="card-charts">Event Timeline:</p>
							<div id="card-event-chart" class="">
								<img id="card-priceline" class="card-image" src="${event_priceline}">
								<img id="card-heatmap" class="card-image" src="${event_rowdata}">
							</div>
							<div id="card-tags" class="card-pills">
								${event_tags}
							</div>
						</div>
			*/

			swanbot_dataexplorer_links_data[event_id]["card_data"] = card_template;

			//send_dataexplorer_results(card_template, "swanbot", 0);

			resolve();
		});
	} else {
		return new Promise((resolve) => {
			resolve();
		});
	}

}

function replaceUrlsWithAnchorTags(htmlContent) {
	// unused

	const urlPattern = /https:\/\/wingman\.grayswan\.io\/events\/details\?event=([a-zA-Z0-9]+)/g;

	const modifiedContent = htmlContent.replace(urlPattern, (fullMatch, url) => {
		//return '<a href="${url}" target="_blank" class="text-blue-600 hover:underline">${url}</a>';
		//return `<a href="${url}" target="_blank" class="text-blue-600 hover:underline">View event</a>`
		return `[View event](${url}){:target="_blank"}`
	});

	return modifiedContent;
}


window.send_user_data = function(querytext) {

	async function sendMessageSequence() {
		await window.add_swan_chat(querytext, 0, "user");
	}

	sendMessageSequence();
}


function addQueryParam(url, key, value) {
	const separator = url.includes('?') ? '&' : '?';
	return url + separator + key + '=' + encodeURIComponent(value);
}


/* extracted get_swanbot_data */




/* extracted get_swanbot_graphs */



window.make_swan_graphs = async function() {
	// swanbot_graphs from chat text
	if (window.swanbot_graphdata) {
		if (window.swanbot_graphs.length > 0) {
			for (let i = 0; i < window.swanbot_graphs.length; i++) {
				let added_date = false;

				//console.log(i);
				//console.log("window.swanbot_graphdata", window.swanbot_graphdata)	
				//console.log("graphs", window.swanbot_graphdata.graphs)
				//console.log("titles", window.swanbot_graphdata.titles)

				//console.log("Lets find this in the graphdata: ", parseInt(window.swanbot_graphs[i]))
				let chart_graphs = window.swanbot_graphdata.graphs[window.swanbot_graphs[i]];
				let graph_sections = window.swanbot_graphdata.sections[window.swanbot_graphs[i]]
				let chart_titles = window.swanbot_graphdata.titles[window.swanbot_graphs[i]]



				const graphsectiontext = "<h3 class='swanbot_chart_section'>" + graph_sections + "</h3>"
				await window.add_swan_chat(graphsectiontext, 0, "plotsection");

				for (let k = 0; k < chart_graphs.length; k++) {


					// total traffic
					// window.swanbot_graphdata["graphs"][window.swanbot_graphs[i]];
					// window.swanbot_graphdata["titles"][window.swanbot_graphs[i]];


					// totals
					let graph_data = JSON.parse(chart_graphs[k]);
					let graph_title = chart_titles[k];


					const config = {
						displayModeBar: false,
						modeBarButtonsToRemove: ['toImage', 'sendDataToCloud', 'hoverCompareCartesian'],
					};

					//console.log("graph_data.data", graph_data.data)
					//console.log("graph_data.data", graph_data.data.length)
					if (graph_data.data.length > 0) {




						if (!added_date) {
							let date_row_data = draw_date_row_events(graph_data, true, true);

							const addgraph = "<div id='" + date_row_data[0] + "'></div>"
							await window.add_swan_chat(addgraph, 0, "plot");

							Plotly.newPlot(date_row_data[0], date_row_data[1]);

							dategraphobj = document.getElementById(date_row_data[0])
							dategraphobj.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

							added_date = true
						}




						graphid = "swanbot_graph_" + fivedigit();
						let total_traffic_max_value_label = graph_title
						const addgraph = "<h4 class='swanbot_chart_label'>" + total_traffic_max_value_label + "</h4><div id='" + graphid + "'></div>"
						await window.add_swan_chat(addgraph, 0, "plot");


						/*
   
   
   
   
   
   
					   // total traffic layout
   
					   //console.log("graph data to plot", trace1);
					   var data = [trace1];
					   var layout = {
						 height: 46,
						 dragmode: false,
						 grid: {rows: 1, columns: 1, pattern: 'coupled'},
						 xaxis: {
						   zeroline: false,
						   showline: false,
						   showgrid: false,
						   showticklabels: true,
						   title: "",
						   linecolor: "rgb(204, 204, 204)",
						   linewidth: 0,
						   ticks: "outside",
						   tickfont: {
							   family: "Arial",
							   size: 12,
							   color: "rgb(82, 82, 82)"
						   }
						 },
						 yaxis: {
						   zeroline: false,
						   showline: false,
						   showgrid: false,
						   showticklabels: true,
						   title:"",
						   linecolor: "rgb(204, 204, 204)",
						   linewidth: 0,
						   ticks: "outside",
						   tickfont: {
							   family: "Arial",
							   size: 8,
							   color: "rgb(82, 82, 82)"
						   }
   
						 },
						 autosize: true,
							   margin: {
						   autoexpand: false,
						   r: 5,
						   l: 50,
						   t: 0,
						   b: 0
						 },
						 showlegend: false,
						 plot_bgcolor: 'white',
						 xaxis_showgrid: false,
						 yaxis_showgrid: false
					   };
   
   
   
   
					   */



						const fig_date_start = new Date(graph_data.data[0]['x'].at(0));
						const fig_date_end = new Date(graph_data.data[0]['x'].at(-1));


						//console.log("fig_date_start and end ", fig_date_start, fig_date_end)


						graph_data.data[0]['name'] = "Total Transactions";
						graph_data.data[0]['showlegend'] = true;
						if (graph_data.data.length == 2) {
							graph_data.data[1]['showlegend'] = true
						}

						var pricelinelayout = {
							line: {
								width: 3.5
							},
							height: 115,
							dragmode: false,
							xaxis: {
								showline: true,
								showgrid: true,
								showticklabels: true,
								title: "",
								linecolor: "rgb(204, 204, 204)",
								linewidth: 2,
								ticks: "outside",
								tickfont: {
									family: "Arial",
									size: 8
								},
								domain: [0, 1],
								range: [fig_date_start, fig_date_end],
								row: 1,
								col: 1
							},
							yaxis: {
								automargin: true,
								anchor: 'x',
								zeroline: true,
								showline: true,
								showgrid: true,
								showticklabels: true,
								title: "",
								linecolor: "rgb(204, 204, 204)",
								linewidth: 2,
								ticks: "outside",
								side: "left",
								tickfont: {
									family: "Arial",
									size: 8
								}
							},
							autosize: true,
							margin: {
								autoexpand: false,
								r: 7,
								l: 45,
								t: 0,
								b: 0
							},
							legend: {
								bgcolor: 'white',
								bordercolor: 'black',
								borderwidth: 1,
								orientation: "v",
								x: 0.005,
								y: 1,
								xanchor: "left",
								yanchor: "top",
							},
							showlegend: true,
							plot_bgcolor: 'white',
						};


						let shapes = []

						let clusterdata = document.getElementById("event_clusterdata").value;

						if (clusterdata) {
							clusterdata = JSON.parse(clusterdata);
							var total_clusters = clusterdata.length;

							for (let x = 0; x < total_clusters; x++) {

								var start_cluster = clusterdata[x]["ts_start"];
								var end_cluster = clusterdata[x]["ts_end"];
								start_cluster = moment(start_cluster);
								start_cluster = start_cluster.subtract(1, 'hour');
								start_cluster_str = start_cluster.format('YYYY-MM-DD HH:mm:ss');
								end_cluster = moment(end_cluster);
								end_cluster = end_cluster.add(1, 'hour');
								end_cluster_str = end_cluster.format('YYYY-MM-DD HH:mm:ss');


								start_annotation = {
									type: 'line',
									x0: start_cluster_str,
									y0: 0,
									x1: start_cluster_str,
									y1: 1,
									xref: 'x',
									yref: 'paper',
									line: {
										color: 'green',
										width: 2,
										dash: 'dash'
									}
								}

								end_annotation = {
									type: 'line',
									x0: end_cluster_str,
									y0: 0,
									x1: end_cluster_str,
									y1: 1,
									xref: 'x',
									yref: 'paper',
									line: {
										color: 'red',
										width: 2,
										dash: 'dash'
									}
								}
								shapes.push(start_annotation)
								shapes.push(end_annotation)
							}


						}

						if (shapes) {
							pricelinelayout["shapes"] = shapes;
						}



						const figure = { data: graph_data.data, layout: pricelinelayout, config: config };




						Plotly.newPlot(graphid, figure);

						//Plotly.newPlot(graphid, data, layout, config);
						graphobj = document.getElementById(graphid)
						graphobj.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });


					}

					else {
						graphid = "swanbot_graph_" + fivedigit();
						let total_traffic_max_value_label = graph_title
						const addgraph = "<h4 class='swanbot_chart_label'>" + total_traffic_max_value_label + "</h4><div class='swanbot_chart_no_data'>No Graph Data</div>"
						await window.add_swan_chat(addgraph, 0, "plot");
					}




					//Plotly.newPlot(graphid, graph_data);
					//Plotly.relayout(graphid, {height: 86});
				}

				/*
				const total_traces = all_traces.length;
				console.log("total traces", total_traces)
				var old_layout = {
				  grid: {rows: total_traces, columns: 1}
				};
  
			    
				const layout = {
						height: 200,
					barmode: 'stack',
					grid: {rows: total_traces, columns: 1},
					xaxis: {domain: [0, 1]},
					xaxis2: {domain: [0, 1], anchor: 'y2'},
					yaxis: {domain: [0, 1]},
					yaxis2: {domain: [0, 1], anchor: 'x2'},
				};
  
  
				const config = {
				  displayModeBar: false,
				  modeBarButtonsToRemove: ['toImage', 'sendDataToCloud','hoverCompareCartesian'],
				};
  
				const figure = {data: all_traces, layout: layout, config: config};
  
				console.log("all_traces", all_traces)
				const graphid = "swanbot_graph_" + Date.now();
				const addgraph = "<h4 class='swanbot_chart_label'>" + all_titles + "</h4><div id='" + graphid + "'></div>"
				await window.add_swan_chat(addgraph, 0, "plot");
				//Plotly.newPlot(graphid, all_traces, layout, config);
				Plotly.newPlot(graphid, figure);
				*/


			}
		}
	}


}



/* extracted get_dataexplorer_swanbot_stop */




/* extracted reset_swanbot_end */




/* extracted get_dataexplorer_swanbot_data */






/* extracted monitorRequestAndPoll */







/* extracted load_explorer_swanbot_endpoint */


//async function, return the promise correctly

/* extracted load_explorer_swanbot_key */




/* extracted load_explorer_swanbot */


function areArraysEqual(arr1, arr2) {
	if (arr1.length !== arr2.length) {
		return false;
	}

	return arr1.every((value, index) => value === arr2[index]);
}

async function send_dataexplorer_events(card_data) {

}




async function send_dataexplorer_results(chatdata, speaker, speed, scroll = true) {

	//console.log("-------- send_dataexplorer_results --------------");
	let chatoutput = document.getElementById("dataexplorer-data-results");


	var div = document.createElement('div');
	if (speaker == "swanbot") {
		div.setAttribute('class', 'chat-message other');
		handle_dataexplorer_events(chatdata);
	} else if (speaker == "swanbot_start") {
		div.setAttribute('class', 'chat-message other');
		handle_dataexplorer_events(chatdata);
	} else if (speaker == "swanbot_error") {
		div.setAttribute('class', 'chat-message error');
		handle_dataexplorer_events(chatdata);
	} else if (speaker == "plot") {
		div.setAttribute('class', 'chat-message other');
	} else if (speaker == "plotsection") {
		div.setAttribute('class', 'chat-message other');
	} else {
		div.setAttribute('class', 'chat-message self');
	}
	let chatid_suffix = + Date.now();
	let chatid = "swanbot_modal_" + chatid_suffix;
	div.setAttribute("id", chatid);
	chatoutput.appendChild(div);


	let chatdata_cleaned = clean_dataexplorer_swanbot_chat(chatdata);

	let chatdata_action_buttons = "";

	if (speaker == "swanbot") {
		chatdata_action_buttons = "<a id='dataexplorer_response_like_" + chatid_suffix + "' data-relatedid='" + chatid + "' class='btn btn-link btn-like response-like-up' href='#'></a><a id='dataexplorer_response_dislike_" + chatid_suffix + "' data-relatedid='" + chatid + "' class='btn btn-link btn-unlike response-like-down' href='#'></a><a id='dataexplorer_response_copy_" + chatid_suffix + "' data-relatedid='" + chatid + "' class='btn btn-link btn-copy response-copy' href='#'></a><a id='dataexplorer_response_tryagain_" + chatid_suffix + "' data-relatedid='" + chatid + "' class='btn btn-link btn-dataexplorer-try-again' href='#'>Try Again</a>";
		chatdata_cleaned += "<div class='chat-message-actions' data-relatedid='" + chatid + "'>" + chatdata_action_buttons + "</div>"
	}



	//console.log("cleaned html", chatdata_cleaned)
	if (speed > 0) {
		await typeWriterEffectHTML(div, chatdata_cleaned, speed);
		await init_chatdata_action_buttons(chatid_suffix);
		if (scroll) div.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

	} else {
		await addChatNoEffectHTML(div, chatdata_cleaned);
		await init_chatdata_action_buttons(chatid_suffix);
		if (scroll) div.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
	}

}


async function init_chatdata_action_buttons(chatid) {

	let tryagainbtn = document.getElementById("dataexplorer_response_tryagain_" + chatid);
	let dislikebtn = document.getElementById("dataexplorer_response_dislike_" + chatid);
	let likebtn = document.getElementById("dataexplorer_response_like_" + chatid);
	let copybtn = document.getElementById("dataexplorer_response_copy_" + chatid);

	if (tryagainbtn) {
		tryagainbtn.addEventListener("click", function () {
			async function sendMessageSequence() {

				get_dataexplorer_swanbot_data("Try again.");
			}
			sendMessageSequence();
		});
	}

	if (dislikebtn) {
		dislikebtn.addEventListener("click", function () {
			async function sendMessageSequence() {

				get_dataexplorer_swanbot_data("That's not quite right. Try again.");
			}
			sendMessageSequence();
		});
	}

	if (likebtn) {
		likebtn.addEventListener("click", function () {
			async function sendMessageSequence() {
				send_dataexplorer_results("👍", "user", 0);
				send_dataexplorer_results("Glad it was useful.", "swanbot", 5);
			}
			sendMessageSequence();
		});
	}

	if (copybtn) {
		const copybtnaction = new ClipboardJS('#dataexplorer_response_copy_' + chatid, {
			target: function (trigger) {
				//const relatedId = trigger.getAttribute('data-relatedid');
				console.log("relatedId", 'swanbot_modal_' + chatid)
				//const targetId = 'swanbot_modal_' + chatid;
				return document.getElementById('swanbot_modal_' + chatid);
			}
		});

		copybtnaction.on('success', function (e) {
			display_toast("Copied chat response to your clipboard!", mdtoast.INFO);

			e.clearSelection();
		});




	}

}



async function make_dataexplorer_events() {
	return new Promise((resolve) => {

		//console.log("make_dataexplorer_events resolved - display links or no events display")
		let queryeventoutput = document.getElementById("graph-dataexplorer-events");
		//console.log("this is where we make the event links");
		//console.log("event length: ", swanbot_dataexplorer_links.length)
		if (swanbot_dataexplorer_links.length > 0) {
			display_links();
		} else {
			//console.log("NO dataexplorer links to display");
			ensureDataExplorerSectionToggleStyles();
			queryeventoutput.innerHTML = renderDataExplorerCollapsibleSection('events', formatDataExplorerEventsSectionTitle(0), "<div class='text-muted'>No events discovered in your chat.</div>");
			bindDataExplorerSectionToggleHandlers(queryeventoutput);
		}
		//console.log("----- finished with data explorer events ------")
		resolve();
	});
}

window.make_dataexplorer_agents = make_dataexplorer_agents;



// async function fade_dataexplorer_graph() {
// 	let graphlocation = document.getElementById("graph-dataexplorer-details");

// 	stopLoaderAnimation();

// }



const timezoneOptions = [
	{ "label": "UTC", "value": "UTC" },
	{ "label": "America/New_York", "value": "America/New_York" },
	{ "label": "America/Chicago", "value": "America/Chicago" },
	{ "label": "America/Denver", "value": "America/Denver" },
	{ "label": "America/Los_Angeles", "value": "America/Los_Angeles" },
	{ "label": "Pacific/Honolulu", "value": "Pacific/Honolulu" },
	{ "label": "America/Anchorage", "value": "America/Anchorage" },
];


/* extracted getShortTimezone */






async function make_dataexplorer_graph(period = "hourly") {
window.make_dataexplorer_graph = make_dataexplorer_graph;
	swanbot_dataexplorer_graphs = [];
	let graphdata = '{"data": {}}';
	if (window.WingmanState.swanbot_dataexplorer_graphdata["graphs"]) {
		graphdata = window.WingmanState.swanbot_dataexplorer_graphdata["graphs"];
	}

	let graphdatacompare = '';
	if (window.WingmanState.swanbot_dataexplorer_graphdata["graphs_compare"]) {
		graphdatacompare = window.WingmanState.swanbot_dataexplorer_graphdata["graphs_compare"];
	}

	let subgraphdatacompare = '';
	if (window.WingmanState.swanbot_dataexplorer_graphdata["subgraphs_compare"]) {
		subgraphdatacompare = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphs_compare"];
	}

	let filterdata = window.WingmanState.swanbot_dataexplorer_graphdata["filters"];
	let focusdata = window.WingmanState.swanbot_dataexplorer_graphdata["focus"] || {};
	let subgraphGroupData = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"];
	let subgraphGroupTitles = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupTitles"];
	let subgraphGroupIndex = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupIndex"];
	let maingraphTitles = window.WingmanState.swanbot_dataexplorer_graphdata["maingraphTitles"];
	let maingraphIndex = window.WingmanState.swanbot_dataexplorer_graphdata["maingraphIndex"];
	let subgraphGroupDimensions = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupDimensions"];

	let created_main_graphs = null;
	let created_main_compare_graphs = null;
	let created_main_graphs_titles = null;

	let graphlocation = document.getElementById("graph-dataexplorer-details");

	document.querySelectorAll('.data-hidden-tooltip').forEach(el => el.remove());
	document.querySelectorAll('.data-analysis-modality-hidden-tooltip').forEach(el => el.remove());

	let filterlocation = document.getElementById("graph-dataexplorer-filters");
	let graph_date_selected = document.getElementById("dataexplorer_date-selected-jsfe");
	//let timezone_select_data = document.querySelector("#timezone_options_select .Select-value .Select-value-label");

	//let timezone_selected = "UTC";
	//if (timezone_select_data) {
	//    timezone_selected = timezone_select_data.innerText;
	//}

	let add_filters = "";
	let add_filters_applied = "";
	let added_date = false;
	let date_row_data = [];
	let subgraphGroupIds = [];
	let graph_data = graphdata; // local var
	let graph_data_compare = graphdatacompare;
	let applyButton = "";
	let tooltipInstance;

	swanbot_maingraph_toomuchdata = false;

	if (typeof window.swanbot_dataexplorer_filter_groupselected_prev === 'undefined') {
		window.swanbot_dataexplorer_filter_groupselected_prev = [];
	}

	const newlyAddedTraces = swanbot_dataexplorer_filter_groupselected.filter(x => !window.swanbot_dataexplorer_filter_groupselected_prev.includes(x));

	let useDailyPrecalc = false;
	let precalcX = [];
	// Ensure graph_data is an object before checking properties
	if (typeof graph_data === 'string') {
		try {
			let temp_gd = JSON.parse(graph_data);
			if (temp_gd && temp_gd.days) graph_data = temp_gd;
		} catch (e) { }
	}

	let parseDaypartMinutes = function (timeValue) {
		let timeText = String(timeValue || '').trim();
		let match = timeText.match(/^(\d{1,2}):(\d{2})/);
		if (!match) {
			return null;
		}

		let hours = parseInt(match[1], 10);
		let minutes = parseInt(match[2], 10);
		if (Number.isNaN(hours) || Number.isNaN(minutes)) {
			return null;
		}

		return (hours * 60) + minutes;
	};

	let resolveTimestampMinutes = function (timestampValue) {
		if (timestampValue instanceof Date && !Number.isNaN(timestampValue.getTime())) {
			return (timestampValue.getHours() * 60) + timestampValue.getMinutes();
		}

		let cleanedValue = String(timestampValue || '').trim().replace('T', ' ');
		let timeText = cleanedValue.includes(' ') ? cleanedValue.split(' ')[1] : cleanedValue;
		return parseDaypartMinutes(timeText);
	};

	let focusedDaypart = Array.isArray(focusdata.focused_daypart) ? focusdata.focused_daypart : [];
	let daypartStartLabel = focusedDaypart.length === 2 ? String(focusedDaypart[0] || '').trim() : '';
	let daypartEndLabel = focusedDaypart.length === 2 ? String(focusedDaypart[1] || '').trim() : '';
	let daypartStartMinutes = parseDaypartMinutes(daypartStartLabel);
	let daypartEndMinutes = parseDaypartMinutes(daypartEndLabel);
	let isDaypartActive = daypartStartMinutes !== null && daypartEndMinutes !== null;
	let shouldApplyDaypartFocus = function () {
		return isDaypartActive && swanbot_dataexplorer_filter_period !== "day";
	};

	let isTimestampWithinDaypart = function (timestampValue) {
		if (!shouldApplyDaypartFocus()) {
			return true;
		}

		let timestampMinutes = resolveTimestampMinutes(timestampValue);
		if (timestampMinutes === null) {
			return true;
		}

		if (daypartStartMinutes <= daypartEndMinutes) {
			return timestampMinutes >= daypartStartMinutes && timestampMinutes < daypartEndMinutes;
		}

		return timestampMinutes >= daypartStartMinutes || timestampMinutes < daypartEndMinutes;
	};

	let applyDaypartMaskToSeries = function (xValues, yValues) {
		let seriesValues = Array.from(yValues || []);
		if (!shouldApplyDaypartFocus()) {
			return seriesValues;
		}

		return seriesValues.map(function (value, index) {
			return isTimestampWithinDaypart(xValues && xValues[index]) ? value : null;
		});
	};

	let buildTraceLineStyle = function (lineColor, widthValue) {
		let lineStyle = {
			width: typeof widthValue === 'number' ? widthValue : 1.5,
			shape: shouldApplyDaypartFocus() ? 'linear' : 'spline'
		};

		if (!shouldApplyDaypartFocus()) {
			lineStyle.smoothing = 1.3;
		}

		if (lineColor) {
			lineStyle.color = lineColor;
		}

		return lineStyle;
	};

	// Resolve daily-only mode before any graph shaping, so first render picks daily data.
	let dataexplorerDailyOnlyInput = document.getElementById("dataexplorer_daily_only");
	let dailyOnlyLockedEarly = !!(
		dataexplorerDailyOnlyInput && String(dataexplorerDailyOnlyInput.value).toLowerCase() === "true"
	);
	swanbot_dataexplorer_lock_period_selection = dailyOnlyLockedEarly;
	window.swanbot_dataexplorer_lock_period_selection = dailyOnlyLockedEarly;
	if (dailyOnlyLockedEarly) {
		swanbot_dataexplorer_filter_period = "day";
		window.swanbot_dataexplorer_filter_period = "day";
	} else if (window.swanbot_dataexplorer_filter_period === "day" || window.swanbot_dataexplorer_filter_period === "hour") {
		// Keep local and window period in sync when unlocked.
		swanbot_dataexplorer_filter_period = window.swanbot_dataexplorer_filter_period;
	}

	if (swanbot_dataexplorer_filter_period === "day" && graph_data && graph_data.days && graph_data.days.length > 0) {
		useDailyPrecalc = true;
		precalcX = graph_data.days;
	}

	const config = {
		displayModeBar: false,
		responsive: true,
		modeBarButtonsToRemove: ['toImage', 'sendDataToCloud', 'hoverCompareCartesian'],
	};

	const total_graph_rows = (graph_data && graph_data.graphs) ? Object.keys(graph_data.graphs).length : 0;

	if (total_graph_rows > 0) {
		created_main_graphs = [...Array(total_graph_rows)];
		created_main_graphs_titles = Object.keys(graph_data.graphs);

		const total_graph_hours_rows = Object.keys(graph_data.hours).length;
		if (total_graph_hours_rows > 0 && !added_date) {
			date_row_data = draw_date_row(graph_data.hours, false, false);
			added_date = true;
		}

		if (isNotEmpty(filterdata)) {
			add_filters = "<h4>Filters Applied to Total Transactions</h4>";
			if (filterdata) {
				add_filters += "<ul class='explorertree'>";
				let i = 0;
				let max_filters_len = Object.keys(filterdata).length;
				add_filters_applied += ": " + Object.keys(filterdata).join(', ');

				while (i < max_filters_len) {
					let filter_values = "";
					let filter_type = Object.keys(filterdata)[i];
					let j = 0;
					let max_filters_content_len = Object.values(filterdata)[i].length;

					while (j < max_filters_content_len) {
						let cause_name = Object.values(filterdata)[i][j];
						filter_values += "<li title='" + cause_name + "' class='leaf'>" + cause_name + "</li>";
						j++;
					}

					let filter_subgroup_total = "&subGraphGroupsDim=" + filter_type;
					add_filters += "<li><details open><summary>" + filter_type + " <button class='btn btn-sm btn-link show_subgrouping_button' data-subfilter='" + filter_subgroup_total + "' title='Filter chart by " + filter_type + "'><span class=''><i class='ix--add-filter-filled'></i></span></button></summary><ul>" + filter_values + "</ul></details></li>";
					i++;
				}
				add_filters += "</ul>";
			}
		} else {
			add_filters = "<h4>No Filters Applied to Total Transactions</h4>";
		}



		//const fig_date_start = new Date(graph_data.hours.at(0));
		//const fig_date_end = new Date(graph_data.hours.at(-1));

		const fig_date_start = useDailyPrecalc ? new Date(precalcX.at(0)) : new Date(graph_data.hours.at(0));
		const fig_date_end = useDailyPrecalc ? new Date(precalcX.at(-1)) : new Date(graph_data.hours.at(-1));

		let dgraph_i = 0;
		let dgraph_i_wow = 0;
		maingraphTitles = [];
		maingraphIndex = {};

		for (let dgraph in graph_data.graphs) {
			created_main_graphs[dgraph_i] = create_dataexplorer_graph(graph_data.hours, graph_data.hours, graph_data.graphs[dgraph], graph_data.graphs[dgraph], dgraph);

			if (useDailyPrecalc && graph_data.daily_totals && graph_data.daily_totals[dgraph]) {
				created_main_graphs[dgraph_i].data[0].x = [...precalcX];
				created_main_graphs[dgraph_i].data[0].y = [...graph_data.daily_totals[dgraph]];
			}

			created_main_graphs[dgraph_i]['showlegend'] = dgraph_i <= 10;
			created_main_graphs[dgraph_i]['marker'] = { "color": graphHexColors[dgraph] };
			created_main_graphs[dgraph_i]['hovertemplate'] = "%{y}";
			created_main_graphs[dgraph_i]['name'] = dgraph;
			maingraphTitles.push(dgraph);
			dgraph_i++;
		}

		if (isNotEmpty(graph_data_compare)) {
			let total_graph_compare_rows = Object.keys(graph_data_compare.graphs).length;
			if (total_graph_compare_rows > 0) {
				created_main_compare_graphs = [...Array(total_graph_compare_rows)];
			}
			for (let dgraph in graph_data_compare.graphs) {
				created_main_compare_graphs[dgraph_i_wow] = create_dataexplorer_graph(graph_data_compare.hours, graph_data.hours, graph_data_compare.graphs[dgraph], graph_data_compare.graphs[dgraph], dgraph);

				if (useDailyPrecalc && graph_data_compare.daily_totals && graph_data_compare.daily_totals[dgraph]) {
					created_main_compare_graphs[dgraph_i_wow].data[0].x = [...precalcX];
					created_main_compare_graphs[dgraph_i_wow].data[0].y = [...graph_data_compare.daily_totals[dgraph]];
				}

				created_main_compare_graphs[dgraph_i_wow]['showlegend'] = dgraph_i_wow <= 10;
				created_main_compare_graphs[dgraph_i_wow]['marker'] = { "color": "#e0e0e0" };
				created_main_compare_graphs[dgraph_i_wow]['hovertemplate'] = "%{y}";
				created_main_compare_graphs[dgraph_i_wow]['name'] = dgraph;
				dgraph_i_wow++;
			}
		}

		window.WingmanState.swanbot_dataexplorer_graphdata["maingraphTitles"] = maingraphTitles;

		var pricelinelayout = {
			line: { width: 3.5 },
			height: 415,
			dragmode: false,
			xaxis: {
				showline: true,
				showgrid: true,
				showticklabels: true,
				linecolor: "rgb(204, 204, 204)",
				linewidth: 2,
				ticks: "inside",
				side: "bottom",
				tickfont: { family: "Arial", size: 8 },
				domain: [0, 1],
				range: [fig_date_start, fig_date_end],
				row: 1,
				col: 1,
				rangemode: "tozero"
			},
			yaxis: {
				automargin: true,
				anchor: 'x',
				zeroline: true,
				showline: true,
				showgrid: true,
				showticklabels: true,
				linecolor: "rgb(204, 204, 204)",
				linewidth: 2,
				ticks: "outside",
				side: "left",
				tickfont: { family: "Arial", size: 8 },
				title: { standoff: 20 },
				rangemode: "tozero"
			},
			yaxis2: {
				overlaying: 'y',
				side: 'right',
				automargin: true,
				anchor: 'x',
				showline: true,
				showgrid: false,
				showticklabels: true,
				autorange: true,
				linecolor: "rgb(204, 204, 204)",
				linewidth: 2,
				ticks: "outside",
				tickformat: '$,.0f',
				tickfont: { family: "Arial Black", size: 8, color: "green" },
				title: { standoff: 20 }
			},
			yaxis3: {
				overlaying: 'y',
				side: 'right',
				automargin: true,
				anchor: 'x',
				zeroline: true,
				showline: true,
				showgrid: false,
				showticklabels: true,
				linecolor: "rgb(204, 204, 204)",
				linewidth: 2,
				ticks: "outside",
				tickformat: '$,.0f',
				tickfont: { family: "Arial Black", size: 8 },
				title: { standoff: 20 },
				rangemode: "tozero"
			},
			yaxis4: {
				overlaying: 'y',
				side: 'left',
				automargin: true,
				anchor: 'free',
				position: 0,
				showline: true,
				showgrid: false,
				showticklabels: true,
				linecolor: "rgb(204, 204, 204)",
				linewidth: 2,
				ticks: "outside",
				tickformat: '.0f',
				ticksuffix: '%',
				tickfont: { family: "Arial", size: 8, color: "#333" },
				title: { standoff: 20 },
				rangemode: "tozero"
			},
			hovermode: 'x unified',
			autosize: true,
			margin: { autoexpand: true, r: 45, l: 45, t: 0, b: 32, pad: 0 },
			legend: { bgcolor: 'white', bordercolor: 'black', borderwidth: 1, orientation: "v", x: 0.005, y: 1, xanchor: "left", yanchor: "top" },
			showlegend: true,
			plot_bgcolor: 'white',
		};

		const figure = { data: [], layout: pricelinelayout, config: config };
		let graphid = "swanbot_graph_" + fivedigit();
		setDataExplorerGraphId(graphid);

		let selected_group_combined = window.swanbot_dataexplorer_filter_groupstacked ? " selected" : "";
		let selected_group_combined_str = window.swanbot_dataexplorer_filter_groupstacked ? "Grouping On" : "Grouping Off";
		let dailyOnlyLocked = swanbot_dataexplorer_lock_period_selection === true;
		let dataExplorerIsAdminEl = document.getElementById('dataexplorer_is_admin');
		let dataExplorerIsAdmin = !!(dataExplorerIsAdminEl && String(dataExplorerIsAdminEl.value).toLowerCase() === 'true');
		let selected_data_period_str = swanbot_dataexplorer_filter_period == "day" ? "Daily Data" : "Hourly Data";
		let selected_data_period_icon = swanbot_dataexplorer_filter_period == "day" ? "ion--today-outline" : "tabler--clock-hour-8";

		let toggle_grouping = isNotEmpty(subgraphGroupData) ? "<button class='btn btn-link" + selected_group_combined + "' id='dataexplorer_toggle_subgroup' data-bs-toggle=x22tooltipx22 data-bs-placement='top' title='To see all comparison sets, turn off grouping.'><i class='gravity-ui--chart-line fas align-middle'></i><span class='align-middle'>" + selected_group_combined_str + "</span></button>" : "";
		let pick_moment = dataExplorerIsAdmin ? "<button class='btn btn-link' id='dataexplorer_pick_moment' title='Pick a Moment'><i class='ri--search-eye-line fas align-middle'></i><span class='align-middle'>Investigate</span></button>" : "";
		
		let isDailyContent = swanbot_dataexplorer_filter_period === "day";
		let customStyle = `
			<style>
				.chart-pill-toggle { position: relative; display: inline-flex; align-items: center; background-color: #000000; border-radius: 6px; padding: 3px; cursor: pointer; width: 140px; box-shadow: inset 0 2px 4px rgba(0,0,0,0.1); margin: 0; margin-left: 8px; margin-right: 8px;}
				.chart-pill-toggle input { display: none; }
				.chart-pill-toggle .pill-slider { position: absolute; top: 4px; left: 4px; width: 66px; bottom: 4px; background-color: #fff; border-radius: 6px; transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1); box-shadow: 0 1px 3px rgba(0,0,0,0.15); z-index: 1; }
				.chart-pill-toggle input:checked ~ .pill-slider { transform: translateX(66px); }
				.chart-pill-toggle .pill-option { flex: 1; position: relative; z-index: 2; text-align: center; font-size: 11px; font-weight: 600; color: #fff; padding: 4px 0; user-select: none; transition: color 0.3s; line-height: 1.2; }
				.chart-pill-toggle input:not(:checked) ~ .opt-hourly { color: #000000; }
				.chart-pill-toggle input:checked ~ .opt-daily { color: #000000; }
				#dataexplorer_toggle_daily_label {margin-left: 0px !important; margin-right: 8px;}
			</style>
		`;
		let showPeriodToggle = !dailyOnlyLocked && !isDailyContent;
		let change_daily = showPeriodToggle ? customStyle + `
			<label class="chart-pill-toggle" id="dataexplorer_toggle_daily_label" title="Plot by Day or Hour" style="vertical-align: middle;">
				<input type="checkbox" id="dataexplorer_toggle_daily" ${isDailyContent ? "checked" : ""}>
				<div class="pill-slider"></div>
				<div class="pill-option opt-hourly">Hourly</div>
				<div class="pill-option opt-daily">Daily</div>
			</label>
		` : "";
		let daypartFocusHtml = shouldApplyDaypartFocus()
			? "<div id='dataexplorer_daypart_focus_display' class='badge badge-info' data-bs-toggle='tooltip' data-bs-placement='bottom' title='Visual chart data point hilight that is set or removed via your chat with swanbot.' style='display: block; white-space: normal; text-align: left; max-width: 100%;'><i class='fas fa-bullseye align-middle' style='margin-right: 4px;'></i><strong>Day Part Focus:</strong> " + daypartStartLabel + " to " + daypartEndLabel + "</div>"
			: "";
		let focusPeriodHtml = (("focused_ts_start" in focusdata) && ("focused_ts_end" in focusdata))
			? "<div id='dataexplorer_focus_period_display' class='badge badge-dark' data-bs-toggle='tooltip' data-bs-placement='bottom' title='Data for the Source Totals will be limited to " + focusdata["focused_ts_start"] + " to " + focusdata["focused_ts_end"] + " which is set or removed via your chat with swanbot.' style='display: block; white-space: normal; text-align: left; max-width: 100%; font-size: 12px;'><i class='fas fa-database align-middle' style='margin-right: 4px;'></i><strong>Data Focus:</strong> " + focusdata["focused_ts_start"] + " to " + focusdata["focused_ts_end"] + "</div>"
			: "";
		
		let toggle_legend = "<button id='toggle_dataexplorer_graph_legend' title='Toggle Legend' class='btn btn-link dropdown-item'><i class='flowbite--toggle-header-column-outline fas align-middle'></i><span class='align-middle'>Show/Hide Legend</span></button>";
		let toggle_totals = "<button id='toggle_dataexplorer_graph_totals' title='Toggle Totals Table' class='btn btn-link dropdown-item'><i class='fluent-mdl2--table-total-row fas align-middle'></i><span class='align-middle'>Source Totals</span></button>";
		let download_dropdown = '<button class="btn btn-link dropdown-toggle" type="button" id="downloadMenuButton" data-mdb-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="icon-park--download fas align-middle"></i><span class="align-middle">Download Data</span></button><ul class="dropdown-menu dropdown-menu-end" id="download_drowpdown_container"><li><button id="download_dataexplorer_csv_link" class="btn btn-link dropdown-item">Download CSV</button></li><li><button id="download_dataexplorer_link" class="btn btn-link dropdown-item">Download Powerpoint</button></li></ul>';

		let comparison_dropdown = "";
		if (window.WingmanState.swanbot_dataexplorer_processing_compare_type) {
			let selected_modality_name = getDescriptorByModality(swanbot_dataexplorer_compare_types, window.WingmanState.swanbot_dataexplorer_processing_compare_type);
			comparison_dropdown = '<button class="btn btn-link dropdown-toggle" type="button" id="compareMenuButton" data-mdb-toggle="dropdown" aria-expanded="false"><i class="carbon--chart-multi-line fas align-middle"></i><span class="align-middle">✓ ' + selected_modality_name + '</span></button>';
		} else {
			comparison_dropdown = '<button class="btn btn-link dropdown-toggle" type="button" id="compareMenuButton" data-mdb-toggle="dropdown" aria-expanded="false"><i class="carbon--chart-multi-line fas align-middle"></i><span class="align-middle">Compare Options</span></button>';
		}
		comparison_dropdown += '<ul class="dropdown-menu dropdown-menu-end" id="comparison_drowpdown_container"></ul>';

		let compare_analysis_area = "<div class='dataexplorer-data-context' style='display: flex; flex-wrap: wrap; gap: 8px; align-items: flex-start; padding-left: 11px;'><div id='dataexplorer_analysis_modality_display' class='badge badge-info' data-bs-toggle=x22tooltipx22 data-bs-placement='bottom' title='Comparison Analysis Modality is set or removed via your chat with swanbot.' style='display: none; white-space: normal; text-align: left; max-width: 100%;'></div>" + daypartFocusHtml + focusPeriodHtml + "</div>";

		const buttonRow = document.createElement('div');
		buttonRow.className = "btn-maingraph-block d-flex gap-2";
		maingraphTitles.forEach(title => {
			const btn = document.createElement('button');
			btn.className = "btn btn-link btn-maingraph-filter " + (swanbot_dataexplorer_filter_groupselected.includes(title) ? "btn-maingraph-filter-selected" : "btn-maingraph-filter-unselected");
			btn.innerHTML = "<span></span>" + (title === "total" ? "Total Transactions" : title);
			btn.dataset.index = title;
			buttonRow.appendChild(btn);
		});

		let sourceselection = "<div class='btn-maingraph-container'>" + buttonRow.outerHTML + "</div>";
		let sourceselectiongraphtitle = (isNotEmpty(subgraphGroupData) && !window.swanbot_dataexplorer_filter_groupstacked) ? "<h5 class=''>[Source Totals]</h5>" : "";
		let addgraph = "<div class='row'><div class='col-5'><h4>Total Transactions Explorer" + add_filters_applied + "</h4><div class='dataexplorer_date_range'>" + graph_date_selected.innerHTML + "</div></div><div class='col-7 text-end chart_actions'><div>" + pick_moment + toggle_grouping + " " + change_daily + " " + download_dropdown + "</div></div></div>" + sourceselectiongraphtitle + sourceselection + "<div id='" + graphid + "'></div>";

		if (isNotEmpty(subgraphGroupData)) {

			subgraphGroupData.forEach((group, index) => {
				let subgroupTitle = subgraphGroupTitles[index];
				let group_graph_data = group["graphs"];
				subgraphGroupIndex[subgroupTitle] = { "index": index };
				Object.entries(group_graph_data).forEach(([key, values]) => {
					subgraphGroupIndex[subgroupTitle][key] = values;
				});

				let sub_graphid = "swanbot_graph_" + fivedigit();
				subgraphGroupIds.push(sub_graphid);
				swanbot_dataexplorer_graphs.push(sub_graphid);
				if (!window.swanbot_dataexplorer_filter_groupstacked) {
					addgraph += "<h5 class=''>" + (subgroupTitle || "[No Name]") + "</h5><div id='" + sub_graphid + "'></div>";
				}
			});
		}

		addgraph += "<div id='" + date_row_data[0] + "'></div><div class='canvas-body'></div><div class='dataexplorer_graph_tools btn-group'>" + toggle_legend + toggle_totals + comparison_dropdown + "</div>" + compare_analysis_area;
		graphlocation.innerHTML = addgraph;
		Plotly.newPlot(graphid, figure);

		const daypartFocusDisplay = document.getElementById('dataexplorer_daypart_focus_display');
		if (daypartFocusDisplay) {
			const oldDaypartTooltip = bootstrap.Tooltip.getInstance(daypartFocusDisplay);
			if (oldDaypartTooltip) oldDaypartTooltip.dispose();

			new bootstrap.Tooltip(daypartFocusDisplay, {
				trigger: 'hover',
				customClass: 'data-analysis-modality-hidden-tooltip'
			});
		}

		const focusPeriodDisplay = document.getElementById('dataexplorer_focus_period_display');
		if (focusPeriodDisplay) {
			const oldFocusPeriodTooltip = bootstrap.Tooltip.getInstance(focusPeriodDisplay);
			if (oldFocusPeriodTooltip) oldFocusPeriodTooltip.dispose();

			new bootstrap.Tooltip(focusPeriodDisplay, {
				trigger: 'hover',
				customClass: 'data-analysis-modality-hidden-tooltip'
			});
		}

		if (isNotEmpty(subgraphGroupData)) {
			applyButton = document.getElementById('dataexplorer_toggle_subgroup');

			document.querySelectorAll('.data-hidden-tooltip').forEach(el => el.remove());

			const oldTooltip = bootstrap.Tooltip.getInstance(applyButton);
			if (oldTooltip) oldTooltip.dispose();

			if (subgraphdatacompare !== '' && swanbot_dataexplorer_filter_period === "hour") {
				tooltipInstance = new bootstrap.Tooltip(applyButton, {
					trigger: 'hover',
					customClass: 'data-hidden-tooltip' // Link to the CSS style above
				});
			}
		}


		const y2Traces = window.WingmanState.swanbot_dataexplorer_graphdata.axis_types?.["cpm"] || []
		const y3Traces = window.WingmanState.swanbot_dataexplorer_graphdata.axis_types?.["revenue"] || []
		const y4Traces = window.WingmanState.swanbot_dataexplorer_graphdata.axis_types?.["fillrate"] || []
		let has_y_axis_data = false;



		const isDaily = swanbot_dataexplorer_filter_period === "day";

		for (let dgraph in created_main_graphs) {
			if (created_main_graphs[dgraph]) {
				created_main_graphs[dgraph].data[0].yaxis = "y";

				let dname = created_main_graphs[dgraph].data[0]['name'];
				dname = dname.length > 50 ? dname.substring(0, 50) + "..." : dname;

				created_main_graphs[dgraph].data[0].hovertemplate = dname + ' : %{y}<extra></extra>';


				if (y2Traces.includes(created_main_graphs[dgraph].data[0]['name'])) {
					created_main_graphs[dgraph].data[0].yaxis = "y2";
					created_main_graphs[dgraph].data[0].hovertemplate = dname + ' : %{y:$,.2f}<extra></extra>';
				}
				if (y3Traces.includes(created_main_graphs[dgraph].data[0]['name'])) {
					created_main_graphs[dgraph].data[0].yaxis = "y3";
					created_main_graphs[dgraph].data[0].hovertemplate = dname + ' : %{y:$,.2f}<extra></extra>';
				}
				if (y4Traces.includes(created_main_graphs[dgraph].data[0]['name'])) {
					created_main_graphs[dgraph].data[0].yaxis = "y4";
					created_main_graphs[dgraph].data[0].hovertemplate = dname + ' : %{y:.2f}%<extra></extra>';
				}

				let xdates = Array.from(created_main_graphs[dgraph].data[0].x);
				//if (timezone_selected !== 'UTC' && typeof moment !== 'undefined') {
				//    xdates = created_main_graphs[dgraph].data[0].x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
				//}

				let trace_source_id = created_main_graphs[dgraph].data[0].name;

				let selected_source_name = created_main_graphs[dgraph].data[0].name === "total" ? "Total Transactions" : created_main_graphs[dgraph].data[0].name;
				if (isNotEmpty(subgraphGroupData)) {
					selected_source_name += " (Source Totals)";
				}


				let trace_visible = true;
				if (isDaily) {
					if (newlyAddedTraces.includes(created_main_graphs[dgraph].data[0].name)) {
						trace_visible = "legendonly";
					}
				}

				let add_sub_trace = {
					x: xdates,
					y: applyDaypartMaskToSeries(xdates, created_main_graphs[dgraph].data[0].y),
					tracetype: "source",
					tracesubtype: "primary",
					traceindex: dgraph,
					traceid: "source_" + dgraph,
					trace_source_id: trace_source_id,
					type: 'scatter',
					mode: 'lines+markers',
					name: selected_source_name,
					yaxis: created_main_graphs[dgraph].data[0].yaxis,
					hovertemplate: created_main_graphs[dgraph].data[0].hovertemplate,
					line: buildTraceLineStyle(),
					marker: { "color": graphHexColors[maingraphTitles.indexOf(created_main_graphs[dgraph].data[0].name)] },
					visible: isDaily ? false : true
				};

				if (swanbot_dataexplorer_filter_groupselected.includes(created_main_graphs[dgraph].data[0].name)) {
					// --- OPTIMIZATION START ---
					// If we have pre-calculated daily totals for the main graph trace, apply them to the new trace
					if (useDailyPrecalc && graph_data.daily_totals && graph_data.daily_totals[trace_source_id]) {
						add_sub_trace.x = [...precalcX];
						add_sub_trace.y = [...graph_data.daily_totals[trace_source_id]];
						add_sub_trace.visible = true; // Show immediately if we have the data
					}
					if (JSON.stringify(add_sub_trace.meta) === '{"loading":true}' && add_sub_trace.visible === true) {
						delete add_sub_trace.meta;
					}
					// --- OPTIMIZATION END ---

					if (shouldApplyDaypartFocus() && graph_data.graphs_bg && graph_data.graphs_bg[trace_source_id]) {
						let backgroundTraceColor = getGraphGrayColor(maingraphTitles.indexOf(created_main_graphs[dgraph].data[0].name));
						Plotly.addTraces(swanbot_dataexplorer_graph_id, {
							x: xdates,
							y: Array.from(graph_data.graphs_bg[trace_source_id]),
							tracetype: "source_bg",
							tracesubtype: "background",
							traceindex: dgraph,
							traceid: "source_bg_" + dgraph,
							trace_source_id: trace_source_id,
							type: 'scatter',
							mode: 'lines',
							name: selected_source_name + ' background',
							yaxis: created_main_graphs[dgraph].data[0].yaxis,
							hoverinfo: 'skip',
							showlegend: false,
							line: buildTraceLineStyle(backgroundTraceColor, 1),
							visible: true
						});
					} else if (useDailyPrecalc && graph_data.daily_totals_bg && graph_data.daily_totals_bg[trace_source_id]) {
						let backgroundTraceColor = getGraphGrayColor(maingraphTitles.indexOf(created_main_graphs[dgraph].data[0].name));
						Plotly.addTraces(swanbot_dataexplorer_graph_id, {
							x: [...precalcX],
							y: Array.from(graph_data.daily_totals_bg[trace_source_id]),
							tracetype: "source_bg",
							tracesubtype: "background",
							traceindex: dgraph,
							traceid: "source_bg_" + dgraph,
							trace_source_id: trace_source_id,
							type: 'scatter',
							mode: 'lines',
							name: selected_source_name + ' background',
							yaxis: created_main_graphs[dgraph].data[0].yaxis,
							hoverinfo: 'skip',
							showlegend: false,
							line: buildTraceLineStyle(backgroundTraceColor, 1),
							visible: true
						});
					}

					if (created_main_graphs[dgraph].data[0].yaxis == "y") has_y_axis_data = true;
					Plotly.addTraces(swanbot_dataexplorer_graph_id, add_sub_trace);
				}
			}
		}

		if (!has_y_axis_data) {
			let sbplot = document.getElementById(swanbot_dataexplorer_graph_id);
			sbplot.layout.yaxis2.overlaying = "";
			sbplot.layout.yaxis3.overlaying = "y2";
			sbplot.layout.yaxis4.overlaying = "y2";
		}



		if (created_main_compare_graphs) {
			let i = 0;

			for (let dgraph in created_main_compare_graphs) {

				if (created_main_compare_graphs[dgraph].data[0]) {

					let gendname = created_main_compare_graphs[dgraph]['name'];
					gendname = gendname.length > 50 ? gendname.substring(0, 50) + "..." : gendname;

					created_main_compare_graphs[dgraph].data[0].hovertemplate = '%{customdata[0]|%b %d, %Y}: ' + gendname + ' : %{y} (%{customdata[1]})<extra></extra>';
					created_main_compare_graphs[dgraph].data[0].yaxis = "y";

					if (y2Traces.includes(created_main_compare_graphs[dgraph].data[0]['name'])) {
						created_main_compare_graphs[dgraph].data[0].yaxis = "y2";
						created_main_compare_graphs[dgraph].data[0].hovertemplate = '%{customdata[0]|%b %d, %Y}: ' + gendname + ' : %{y:$,.2f} (%{customdata[1]})<extra></extra>';
					}
					if (y3Traces.includes(created_main_compare_graphs[dgraph].data[0]['name'])) {
						created_main_compare_graphs[dgraph].data[0].yaxis = "y3";
						created_main_compare_graphs[dgraph].data[0].hovertemplate = '%{customdata[0]|%b %d, %Y}: ' + gendname + ' : %{y:$,.2f} (%{customdata[1]})<extra></extra>';
					}
					if (y4Traces.includes(created_main_compare_graphs[dgraph].data[0]['name'])) {
						created_main_compare_graphs[dgraph].data[0].yaxis = "y4";
						created_main_compare_graphs[dgraph].data[0].hovertemplate = '%{customdata[0]|%b %d, %Y}: ' + gendname + ' : %{y:.2f}% (%{customdata[1]})<extra></extra>';
					}

					// WHY DOESN"T THIS CALCULATE
					let main_y_graph = (created_main_graphs[dgraph] && created_main_graphs[dgraph].data && created_main_graphs[dgraph].data[0]);

					const graph_data_diff_y = (main_y_graph) ? calculatePercentageDifference(Array.from(main_y_graph.y), Array.from(created_main_compare_graphs[dgraph].data[0].y)) : new Array(created_main_compare_graphs[dgraph].data[0].y.length).fill("N/A");
					let xdates = (main_y_graph) ? Array.from(main_y_graph.x) : Array.from(created_main_compare_graphs[dgraph].data[0].x);
					let xdates_comp = Array.from(created_main_compare_graphs[dgraph].data[0].x);
					if (graphdatacompare) {
						if (swanbot_dataexplorer_filter_period === "day" && graphdatacompare["days"]) {
							xdates_comp = Array.from(graphdatacompare["days"]);
						} else if (graphdatacompare["hours"]) {
							xdates_comp = Array.from(graphdatacompare["hours"]);
						}
					}

					// if (timezone_selected !== 'UTC' && typeof moment !== 'undefined') {
					//     xdates = created_main_graphs[dgraph].data[0].x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
					//     xdates_compare = created_main_compare_graphs[dgraph].data[0].x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
					// }

					let trace_source_id = created_main_compare_graphs[dgraph].name;

					let selected_source_name = created_main_compare_graphs[dgraph].name === "total" ? "compare: Total Transactions" : "compare: " + created_main_compare_graphs[dgraph].name;
					if (isNotEmpty(subgraphGroupData)) selected_source_name += " (Source Totals)";

					let trace_visible = true;
					if (isDaily) {
						if (newlyAddedTraces.includes(created_main_compare_graphs[dgraph].name)) {
							trace_visible = "legendonly";
						}
					}

					let add_sub_trace = {
						x: xdates,
						y: applyDaypartMaskToSeries(xdates, created_main_compare_graphs[dgraph].data[0].y),
						traceid: "compare_" + dgraph,
						tracetype: "compare",
						tracesubtype: "compare",
						traceindex: i,
						trace_source_id: trace_source_id,
						type: 'scatter',
						mode: 'lines+markers',
						name: selected_source_name,
						yaxis: created_main_compare_graphs[dgraph].data[0].yaxis,
						hovertemplate: created_main_compare_graphs[dgraph].data[0].hovertemplate,
						customdata: xdates_comp.map((d, idx) => [d, graph_data_diff_y[idx]]),
						sourcetraceid: "source_" + dgraph,
						line: buildTraceLineStyle(),
						marker: { "color": "#e0e0e0" },
						visible: trace_visible,
						meta: { loading: trace_visible === "legendonly" }
					};

					// --- OPTIMIZATION START ---
					if (useDailyPrecalc && graph_data_compare.daily_totals && graph_data_compare.daily_totals[trace_source_id]) {
						add_sub_trace.x = [...precalcX];
						add_sub_trace.y = [...graph_data_compare.daily_totals[trace_source_id]];
						if (graph_data.daily_totals && graph_data.daily_totals[trace_source_id]) {
							let daily_diff_y = calculatePercentageDifference(
								graph_data.daily_totals[trace_source_id],
								graph_data_compare.daily_totals[trace_source_id]
							);
							add_sub_trace.customdata = xdates_comp.map((d, idx) => [d, daily_diff_y[idx]]);
						}
						add_sub_trace.visible = true;

						// Recalculate diff for daily data? Or rely on rollup?
						// If we set Y here, we should probably set valid customdata or clear it to avoid mismatch
						// For now let's rely on rollup to fix the customdata/diffs for comparisons, 
						// but setting X/Y prevents shape mismatch.
						// Actually, if we set Y, we MUST show it.
						if (add_sub_trace.meta) delete add_sub_trace.meta;
					}
					// --- OPTIMIZATION END ---

					if (swanbot_dataexplorer_filter_groupselected.includes(created_main_compare_graphs[dgraph].name)) {
						Plotly.addTraces(swanbot_dataexplorer_graph_id, add_sub_trace);
					}
				}

				i = i + 1;
			}
		}

		Plotly.relayout(graphid, { paper_bgcolor: 'rgba(0,0,0,0)', plot_bgcolor: 'rgba(0,0,0,0)' });

		if (subgraphGroupIds.length > 0) {
			let add_traces = [];

			for (let x = 0; x < subgraphGroupIds.length; x++) {
				//console.log("subgraphGroupIds x => ", x, "subgraphGroupData[x] => ", subgraphGroupData[x])
				let group_graph_data = subgraphGroupData[x]?.["graphs"] || {};
				let created_subgraph_graphs = Object.entries(group_graph_data).map(([key, vals]) => create_dataexplorer_graph(graph_data.hours, graph_data.hours, vals, vals, key));

				let created_subgraph_compare_graphs = []
				if (subgraphdatacompare) {
					let compare_group_graph_data = subgraphdatacompare[x]?.["graphs"] || {};
					created_subgraph_compare_graphs = Object.entries(compare_group_graph_data).map(([key, vals]) => create_dataexplorer_graph(subgraphdatacompare[x].hours, graph_data.hours, vals, group_graph_data[key], key));
				}


				// grouped - one main graph with all traces
				if (window.swanbot_dataexplorer_filter_groupstacked) {

					created_subgraph_graphs.forEach((entry, index) => {
						const name = entry.data?.[0]?.name;
						if (swanbot_dataexplorer_filter_groupselected.includes(name)) {
							let xdates = Array.from(entry.data[0].x);
							// if (timezone_selected !== 'UTC' && typeof moment !== 'undefined') {
							//     xdates = entry.data[0].x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
							// }
							let settings_name = entry.data[0]['name'];
							let yaxis_set = "y";
							let hover_txt = "%{y}";

							let dname = (subgraphGroupTitles[x] || "[No Name]")
							dname = dname.length > 50 ? dname.substring(0, 50) + "..." : dname;

							if (y2Traces.includes(settings_name) || y3Traces.includes(settings_name) || y4Traces.includes(settings_name)) {
								if (y4Traces.includes(settings_name)) {
									yaxis_set = "y4";
									hover_txt = dname + ' (' + name + ') : %{y:.2f}%<extra></extra>';
								} else {
									yaxis_set = y2Traces.includes(settings_name) ? "y2" : "y3";
									hover_txt = dname + ' (' + name + ') : %{y:$,.2f}<extra></extra>';
								}
							}

							let trace_visible = true;
							if (isDaily) {
								if (newlyAddedTraces.includes(name)) {
									trace_visible = "legendonly";
								}
							}

							add_traces.push({
								x: xdates,
								y: applyDaypartMaskToSeries(xdates, entry.data[0].y),
								yaxis: yaxis_set,
								tracetype: "source",
								tracesubtype: "secondary",
								traceindex: x,
								traceid: "source_" + x,
								trace_source_id: name,
								type: 'scatter',
								mode: 'lines+markers',
								name: dname + ' (' + (name === "total" ? "Total Transactions" : name) + ')',
								hovertemplate: hover_txt,
								line: buildTraceLineStyle(),
								visible: trace_visible,
								meta: { loading: trace_visible === "legendonly" }
							});

							// --- OPTIMIZATION START ---
							if (useDailyPrecalc) {
								let lastTrace = add_traces[add_traces.length - 1];
								// Check if we have subgraph totals
								// entry is from created_subgraph_graphs which is from group_graph_data
								// We need to check if that group data has daily_totals
								let groupData = subgraphGroupData[x];
								if (groupData && groupData.daily_totals && groupData.daily_totals[name]) {
									lastTrace.x = [...precalcX];
									lastTrace.y = [...groupData.daily_totals[name]];
									lastTrace.visible = true;
									if (lastTrace.meta) delete lastTrace.meta;
								}
							}
							// --- OPTIMIZATION END ---
						}
					});


					//console.log("subgraphdatacompare and period", subgraphdatacompare, swanbot_dataexplorer_filter_period)


					if (subgraphdatacompare !== '' && swanbot_dataexplorer_filter_period === "redacted") { // "day" Day is okay for comparisons



						created_subgraph_compare_graphs.forEach((entry, index) => {
							const name = entry.data?.[0]?.name;

							//console.log("created_subgraph_compare_graphs entry name => ", name, "index => ", index, "entry => ", entry)

							if (swanbot_dataexplorer_filter_groupselected.includes(name)) {

								const diff_y = calculatePercentageDifference(Array.from(entry.data[0].y_source), Array.from(entry.data[0].y));

								let xdates = Array.from(entry.data[0].x_base);
								let xdates_comp = Array.from(entry.data[0].x);
								if (subgraphdatacompare && subgraphdatacompare[x]) {
									if (swanbot_dataexplorer_filter_period === "day" && subgraphdatacompare[x]["days"]) {
										xdates_comp = Array.from(subgraphdatacompare[x]["days"]);
									} else if (subgraphdatacompare[x]["hours"]) {
										xdates_comp = Array.from(subgraphdatacompare[x]["hours"]);
									}
								}

								//console.log(`${name} is enabled, and pushing the following values - x: ${xdates}, y: ${entry.data[0].y}`)

								// if (timezone_selected !== 'UTC' && typeof moment !== 'undefined') {
								//     xdates = entry.data[0].x_base.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
								//     xdates_comp = entry.data[0].x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
								// }
								let yaxis_set = "y";
								let dname = (subgraphGroupTitles[x] || "[No Name]")
								dname = dname.length > 50 ? dname.substring(0, 50) + "..." : dname;

								let hover_txt = '%{customdata[0]|%b %d, %Y}: compare ' + dname + ' (' + name + ') : %{y} (%{customdata[1]})<extra></extra>';
								if (y2Traces.includes(name) || y3Traces.includes(name) || y4Traces.includes(name)) {
									if (y4Traces.includes(name)) {
										yaxis_set = "y4";
										hover_txt = '%{customdata[0]|%b %d, %Y}: compare ' + dname + ' (' + name + ') : %{y:.2f}% (%{customdata[1]})<extra></extra>';
									} else {
										yaxis_set = y2Traces.includes(name) ? "y2" : "y3";
										hover_txt = '%{customdata[0]|%b %d, %Y}: compare ' + dname + ' (' + name + ') : %{y:$,.2f} (%{customdata[1]})<extra></extra>';
									}
								}

								let trace_visible = true;
								if (isDaily) {
									if (newlyAddedTraces.includes(name)) {
										trace_visible = "legendonly";
									}
								}

								new_compare_trace = {
									x: xdates,
									y: applyDaypartMaskToSeries(xdates, entry.data[0].y),
									yaxis: yaxis_set,
									tracetype: "compare",
									tracesubtype: "secondary_compare",
									traceindex: x,
									traceid: "compare_" + x,
									trace_source_id: name,
									type: 'scatter',
									mode: 'lines+markers',
									name: 'compare: ' + dname + ' (' + name + ')',
									hovertemplate: hover_txt,
									line: buildTraceLineStyle(),
									marker: { "color": "#e0e0e0" },
									customdata: xdates_comp.map((d, idx) => [d, diff_y[idx]]),
									visible: trace_visible,
									meta: { loading: trace_visible === "legendonly" }
								};

								//console.log("new_compare_trace customdata", new_compare_trace["customdata"])
								//console.log("new_compare_trace name: ", new_compare_trace["name"])


								// --- OPTIMIZATION START ---
								if (useDailyPrecalc && subgraphdatacompare && subgraphdatacompare[x]) {
									//console.log("time to override with daily values");

									//let lastTrace = new_compare_trace; //add_traces[add_traces.length - 1];
									//console.log("new_compare_trace name: ", new_compare_trace["name"]);

									let compareGroupData = subgraphdatacompare[x];
									let sourceGroupData = subgraphGroupData[x];
									//console.log("subgraphdatacompare: ", subgraphdatacompare[x]);
									if (compareGroupData && compareGroupData.daily_totals && compareGroupData.daily_totals[name]) {
										let newDateValues = compareGroupData.days;
										new_compare_trace.x = [...precalcX]; // Assign to precalcX instead to align x-axis correctly
										//console.log("updated x ", new_compare_trace.x)
										new_compare_trace.y = [...compareGroupData.daily_totals[name]];
										//console.log("updated y ", new_compare_trace.y)

										if (sourceGroupData && sourceGroupData.daily_totals && sourceGroupData.daily_totals[name]) {
											let daily_diff_y = calculatePercentageDifference(
												sourceGroupData.daily_totals[name],
												compareGroupData.daily_totals[name]
											);
											new_compare_trace.customdata = xdates_comp.map((d, idx) => [d, daily_diff_y[idx]]);
										}

										new_compare_trace.visible = true;
										if (new_compare_trace.meta) delete new_compare_trace.meta;
									}
								}

								//console.log("new_compare_trace customdata again ", new_compare_trace["customdata"])

								add_traces.push(new_compare_trace);
								// --- OPTIMIZATION END ---
							}
						});



					} else {
						swanbot_maingraph_toomuchdata = true;
					}




				} else {
					// ungrouped - new graph for each subgraph with all traces related to that subgraph

					let filteredData = [];


					created_subgraph_graphs.forEach((entry, index) => {
						const name = entry.data?.[0]?.name;
						if (swanbot_dataexplorer_filter_groupselected.includes(name)) {
							let trace = entry.data[0];
							trace.marker = { "color": graphHexColors[maingraphTitles.indexOf(name)] };
							if (name === "total") trace.name = "Total Transactions";
							trace.yaxis = "y";

							trace.tracetype = "source";
							trace.tracesubtype = "secondary";
							trace.traceindex = index;
							trace.traceid = "source_" + index;
							trace.trace_source_id = name;
							trace.line = buildTraceLineStyle();

							let dname = trace.name
							dname = dname.length > 50 ? dname.substring(0, 50) + "..." : dname;

							trace.hovertemplate = dname + ' : %{y}';
							if (y2Traces.includes(name) || y3Traces.includes(name) || y4Traces.includes(name)) {
								if (y4Traces.includes(name)) {
									trace.yaxis = "y4";
									trace.hovertemplate = dname + ' : %{y:.2f}%<extra></extra>';
								} else {
									trace.yaxis = y2Traces.includes(name) ? "y2" : "y3";
									trace.hovertemplate = dname + ' : %{y:$,.2f}<extra></extra>';
								}
							}
							let groupData = subgraphGroupData[x];
							// if (timezone_selected !== 'UTC' && typeof moment !== 'undefined') {
							//     trace.x = trace.x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
							// }
							let trace_visible = true;
							if (isDaily) {
								if (newlyAddedTraces.includes(name)) {
									trace_visible = "legendonly";
								}
							}
							trace.y = applyDaypartMaskToSeries(trace.x, trace.y);
							trace.visible = trace_visible;

							// --- OPTIMIZATION START ---
							if (useDailyPrecalc && groupData && groupData.daily_totals && groupData.daily_totals[name]) {
								trace.x = [...precalcX];
								trace.y = [...groupData.daily_totals[name]];
								trace.visible = true;
							} else {
								trace.meta = { loading: trace_visible === "legendonly" };
							}
							// --- OPTIMIZATION END ---

							filteredData.push(trace);
						}
					});


					created_subgraph_compare_graphs.forEach((entry, index) => {
						const name = entry.data?.[0]?.name;
						if (swanbot_dataexplorer_filter_groupselected.includes(name)) {
							let trace = entry.data[0];
							const diff_y = calculatePercentageDifference(Array.from(trace.y_source), Array.from(trace.y));
							let xdates = Array.from(trace.x_base);
							let xdates_comp = Array.from(trace.x);
							if (subgraphdatacompare && subgraphdatacompare[x]) {
								if (swanbot_dataexplorer_filter_period === "day" && subgraphdatacompare[x]["days"]) {
									xdates_comp = Array.from(subgraphdatacompare[x]["days"]);
								} else if (subgraphdatacompare[x]["hours"]) {
									xdates_comp = Array.from(subgraphdatacompare[x]["hours"]);
								}
							}
							// if (timezone_selected !== 'UTC' && typeof moment !== 'undefined') {
							//     xdates = trace.x_base.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
							//     xdates_comp = trace.x.map(ts => moment.utc(ts).tz(timezone_selected).format('YYYY-MM-DDTHH:mm:ss.SSSZZ'));
							// }
							trace.x = xdates;
							trace.marker = { "color": "#e0e0e0" };
							trace.line = buildTraceLineStyle();
							trace.yaxis = "y";
							trace.hovertemplate = '%{customdata[0]|%b %d, %Y}: compare ' + (trace.name === "total" ? "Total Transactions" : trace.name) + ' : %{y} (%{customdata[1]})<extra></extra>';

							trace.tracetype = "compare";
							trace.tracesubtype = "compare";
							trace.traceindex = index;
							trace.traceid = "compare_" + index;
							trace.trace_source_id = name;

							let dname = trace.name
							dname = dname.length > 50 ? dname.substring(0, 50) + "..." : dname;

							if (y2Traces.includes(name) || y3Traces.includes(name) || y4Traces.includes(name)) {
								if (y4Traces.includes(name)) {
									trace.yaxis = "y4";
									trace.hovertemplate = '%{customdata[0]|%b %d, %Y}: compare ' + dname + ' : %{y:.2f}% (%{customdata[1]})<extra></extra>';
								} else {
									trace.yaxis = y2Traces.includes(name) ? "y2" : "y3";
									trace.hovertemplate = '%{customdata[0]|%b %d, %Y}: compare ' + dname + ' : %{y:$,.2f} (%{customdata[1]})<extra></extra>';
								}
							}
							trace.customdata = xdates_comp.map((d, idx) => [d, diff_y[idx]]);
							trace.name = 'compare: ' + dname;
							let trace_visible = true;
							if (isDaily) {
								if (newlyAddedTraces.includes(name)) {
									trace_visible = "legendonly";
								}
							}
							trace.y = applyDaypartMaskToSeries(trace.x, trace.y);
							trace.visible = trace_visible;

							// --- OPTIMIZATION START ---
							if (useDailyPrecalc && subgraphdatacompare && subgraphdatacompare[x]) {
								let compareGroupData = subgraphdatacompare[x];
								if (compareGroupData && compareGroupData.daily_totals && compareGroupData.daily_totals[name]) {
									trace.x = [...precalcX];
									trace.y = [...compareGroupData.daily_totals[name]];
									trace.visible = true;
								} else {
									trace.meta = { loading: trace_visible === "legendonly" };
								}
							} else {
								trace.meta = { loading: trace_visible === "legendonly" };
							}
							// --- OPTIMIZATION END ---

							filteredData.push(trace);
						}
					});


					Plotly.newPlot(subgraphGroupIds[x], { data: filteredData, layout: { ...pricelinelayout, height: 140 }, config });


					if (swanbot_dataexplorer_filter_period === "day" && swanbot_dataexplorer_lock_period_selection == false) {
						rollupHourlyDataByDay(subgraphGroupIds[x]);
					}

					truncateLegendNames(subgraphGroupIds[x], 60);
					//applyScrollableUnifiedTooltip(subgraphGroupIds[x]);
				}
			}

			// add all updated traces to main graph
			if (isNotEmpty(add_traces)) {
				Plotly.addTraces(graphid, add_traces);
				truncateLegendNames(graphid, 60);
			}
		}

		// show window.WingmanState.tooltip if too much data is set
		if (swanbot_maingraph_toomuchdata && tooltipInstance) {
			tooltipInstance.show();
		}


		swanbot_dataexplorer_compare_modality_analysis = ""; // no analysis modality by default


		if (isNotEmpty(focusdata)) {
			//console.log("focusdata")
			if (("focused_ts_start" in focusdata) && ("focused_ts_end" in focusdata)) {
				update_graph_aoe(focusdata["focused_ts_start"], focusdata["focused_ts_end"])
			}

			if (("curret_comparison_modality_for_analysis" in focusdata)) {
				swanbot_dataexplorer_compare_modality_analysis = focusdata["curret_comparison_modality_for_analysis"];
				swanbot_dataexplorer_compare_modality_analysis = focusdata["curret_comparison_modality_for_analysis_desc"];
				console.log("Setting comparison modality for analysis to: " + swanbot_dataexplorer_compare_modality_analysis);
				show_analysis_modality_in_ui(swanbot_dataexplorer_compare_modality_analysis);
			}

		}



		document.getElementById(graphid).scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
		filterlocation.innerHTML = add_filters;
		init_subgrouping_filters();



		if (swanbot_dataexplorer_filter_period === "day" && swanbot_dataexplorer_lock_period_selection == false) {
			rollupHourlyDataByDay(swanbot_dataexplorer_graph_id);
		}

		truncateLegendNames(swanbot_dataexplorer_graph_id, 60);

		//applyScrollableUnifiedTooltip(swanbot_dataexplorer_graph_id);

		swanbot_dataexplorer_compare_option_loaded = false;

		if (swanbot_dataexplorer_totalstable_isopen) {
			display_dataexplorer_totals();
		}

		window.swanbot_dataexplorer_filter_groupselected_prev = [...swanbot_dataexplorer_filter_groupselected];

	} else {
		console.log("no graph data");
	}
}



function show_analysis_modality_in_ui(modality) {
	const container = document.getElementById("dataexplorer_analysis_modality_display");
	if (container) {
		if (modality) {

			document.querySelectorAll('.data-analysis-modality-hidden-tooltip').forEach(el => el.remove());

			const oldTooltip = bootstrap.Tooltip.getInstance(container);
			if (oldTooltip) oldTooltip.dispose();


			let tooltipInstancedatamodality = new bootstrap.Tooltip(container, {
				trigger: 'hover',
				customClass: 'data-analysis-modality-hidden-tooltip'
			});
			container.innerHTML = "<i class='fas fa-equals align-middle' style='margin-right: 4px;'></i><strong>Comparison Analysis Modality:</strong> " + modality;
			container.style.display = "block";

			//tooltipInstancedatamodality.show();
		} else {
			container.innerHTML = "";
			container.style.display = "none";
		}
	}
}






function calculatePercentageDifference(graph_data_source_y, graph_data_compare_y) {

	const graph_data_diff_y = graph_data_source_y.map((source_value, index) => {
		const compare_value = graph_data_compare_y[index];


		if (typeof source_value === 'number' && typeof compare_value === 'number') {

			if (compare_value === 0) {
				return "N/A (Division by Zero)";
			}

			let rawDiff = source_value - compare_value;

			//console.log("source_value:" + source_value)
			//console.log("compare_value:" + compare_value)

			let percentDiff = (rawDiff / compare_value) * 100;

			let formattedPercent = percentDiff.toFixed(2);

			let finalString = (percentDiff >= 0 ? '+' : '') + formattedPercent + '%';


			return finalString;
		}

		return null;
	});

	return graph_data_diff_y;
}





function applyScrollableUnifiedTooltip(chartId) {
	const chartDiv = document.getElementById(chartId);
	if (!chartDiv) return;

	let visibleCount = chartDiv.data ? chartDiv.data.filter(t => t.visible === true || t.visible === undefined).length : 0;
	if (visibleCount < 15) return;

	Plotly.relayout(chartDiv, { hovermode: 'x' });
	Plotly.restyle(chartDiv, { hoverinfo: 'none' });

	let tooltipDiv = document.getElementById('custom-plotly-tooltip');
	if (!tooltipDiv) {
		tooltipDiv = document.createElement('div');
		tooltipDiv.id = 'custom-plotly-tooltip';
		Object.assign(tooltipDiv.style, {
			position: 'fixed',
			display: 'none',
			pointerEvents: 'auto',
			backgroundColor: 'rgba(255, 255, 255, 0.95)',
			border: '1px solid #ddd',
			borderRadius: '4px',
			padding: '10px',
			boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
			maxHeight: '350px',
			overflowY: 'auto',
			zIndex: '9999',
			fontSize: '12px',
			fontFamily: 'Arial, sans-serif'
		});

		tooltipDiv.addEventListener('mouseleave', () => {
			tooltipDiv.style.display = 'none';
		});

		document.body.appendChild(tooltipDiv);
	}

	chartDiv.on('plotly_hover', function (data) {
		if (data.points.length === 0) return;

		let pts = data.points;
		let xVal = pts[0].x;
		if (typeof xVal === 'string' && xVal.includes('-')) {
			try { xVal = moment(xVal).format('MMM D, YYYY'); } catch (e) { } // Quick shorthand check for date formats if moment exists
		} else if (typeof xVal === 'string' && xVal.includes('T')) {
			try { xVal = new Date(xVal).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }); } catch (e) { }
		}

		let htmlContent = '<div style="font-weight:bold; margin-bottom:5px; border-bottom:1px solid #ddd; padding-bottom:5px;">' + xVal + '</div>';
		htmlContent += '<div style="display:grid; grid-template-columns: auto auto auto; gap: 6px; align-items:center;">';

		pts.forEach(p => {
			let name = p.data.name || 'Trace';
			let color = Array.isArray(p.fullData.marker.color) ? p.fullData.marker.color[0] : p.fullData.marker.color || '#000';
			let yVal = p.y !== undefined ? p.y : '?';

			if (typeof yVal === 'number') {
				yVal = yVal.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
			}

			if (p.data.yaxis === 'y2' || p.data.yaxis === 'y3') {
				yVal = '$' + yVal;
			} else if (p.data.yaxis === 'y4') {
				yVal = yVal + '%';
			}

			let diffHtml = '';
			if (p.customdata && Array.isArray(p.customdata) && p.customdata[1]) {
				let diffStr = String(p.customdata[1]);
				let colorStyle = diffStr.includes('+') ? 'color:green;' : diffStr.includes('-') ? 'color:red;' : 'color:#666;';
				diffHtml = '<span style="margin-left:8px; font-weight:normal; font-size:11px;' + colorStyle + '">' + p.customdata[1] + '</span>';
			}

			htmlContent += `
              <div style="width:10px; height:10px; background-color:${color}; border-radius:50%;"></div>
              <div style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:200px;">${name}</div>
              <div style="text-align:right; font-weight:bold;">${yVal}${diffHtml}</div>
            `;
		});

		htmlContent += '</div>';
		tooltipDiv.innerHTML = htmlContent;
		tooltipDiv.style.display = 'block';

		let ev = data.event;
		let left = ev.clientX + 15;
		let top = ev.clientY + 15;

		if (left + 350 > window.innerWidth) left = ev.clientX - 370;
		if (top + 350 > window.innerHeight) top = window.innerHeight - 370;

		tooltipDiv.style.left = left + 'px';
		tooltipDiv.style.top = top + 'px';
	});

	let hideTimeout;
	chartDiv.on('plotly_unhover', function (data) {
		hideTimeout = setTimeout(() => {
			if (!tooltipDiv.matches(':hover')) {
				tooltipDiv.style.display = 'none';
			}
		}, 250);
	});

	tooltipDiv.addEventListener('mouseenter', () => {
		clearTimeout(hideTimeout);
	});
}


async function complete_dataexplorer_init() {
	de_loading_events = false;
}




/**
 * Optimized version of rollupHourlyDataByDay with Performance Tracing.
 * Uses console.time to identify bottlenecks and batch updates to Plotly.
 * Added setTimeout yielding to prevent UI blocking (click handler lag).
 */
function rollupHourlyDataByDay(chartId) {
	const totalStart = performance.now();

	const chartDiv = document.getElementById(chartId);

	if (!chartDiv || !chartDiv.data) {
		console.warn(`Chart ID ${chartId} not found or has no data.`);
		return;
	}

	let subGraphIndex = 0;
	const sourceTraces = {};

	let globalGraphData = (typeof window.WingmanState.swanbot_dataexplorer_graphdata !== 'undefined') ?
		window.WingmanState.swanbot_dataexplorer_graphdata["graphs"] :
		null;

	// Handle potential string graphdata (same as make_dataexplorer_graph)
	if (typeof globalGraphData === 'string') {
		try {
			let temp_gd = JSON.parse(globalGraphData);
			if (temp_gd) globalGraphData = temp_gd;
		} catch (e) { }
	}

	let mainGraphDays = (globalGraphData && globalGraphData.days) ? [...globalGraphData.days] : [];
	// If globalGraphData is still a string (failed parse) or missing days, we might have issues.

	if (chartId !== swanbot_dataexplorer_graph_id && typeof swanbot_dataexplorer_graphs !== 'undefined' && Array.isArray(swanbot_dataexplorer_graphs)) {
		// subgraph ungroup charts will always be subgraphGroupData
		subGraphIndex = swanbot_dataexplorer_graphs.indexOf(chartId);

		if (subGraphIndex !== -1 && window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"] && window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"][subGraphIndex]) {
			globalGraphData = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"][subGraphIndex];
		}

	}

	// Default global days from the determined global graph data, falling back to main graph days
	const globalDays = (globalGraphData && globalGraphData.days && globalGraphData.days.length > 0) ? [...globalGraphData.days] : mainGraphDays;

	// Batch update arrays to call Plotly.restyle only once
	const updateIndices = [];
	const updateX = [];
	const updateY = [];
	const updateCustomData = [];
	const updateVisibility = [];


	// 1. Process Data (This part is already fast)
	for (let i = 0; i < chartDiv.data.length; i++) {

		const trace = chartDiv.data[i];
		const traceName = trace.trace_source_id || trace.name || "";

		const originalX = trace.x;
		const originalY = trace.y;

		if (!originalX || !originalY || originalX.length === 0) continue;

		let newX = [];
		let newY = [];
		let newCustomData = [];

		let sourceGraphData = globalGraphData;

		// Determine source graph data based on trace type and chart context
		if (trace.tracetype === "compare") {
			if (chartId === swanbot_dataexplorer_graph_id) {
				sourceGraphData = window.WingmanState.swanbot_dataexplorer_graphdata["graphs_compare"];

				// Handle secondary traces (e.g., from subgroups overlaid on main graph)
				if (trace.tracesubtype === "secondary_compare" && typeof trace.traceindex !== 'undefined') {
					if (window.WingmanState.swanbot_dataexplorer_graphdata.subgraphs_compare) {
						sourceGraphData = window.WingmanState.swanbot_dataexplorer_graphdata.subgraphs_compare[trace.traceindex];
					}
				}

			} else if (typeof window.WingmanState.swanbot_dataexplorer_processing_compare_type !== 'undefined' && window.WingmanState.swanbot_dataexplorer_processing_compare_type) {
				sourceGraphData = window.WingmanState.swanbot_dataexplorer_graphdata.subgraphs_compare[subGraphIndex];
			}

		} else if (trace.tracetype === "source") {
			if (chartId === swanbot_dataexplorer_graph_id) {
				// Secondary source traces on main graph use subgraph data
				if (trace.tracesubtype === "secondary" && typeof trace.traceindex !== 'undefined') {
					sourceGraphData = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"][trace.traceindex];
				}
			}
		}

		// If we have pre-aggregated daily totals, use them directly for lightning-fast rollup.
		if (sourceGraphData && sourceGraphData.daily_totals && sourceGraphData.daily_totals[traceName]) {
			newX = globalDays;
			newY = sourceGraphData.daily_totals[traceName];
			//console.log("this is the newY", newY)
			let customDates = (trace.tracetype === "compare" && sourceGraphData.days) ? sourceGraphData.days : newX;
			newCustomData = customDates.map(date => [date, "n/a"]);
		}

		if (newX.length === 0) continue;

		// Processing for compare/source logic
		if (trace.tracetype === "compare") {
			const sourceTraceId = trace.trace_source_id;
			const sourceData = sourceTraces[sourceTraceId];

			if (sourceData && sourceData.y && typeof calculatePercentageDifference === 'function') {
				const diffY = calculatePercentageDifference(sourceData.y, newY);
				updateX.push(sourceData.x);
				newCustomData.forEach((item, idx) => {
					item[1] = diffY[idx] !== undefined ? diffY[idx] : "n/a";
				});
			}

		} else if (trace.traceid) {
			sourceTraces[trace.trace_source_id] = {
				x: [...newX],
				y: [...newY]
			};
			updateX.push(newX);
		}

		updateIndices.push(i);
		updateY.push(newY);
		updateCustomData.push(newCustomData);


		let nextVisible = true;


		if (trace.visible === "legendonly") {
			if (trace.meta && trace.meta.loading) {
				nextVisible = true;
			} else {
				nextVisible = "legendonly";
			}
		}


		updateVisibility.push(nextVisible);

	}




	// 2. Schedule the heavy DOM/Plotly update for the next tick
	// This allows the browser to finish the "click" event and update 
	// any immediate UI feedback before the main render lockup happens.
	if (updateIndices.length > 0) {
		setTimeout(() => {
			//console.time("plotly_batch_restyle_actual");

			const batchUpdate = {
				x: updateX,
				y: updateY,
				customdata: updateCustomData,
				visible: updateVisibility
			};

			Plotly.restyle(chartDiv, batchUpdate, updateIndices)
				.then(() => {
					//console.timeEnd("plotly_batch_restyle_actual");
					//console.timeEnd("rollup_total_execution");
					const totalTime = performance.now() - totalStart;
					//console.log(`[Rollup Complete] Total Time (inc. UI yield): ${totalTime.toFixed(2)}ms`);
				});
		}, 0);
	} else {
		//console.timeEnd("rollup_total_execution");
	}

}






function truncateLegendNames(chartId, maxLength = 60) {
	const chartDiv = document.getElementById(chartId);

	if (chartDiv && chartDiv.data) {
		const traces = chartDiv.data;

		traces.forEach(trace => {
			if (trace.name && trace.name.length > maxLength) {
				trace.name = trace.name.substring(0, maxLength) + '...';
			}
		});

		Plotly.react(chartDiv, traces, chartDiv.layout);
	}
}



function getRandomSpinner(arr) {

	const randomIndex = Math.floor(Math.random() * arr.length);
	return arr[randomIndex];
}





function preload_dataexplorer_graph() {

	//console.log("---- preload_dataexplorer_graph ----");

	let graphlocation = document.getElementById("graph-dataexplorer-details");
	let filterlocation = document.getElementById("graph-dataexplorer-filters");
	if (filterlocation) {
		filterlocation.innerHTML = "<h4>No Filters Applied to Total Transactions</h4>";
	}

	let graphid = "swanbot_graph_" + fivedigit();
	setDataExplorerGraphId(graphid);
	let pulsetypes = ["svg-spinners--pulse-2", "svg-spinners--pulse-ring"]

	//let addgraph = "<div id='" + graphid + "'></div>"





	// Configuration for the animation
	const numPoints = 30;


	// Build the HTML for the scatter points
	let scatterPointsHtml = '';
	for (let i = 0; i < numPoints; i++) {
		scatterPointsHtml += `<div class="dataexplorer_loader_scatter-point"></div>`;
	}

	// The main HTML for the loader
	const containerHtml = `
                <div class="dataexplorer_loader_container" style="height: calc(100vh - 375px); max-height: 550px; display: flex; flex-direction: column;">
                    <div class="flex items-center mb-4">
                        <h4 class="text-xl font-semibold text-gray-700">Loading Total Transactions Explorer</h4>
                    </div>
                    <div id="dataexplorer_loader_skeletonLoader" class="dataexplorer_loader_skeleton-loader rounded-lg bg-gray-200 overflow-hidden" style="flex-grow: 1; height: 100%; position: relative;">
                        <svg style="position: absolute; top: 0; left: 0;" width="100%" height="100%" preserveAspectRatio="none" viewBox="0 0 800 300">
                            <!-- Left (Y) Axis -->
                            <line x1="0" y1="300" x2="0" y2="0" class="dataexplorer_loader_chart-axis" />
                            <!-- Bottom (X) Axis -->
                            <line x1="0" y1="300" x2="800" y2="300" class="dataexplorer_loader_chart-axis" />

                            <!-- Y-axis Ticks -->
                            <g class="dataexplorer_loader_y-ticks">
                                <line x1="0" y1="250" x2="5" y2="250" class="dataexplorer_loader_tick" />
                                <line x1="0" y1="200" x2="5" y2="200" class="dataexplorer_loader_tick" />
                                <line x1="0" y1="150" x2="5" y2="150" class="dataexplorer_loader_tick" />
                                <line x1="0" y1="100" x2="5" y2="100" class="dataexplorer_loader_tick" />
                                <line x1="0" y1="50" x2="5" y2="50" class="dataexplorer_loader_tick" />
                            </g>

                            <!-- X-axis Ticks -->
                            <g class="dataexplorer_loader_x-ticks">
                                <line x1="100" y1="300" x2="100" y2="295" class="dataexplorer_loader_tick" />
                                <line x1="250" y1="300" x2="250" y2="295" class="dataexplorer_loader_tick" />
                                <line x1="400" y1="300" x2="400" y2="295" class="dataexplorer_loader_tick" />
                                <line x1="550" y1="300" x2="550" y2="295" class="dataexplorer_loader_tick" />
                                <line x1="700" y1="300" x2="700" y2="295" class="dataexplorer_loader_tick" />
                            </g>
                        </svg>

                        <!-- HTML scatter points overlaid over the SVG -->
                        <div class="dataexplorer_loader_scatter-points" style="position: absolute; top:0; left:0; width: 100%; height: 100%;">
                            ${scatterPointsHtml}
                        </div>

                    </div>
                </div>
            `;

	// Append the HTML string to the container
	graphlocation.innerHTML = containerHtml;
	dataExplorerInitialLoaderShown = true;
	let agentsContainer = document.getElementById("graph-dataexplorer-agents");
	if (agentsContainer) {
		agentsContainer.style.display = '';
	}

	// Get the newly created scatter points
	const scatterPointsContainer = document.querySelector('.dataexplorer_loader_scatter-points');
	const scatterPoints = scatterPointsContainer.querySelectorAll('.dataexplorer_loader_scatter-point');

	// Initialize and listen for animation events
	scatterPoints.forEach((point, index) => {
		// Generate a single random duration to be used for both the timeout and animation
		const randomDuration = Math.random() * 2 + 2; // 2 to 4 seconds
		const initialDelay = Math.random() * 5000; // Random delay up to 1 second

		setTimeout(() => {
			setRandomDotProperties(point, randomDuration);
			// Listen for the end of each animation cycle to reposition and recolor
			point.addEventListener('animationiteration', () => {
				setRandomDotProperties(point, randomDuration);
			});
		}, initialDelay);
	});

	// Start Canvas connecting lines
	startScatterNetwork(scatterPointsContainer);

	// const data = [{
	//     x: [0, 1, 2, 3, 4],
	//     y: [0, 0, 0, 0, 0], // Dummy data
	//     mode: 'lines',
	//     line: {
	//         color: 'rgb(180, 180, 180)', // Grayscale line
	//         width: 2
	//     },
	//     name: 'Loading Data'
	// }];

	// const layout = {
	//     title: {
	//         text: '<b>Loading Data... Please Wait</b>',
	//         font: {
	//             color: 'rgb(80, 80, 80)' // Grayscale title
	//         }
	//     },
	//     xaxis: {
	//         title: {
	//             text: 'X-axis (Loading)',
	//             font: { color: 'rgb(120, 120, 120)' }
	//         },
	//         showgrid: false,
	//         zeroline: false,
	//         showticklabels: false // Hide ticks during loading
	//     },
	//     yaxis: {
	//         title: {
	//             text: 'Y-axis (Loading)',
	//             font: { color: 'rgb(120, 120, 120)' }
	//         },
	//         showgrid: false,
	//         zeroline: false,
	//         showticklabels: false // Hide ticks during loading
	//     },
	//     plot_bgcolor: 'rgb(240, 240, 240)', // Light grayscale background
	//     paper_bgcolor: 'rgb(250, 250, 250)', // Lighter grayscale paper background
	//     margin: { t: 60, b: 40, l: 40, r: 40 },
	//     annotations: [{
	//         text: 'Fetching data from server...',
	//         xref: 'paper',
	//         yref: 'paper',
	//         x: 0.5,
	//         y: 0.5,
	//         showarrow: false,
	//         font: {
	//             size: 20,
	//             color: 'rgb(100, 100, 100)' // Grayscale annotation
	//         }
	//     }]
	// };

	// // Create the initial Plotly graph with loading state
	// Plotly.newPlot(swanbot_dataexplorer_graph_id, data, layout);
}



function getDescriptorByModality(arr, modality) {

	//console.log("arr", arr, "modality", modality)
	let selected_modality_name = { "desc": "none" };

	try {
		selected_modality_name = arr.find(item => item.modality === modality);
	} catch (exception) {
		console.error("exception selecting modality from comparison types")
	}

	if (selected_modality_name) {
		return selected_modality_name.desc;
	}
	return null;
}




function compare_dataexplorer_begin(comparison) {


	let compare_option_button = document.getElementById("compareMenuButton");
	let comparison_drowpdown_container = document.getElementById("comparison_drowpdown_container");


	compare_option_button.setAttribute("disabled", "disabled");
	comparison_drowpdown_container.classList.remove("show");

	compare_option_button.innerHTML = '<i class="line-md--loading-loop fas align-middle"></i><span class="align-middle">Loading Comparison Data</span>'


	swanbot_dataexplorer_processing_compare = true;
	window.swanbot_dataexplorer_processing_compare = true;
	if (comparison == "none") {
		load_swanbot_dataexplorer_compare_graphData(comparison);
		window.WingmanState.swanbot_dataexplorer_processing_compare_type = "";
		swanbot_dataexplorer_processing_compare = false;
		window.swanbot_dataexplorer_processing_compare = false;
	} else {
		window.WingmanState.swanbot_dataexplorer_processing_compare_type = comparison;
		load_swanbot_dataexplorer_compare(comparison);
	}





}

function get_compare_dataexplorer_options() {
	window.swanbot_dataexplorer_compare_options_requested = true;

	if (window.swanbot_dataexplorer_compare_options_refresh_inflight) {
		return;
	}

	if (swanbot_dataexplorer_compare_types && window.swanbot_dataexplorer_compare_options_stale !== true) {
		window.set_compare_dataexplorer_options(swanbot_dataexplorer_compare_types)
	} else {
		async function sendMessageSequence() {
			window.swanbot_dataexplorer_compare_options_refresh_inflight = true;
			swanbot_dataexplorer_compare_option_loaded = false;

			//const message = "Okay. Getting comparison options."
			//await send_dataexplorer_results(message, "swanbot", 0);

			await load_explorer_swanbot("comparisonStatus", "", "")
			//console.log("get_compare_dataexplorer_options - complete")
		}
		sendMessageSequence();
	}

}



window.set_compare_dataexplorer_options = function(modalities) {

	if (swanbot_dataexplorer_compare_option_loaded) {

		//pass

	} else {


		let loaded_modalities = modalities; //JSON.parse(modalities)
		swanbot_dataexplorer_compare_types = loaded_modalities; // set globals
		window.swanbot_dataexplorer_compare_options_stale = false;
		window.swanbot_dataexplorer_compare_options_refresh_inflight = false;

		let compare_option_list = document.getElementById("comparison_drowpdown_container");
		if (!compare_option_list) {
			return;
		}

		compare_option_list.innerHTML = "";



		// [{"desc":"Day over day","modality":"dod","order":0},{"desc":"Week over week","modality":"wow","order":1},{"desc":"Month over month - 4 weeks","modality":"mom_4week","order":2},{"desc":"Month over month - week of month","modality":"mom_byweek","order":3},{"desc":"Month over month - date of month","modality":"mom_bydate","order":4}]

		let newmodalityoption_none = "<li><button id='' title='None' data-modality='none' class='btn btn-link dropdown-item handle_modality_pick'><span class='align-middle'>No Comparison</span></button></li>"
		compare_option_list.insertAdjacentHTML('beforeend', newmodalityoption_none);



		for (modality in swanbot_dataexplorer_compare_types) {
			let selected_modality = swanbot_dataexplorer_compare_types[modality];
			//console.log("modality ", swanbot_dataexplorer_compare_types[modality])
			let modality_option = selected_modality['modality'];
			let newmodalityoption = ""
			if (window.WingmanState.swanbot_dataexplorer_processing_compare_type == modality_option) {
				newmodalityoption = "<li><button id='' title='" + selected_modality['desc'] + "' data-modality='" + selected_modality['modality'] + "' class='btn btn-link dropdown-item handle_modality_pick'><span class='align-middle'>✓ " + selected_modality['desc'] + "</span></button></li>"
			} else {
				newmodalityoption = "<li><button id='' title='" + selected_modality['desc'] + "' data-modality='" + selected_modality['modality'] + "' class='btn btn-link dropdown-item handle_modality_pick'><span class='align-middle'>" + selected_modality['desc'] + "</span></button></li>"
			}
			compare_option_list.insertAdjacentHTML('beforeend', newmodalityoption);
		}

		let all_modality_buttons = document.getElementsByClassName("handle_modality_pick");

		Array.from(all_modality_buttons).forEach(element => {
			let modality_action = element.dataset.modality;

			element.addEventListener('click', function (event) {
				compare_dataexplorer_begin(modality_action);
				event.preventDefault();
			});

		});

		swanbot_dataexplorer_compare_option_loaded = true;

	}

}


window.compare_dataexplorer_complete = function(comparison) {


	let compare_option_button = document.getElementById("compareMenuButton");
	compare_option_button.removeAttribute("disabled");

	console.log("got comparison data: ", comparison)


	if (comparison == "error") {
		compare_option_button.innerHTML = '<i class="carbon--chart-multi-line fas align-middle"></i><span class="align-middle">Compare Options [Error - Try Again]</span>'
	} else {
		if (window.WingmanState.swanbot_dataexplorer_processing_compare_type) {
			let selected_modality_name = getDescriptorByModality(swanbot_dataexplorer_compare_types, window.WingmanState.swanbot_dataexplorer_processing_compare_type)

			compare_option_button.innerHTML = '<i class="carbon--chart-multi-line fas align-middle"></i><span class="align-middle">✓ ' + selected_modality_name + '</span>'
		} else {
			compare_option_button.innerHTML = '<i class="carbon--chart-multi-line fas align-middle"></i><span class="align-middle">Compare Options</span>'
		}

		load_swanbot_dataexplorer_compare_graphData(comparison)
	}
	swanbot_dataexplorer_processing_compare = false;
	window.swanbot_dataexplorer_processing_compare = false;
	//window.WingmanState.swanbot_dataexplorer_processing_compare_type = "";

}



/* extracted load_swanbot_dataexplorer_compare */




/* extracted load_swanbot_dataexplorer_compare_graphData */




/* extracted download_dataexplorer_csv */



/* extracted download_dataexplorer_from_datasource_csv */





/* extracted download_dataexplorer_div */




function toggle_graph_legend(graphDivId) {
	const graphDiv = document.getElementById(graphDivId);

	if (!graphDiv) {
		console.error("Graph div not found with ID:", graphDivId);
		return;
	}


	const currentData = graphDiv.data;
	const currentLayout = graphDiv.layout;
	if (currentLayout.showlegend) {
		currentLayout.hovermode = "closest"
		currentLayout.showlegend = false;
	} else {
		currentLayout.hovermode = "x unified"
		currentLayout.showlegend = true;
	}


	Plotly.react(graphDivId, currentData, currentLayout);

}






function init_subgrouping_filters() {

	let all_subgroups = document.getElementsByClassName('show_subgrouping_button');
	let all_mainsourcefilters = document.getElementsByClassName('btn-maingraph-filter');

	Array.from(all_subgroups).forEach(element => {
		let subfilterValue = element.dataset.subfilter;

		// Add a click event listener to each 'element'
		element.addEventListener('click', function () {
			window.WingmanState.swanbot_dataexplorer_filter_subgrouping = subfilterValue;
			swanbot_load_subgroup();
		});

	});


	Array.from(all_mainsourcefilters).forEach(element => {
		let sourcefilterIndex = element.dataset.index;

		element.addEventListener('click', function () {

			//console.log("update swanbot_dataexplorer_filter_groupselected with ", sourcefilterIndex)

			if (!swanbot_dataexplorer_filter_groupselected.includes(sourcefilterIndex)) {
				swanbot_dataexplorer_filter_groupselected.push(sourcefilterIndex);
			} else {
				let index = swanbot_dataexplorer_filter_groupselected.indexOf(sourcefilterIndex);
				swanbot_dataexplorer_filter_groupselected.splice(index, 1);
			}

			customerid = document.querySelector("#customer_id").value;

			let cachekey = customerid + "_dataexplorer_subgroup_sources";
			set_cache(cachekey, swanbot_dataexplorer_filter_groupselected);


			//swanbot_dataexplorer_filter_groupselected = sourcefilterIndex;
			make_dataexplorer_graph();
		});
	});


	if (document.getElementById("dataexplorer_toggle_subgroup")) {

		document.getElementById("dataexplorer_toggle_subgroup").addEventListener('click', function () {
			swanbot_toggle_graphgroup();
		});

	}


	if (document.getElementById("dataexplorer_toggle_daily")) {
		document.getElementById("dataexplorer_toggle_daily").addEventListener('change', function () {
			let isDaily = this.checked;
			let refreshGraphAfterToggle = function () {
				window.setTimeout(function () {
					make_dataexplorer_graph();
				}, 220);
			};
			
			if (isDaily) {
				swanbot_dataexplorer_filter_period = "day";
				if (typeof rollupHourlyDataByDay === 'function') {
					rollupHourlyDataByDay(swanbot_dataexplorer_graph_id);
					let subgraphGroupData = window.WingmanState.swanbot_dataexplorer_graphdata["subgraphGroupData"];
					if (isNotEmpty(subgraphGroupData) && !window.swanbot_dataexplorer_filter_groupstacked) {
						for (let sub_graph_id in swanbot_dataexplorer_graphs) {
							rollupHourlyDataByDay(swanbot_dataexplorer_graphs[sub_graph_id]);
						}
					}
				} else {
					refreshGraphAfterToggle();
				}
			} else {
				swanbot_dataexplorer_filter_period = "hour";
				refreshGraphAfterToggle();
			}
		});
	}




	// investigate picker

	if (document.getElementById("dataexplorer_pick_moment")) {

		let q_pick = document.getElementById("dataexplorer_pick_moment");



		q_pick.addEventListener('click', function () {


			let q_pick = document.getElementById("dataexplorer_pick_moment");

			swanbot_dataexplorer_investigate_selected = true;
			// set a global to indicate we are in pick mode for the graph, 
			// this will be used to trigger the datepicker to open when we click on the graph, 
			// and to handle the logic of what happens when we pick a date from the datepicker

			//console.log(q_pick)
			//console.log(q_pick.dataset)
			//console.log(q_pick.dataset.isInit)


			if (q_pick.dataset.isInit == "init") {

				// If already initialized (meaning mode is active), treat click as cancel
				if (typeof cancel_investigate_mode === 'function') {
					//console.log("Canceling investigate mode via button click.");
					cancel_investigate_mode();
				} else {
					// Fallback if function scope issue, though typically defined inside this block in previous edit
					// But wait, the function is defined INSIDE the else block in the previous turn.
					// I need to restructure so cancel_investigate_mode is available here or trigger the click on bgmask.
					//console.log("Fallback: Canceling investigate mode via trigger the click on bgmask.");

					const bgmask = document.getElementById("graph-dataexplorer-mask");
					if (bgmask) bgmask.click();
				}

			} else {

				const sbplot = document.getElementById(swanbot_dataexplorer_graph_id);
				const bgmask = document.getElementById("graph-dataexplorer-mask");
				const graph_abovemask = document.getElementById("graph-dataexplorer-details");
				const toggleleg = document.getElementById('toggle_dataexplorer_graph_legend');

				// --- CANCEL HANDLER START ---
				const cancel_investigate_mode = function () {
					swanbot_dataexplorer_investigate_selected = false;

					// Visual Reset
					bgmask.classList.remove("blurred-background");
					graph_abovemask.classList.remove("blurred-visible");
					toggleleg.style.display = "";

					// Button Reset
					// q_pick.innerHTML = "<i class='ri--search-eye-line fas align-middle'></i><span class='align-middle'>Investigate</span>";
					q_pick.innerHTML = "<i class='ri--search-eye-line fas align-middle'></i><span class='align-middle'>Investigate</span>";

					// Graph Layout Reset
					const cancelLayout = sbplot.layout;
					cancelLayout.hovermode = "x unified";
					cancelLayout.dragmode = false;
					cancelLayout.showlegend = true;

					// Restore Hover Templates						
					if (typeof originalHoverTemplates !== 'undefined') {
						restoreAllOriginalTemplates(sbplot, originalHoverTemplates);
					}

					Plotly.react(sbplot, sbplot.data, cancelLayout);

					// Remove Listeners
					bgmask.removeEventListener("click", cancel_investigate_mode);
					document.removeEventListener("keydown", escape_handler);

					// Reset Button State
					q_pick.dataset.isInit = "";
				};

				const escape_handler = function (evt) {
					if (evt.key === "Escape") {
						cancel_investigate_mode();
					}
				};

				// Attach Cancel Listeners
				bgmask.addEventListener("click", cancel_investigate_mode);
				document.addEventListener("keydown", escape_handler);
				// --- CANCEL HANDLER END ---

				// Update Button Appearance
				q_pick.innerHTML = "<i class='ic--outline-cancel fas align-middle'></i><span class='align-middle'>Cancel</span>";


				//const cursorOverlay = document.createElement('div');

				bgmask.classList.add("blurred-background");
				graph_abovemask.classList.add("blurred-visible");


				const currentData = sbplot.data;
				const currentLayout = sbplot.layout;

				currentLayout.hovermode = "closest";
				currentLayout.dragmode = "select";
				currentLayout.showlegend = false;
				toggleleg.style.display = "none";

				//Plotly.react(sbplot, currentData, currentLayout);



				sbplot.on('plotly_click', function (data) {



					if (data.points && data.points.length > 0) {
						// Clean up listeners immediately upon valid selection
						//bgmask.removeEventListener("click", cancel_investigate_mode);
						//document.removeEventListener("keydown", escape_handler);

						const clickedPoint = data.points[0];
						const traceName = clickedPoint.data.name; // Get the trace's name
						const pointData = {
							x: clickedPoint.x,
							y: clickedPoint.y,
							traceName: traceName, // Include the trace name
							traceIndex: clickedPoint.curveNumber,
							pointIndex: clickedPoint.pointNumber
						};
						const dselected = clickedPoint.x;
						const tselected = traceName;
						//console.log('Clicked Point Data:', pointData);





						const sbplot = document.getElementById(swanbot_dataexplorer_graph_id);

						const currentData = sbplot.data;
						const currentLayout = sbplot.layout;

						currentLayout.hovermode = "x unified";
						currentLayout.dragmode = false;
						currentLayout.showlegend = true;

						Plotly.react(sbplot, currentData, currentLayout);
						//Plotly.relayout(sbplot, {selections: []});



						let querytext = `What happened on ${dselected} with ${traceName}?`;
						//console.log(querytext);
						async function sendMessageSequence() {
							get_dataexplorer_swanbot_data(querytext);
						}
						sendMessageSequence();


						const bgmask = document.getElementById("graph-dataexplorer-mask");
						bgmask.classList.remove("blurred-background");
						const graph_abovemask = document.getElementById("graph-dataexplorer-details");
						graph_abovemask.classList.remove("blurred-visible");
						const toggleleg = document.getElementById('toggle_dataexplorer_graph_legend');
						toggleleg.style.display = "";

						bgmask.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);

						restoreAllOriginalTemplates(sbplot, originalHoverTemplates)

						// You can now use this information to perform actions
					}
					// The 'else' case for doing nothing is implicitly handled,
					// as the code inside the 'if' block won't execute.
				});


				sbplot.on('plotly_relayout', function (data) {

					// console.log("okay we have a seelection")
					// console.log(data)

					if (data && data.selections && data.selections.length > 0) {
						// This event fires after a drag, zoom, or box select
						// console.log("data I have")
						// console.log(data)
						let selectionStart = moment(data.selections[0].x0);
						let selectionEnd = moment(data.selections[0].x1);
						if (selectionStart.isAfter(selectionEnd)) {
							[selectionStart, selectionEnd] = [selectionEnd, selectionStart];
						}
						let xstart = selectionStart.format('MM-DD-YYYY HH:00:00');
						let xend = selectionEnd.format('MM-DD-YYYY HH:00:00');


						// console.log(xstart)
						// console.log(xend)

						const sbplot = document.getElementById(swanbot_dataexplorer_graph_id);

						const currentData = sbplot.data;
						const currentLayout = sbplot.layout;

						currentLayout.hovermode = "x unified";
						currentLayout.dragmode = false;
						currentLayout.showlegend = true;

						Plotly.react(sbplot, currentData, currentLayout);
						Plotly.relayout(sbplot, { selections: [] });


						let querytext = `What happened between ${xstart} and ${xend}?`;
						console.log(querytext);
						async function sendMessageSequence() {
							get_dataexplorer_swanbot_data(querytext);
						}
						sendMessageSequence();


						const bgmask = document.getElementById("graph-dataexplorer-mask");
						bgmask.classList.remove("blurred-background");
						const graph_abovemask = document.getElementById("graph-dataexplorer-details");
						graph_abovemask.classList.remove("blurred-visible");
						const toggleleg = document.getElementById('toggle_dataexplorer_graph_legend');
						toggleleg.style.display = "";

						bgmask.removeEventListener("click", swanbot_dataexplorer_datepicker_null_clickhandler, false);

						restoreAllOriginalTemplates(sbplot, originalHoverTemplates)


					}
				});



				sbplot.on('plotly_selected', function (data) {
					//console.log("selected data", data)

				});




				// Store the original marker colors and hover templates for each trace
				// var originalMarkerColors = sbplot.data.map(trace => {
				//   return Array.isArray(trace.marker.color) ? trace.marker.color.slice() : new Array(trace.x.length).fill(trace.marker.color);
				// });

				var originalHoverTemplates = sbplot.data.map(trace => trace.hovertemplate);

				// A variable to store the index of the previously hovered point and trace
				var previousHover = {
					traceIndex: null,
					pointIndex: null
				};



				var custominspecttemplate = `<span class="dataexplorer_learn_more" style="font-family: 'Oswald', sans-serif; font-size: 16px; font-weight: bold; background-color: #ffffff">Click to learn more</span><br><br><span style="font-family: 'Oswald', sans-serif; font-size: 14px;"><b>Source:</b> %{data.name}<br><b>Date:</b> %{x}<br><b>Value:</b> %{y}</span><extra></extra>`;



				setAllHoverTemplates(sbplot, custominspecttemplate);

				// Listen for a custom 'plotly_hover_unified' event
				sbplot.on('plotly_hover', function (eventData) {
					try {
						// Check if eventData and its points array contain valid data
						if (!eventData.points || eventData.points.length === 0) {
							// If no valid data, we consider this an "unhover" event
							// and reset the previously hovered point.
							if (previousHover.traceIndex !== null) {
								//var resetColorArray = originalMarkerColors[previousHover.traceIndex];


								// Plotly.restyle(sbplot, {
								//   'marker.color': [resetColorArray],
								// }, previousHover.traceIndex);

								// Clear the previous hover state
								previousHover.traceIndex = null;
								previousHover.pointIndex = null;
							}
							// Reset the cursor style
							sbplot.style.cursor = 'auto';
							return;
						}

						// Get the index of the hovered trace and point
						var currentTraceIndex = eventData.points[0].curveNumber;
						var currentPointIndex = eventData.points[0].pointIndex;

						// Set the cursor style on hover
						sbplot.style.cursor = 'help';

						// If we are hovering over a new point or a different trace, reset the previous one
						if (previousHover.traceIndex !== null && (previousHover.traceIndex !== currentTraceIndex || previousHover.pointIndex !== currentPointIndex)) {
							//var resetColorArray = originalMarkerColors[previousHover.traceIndex];


							// Plotly.restyle(sbplot, {
							//   'marker.color': [resetColorArray],
							// }, previousHover.traceIndex);


						}

						// Highlight the current hovered point
						//var newColorArray = originalMarkerColors[currentTraceIndex].slice();
						//newColorArray[currentPointIndex] = 'white';

						// Plotly.restyle(sbplot, {
						//   'marker.color': [newColorArray],
						// }, currentTraceIndex);

						// Update the previous hover state
						previousHover.traceIndex = currentTraceIndex;
						previousHover.pointIndex = currentPointIndex;
					} catch (error) {
						// Log the error for debugging but prevent it from crashing the script
						console.error("An error occurred during hover handling:", error);
					}
				});





				//console.log("okay, lets reset the layout and data here")

				Plotly.react(sbplot, currentData, currentLayout);

				q_pick.dataset.isInit = "init";

			}



		});



	}






	if (document.getElementById("download_dataexplorer_link")) {

		document.getElementById("download_dataexplorer_link").addEventListener('click', function () {
			download_dataexplorer_div();
		});

	}


	if (document.getElementById("download_dataexplorer_csv_link")) {

		document.getElementById("download_dataexplorer_csv_link").addEventListener('click', function () {
			download_dataexplorer_from_datasource_csv();
		});

	}

	if (document.getElementById("compareMenuButton")) {

		document.getElementById("compareMenuButton").addEventListener('click', function (event) {

			event.preventDefault(); // Moved up
			get_compare_dataexplorer_options();
			return false;

		});

	}








	if (document.getElementById("toggle_dataexplorer_graph_legend")) {

		document.getElementById("toggle_dataexplorer_graph_legend").addEventListener('click', function () {
			toggle_graph_legend(swanbot_dataexplorer_graph_id);
		});

	}

	if (document.getElementById("toggle_dataexplorer_graph_totals")) {

		document.getElementById("toggle_dataexplorer_graph_totals").addEventListener('click', function () {
			display_dataexplorer_totals();
		});

	}



}



// Function to change the hovertemplate for all traces

/* extracted setAllHoverTemplates */


// Function to restore the original hovertemplate for all traces

/* extracted restoreAllOriginalTemplates */




/* extracted swanbot_load_subgroup */




/* extracted swanbot_toggle_graphgroup */




function isNotEmpty(obj) {
	return Object.keys(obj).length !== 0;
}



/* extracted getDatesBetween */




/* extracted formatDate */




/* extracted create_dataexplorer_graph */





/* extracted draw_date_row_events */




/* extracted draw_date_row */






/* extracted swanbot_input_disabled */



/* extracted swanbot_input_enabled */


let swanbot_dataexplorer_admin_clickhandler = function () { event.preventDefault(); };
let swanbot_dataexplorer_datepicker_null_clickhandler = function () { event.preventDefault(); };


/* extracted swanbot_dataexplorer_input_disabled */



/* extracted swanbot_dataexplorer_input_enabled */



window.add_swan_chat = async function(content, speed, speaker = "swanbot") {
	let container = document.getElementById("swanbot_chat_container");
	swanbot_input_disabled();


	if (!container) {
		console.error("Error: swanbot_chat_container element not found!");
		return;
	}

	var div = document.createElement('div');
	if (speaker == "swanbot") {
		div.setAttribute('class', 'swantbot-text-entry');
	} else if (speaker == "plot") {
		div.setAttribute('class', 'swantbot-text-plot');
	} else if (speaker == "plotsection") {
		div.setAttribute('class', 'swantbot-text-plotsection');
	} else {
		div.setAttribute('class', 'swantbot-text-question');
	}
	div.setAttribute("id", "swanbot_modal_" + Date.now());
	container.appendChild(div);

	if (speed > 0) {
		await typeWriterEffectHTML(div, content, speed);
		div.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });

	} else {
		await addChatNoEffectHTML(div, content);
		div.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
	}

	swanbot_input_enabled();
}



async function remove_swan_loading() {
	let swanbot_loader = document.getElementById("swanbot_loading");

	if (swanbot_loader) {
		swanbot_loader.remove();
	} else {
		console.log("no swanbot_loading");
	}
}

async function add_swan_loading(swanbot_container_id) {
	let container = document.getElementById(swanbot_container_id);

	if (!container) {
		console.error("Error: swanbot_chat_container element not found!");
		return;
	}

	let swanbot_loader = document.getElementById("swanbot_loading");

	if (swanbot_loader) {
		console.log("swanbot_loader already running");
	} else {
		swanbot_loader = document.createElement('div');
		swanbot_loader.setAttribute('class', 'swanbot_loading');
		swanbot_loader.setAttribute("id", "swanbot_loading");
		swanbot_loader_spinner = document.createElement('i');
		swanbot_loader_spinner.setAttribute('class', 'swanbot_loading_spinner');
		swanbot_loader_spinner.setAttribute("id", "swanbot_loading_spinner");
		swanbot_loader.appendChild(swanbot_loader_spinner);
		swanbot_loader_status = document.createElement('span');
		swanbot_loader_status.setAttribute('class', 'swanbot_loading_status');
		swanbot_loader_status.setAttribute("id", "swanbot_loading_status");
		swanbot_loader.appendChild(swanbot_loader_status);
		container.appendChild(swanbot_loader);
	}


	setTimeout(function () {
		let swanbot_loader = document.getElementById("swanbot_loading");

		if (swanbot_loader) {
			swanbot_loader.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
		} else {
			console.log("cannot scroll to loader")
		}

	}, 100)



}


function getScreen(evt) {

	if ($(".canvas-body").length > 0) {
		$(".canvas-body").empty();
	}
	/*       scale: 0.5, */
	html2canvas(document.getElementById("social_capture_area"), {
		width: document.getElementById('social_capture_area').offsetWidth,
		height: document.getElementById('social_capture_area').offsetHeight,
		scale: 1,
		useCORS: true,
		allowTaint: false
	})
		.then(function (c) {
			if ($("#snapshot_modal").length == 0) {

				var div = document.createElement('div');
				div.setAttribute('class', 'modal');
				div.setAttribute('role', 'dialog');
				div.setAttribute("id", "snapshot_modal");
				div.innerHTML = `



			  <div class="modal-dialog">
			    <div class="modal-content">
			      <div class="modal-header">
			        <h1 class="modal-title fs-5" id="exampleModalLabel">Attach a Screenshot</h1>
			      </div>
			      <div class="modal-body">
			      	<div class="row">
				      	<div class="social-comment col-12">
				      		<div class="social-label">Use the markup tools to add notes and draw attention to areas of the Event Timeline that you wish to highlight.</div>

							<div class="canvas-body"></div>
						</div>
			        </div>

			      </div>
			      <div class="modal-footer">
			      	<div>
				        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
				        <button type="button" class="btn btn-primary" id="sendnotification" data-sendid="" onclick="save_comment();">Attach</button>
				    </div>
			      </div>
			    </div>
			  </div>
			`;
				document.getElementsByClassName('body')[0].appendChild(div);

			}

			$("#sendnotification").data("sendid", actionid);

			//$("#main-scrim").show();
			$("#snapshot_modal").modal('show');


			$(".notify-comments").val("");

			document.getElementsByClassName("canvas-body")[0].appendChild(c);


			const canvas = document.querySelector(".canvas-body canvas")
			const canvasImg = canvas.toDataURL();

			var elem = document.createElement("img");
			//elem.setAttribute("height", "768");
			//elem.setAttribute("width", "1024");

			document.getElementsByClassName("canvas-body")[0].appendChild(elem);
			const cimg = document.querySelector(".canvas-body img")
			canvas.remove();

			cimg.setAttribute("src", canvasImg)

			markerArea = new markerjs2.MarkerArea(document.querySelector('.canvas-body img'));
			let targetRoot = document.querySelector('.canvas-body img').parentElement;
			markerArea.targetRoot = targetRoot;
			markerArea.availableMarkerTypes = [markerjs2.HighlightMarker, markerjs2.TextMarker, markerjs2.ArrowMarker, markerjs2.CalloutMarker];
			markerArea.settings.defaultColor = 'red';
			markerArea.settings.defaultStrokeWidth = 5;
			markerArea.settings.resultButtonBlockVisible = false;

			markerArea.addRenderEventListener(dataUrl => {
				// we are setting the markup result to replace our original image on the page
				// but you can set a different image or upload it to your server
				markup_save_callback(dataUrl);
			});

			/*
			markerArea.addEventListener(
			  "render",
			  (event) => (
	
					document.querySelector('.canvas-body img').src = event.dataUrl
					markup_save_callback();
	
					)
			);
			*/

			markerArea.show();


		});

}




function markup_save_callback(imgDataFromCallback) {

	let imgData = imgDataFromCallback; //document.querySelector(".canvas-body img").src; //toDataURL("image/png");

	attachedimg = imgData
	let notifyComments = document.querySelector("#new_comment_attachment");
	notifyComments.innerHTML = "<button class='btn btn-link'><span class='screenshot'><i class='screenshot-icon'></i>Screenshot Attached</span></button>";




	$("#snapshot_modal").modal('hide');
	document.getElementById("details-new-interaction").classList.add("btn-hide");


}


/*

function do_save_comment() {
		let notifyComments = document.querySelector(".notify-comments").value;

		let metaRangeStart = document.querySelector("#detail_date_start").value;
		let metaRangeEnd = document.querySelector("#detail_date_end").value;
		let metaOutage = "*Comment:* " + actionid;
		let watchers_list = []

		let formData = new FormData();
		if (attachedimg) {
			formData.append('canvas', imgData);
		}
		formData.append('outagemeta', metaOutage);
		formData.append('outagerangestart', metaRangeStart);
		formData.append('outagerangeend', metaRangeEnd);
		formData.append('comment', notifyComments);
		formData.append('watchers', watchers_list);


		var jsondata = JSON.stringify({ "comment": notifyComments });




		res = axios.post('/apiurl/' + actionid,
		  jsondata, {
			headers: {
			  'Content-Type': 'application/json'
			}
		  }
		).then(response => {
		  console.log(response);
		})
		.catch(error => {
		  console.log(error);
		});
}

*/


function save_comment() {

	// render comments
	markerArea.startRenderAndClose();

}




function clean_popovers() {
	//clean up unused popups
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[aria-describedby]'))
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		var popo = popoverTriggerEl.getAttribute("aria-describedby");
		if (popo.indexOf("popover") >= 0) {
			var popoh = document.getElementById(popo);
			var popoh_e = popoh.querySelectorAll("#event_details");
			if (popoh_e.length == 0) {
				console.log("trying to hide the following popup", popoverTriggerEl)
				bootstrap.Popover.getInstance(popoverTriggerEl).hide();
			}
		}

	})
}


function close_all_popups(fromwhere) {
	console.log("close all open popups to preserve the modal", fromwhere)
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[aria-describedby]'))
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		var popo = popoverTriggerEl.getAttribute("aria-describedby");
		if (popo.indexOf("popover") >= 0) {
			bootstrap.Popover.getInstance(popoverTriggerEl).hide();
		}
	})

	return false;

}

function imageExists(image_url) {
	// deprecated

	var http = new XMLHttpRequest();

	http.open('HEAD', image_url, false);
	http.send();

	if (http.status == 200) {
		return true
	} else {
		return false
	}
	//return http.status != 404;

}



function create_card(args, inst) {
	//console.log("create card", args, inst);
	//close_all_popups("from card");


	setTimeout(function () {
		if (args.domEvent.target.parentElement.parentElement.attributes["aria-describedby"]) {
			window.populate_card(args, args.domEvent.target.parentElement.parentElement.attributes["aria-describedby"])
		} else {
			if (args.domEvent.target.parentElement.attributes["aria-describedby"]) {
				window.populate_card(args, args.domEvent.target.parentElement.attributes["aria-describedby"])
			} else {
				// pass
			}
		}
	}, 10)



}

window.populate_card = function(args, popoverid) {
	//var popoverid = popovertarget.nodeValue;
	var popoverobj = document.getElementById(popoverid);
	//console.log("got a popover")
	//console.log(popoverobj)
	var did = popoverobj.querySelector("#card-id");
	var drange = popoverobj.querySelector("#card-range");
	var ddrange = popoverobj.querySelector("#card-range-duration");
	var dlink = popoverobj.querySelector("#card-link");
	var dlinktitle = popoverobj.querySelector("#card-link-title");

	var dheatmap = popoverobj.querySelector("#card-heatmap");
	var dpriceline = popoverobj.querySelector("#card-priceline");

	var dtags = popoverobj.querySelector("#card-tags");
	var dnotes = popoverobj.querySelector("#class-text");
	var dclosecard = popoverobj.querySelector(".close-all-card");
	var ddetailslink = popoverobj.querySelector(".btn-details");


	var drootcause = popoverobj.querySelector("#card-root-cause");

	var cardlike = popoverobj.querySelector("#card-like-up");
	var carddislike = popoverobj.querySelector("#card-like-down");

	//make popoverconsole.log("make popover", args)
	var event_start = moment(args.event.start);
	var event_end = moment(args.event.end);
	var event_duration = args.event.event_duration_hours; //event_end.diff(event_start, 'hours')

	var event_heatmap = "/assets/img/heatmaps/event_processing.png";
	var heatmap_status = "pending";

	if (args.event.heatmap_status !== undefined) {
		heatmap_status = args.event.heatmap_status
	}

	if (args.event.cardpath !== undefined) {
		event_heatmap = args.event.cardpath;
		heatmap_status = "processed"
	}

	var event_priceline;
	if (args.event.cardpath_priceline !== undefined) {
		event_priceline = args.event.cardpath_priceline;
	}


	dclosecard.addEventListener("click", function (e) {
		window.WingmanState.tooltip.close();
		//close_all_popups("from close card event");
		e.preventDefault();
		return false;
	});


	ddetailslink.addEventListener("click", function (e) {
		open_event_details();
		e.preventDefault();
		return false;
	})

	//console.log('all rows found')
	//console.log(event_duration);
	//var event_duration = moment.duration(event_end.diff(event_start));
	//var event_duration_hours = event_duration.asHours();

	//console.log("does drange exist:", drange);

	if (drange !== null) {

		//console.log("-------")
		drange.innerHTML = event_start.format('LLL') + " to " + event_end.format('LLL');
		ddrange.innerHTML = "Event Duration: " + event_duration + " hours";
		did.innerHTML = "Event ID: " + args.event.id;
		let spani = document.createElement("span");
		spani.classList.add("copy_id_icon");
		spani.append(" ");
		did.append(spani);

		did.dataset.eventID = args.event.id;

		new ClipboardJS(did, {
			text: function (trigger) {
				const cardid_obj = document.querySelector("#card-id");
				const cardid = cardid_obj.dataset.eventID;
				display_toast("Copied ID: " + cardid + " to your clipboard", mdtoast.INFO);
				//trigger.style.backgroundColor = "#a8f1a8";
				return cardid;
			}
		});
		active_event_track = args.event.id;
		dlinktitle.innerHTML = "Event Details"; // (" + active_event_track + ")";
		// dlink.href="/details" in popup handler
		//console.log("event img", event_heatmap)
		dheatmap.src = event_heatmap;

		if (event_priceline) {
			dpriceline.classList.remove("btn-hide");
			dpriceline.src = event_priceline;
		} else {
			dpriceline.classList.add("btn-hide");
		}

		//console.log("args.event", args.event)
		add_tags = returnTag("resource", args.event.resource, args.event.type)
		if (args.event.tags) {
			let i = 0;
			while (i < args.event.tags.length) {
				add_tags = add_tags + returnTag("user", args.event.tags[i], args.event.type)
				i++;
			}
		}
		dtags.innerHTML = add_tags;

		add_filters = ""
		//console.log("args.event.filters", Object.keys(args.event.filters).length)

		if (args.event.filters) {
			let i = 0;
			while (i < Object.keys(args.event.filters).length) {
				//console.log("keys:", Object.keys(args.event.filters)[i])
				add_filters = add_filters + returnFilter("filter", Object.keys(args.event.filters)[i], Object.values(args.event.filters)[i])

				if (i + 1 < Object.keys(args.event.filters).length) {
					add_filters = add_filters + returnFilter("and", "AND", "")
				}

				i++;
			}
		}
		//console.log("filters", add_filters);
		drootcause.innerHTML = add_filters;


		dnotes.innerHTML = "";

		//console.log(args.event)
		if (args.event.resolvedNotes) {
			dnotes.innerHTML = "<div class='notes-container'><div class='notes-owner'>Swan Bot</div><div class='notes-date'>" + moment(args.event.resolvedNotes.createdOn).format("LLL") + "</div><div class='notes-note'><div class='notes-resolved'>Event was resolved by <span class='notes-resolved-inline-hilight'>" + args.event.resolvedNotes.createdBy + "</span> on <span class='notes-resolved-inline-hilight'>" + moment(args.event.resolvedNotes.createdOn).format("LLL") + "</span>.</div><br/>" + args.event.resolvedNotes.note + "</div></div>";
			//popoverobj.querySelector("#dashboard-resolve-button").style.display = "none";
		} else {
			//popoverobj.querySelector("#dashboard-resolve-button").style.display = "block";
		}


		if (args.event.newNotes) {
			dnotes.innerHTML = "<div class='notes-container'><div class='notes-owner'>" + args.event.newNotes.createdBy + "</div><div class='notes-date'>" + moment(args.event.newNotes.createdOn).format("LLL") + "</div><div class='notes-note'><br/>" + args.event.newNotes.note + "</div></div>";
		}


		if (heatmap_status !== "processed") {
			dlink.style.display = "none";
			cardlike.style.display = "none";
			carddislike.style.display = "none";
		} else {
			dlink.style.display = "block";
			dheatmap.addEventListener("click", function (e) {
				open_event_details();
				e.preventDefault();
				return false;
			})

			if (args.event.likestatus) {
				draw_likes(popoverobj, args.event.likestatus);
			} else {
				cardlike.classList.remove("btn-like-unselected")
				cardlike.classList.remove("btn-like-selected")
				cardlike.classList.remove("btn-like")
				cardlike.classList.add("btn-like")
				carddislike.classList.remove("btn-unlike-selected")
				carddislike.classList.remove("btn-unlike-unselected")
				carddislike.classList.remove("btn-unlike")
				carddislike.classList.add("btn-unlike")
			}


			cardlike.addEventListener("click", function (e) {
				update_likes(popoverobj, "like", active_event_track);
				e.preventDefault();
				return false;
			})

			carddislike.addEventListener("click", function (e) {
				update_likes(popoverobj, "dislike", active_event_track);
				e.preventDefault();
				return false;
			})

		}




	}

	//console.log("window.WingmanState.tooltip set options ", args.domEvent.target);

	window.WingmanState.tooltip.setOptions({ anchor: args.domEvent.target });
	window.WingmanState.tooltip.open();
}

function update_likes(popoverobj, likeval, eventid) {
	var updatestatus = false;
	var update_json = {};
	update_json["likestatus"] = likeval;

	var jsondata = JSON.stringify(update_json);

	//console.log("put", jsondata)

	res = axios.put('/xapi/event/' + eventid,
		jsondata, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		//console.log(response);	 
		updatestatus = true;
		draw_likes(popoverobj, likeval);
		args_handle.event.likestatus = likeval;
	})
		.catch(error => {
			//console.log(error);
		});

	return updatestatus;

}

function draw_likes(popoverobj, likestatus) {
	var cardlike = popoverobj.querySelector("#card-like-up");
	var carddislike = popoverobj.querySelector("#card-like-down");

	if (likestatus == "like") {
		cardlike.classList.remove("btn-like-unselected")
		cardlike.classList.remove("btn-like")
		cardlike.classList.add("btn-like-selected")
		carddislike.classList.remove("btn-unlike-selected")
		carddislike.classList.remove("btn-unlike")
		carddislike.classList.add("btn-unlike-unselected")
	}
	if (likestatus == "dislike") {
		cardlike.classList.remove("btn-like-selected")
		cardlike.classList.remove("btn-like")
		cardlike.classList.add("btn-like-unselected")
		carddislike.classList.remove("btn-unlike-unselected")
		carddislike.classList.remove("btn-unlike")
		carddislike.classList.add("btn-unlike-selected")
	}
}

window.make_dashboard = function() {
	dashboardPage.refresh({ rebuild: true });
}


function filter_dashboard(_args) {
	let args = Array.from(arguments);
	//console.log("filter_dashboard args", args)

	cat_filters = args[0];
	//console.log("category filters", cat_filters);

	advanced_filters = args[1];
	//console.log("advanced filters", advanced_filters);


	//console.log(calOptions);
	if (window.WingmanState.customer_events) {
		//console.log("no need to get window.WingmanState.customer_events_categories, already exists in filter_dashboard clientside callback")
	} else {
		window.updateCustomerEventCats();
	}


	let get_resources = window.get_resources_by_event_types(window.WingmanState.customer_events, cat_filters)



	load_events("", advanced_filters);

	// update the data


	//console.log("window.WingmanState.eventcalendarObj", window.WingmanState.eventcalendarObj);
	if (window.WingmanState.eventcalendarObj) {
		window.WingmanState.eventcalendarObj.setOptions({
			resources: get_resources,
		});
	}

}

function make_limbo() {
	gridOptions = {

		columnDefs: [
			{
				headerName: 'ID',
				field: 'id',
				width: 140,
				suppressSizeToFit: true
			},
			{
				suppressNavigable: true,
				cellClass: 'no-border',
				headerName: 'Open',
				width: 160,
				colId: 'gen_launch',
				title: 'Open',
				valueGetter: 'data.id',
				cellRenderer: OpenLinkCellRenderer,
				cellRendererParams: {
					clicked: function (field) {
						console.log("field clicked", field);
					}
				}
			},
			{
				headerName: 'Customer ID',
				field: "customer_id",
				resizable: true,
				width: 100,
				suppressSizeToFit: true,
				editable: true
			},
			{
				headerName: 'Name',
				field: "name",
				resizable: true,
				width: 200,
				suppressSizeToFit: true,
				editable: true
			},
			{
				headerName: 'Status',
				field: "status",
				resizable: true,
				width: 100,
				suppressSizeToFit: true,
				editable: true,
				cellEditorSelector: cellEditorSelector
			},
			{
				headerName: 'Disposition',
				field: "disposition",
				resizable: true,
				width: 100,
				suppressSizeToFit: true,
				editable: true,
				cellEditorSelector: cellEditorSelector
			},
			{
				headerName: 'Finder',
				field: "finder",
				resizable: true,
				width: 100, suppressSizeToFit: true
			},
			{
				headerName: 'Start',
				field: "ts_start",
				resizable: true,
				width: 200, suppressSizeToFit: true
			},
			{
				headerName: 'End',
				field: "ts_end",
				resizable: true,
				sort: 'desc',
				width: 200, suppressSizeToFit: true
			},
			{
				headerName: 'Days',
				field: "event_duration_day",
				resizable: true,
				width: 100, suppressSizeToFit: true
			},
			{
				headerName: 'Type',
				field: "type",
				resizable: true,
				width: 100,
				editable: true,
				cellEditorSelector: cellEditorSelector
			},
			{
				headerName: 'RCA',
				field: "rca",
				resizable: true,
				width: 100
			},
			{
				headerName: 'AD',
				field: "ad",
				resizable: true,
				width: 100
			},
			{
				headerName: 'Tags',
				field: 'tags',
				valueFormatter: listFormatter,
				resizable: true
			},
			{
				headerName: 'Filters',
				field: 'filters',
				valueFormatter: dictFormatter,
				resizable: true
			},
			{
				headerName: 'Clusters',
				field: 'clusters',
				valueFormatter: objectFormatter,
				resizable: true
			},
			{
				headerName: 'Last Updated',
				field: 'last_updated',
				resizable: true
			},
			{
				headerName: 'HM Version',
				field: 'heatmap_version',
				resizable: true
			},
			{
				headerName: "Heatmap",
				field: "heatmap_start",
				width: 100,
				hide: true,
				suppressToolPanel: true
			},
			{
				headerName: 'Heatmap',
				colId: 'gen_heatmap',
				title: 'Heatmap',
				valueGetter: 'data.customer_id + /heatmap/ + data.id',
				cellRenderer: HeatmapCellRenderer,
				cellRendererParams: {
					clicked: function (field) {
						console.log("field clicked", field);
					}
				}
			},
			{
				headerName: 'Card',
				colId: 'gen_card',
				title: 'Card',
				valueGetter: HeatmapCardValueGetter, //'data.customer_id + /heatmap/card/ + data.id',
				cellRenderer: HeatmapCardCellRenderer,
				cellRendererParams: {
					clicked: function (field) {
						console.log("field clicked", field);
					}
				}
			},
			{
				headerName: 'Rowdata',
				colId: 'cardpath',
				width: 100,
				cellRenderer: (params) => '<img style="height: 40px; width: 40px" src=' + params.data.cardpath + ' />',
				resizable: true
			},
			{
				headerName: 'Priceline',
				colId: 'cardpath_priceline',
				width: 100,
				cellRenderer: (params) => '<img style="height: 40px; width: 40px" src=' + params.data.cardpath_priceline + ' />',
				resizable: true
			}
		],

		defaultColDef: { sortable: true, filter: true },
		domLayout: 'autoHeight',
		pagination: true,
		paginationPageSize: 50,
		rowSelection: 'multiple',
		animateRows: true,
		cellFlashDelay: 2000,

		onCellClicked: params => {
			console.log('cell was clicked', params)
		},

		onFirstDataRendered: (params) => {
			//console.log("data rendered", params);
			dynSizeToFit(gridOptions);
		},
		onRowEditingStarted: (event) => {
			console.log('never called - not doing row editing');
		},
		onRowEditingStopped: (event) => {
			console.log('never called - not doing row editing');
		},
		onCellEditingStarted: (event) => {
			console.log('cellEditingStarted');
		},
		onCellEditingStopped: (event) => {
			console.log('cellEditingStopped');
			if (event.valueChanged) {
				console.log(event, event.data.id, event.column.colId, event.newValue);
				var updateid = event.column.colId;
				var updateval = event.newValue
				var update_json = {};
				update_json[updateid] = updateval;

				var jsondata = JSON.stringify(update_json);

				console.log("put", jsondata)

				res = axios.put('/xapi/event/' + event.data.id,
					jsondata, {
					headers: {
						'Content-Type': 'application/json'
					}
				}
				).then(response => {
					console.log(response);
					var rowNode = gridOptions.api.getDisplayedRowAtIndex(event.rowIndex);
					rowNode.setDataValue('last_updated', response.data.msg);
					gridOptions.api.flashCells({ rowNodes: [rowNode], columns: [event.column.colId, "last_updated"] });

				})
					.catch(error => {
						console.log(error);
					});

			}
		},
	};

	const eGridDiv = document.getElementById("eventlimbo");
	gridObj = new agGrid.Grid(eGridDiv, gridOptions);




	get_limbo_data();
}




function get_limbo_data() {
	fetch("/xapi/events")
		.then(response => response.json())
		.then(data => {
			gridOptions.api.setRowData(data.events);
		});
}




function cellEditorSelector(params) {

	console.log("cellEditorSelector", params);

	if (params.column.colId === 'status') {
		return {
			component: 'agSelectCellEditor',
			params: {
				values: ['active', 'disabled', 'archived', 'draft'],
			},
			popup: false,
			popupPosition: 'over'
		};
	}

	if (params.column.colId === 'type') {
		return {
			component: 'agSelectCellEditor',
			params: {
				values: ['LC', 'SP', 'Misc', 'IS'],
			},
			popup: false,
			popupPosition: 'over'
		};
	}

	if (params.column.colId === 'disposition') {
		return {
			component: 'agSelectCellEditor',
			params: {
				values: ['normal', 'resolved', 'new', 'hot'],
			},
			popup: false,
			popupPosition: 'over'
		};
	}
	return undefined;
}

const updateHeatmap = function (url, eventdata, paramsdata) {
	axios.get('/xapi/' + url)
		.then(response => {
			//console.log(response);
			console.log(paramsdata)
			if (response.data.status == "success") {
				var rowNode = gridOptions.api.getDisplayedRowAtIndex(paramsdata.rowIndex);
				rowNode.setDataValue('last_updated', "updated heatmap object");
				gridOptions.api.flashCells({ rowNodes: [rowNode], columns: [paramsdata.column.colId, "last_updated"] });
				console.log("success", response.data.msg)

			} else {
				var rowNode = gridOptions.api.getDisplayedRowAtIndex(paramsdata.rowIndex);
				rowNode.setDataValue('last_updated', "error generating");
				gridOptions.api.flashCells({ rowNodes: [rowNode], columns: [paramsdata.column.colId, "last_updated"] });
				console.log("error", response.data.msg)
			}
		})
		.catch(error => {

		});
};





function make_digest(args) {

	console.log("args[0]", args[0].length > 0)
	if (digestGridOptions) {
		console.log("digestGridOptions exists")

	} else {

		if (args[0].length > 0) {

			console.log("digestGridOptions is empty, lets popuplate")
			digestGridOptions = {

				columnDefs: [
					{
						headerName: 'ID',
						field: 'id',
						width: 120,
						suppressSizeToFit: true
					},
					{
						suppressNavigable: true,
						cellClass: 'no-border',
						headerName: 'Open',
						width: 120,
						suppressSizeToFit: true,
						colId: 'gen_launch',
						title: 'Open',
						valueGetter: 'data.id',
						cellRenderer: OpenLinkCellRenderer,
						cellRendererParams: {
							clicked: function (field) {
								//console.log("field clicked", field);
							}
						}
					},
					{
						headerName: 'Name',
						field: "name",
						width: 200,
						suppressSizeToFit: false
					},
					{
						headerName: 'Status',
						field: "status",
						width: 100,
						suppressSizeToFit: true
					},
					{
						headerName: 'Start',
						field: "ts_start",
						width: 175,
						suppressSizeToFit: true
					},
					{
						headerName: 'End',
						field: "ts_end",
						width: 175,
						suppressSizeToFit: true
					},
					{
						headerName: 'Type',
						field: "type",
						width: 175,
						suppressSizeToFit: true
					},
					{
						headerName: 'Tags',
						field: 'tags',
						width: 100,
						suppressSizeToFit: true,
						valueFormatter: listFormatter,
					},
					{
						headerName: 'Filters',
						field: 'filters',
						width: 100,
						suppressSizeToFit: true,
						valueFormatter: dictFormatter,
					},
					{
						headerName: 'Clusters',
						field: 'clusters',
						width: 100,
						suppressSizeToFit: true,
						valueFormatter: objectFormatter,
					},
					{
						headerName: 'Last Updated',
						field: 'last_updated',
						suppressSizeToFit: true,
						width: 175
					},
					{
						headerName: 'Swanbot Comment',
						field: 'swancomment',
						suppressSizeToFit: true,
						width: 100,
						cellRenderer: (params) => {
							return params.value ? '<span title="' + params.value + '">💬</span>' : '';
						}
					},
					{
						headerName: 'Rowdata',
						colId: 'cardpath',
						width: 100,
						suppressSizeToFit: true,
						cellRenderer: (params) => '<img style="height: 40px; width: 40px" src=' + params.data.cardpath + ' />',
					},
					{
						headerName: 'Priceline',
						colId: 'cardpath_priceline',
						width: 100,
						suppressSizeToFit: true,
						cellRenderer: (params) => '<img style="height: 40px; width: 40px" src=' + params.data.cardpath_priceline + ' />',
					},
					{
						headerName: "cause",
						field: "cause",
						width: 0,
						hide: true,
						suppressToolPanel: true
					},
					{
						headerName: "display_tags",
						field: "display_tags",
						width: 0,
						hide: true,
						suppressToolPanel: true
					},
					{
						headerName: "event_daterange",
						field: "event_daterange",
						width: 0,
						hide: true,
						suppressToolPanel: true
					},
					{
						headerName: "event_type",
						field: "event_type",
						width: 0,
						hide: true,
						suppressToolPanel: true
					},
					{
						headerName: "event_color",
						field: "event_color",
						width: 0,
						hide: true,
						suppressToolPanel: true
					},

				],

				defaultColDef: { sortable: false, filter: false, suppressMovable: true },
				domLayout: 'autoHeight',
				pagination: false,
				animateRows: false,
				cellFlashDelay: 2000,

				onCellClicked: params => {
					console.log('cell was clicked', params)
				},

				onFirstDataRendered: (params) => {
					//console.log("data rendered", params);
					dynSizeToFit(digestGridOptions);
				},
				onRowEditingStarted: (event) => {
					console.log('never called - not doing row editing');
				},
				onRowEditingStopped: (event) => {
					console.log('never called - not doing row editing');
				},
				onCellEditingStarted: (event) => {
					console.log('cellEditingStarted');
				},
				onCellEditingStopped: (event) => {
					console.log('cellEditingStopped');
				},
			};


			const digestGridDiv = document.getElementById("daily_digest_data_table");
			digestGridObj = new agGrid.Grid(digestGridDiv, digestGridOptions);
			console.log("digestGridOptions created", digestGridOptions)
		}


	}

	if (digestGridOptions) {

		//console.log("args", args)
		//console.log("digestGridOptions", digestGridOptions);
		//console.log("this value", args[0])

		digestGridOptions.api.setRowData(args[0]);
	}


}


window.get_resources_by_event_types = function (event_types, filter = null) {

	let all_event_cats = []
	let skipcat = false;
	for (let event in event_types) {
		skipcat = false;
		if (filter) {
			if (!filter.includes(event)) {
				skipcat = true;
			}
		}
		let new_event = {}
		if (!skipcat) {
			new_event["id"] = event_types[event].rank;
			new_event["category"] = event;
			new_event["name"] = event_types[event].display_name;
			new_event["color"] = event_types[event].color;
			new_event["title"] = event_types[event].description;
			new_event["img"] = event_types[event].icon;
			all_event_cats.push(new_event);
		}
	}

	return all_event_cats;

}


window.updateCustomerEventCats = function () {

	//console.log("get updateCustomerEventCats")
	window.WingmanState.customer_events = JSON.parse(document.getElementById('event_cats').value);
	//console.log("window.WingmanState.customer_events", window.WingmanState.customer_events)
	/*
	axios.get('/xapi/events/cats')
	.then(response => {
		if (response.data.status == "success") {
			window.WingmanState.customer_events = response.data.event_types;
			console.log("window.WingmanState.customer_events success", response.data.msg)
		} else {
			console.log("window.WingmanState.customer_events error", response.data.msg)
		}
	})
	.catch(error => {
		console.log("window.WingmanState.customer_events error getting event cats");
	});
	*/

};



function make_dataexplorer(_args) {
	if (window.swanbot_dataexplorer_blocked) {
		console.log("make_dataexplorer blocked by initial modal");
		return;
	}

	//console.log("------  make_dataexplorer  -----------", arguments)


	let args = Array.from(arguments);

	swanbot_dataexplorer_session = ""

	//console.log("make_dataexplorer args", args)



	//if (!already_loaded.includes(page_type)) {
	//	console.log("init those fields")
	dataexplorer_swanbot_input_init();
	//    already_loaded.push(page_type);
	//} else {
	//	console.log("no need to init")
	//}



	getDates();

	getSubgroupCache();


	setTimeout(function () {
		if (de_loading_events == false) {

			de_loading_events = true;


			window.WingmanState.swanbot_dataexplorer_processing_compare_type = "";
			swanbot_dataexplorer_compare_types = "";

			//window.WingmanState.swanbot_dataexplorer_graphdata = {"graphs": [], "graphs_compare": "", "filters": [], "output": "", "maingraphTitles": [], "maingraphIndex": {}, "subgraphGroupData": [],  "subgraphs_compare": "", "subgraphGroupTitles": [], "subgraphGroupIndex": {}, "subgraphGroupDimensions" : "", "focus": {}, "axis_types": {}}




			//console.log("deferred call into clientside event - debounce this");


			async function sendMessageSequence() {
				try {
					de_loading_events = true;
					const message = "Heading to the lake to get you a swan for this date range. Hold on a honk ..."
					await load_explorer_swanbot_key(); // Ensure key is loaded before proceeding
					await make_dataexplorer_agents();
					renderDataExplorerEventsWaitingState();
					await preload_dataexplorer_graph();
					await send_dataexplorer_results(message, "swanbot_start", 0);
					await load_explorer_swanbot();
					await load_explorer_swanbot("graphTypes")
					await load_explorer_swanbot("graphData")
					await fade_dataexplorer_graph();
					await make_dataexplorer_events();
					await make_dataexplorer_graph();
					await complete_dataexplorer_init();
				} catch (error) {
					de_loading_events = false;
					console.error("Data explorer sequence failed:", error);
					const loaderTitle = document.querySelector('.dataexplorer_loader_container h4');
					if (loaderTitle) {
						loaderTitle.textContent = "Error Loading Transactions Explorer";
						loaderTitle.classList.replace("text-gray-700", "text-red-600");
					}
					const skeletonLoader = document.getElementById('dataexplorer_loader_skeletonLoader');
					if (skeletonLoader) {
						skeletonLoader.innerHTML = `
                            <div class="flex flex-col items-center justify-center w-full h-full text-center bg-gray-100" style="min-height: 300px;">
                                <div class="text-red-500 mb-4 font-semibold text-lg max-w-sm mx-auto leading-snug">
                                    An error occurred while connecting to Swanbot.
                                </div>
                                <button id="dataexplorer_retry_button" class="btn btn-primary px-6 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition cursor-pointer shadow-sm mx-auto mt-2 flex items-center justify-center">
                                    <i class="fas fa-redo" style="margin-right: 10px;"></i>Retry
                                </button>
                            </div>
                        `;
						const retryBtn = document.getElementById("dataexplorer_retry_button");
						if (retryBtn) {
							retryBtn.addEventListener("click", function() {
								sendMessageSequence();
							});
						}
					}
				}
			}
			sendMessageSequence();


			// setTimeout(function() {
			// 	de_loading_events = false;
			// }, 400)


		}

	}, 200)
}




function make_dataexplorer_start_selected(_args) {
	//console.log("------  make_dataexplorer_start_selected  -----------", arguments)
	let args = Array.from(arguments);

	let over15dayalert = args[0]

	if (over15dayalert == "over15") {

		let over15exists = document.getElementById("daypicker15warn");
		if (over15exists) {
			// pass
		} else {

			let over15warningdiv = document.querySelector(".DayPicker_focusRegion > div:last-child")
			var over15warningdiv_div = document.createElement("div");
			over15warningdiv_div.setAttribute("id", "daypicker15warn");
			over15warningdiv_div.innerHTML = "You must pick an end date less than 14 days after the start date";
			over15warningdiv.appendChild(over15warningdiv_div)

		}



		//  async function sendMessageSequence() {
		// 	const message = "Please pick a date less than 14 days after the start date."
		// 	await send_dataexplorer_results(message, "swanbot", 0);
		//  }

		// sendMessageSequence();

	} else {
		let over15exists = document.getElementById("daypicker15warn");
		if (over15exists) {
			over15exists.remove();
		}

	}



}



const OpenLinkCellRenderer = class {
	init(params) {
		this.params = params;

		this.eGui = document.createElement('button');
		this.eGui.innerHTML = this.params.colDef.title;
		this.eGui.classList.add("btn")
		this.eGui.classList.add("btn-sm")
		this.eGui.classList.add("btn-link")
		this.eGui.classList.add("btn-openevent")


		this.btnClickedHandler = this.btnClickedHandler.bind(this);
		this.eGui.addEventListener('click', this.btnClickedHandler);
	}

	getGui() {
		return this.eGui;
	}

	btnClickedHandler(event) {
		//console.log("event clicked", this.params.value)
		console.log('open this url', '/events/details?event=' + this.params.value)
		window.open('/events/details?event=' + this.params.value, "_blank");

		//updateHeatmap(this.params.value, event, this.params)
		this.params.clicked(this.params.value);
	}


	destroy() {
		this.eGui.removeEventListener('click', this.btnClickedHandler);
	}

}

const HeatmapCellRenderer = class {

	init(params) {
		this.params = params;

		this.eGui = document.createElement('button');
		this.eGui.innerHTML = this.params.colDef.title;
		this.eGui.classList.add("btn")
		this.eGui.classList.add("btn-secondary")
		this.eGui.classList.add("btn-sm")
		this.eGui.classList.add("btn-heatmap")

		if (this.params.data.heatmap_start !== undefined) {
			this.eGui.classList.add("btn-heatmap-okay")
		}

		this.btnClickedHandler = this.btnClickedHandler.bind(this);
		this.eGui.addEventListener('click', this.btnClickedHandler);
	}

	getGui() {
		return this.eGui;
	}

	btnClickedHandler(event) {
		//console.log("event clicked", this.params.value)
		console.log('get this url', '/xapi/' + this.params.value)
		updateHeatmap(this.params.value, event, this.params)
		this.params.clicked(this.params.value);
	}

	refresh() {
		console.log("refresh this column")

	}

	destroy() {
		this.eGui.removeEventListener('click', this.btnClickedHandler);
	}
}

const HeatmapCardValueGetter = function (params) {
	//console.log("heatmap ma", params)
	var heatmapurl = params.data.customer_id + '/heatmap/card/' + params.data.id;
	//.var total = params.getValue('total');
	return heatmapurl
};


const HeatmapCardCellRenderer = class {

	init(params) {
		this.params = params;

		this.eGui = document.createElement('button');
		this.eGui.innerHTML = this.params.colDef.title;
		this.eGui.classList.add("btn")
		this.eGui.classList.add("btn-secondary")
		this.eGui.classList.add("btn-sm")
		this.eGui.classList.add("btn-heatmapcard")


		this.btnClickedHandler = this.btnClickedHandler.bind(this);
		this.eGui.addEventListener('click', this.btnClickedHandler);
	}

	getGui() {
		return this.eGui;
	}

	btnClickedHandler(event) {
		//console.log("event clicked", this.params.value)
		console.log('get this url', '/xapi/' + this.params.value)
		updateHeatmap(this.params.value, event, this.params)
		this.params.clicked(this.params.value);
	}

	refresh() {
		console.log("refresh this column")

	}

	destroy() {
		this.eGui.removeEventListener('click', this.btnClickedHandler);
	}
}



function sizeToFit() {
	gridOptions.api.sizeColumnsToFit({
		defaultMinWidth: 100,
		columnLimits: [{ key: 'id', minWidth: 900 }],
	});
}

function dynSizeToFit(opt) {
	opt.api.sizeColumnsToFit({
		defaultMinWidth: 100,
		columnLimits: [{ key: 'id', minWidth: 900 }],
	});
}

function listFormatter(params) {
	return params.value.join(", ");
}

function commentFormatter(params) {
	if (typeof params.value !== 'undefined' && params.value !== null) {
		return "<span>💬</span>"
	} else {
		return ""
	}
}

function objectFormatter(params) {

	return params.value.length;

}

function dictFormatter(params) {
	return Object.keys(params.value).length
}


function add_social_channel() {
	social_channels = document.getElementById("social_channel");
	social_dropdown_container = document.getElementById("social_dropdown_container");
	var social_dropdown = document.createElement('select');
	social_dropdown.classList.add("social_dropdown");

	var opt = document.createElement('option');
	opt.value = "";
	opt.innerHTML = "select a channel / don't share";
	social_dropdown.appendChild(opt);

	axios.get('/xapi/slack/channels')
		.then(response => {
			// console.log(response);
			// console.log(response)

			if (response.data.status == "success") {
				channels = response.data.channels
				//console.log("channels", channels)
				for (let k in channels) {
					// console.log(k + ' is ' + channels[k].name_normalized)
					channel_mentions.push({ id: channels[k].id, value: channels[k].name_normalized })
					var opt = document.createElement('option');
					opt.value = channels[k].id;
					if (channels[k].selected == true) {
						opt.selected = 'selected'
					}
					opt.innerHTML = "#" + channels[k].name_normalized + " (" + channels[k].num_members + ")";
					social_dropdown.appendChild(opt);
				}
				// console.log("success", response.data.msg)

			} else {
				console.log("error", response.data.msg)
			}

			social_dropdown_container.appendChild(social_dropdown)
			social_channels.classList.remove("btn-hide");
		})
		.catch(error => {

		});
}





function get_social_mentions() {
	axios.get('/xapi/slack/users')
		.then(response => {
			console.log(response)

			if (response.data.status == "success") {
				members = response.data.members
				console.log("members", members)
				for (let k in members) {
					console.log(k + ' is ' + members[k].name)
					comment_mentions.push({ id: members[k].id, value: members[k].name })
				}
				console.log("success", response.data.msg)

			} else {
				console.log("error", response.data.msg)
			}

		})
		.catch(error => {

		});
}






function removeChildren(elementSelector) {
	if (!elementSelector) {
		console.warn("removeChildren: elementSelector is null or undefined. Exiting.");
		return;
	}

	let element;
	if (typeof elementSelector === 'string') {
		element = document.querySelector(elementSelector);
	} else if (elementSelector instanceof HTMLElement) {
		element = elementSelector;
	} else {
		console.error("removeChildren: elementSelector is not a valid type. Expected string or HTMLElement. Got:", typeof elementSelector);
	}

	if (!element) {
		console.warn("removeChildren: Element not found in the DOM.");
		return;
	}

	let child = element.firstElementChild;
	while (child) {
		child.remove();
		child = element.firstElementChild;
	}
}



function monitor_comment_save() {
	console.log("monitor_comment_save");
	save_comment_button = document.getElementById("details-save-comment")
	add_screenshot_button = document.getElementById("details-new-interaction")


	save_comment_button.addEventListener("click", function (e) {
		submit_comment();
		save_comment_button.setAttribute("disabled", "disabled")
		add_screenshot_button.setAttribute("disabled", "disabled")
		e.preventDefault();
		return false;
	});
}




function submit_comment() {
	//comment_contents = document.getElementById("details-save-comment")

	var updated_comment = comment_editor.getHtml();
	console.log("updated_comment", updated_comment)

	let actionid = document.querySelector("#detail_id").value;
	let loggedinid = document.querySelector("#loggedin_js").value;


	let select_channel = "";

	if (has_slack_service) {
		select_channel = document.querySelector(".social_dropdown").value;
	}





	postdata = {
		"createdby": loggedinid,
		"body": updated_comment,
		"channel": select_channel,
		"canvas": attachedimg
	}

	let comments_json = JSON.stringify(postdata);
	res = axios.post('/xapi/comment/' + actionid,
		comments_json, {
		headers: {
			'Content-Type': 'application/json'
		}
	}
	).then(response => {
		console.log(response);
		if (response.status == 200) {
			if (response.data.status == "success") {
				location.reload();
			} else {
				console.log("error saving")
			}
		} else {
			console.log("app fault")
		}
	})
		.catch(error => {
			console.log(error);
		});

	/*
	comment_editor.save().then((outputData) => {
	  console.log('Comment Data: ', outputData)
	}).catch((error) => {
	  console.log('Saving failed: ', error)
	});
	*/



}







function copyElementToClipboard(element) {
	window.getSelection().removeAllRanges();
	let range = document.createRange();
	range.selectNode(typeof element === 'string' ? document.getElementById(element) : element);
	window.getSelection().addRange(range);
	document.execCommand('copy');
	window.getSelection().removeAllRanges();
}



window.add_comment = function() {
	var base_com = document.getElementById("details-notes-area")

	if (base_com.getElementsByClassName("no-comments").length >= 1) {
		base_com.getElementsByClassName("no-comments")[0].style.display = "none"
	}

	if (document.getElementById("social_channel")) {
		has_slack_service = true;
	}


	var new_comment_div = document.createElement("div");
	new_comment_div.setAttribute("id", "new_comments");

	//var new_comment_from = document.createElement("div");
	//new_comment_from.setAttribute("id", "new_comment_author");

	var new_comment_attachment = document.createElement("div");
	new_comment_attachment.setAttribute("id", "new_comment_attachment");

	prependChild(base_com, new_comment_attachment);
	//prependChild(base_com, new_comment_from);
	prependChild(base_com, new_comment_div);

	if (has_slack_service) {
		get_social_mentions();
	}


	var toolbarOptions = ['bold', 'italic', 'underline', 'strike'];


	comment_editor = new Quill('#new_comments', {
		theme: 'snow',
		placeholder: 'Jack found one morning, as I have been told, His goose had laid him an egg of pure gold!',
		modules: {
			toolbar: toolbarOptions,
			mention: {
				allowedChars: /^[A-Za-z\s]*$/,
				mentionDenotationChars: ["@", "#"],
				source: function (searchTerm, renderList, mentionChar) {

					if (has_slack_service) {

						let values;

						if (mentionChar === "@") {
							values = comment_mentions;
						} else {
							values = channel_mentions;
						}

						if (searchTerm.length === 0) {

							renderList(values, searchTerm);

						} else {

							const matches = [];
							for (i = 0; i < values.length; i++)
								if (
									~values[i].value
										.toLowerCase()
										.indexOf(searchTerm.toLowerCase())
								)
									matches.push(values[i]);
							renderList(matches, searchTerm);
						}
					}
				}
			}
		}
	});

	/*
	comment_editor = new EditorJS({
	  holder : 'new_comments',
	  autofocus: true,
	  logLevel: 'VERBOSE',
	  inlineToolbar: ['marker', 'bold', 'italic'],
	  minHeight : 0,
	  placeholder: 'Jack found one morning, as I have been told, His goose had laid him an egg of pure gold!',
	  data: {}
	});

	comment_editor.isReady
	  .then(() => {
			comment_editor.blocks.render({});
		document.getElementById("details-new-interaction").classList.remove("btn-hide");
		document.getElementById("details-save-comment").classList.remove("btn-hide");
		document.getElementById("details-new-comment").classList.add("btn-hide");
		monitor_comment_save();
	  })
	  .catch((reason) => {
		console.log(`comment_editor initialization failed because of ${reason}`)
	  });

	*/
	document.getElementById("details-new-interaction").classList.remove("btn-hide");
	document.getElementById("details-save-comment").classList.remove("btn-hide");
	document.getElementById("details-new-comment").classList.add("btn-hide");
	monitor_comment_save();
	if (has_slack_service) {
		add_social_channel();
	} else {
		document.getElementById("social_channel_missing").classList.remove("btn-hide");
	}

}


function delete_comment(comment_id) {
	console.log("delete", comment_id)

	res = axios.delete('/xapi/comments/' + comment_id)
		.then(response => {
			console.log(response);
			location.reload();
		})
		.catch(error => {
			console.log(error);
		});
}



function getContrastColor(bgColor) {
	// Convert hex color to RGB values
	const rgb = hexToRgb(bgColor);

	// Calculate luminance using the formula
	const luminance = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;

	// Return black or white depending on luminance
	return luminance > 186 ? "black" : "white";
}

function hexToRgb(hex) {
	// Remove the # if present
	hex = hex.replace("#", "");

	// Convert hex to decimal RGB values
	const r = parseInt(hex.substr(0, 2), 16);
	const g = parseInt(hex.substr(2, 2), 16);
	const b = parseInt(hex.substr(4, 2), 16);

	return { r, g, b };
}




window.dash_clientside.clientside = {
	update_daterange: function () {
		//console.log("--------------- update_daterange ---------------")
		//console.log(arguments)
		//console.log("update dashboard from update_daterange clientside callback", arguments)
		make_dashboard(arguments)
		return window.dash_clientside.no_update
	},
	update_filters: function () {
		//console.log("--------------- update_filters ---------------")
		//console.log(arguments)
		//console.log("update dashboard from update_filters clientside callback", arguments)
		filter_dashboard(arguments)

		return window.dash_clientside.no_update
	},
	update_limbo: function () {
		//console.log("update_limbo");
		make_limbo();
	},
	update_digest: function () {
		//console.log("update_digest");
		//console.log("arguments", arguments)
		digest_events = arguments;
		window.WingmanState.tooltiptimer = setTimeout(function () {
			make_digest(digest_events);
		}, 1100);
		return true;
	},
	update_timezone_value: function () {
		//console.log("--------------- update_timezone_value ---------------")
		//console.log("update dashboard from timezone_change", arguments)
		change_event_timezone(arguments)
	},
	add_comment: function () {
		//console.log("add new comment")
		add_comment();
	},
	update_explore: function () {
		//console.log("reload_ui_explore");
		//console.log("update explorer from update_filters clientside callback", arguments)
		//make_explore_timeline();
		clean_explorer_timeline(arguments);
		get_filter_event_data();
	},
	update_dataexplorer_daterange: function () {
		//console.log("--------------- update_dataexplorer_daterange ---------------")
		//console.log("update dataexplorer from update_dataexplorer_daterange clientside callback", arguments)
		window._dataexplorer_failsafe_triggered = true;
		if (window._dataexplorer_failsafe_timer) clearTimeout(window._dataexplorer_failsafe_timer);
		make_dataexplorer(arguments)
		return window.dash_clientside.no_update
	},
	update_dataexplorer_start_selected: function () {
		//console.log("--------------- update_dataexplorer_start_selected ---------------")
		//console.log("update dataexplorer from update_dataexplorer_start_selected clientside callback", arguments)
		window._dataexplorer_failsafe_triggered = true;
		if (window._dataexplorer_failsafe_timer) clearTimeout(window._dataexplorer_failsafe_timer);
		make_dataexplorer_start_selected(arguments)
		return window.dash_clientside.no_update
	},
}




snartElem();


/*

*/

// var resourceModal = new bootstrap.Modal(document.getElementById("resourceModal"), {}); 


window.make_dataexplorer = make_dataexplorer;
window.make_dataexplorer_start_selected = make_dataexplorer_start_selected;
window.get_filter_event_data = get_filter_event_data;
window.make_digest = make_digest;

window.send_dataexplorer_results = send_dataexplorer_results;

window.make_dataexplorer_events = make_dataexplorer_events;
